
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__decorate", () => $5c96a02c592fcff1$export$29e00dfd3077644b);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});

parcelRegister("800sp", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("4jdI8")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("jJTNo")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("lPSdM")).LitElement);
parcelRequire("3qR54");
parcelRequire("jJTNo");
parcelRequire("lPSdM");
parcelRequire("8FVzH");

});
parcelRegister("3qR54", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", () => $27fcf98b67c2a783$export$7312b35fbf521afb);
$parcel$export(module.exports, "notEqual", () => $27fcf98b67c2a783$export$53a6892c50694894);
$parcel$export(module.exports, "ReactiveElement", () => $27fcf98b67c2a783$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("4jdI8")).css);

var $4jdI8 = parcelRequire("4jdI8");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $27fcf98b67c2a783$var$i, defineProperty: $27fcf98b67c2a783$var$e, getOwnPropertyDescriptor: $27fcf98b67c2a783$var$h, getOwnPropertyNames: $27fcf98b67c2a783$var$r, getOwnPropertySymbols: $27fcf98b67c2a783$var$o, getPrototypeOf: $27fcf98b67c2a783$var$n } = Object, $27fcf98b67c2a783$var$a = globalThis, $27fcf98b67c2a783$var$c = $27fcf98b67c2a783$var$a.trustedTypes, $27fcf98b67c2a783$var$l = $27fcf98b67c2a783$var$c ? $27fcf98b67c2a783$var$c.emptyScript : "", $27fcf98b67c2a783$var$p = $27fcf98b67c2a783$var$a.reactiveElementPolyfillSupport, $27fcf98b67c2a783$var$d = (t, s)=>t, $27fcf98b67c2a783$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $27fcf98b67c2a783$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $27fcf98b67c2a783$export$53a6892c50694894 = (t, s)=>!$27fcf98b67c2a783$var$i(t, s), $27fcf98b67c2a783$var$b = {
    attribute: !0,
    type: String,
    converter: $27fcf98b67c2a783$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $27fcf98b67c2a783$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $27fcf98b67c2a783$var$a.litPropertyMetadata ??= new WeakMap;
class $27fcf98b67c2a783$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $27fcf98b67c2a783$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $27fcf98b67c2a783$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $27fcf98b67c2a783$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $27fcf98b67c2a783$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("elementProperties"))) return;
        const t = $27fcf98b67c2a783$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($27fcf98b67c2a783$var$d("properties"))) {
            const t = this.properties, s = [
                ...$27fcf98b67c2a783$var$r(t),
                ...$27fcf98b67c2a783$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $4jdI8.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $4jdI8.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $4jdI8.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $27fcf98b67c2a783$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $27fcf98b67c2a783$export$7312b35fbf521afb;
            this._$Em = e, this[e] = h.fromAttribute(s, t.type) ?? this._$Ej?.get(e) ?? null, this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            const e = this.constructor, h = this[t];
            if (i ??= e.getPropertyOptions(t), !((i.hasChanged ?? $27fcf98b67c2a783$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(e._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$27fcf98b67c2a783$export$c7c07a37856565d.elementStyles = [], $27fcf98b67c2a783$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("elementProperties")] = new Map, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("finalized")] = new Map, $27fcf98b67c2a783$var$p?.({
    ReactiveElement: $27fcf98b67c2a783$export$c7c07a37856565d
}), ($27fcf98b67c2a783$var$a.reactiveElementVersions ??= []).push("2.1.0");

});
parcelRegister("4jdI8", function(module, exports) {

$parcel$export(module.exports, "css", () => $3233927aa82734f9$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $3233927aa82734f9$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $3233927aa82734f9$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3233927aa82734f9$var$t = globalThis, $3233927aa82734f9$export$b4d10f6001c083c2 = $3233927aa82734f9$var$t.ShadowRoot && (void 0 === $3233927aa82734f9$var$t.ShadyCSS || $3233927aa82734f9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3233927aa82734f9$var$s = Symbol(), $3233927aa82734f9$var$o = new WeakMap;
class $3233927aa82734f9$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $3233927aa82734f9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3233927aa82734f9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3233927aa82734f9$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3233927aa82734f9$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3233927aa82734f9$export$8d80f9cac07cdb3 = (t)=>new $3233927aa82734f9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3233927aa82734f9$var$s), $3233927aa82734f9$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $3233927aa82734f9$export$505d1e8739bad805(o, t, $3233927aa82734f9$var$s);
}, $3233927aa82734f9$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($3233927aa82734f9$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $3233927aa82734f9$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $3233927aa82734f9$export$ee69dfd951e24778 = $3233927aa82734f9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3233927aa82734f9$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("jJTNo", function(module, exports) {

$parcel$export(module.exports, "html", () => $e5ed8027d647799b$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $e5ed8027d647799b$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "render", () => $e5ed8027d647799b$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5ed8027d647799b$var$t = globalThis, $e5ed8027d647799b$var$i = $e5ed8027d647799b$var$t.trustedTypes, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$e = "$lit$", $e5ed8027d647799b$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $e5ed8027d647799b$var$o = "?" + $e5ed8027d647799b$var$h, $e5ed8027d647799b$var$n = `<${$e5ed8027d647799b$var$o}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$l = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$a = Array.isArray, $e5ed8027d647799b$var$u = (t)=>$e5ed8027d647799b$var$a(t) || "function" == typeof t?.[Symbol.iterator], $e5ed8027d647799b$var$d = "[ \t\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$v = /-->/g, $e5ed8027d647799b$var$_ = />/g, $e5ed8027d647799b$var$m = RegExp(`>|${$e5ed8027d647799b$var$d}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$d}*=${$e5ed8027d647799b$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$p = /'/g, $e5ed8027d647799b$var$g = /"/g, $e5ed8027d647799b$var$$ = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$y(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$y(2), $e5ed8027d647799b$export$47d5b44d225be5b4 = $e5ed8027d647799b$var$y(3), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$A = new WeakMap, $e5ed8027d647799b$var$C = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129);
function $e5ed8027d647799b$var$P(t, i) {
    if (!$e5ed8027d647799b$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createHTML(i) : i;
}
const $e5ed8027d647799b$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $e5ed8027d647799b$var$f ? "!--" === u[1] ? c = $e5ed8027d647799b$var$v : void 0 !== u[1] ? c = $e5ed8027d647799b$var$_ : void 0 !== u[2] ? ($e5ed8027d647799b$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $e5ed8027d647799b$var$m) : void 0 !== u[3] && (c = $e5ed8027d647799b$var$m) : c === $e5ed8027d647799b$var$m ? ">" === u[0] ? (c = r ?? $e5ed8027d647799b$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e5ed8027d647799b$var$m : '"' === u[3] ? $e5ed8027d647799b$var$g : $e5ed8027d647799b$var$p) : c === $e5ed8027d647799b$var$g || c === $e5ed8027d647799b$var$p ? c = $e5ed8027d647799b$var$m : c === $e5ed8027d647799b$var$v || c === $e5ed8027d647799b$var$_ ? c = $e5ed8027d647799b$var$f : (c = $e5ed8027d647799b$var$m, r = void 0);
        const x = c === $e5ed8027d647799b$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $e5ed8027d647799b$var$e + s.slice(d) + $e5ed8027d647799b$var$h + x) : s + $e5ed8027d647799b$var$h + (-2 === d ? i : x);
    }
    return [
        $e5ed8027d647799b$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $e5ed8027d647799b$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e5ed8027d647799b$var$V(t, s);
        if (this.el = $e5ed8027d647799b$var$N.createElement(f, n), $e5ed8027d647799b$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e5ed8027d647799b$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e5ed8027d647799b$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($e5ed8027d647799b$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e5ed8027d647799b$var$H : "?" === e[1] ? $e5ed8027d647799b$var$I : "@" === e[1] ? $e5ed8027d647799b$var$L : $e5ed8027d647799b$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($e5ed8027d647799b$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($e5ed8027d647799b$var$$.test(r.tagName)) {
                    const t = r.textContent.split($e5ed8027d647799b$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $e5ed8027d647799b$var$l()), $e5ed8027d647799b$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $e5ed8027d647799b$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e5ed8027d647799b$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e5ed8027d647799b$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $e5ed8027d647799b$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$S(t, i, s = t, e) {
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e5ed8027d647799b$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e5ed8027d647799b$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $e5ed8027d647799b$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e5ed8027d647799b$var$r).importNode(i, !0);
        $e5ed8027d647799b$var$C.currentNode = e;
        let h = $e5ed8027d647799b$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $e5ed8027d647799b$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $e5ed8027d647799b$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $e5ed8027d647799b$var$C.nextNode(), o++);
        }
        return $e5ed8027d647799b$var$C.currentNode = $e5ed8027d647799b$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$S(this, t, i), $e5ed8027d647799b$var$c(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e5ed8027d647799b$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e5ed8027d647799b$var$N.createElement($e5ed8027d647799b$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e5ed8027d647799b$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$A.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$A.set(t.strings, i = new $e5ed8027d647799b$var$N(t)), i;
    }
    k(t) {
        $e5ed8027d647799b$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$R(this.O($e5ed8027d647799b$var$l()), this.O($e5ed8027d647799b$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e5ed8027d647799b$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e5ed8027d647799b$var$S(this, t, i, 0), o = !$e5ed8027d647799b$var$c(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e5ed8027d647799b$var$S(this, e[s + n], i, n), r === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e5ed8027d647799b$var$c(r) || r !== this._$AH[n], r === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e5ed8027d647799b$var$I extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e5ed8027d647799b$export$45b790e32b2810ee);
    }
}
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e5ed8027d647799b$var$S(this, t, i, 0) ?? $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e5ed8027d647799b$export$45b790e32b2810ee && s !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (s === $e5ed8027d647799b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$S(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    M: $e5ed8027d647799b$var$e,
    P: $e5ed8027d647799b$var$h,
    A: $e5ed8027d647799b$var$o,
    C: 1,
    L: $e5ed8027d647799b$var$V,
    R: $e5ed8027d647799b$var$M,
    D: $e5ed8027d647799b$var$u,
    V: $e5ed8027d647799b$var$S,
    I: $e5ed8027d647799b$var$R,
    H: $e5ed8027d647799b$var$k,
    N: $e5ed8027d647799b$var$I,
    U: $e5ed8027d647799b$var$L,
    B: $e5ed8027d647799b$var$H,
    F: $e5ed8027d647799b$var$z
}, $e5ed8027d647799b$var$j = $e5ed8027d647799b$var$t.litHtmlPolyfillSupport;
$e5ed8027d647799b$var$j?.($e5ed8027d647799b$var$N, $e5ed8027d647799b$var$R), ($e5ed8027d647799b$var$t.litHtmlVersions ??= []).push("3.3.0");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e5ed8027d647799b$var$R(i.insertBefore($e5ed8027d647799b$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("lPSdM", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("4jdI8")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("3qR54")).ReactiveElement);
$parcel$export(module.exports, "html", () => (parcelRequire("jJTNo")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("jJTNo")).noChange);
$parcel$export(module.exports, "render", () => (parcelRequire("jJTNo")).render);

$parcel$export(module.exports, "LitElement", () => $fe586ba0757c37f7$export$3f2f9f5909897157);

var $3qR54 = parcelRequire("3qR54");

var $jJTNo = parcelRequire("jJTNo");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fe586ba0757c37f7$var$s = globalThis;
class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $3qR54.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $jJTNo.render)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $jJTNo.noChange;
    }
}
$fe586ba0757c37f7$export$3f2f9f5909897157._$litElement$ = !0, $fe586ba0757c37f7$export$3f2f9f5909897157["finalized"] = !0, $fe586ba0757c37f7$var$s.litElementHydrateSupport?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$var$o = $fe586ba0757c37f7$var$s.litElementPolyfillSupport;
$fe586ba0757c37f7$var$o?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($fe586ba0757c37f7$var$s.litElementVersions ??= []).push("4.2.0");

});

parcelRegister("8FVzH", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $650ed036964a13b8$export$6acf61af03e62db = !1;

});


parcelRegister("4OBpG", function(module, exports) {
$parcel$export(module.exports, "customElement", () => (parcelRequire("DB6gH")).customElement);
$parcel$export(module.exports, "property", () => (parcelRequire("fmLyg")).property);
$parcel$export(module.exports, "state", () => (parcelRequire("9Jyha")).state);
parcelRequire("DB6gH");
parcelRequire("fmLyg");
parcelRequire("9Jyha");
parcelRequire("jJ24L");
parcelRequire("1qzTC");
parcelRequire("39vqa");
parcelRequire("2GsEg");
parcelRequire("5OQlM");
parcelRequire("cUpcY");

});
parcelRegister("DB6gH", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $07706bf0c990b886$export$da64fc29f17f9d0e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $07706bf0c990b886$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

});

parcelRegister("fmLyg", function(module, exports) {

$parcel$export(module.exports, "property", () => $b2fdcbe153c88f81$export$d541bacb2bda4494);

var $3qR54 = parcelRequire("3qR54");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b2fdcbe153c88f81$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $3qR54.defaultConverter),
    reflect: !1,
    hasChanged: (0, $3qR54.notEqual)
}, $b2fdcbe153c88f81$export$8d623b1670eb40f4 = (t = $b2fdcbe153c88f81$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), "setter" === n && ((t = Object.create(t)).wrapped = !0), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t, e), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $b2fdcbe153c88f81$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $b2fdcbe153c88f81$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

});

parcelRegister("9Jyha", function(module, exports) {

$parcel$export(module.exports, "state", () => $7162e77b40ffab5c$export$ca000e230c0caa3e);

var $fmLyg = parcelRequire("fmLyg");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7162e77b40ffab5c$export$ca000e230c0caa3e(r) {
    return (0, $fmLyg.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

});

parcelRegister("jJ24L", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e5c3d47edfef3b02$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("1qzTC", function(module, exports) {

var $1RVBZ = parcelRequire("1RVBZ");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $10a410638b7df95b$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $1RVBZ.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $1RVBZ.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

});
parcelRegister("1RVBZ", function(module, exports) {

$parcel$export(module.exports, "desc", () => $15c76e2f7983b497$export$51987bb50e1f6752);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $15c76e2f7983b497$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

});


parcelRegister("39vqa", function(module, exports) {

var $1RVBZ = parcelRequire("1RVBZ");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $24ba95ebfbdcf6b8$var$e;
function $24ba95ebfbdcf6b8$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $1RVBZ.desc)(n, o, {
            get () {
                return (this.renderRoot ?? ($24ba95ebfbdcf6b8$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

});

parcelRegister("2GsEg", function(module, exports) {

var $1RVBZ = parcelRequire("1RVBZ");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1f45ba04a1effcd1$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $1RVBZ.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

});

parcelRegister("5OQlM", function(module, exports) {

var $1RVBZ = parcelRequire("1RVBZ");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $43ca3aec390b0561$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $1RVBZ.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

});

parcelRegister("cUpcY", function(module, exports) {

var $1RVBZ = parcelRequire("1RVBZ");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $965e44d5bf066bc5$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $1RVBZ.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

});


parcelRegister("hGXTG", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
var $fmLyg = parcelRequire("fmLyg");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("2dqH9");
parcelRequire("lmk8H");
var $1eqYq = parcelRequire("1eqYq");

var $6FqPz = parcelRequire("6FqPz");
class $fc5f7026f3ddf248$export$3b4e64e77073e307 extends (0, $27Ysw.DefaultComponent) {
    static get componentStyles() {
        return (0, $4jdI8.css)`
      .header-wrapper {
        background-image: url(/bnn-banner.png);
          url(/bnn-banner.png);
        height: min-content;
        padding: 0px var(--content-padding);
        padding-top: 16px;
        display: flex;
        justify-content: center;
        background-size: cover;
      }

      .has-description {
        --header-size: 650px;
        --font-size-xl: 40px;
        & p {
          color: white;
          font-size: var(--font-size-l);
        }
      }

      .home {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        margin-top: 2em;
        gap: 0 2em;
        & h1 {
          grid-row: span 2;
          font-size: 90px;
          margin-top: 0;
        }
      }

      .home .subtitle-1, .home .subtitle-2 {
        color: var(--color-white);
        font-size: var(--font-size-xl);
        width: 75%;
      }

      .max-content {
        width: 100%;
        max-width: var(--max-content);
        display: flex;
        flex-direction: column;
      }

      .logo-nav-container {
        display: flex;
        justify-content: space-between;
        width: 100%;
        gap: 16px;
      }

      .logo-nav-container img {
        height: 120px;
      }

      bnn-nav-menu {
        position: relative;
        margin-left: auto;
      }

      h1 {
        margin-top: 0;
        color: white;
        margin-top: 2em;
      }

      .sections-list {
        list-style: none;
        padding: 0;
        margin-top: 1em; /* Adjust as needed */
      }
      
      .sections-list li {
        margin-bottom: 0.5em; /* Adjust spacing between items as needed */
      }
      
      .sections-link {
        display: block;
        text-transform: uppercase;
        white-space: nowrap; 
        overflow: hidden; 
        text-overflow: ellipsis;
        width: max-content;
        max-width: 250px;
        color: white; 
        text-decoration: none;
        cursor: pointer;
        &:hover {
          background-color: var(--color-primary);
        }
      }

      .placeholder {
        background-color: rgba(255, 255, 255, 0.3);
        height: 24px;
        width: 25%; 
        border-radius: 5px;
        animation: pulsate 2s ease-in-out infinite;
        &.placeholder-short {
          width: 20%; 
        }
      }
      
      h1.placeholder {
        height: var(--font-size-xl);
      }

      @keyframes pulsate {
        0% { background-color: rgba(255, 255, 255, 0.3); }
        50% { background-color: rgba(255, 255, 255, 0.5); }
        100% { background-color: rgba(255, 255, 255, 0.3); }
      }

      @media screen and (max-width: 1440px) {
        .home {
          grid-template-columns: 1fr;
          grid-template-rows: auto auto auto;
          gap: 1em 0;
        }
  
        .home .home-title {
          grid-row: 1;
          font-size: 60px;
          margin-top: 0;
        }
  
        .home .subtitle-1, .home .subtitle-2 {
          width: 100%;
          font-size: var(--font-size-l);
        }
      }
    `;
    }
    render() {
        return (0, $jJTNo.html)`
      <div
        class="${(0, $1eqYq.classMap)({
            "header-wrapper": true,
            "has-description": this.isHome
        })}"
      >
        <div class="max-content">
          <div class="logo-nav-container">
            <img src="/logo.webp" alt="Beimnamennennen Logo">
            <bnn-nav-menu></bnn-nav-menu>
          </div>
          ${this.isHome ? (0, $jJTNo.html)`
          <div class="home">
            <span class="subtitle-1">${this.subtitle1}</span>
            <h1 class="home-title">${this.title}</h1>
            <span class="subtitle-2">${this.subtitle2}</span>
          </div>
          ` : this.title ? (0, $jJTNo.html)`<h1>${this.title}</h1>` : (0, $jJTNo.html)`<h1 class="placeholder"></h1>`}

          ${this.sections.length > 0 || this.title ? (0, $jJTNo.html)`<ul class="sections-list">
                ${this.sections.map((section)=>section.fileId ? (0, $jJTNo.html)`<li>
                        <a
                          href="${this.config?.apiUrl}/assets/${section.fileId}"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="sections-link"
                          >${section.name}</a
                        >
                      </li>` : (0, $jJTNo.html)`<li>
                        <span @click="${()=>this.goTo(section.id)}" class="sections-link">${section.name}</span>
                      </li>`)}
              </ul>` : (0, $jJTNo.html)`
            <ul class="sections-list">
              <li class="placeholder placeholder-short"></li>
              <li class="placeholder"></li>
              <li class="placeholder"></li>
              <li class="placeholder"></li>
              <li class="placeholder"></li>
              <li class="placeholder"></li>
            </ul>
            `}
        </div>
      </div>
    `;
    }
    goTo(id) {
        const event = new CustomEvent((0, $6FqPz.City).SCROLL_INTO_VIEW_EVENT, {
            detail: id
        });
        document.dispatchEvent(event);
    }
    constructor(...args){
        super(...args), this.isHome = false, this.sections = [];
    }
}
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)({
        type: String
    })
], $fc5f7026f3ddf248$export$3b4e64e77073e307.prototype, "title", void 0);
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)({
        type: String
    })
], $fc5f7026f3ddf248$export$3b4e64e77073e307.prototype, "subtitle1", void 0);
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)({
        type: String
    })
], $fc5f7026f3ddf248$export$3b4e64e77073e307.prototype, "subtitle2", void 0);
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)({
        type: Boolean
    })
], $fc5f7026f3ddf248$export$3b4e64e77073e307.prototype, "isHome", void 0);
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)({
        type: Array
    })
], $fc5f7026f3ddf248$export$3b4e64e77073e307.prototype, "sections", void 0);
$fc5f7026f3ddf248$export$3b4e64e77073e307 = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-banner")
], $fc5f7026f3ddf248$export$3b4e64e77073e307);

});
parcelRegister("27Ysw", function(module, exports) {

$parcel$export(module.exports, "DefaultComponent", () => $bd8c6436cc738276$export$97115d1df050344e);
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $lPSdM = parcelRequire("lPSdM");

var $1dVZ3 = parcelRequire("1dVZ3");

var $8k8ek = parcelRequire("8k8ek");

var $aY6HT = parcelRequire("aY6HT");
class $bd8c6436cc738276$export$97115d1df050344e extends (0, $lPSdM.LitElement) {
    static{
        this.componentStyles = (0, $4jdI8.css)``;
    }
    static get styles() {
        return [
            (0, $aY6HT.default),
            this.componentStyles
        ];
    }
    connectedCallback() {
        super.connectedCallback();
        this.initializeComponent().then(()=>this.afterComponentInitialized());
        window.addEventListener('refetch-data', this.handleRefetchData);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('refetch-data', this.handleRefetchData);
    }
    async initializeComponent() {
        try {
            await this.initializeConfig();
            await this.initializeTranslations();
            this.requestUpdate();
        } catch (error) {
            console.error("Error initializing component:", error);
        }
    }
    async initializeConfig() {
        this.configService = (0, $1dVZ3.ConfigService).getInstance();
        await this.configService.fetchConfig();
        this.config = this.configService.getConfig();
    }
    async initializeTranslations() {
        this.translationService = (0, $8k8ek.TranslationService).getInstance(this.config);
        await this.translationService.fetchTranslations();
        this.translations = this.translationService.getTranslations();
    }
    t(key) {
        return this.translationService?.getTranslation(key);
    }
    afterComponentInitialized() {}
    constructor(...args){
        super(...args), this.handleRefetchData = async ()=>{
            console.log("Re-fetching general translations...");
            // Call fetchTranslations with forceRefetch set to true
            await this.translationService.fetchTranslations(true);
            this.translations = this.translationService.getTranslations();
            this.requestUpdate();
        };
    }
}

});
parcelRegister("1dVZ3", function(module, exports) {

$parcel$export(module.exports, "ConfigService", () => $faa8eabda56ed334$export$1a7732fb77cdf7b8);
class $faa8eabda56ed334$export$1a7732fb77cdf7b8 {
    static getInstance() {
        if (!$faa8eabda56ed334$export$1a7732fb77cdf7b8.instance) $faa8eabda56ed334$export$1a7732fb77cdf7b8.instance = new $faa8eabda56ed334$export$1a7732fb77cdf7b8();
        return $faa8eabda56ed334$export$1a7732fb77cdf7b8.instance;
    }
    async fetchConfig() {
        // If config is already fetched, do nothing.
        if (this.config) return;
        // If a fetch is already in progress, wait for it to complete.
        if (this.fetchPromise) return this.fetchPromise;
        // Start the fetch operation.
        this.fetchPromise = this.loadConfig();
        await this.fetchPromise;
    }
    async loadConfig() {
        try {
            console.log("Loading config.json...");
            const response = await fetch("/config.json");
            if (!response.ok) throw new Error(`Failed to fetch config: ${response.statusText}`);
            const responseJson = await response.json();
            console.log("Raw config.json response:", responseJson);
            // Parse backend and frontend URLs from comma-separated strings
            const backendUrls = responseJson.backendUrls ? responseJson.backendUrls.split(',').map((url)=>url.trim()) : [];
            const frontendUrls = responseJson.frontendUrls ? responseJson.frontendUrls.split(',').map((url)=>url.trim()) : [];
            console.log("Parsed URLs:", {
                backendUrls: backendUrls,
                frontendUrls: frontendUrls
            });
            // Determine the appropriate backend URL based on current domain
            const currentDomain = window.location.origin;
            const apiUrl = this.selectBackendUrl(currentDomain, frontendUrls, backendUrls);
            this.config = {
                apiUrl: apiUrl,
                environment: responseJson.environment || "",
                backendUrls: backendUrls,
                frontendUrls: frontendUrls
            };
            console.log("Final config:", this.config);
        } catch (error) {
            console.error("Failed to load config.json:", error);
            // Set a default/fallback config to prevent the app from crashing
            this.config = {
                apiUrl: "https://api.beimnamennennen.ch",
                environment: "production"
            };
            console.log("Using fallback config:", this.config);
        }
    }
    selectBackendUrl(currentDomain, frontendUrls, backendUrls) {
        console.log('Selecting backend URL:', {
            currentDomain: currentDomain,
            frontendUrls: frontendUrls,
            backendUrls: backendUrls
        });
        // If no URLs provided, use fallback
        if (!frontendUrls.length || !backendUrls.length) {
            console.log('Using fallback URL (no URLs provided)');
            return backendUrls[0] || "https://api.beimnamennennen.ch";
        }
        // Find exact match first
        const domainIndex = frontendUrls.findIndex((url)=>url === currentDomain);
        console.log('Exact domain index:', domainIndex);
        if (domainIndex !== -1 && domainIndex < backendUrls.length) {
            const selectedUrl = backendUrls[domainIndex];
            console.log('Selected backend URL by exact match:', selectedUrl);
            return selectedUrl;
        }
        // Try to find a partial match for the domain name
        const currentHost = new URL(currentDomain).hostname;
        console.log('Current hostname:', currentHost);
        for(let i = 0; i < frontendUrls.length; i++){
            const frontendHost = new URL(frontendUrls[i]).hostname;
            // Remove www prefix for comparison
            const normalizedCurrent = currentHost.replace(/^www\./, '');
            const normalizedFrontend = frontendHost.replace(/^www\./, '');
            if (normalizedCurrent === normalizedFrontend && i < backendUrls.length) {
                const selectedUrl = backendUrls[i];
                console.log('Selected backend URL by hostname match:', selectedUrl);
                return selectedUrl;
            }
        }
        // Special handling for Fly.dev domains
        if (currentDomain.includes('.fly.dev')) {
            const flyBackend = backendUrls.find((url)=>url.includes('.fly.dev'));
            if (flyBackend) {
                console.log('Selected fly.dev backend URL:', flyBackend);
                return flyBackend;
            }
        }
        // Domain-specific fallbacks
        if (currentHost.includes('beimnamennennen') || currentHost.includes('lesnommerparleurnom')) {
            // For production domains, prefer the API subdomain
            const productionBackend = backendUrls.find((url)=>url.includes('api.beimnamennennen') || url.includes('api.lesnommerparleurnom'));
            if (productionBackend) {
                console.log('Selected production backend URL:', productionBackend);
                return productionBackend;
            }
        }
        // Fallback to first backend URL, but prefer HTTPS
        const httpsBackend = backendUrls.find((url)=>url.startsWith('https://')) || backendUrls[0];
        const fallbackUrl = httpsBackend || "https://api.beimnamennennen.ch";
        console.log('Using fallback URL (no match found):', fallbackUrl);
        return fallbackUrl;
    }
    getConfig() {
        if (!this.config) {
            console.warn("Config not loaded yet. Returning fallback empty config.");
            return {
                apiUrl: "",
                environment: ""
            };
        }
        return this.config;
    }
    constructor(){
        this.config = null;
        this.fetchPromise = null;
    }
}

});

parcelRegister("8k8ek", function(module, exports) {

$parcel$export(module.exports, "TranslationService", () => $ce0d5d1607cabe6a$export$8647276a1b5b7e3);

var $juzok = parcelRequire("juzok");
class $ce0d5d1607cabe6a$export$8647276a1b5b7e3 {
    constructor(config){
        this.fetchPromise = null;
        this.client = (0, $juzok.createDirectus)(config.apiUrl).with((0, $juzok.rest)());
    }
    static getInstance(config) {
        if (!$ce0d5d1607cabe6a$export$8647276a1b5b7e3.instance) $ce0d5d1607cabe6a$export$8647276a1b5b7e3.instance = new $ce0d5d1607cabe6a$export$8647276a1b5b7e3(config);
        return $ce0d5d1607cabe6a$export$8647276a1b5b7e3.instance;
    }
    async fetchTranslations(forceRefetch = false) {
        if (forceRefetch) {
            this.fetchPromise = null;
            this.translations = undefined;
        }
        if (this.fetchPromise) return this.fetchPromise;
        this.fetchPromise = this.loadTranslations();
        await this.fetchPromise;
    }
    async loadTranslations() {
        const languageCode = this.getValidLanguageCode();
        console.log("Loading translations with language code:", languageCode);
        this.langFilter = {
            translations: {
                _filter: {
                    languages_code: {
                        _eq: languageCode
                    }
                }
            }
        };
        try {
            console.log("Loading general strings...");
            const response = await this.client.request((0, $juzok.readItems)("GeneralTranslations", {
                fields: [
                    "key",
                    "translations.text"
                ],
                deep: {
                    ...this.langFilter
                }
            }));
            this.translations = response.map((t)=>({
                    key: t.key,
                    text: t.translations[0]?.text
                }));
        } catch (error) {
            console.error("Failed to load translations:", error);
            // In case of an error, reset the promise to allow for a retry.
            this.fetchPromise = null;
        }
    }
    getValidLanguageCode() {
        // Return selectedLanguage if in storage
        const storedLanguage = sessionStorage.getItem('selectedLanguage');
        if (storedLanguage && (storedLanguage === 'de' || storedLanguage === 'fr')) return storedLanguage;
        // Get browser language, if its de or fr use that, else default to de
        const browserLanguage = navigator.language.slice(0, 2);
        const selectedLanguage = browserLanguage === 'de' || browserLanguage === 'fr' ? browserLanguage : 'de';
        // Store the determined language so it's consistent across services
        sessionStorage.setItem('selectedLanguage', selectedLanguage);
        return selectedLanguage;
    }
    getTranslations() {
        return this.translations ?? [];
    }
    getTranslation(key) {
        const translation = this.translations?.find((t)=>t.key === key);
        if (translation) return translation.text;
        else return "";
    }
}

});
parcelRegister("juzok", function(module, exports) {

$parcel$export(module.exports, "createDirectus", () => $03a97cfeae635a28$export$63427ba69af216fe);
$parcel$export(module.exports, "readItems", () => $03a97cfeae635a28$export$dc1ffac156057709);
$parcel$export(module.exports, "readItem", () => $03a97cfeae635a28$export$5ccb2a3b476b2cd3);
$parcel$export(module.exports, "readSingleton", () => $03a97cfeae635a28$export$2cefaf6e917f5b26);
$parcel$export(module.exports, "rest", () => $03a97cfeae635a28$export$c58417706a208278);
function $03a97cfeae635a28$export$94b8006881d8c10d(e) {
    return e ? `/auth/login/${e}` : "/auth/login";
}
var $03a97cfeae635a28$var$A = "/", $03a97cfeae635a28$var$L = (e, t)=>(e.endsWith($03a97cfeae635a28$var$A) && (e = e.slice(0, -1)), t.startsWith($03a97cfeae635a28$var$A) || (t = $03a97cfeae635a28$var$A + t), e + t), $03a97cfeae635a28$var$g = (e, t, o)=>{
    let a = e.pathname === $03a97cfeae635a28$var$A ? t : $03a97cfeae635a28$var$L(e.pathname, t), s = new globalThis.URL(a, e);
    if (o) for (let [c, i] of Object.entries($03a97cfeae635a28$export$9f72cc599b0bf53(o)))if (i && typeof i == "object" && !Array.isArray(i)) for (let [p, u] of Object.entries(i))s.searchParams.set(`${c}[${p}]`, String(u));
    else s.searchParams.set(c, i);
    return s;
};
function $03a97cfeae635a28$var$$(e) {
    return typeof e != "object" || !e ? !1 : "headers" in e && "ok" in e && "json" in e && typeof e.json == "function" && "text" in e && typeof e.json == "function";
}
async function $03a97cfeae635a28$var$k(e) {
    if (!(typeof e != "object" || !e)) {
        if ($03a97cfeae635a28$var$$(e)) {
            let t = e.headers.get("Content-Type")?.toLowerCase();
            if (t?.startsWith("application/json") || t?.startsWith("application/health+json")) {
                let o = await e.json();
                if (!e.ok || "errors" in o) throw o;
                return "data" in o ? o.data : o;
            }
            if (t?.startsWith("text/html") || t?.startsWith("text/plain")) {
                let o = await e.text();
                if (!e.ok) throw o;
                return o;
            }
            return e.status === 204 ? null : e;
        }
        if ("errors" in e) throw e;
        return "data" in e ? e.data : e;
    }
}
var $03a97cfeae635a28$var$b = async (e, t, o = globalThis.fetch)=>(t.headers = typeof t.headers == "object" && !Array.isArray(t.headers) ? t.headers : {}, o(e, t).then((a)=>$03a97cfeae635a28$var$k(a).catch((s)=>{
            let c = {
                errors: s && typeof s == "object" && "errors" in s ? s.errors : s,
                response: a
            };
            return s && typeof s == "object" && "data" in s && (c.data = s.data), Promise.reject(c);
        })));
var $03a97cfeae635a28$export$28db2db1ba45b8f6 = ()=>{
    let e = null;
    return {
        get: async ()=>e,
        set: async (t)=>{
            e = t;
        }
    };
};
var $03a97cfeae635a28$var$H = {
    msRefreshBeforeExpires: 3e4,
    autoRefresh: !0
}, $03a97cfeae635a28$var$_ = 2 ** 31 - 1, $03a97cfeae635a28$export$8bf4ce924aca1720 = (e = "cookie", t = {})=>(o)=>{
        let a = {
            ...$03a97cfeae635a28$var$H,
            ...t
        }, s = null, c = null, i = a.storage ?? $03a97cfeae635a28$export$28db2db1ba45b8f6(), p = async ()=>i.set({
                access_token: null,
                refresh_token: null,
                expires: null,
                expires_at: null
            }), u = async ()=>{
            try {
                await s;
            } finally{
                s = null;
            }
        }, f = async ()=>{
            let h = await i.get();
            return s || !h?.expires_at || h.expires_at < new Date().getTime() + a.msRefreshBeforeExpires && I().catch((l)=>{}), u();
        }, D = async (h)=>{
            let l = h.expires ?? 0;
            h.expires_at = new Date().getTime() + l, await i.set(h), a.autoRefresh && l > a.msRefreshBeforeExpires && l < $03a97cfeae635a28$var$_ && (c && clearTimeout(c), c = setTimeout(()=>{
                c = null, I().catch((Q)=>{});
            }, l - a.msRefreshBeforeExpires));
        }, I = async ()=>(s = (async ()=>{
                let l = await i.get();
                await p();
                let Q = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    }
                };
                "credentials" in a && (Q.credentials = a.credentials);
                let C = {
                    mode: e
                };
                e === "json" && l?.refresh_token && (C.refresh_token = l.refresh_token), Q.body = JSON.stringify(C);
                let m = $03a97cfeae635a28$var$g(o.url, "/auth/refresh");
                return $03a97cfeae635a28$var$b(m.toString(), Q, o.globals.fetch).then((n)=>D(n).then(()=>n));
            })(), s);
        return {
            refresh: I,
            async login (h, l, Q = {}) {
                await p();
                let C = {
                    email: h,
                    password: l
                };
                "otp" in Q && (C.otp = Q.otp), C.mode = Q.mode ?? e;
                let m = $03a97cfeae635a28$export$94b8006881d8c10d(Q.provider), n = $03a97cfeae635a28$var$g(o.url, m), y = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(C)
                };
                "credentials" in a && (y.credentials = a.credentials);
                let d = await $03a97cfeae635a28$var$b(n.toString(), y, o.globals.fetch);
                return await D(d), d;
            },
            async logout () {
                let h = await i.get(), l = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    }
                };
                "credentials" in a && (l.credentials = a.credentials);
                let Q = {
                    mode: e
                };
                e === "json" && h?.refresh_token && (Q.refresh_token = h.refresh_token), l.body = JSON.stringify(Q);
                let C = $03a97cfeae635a28$var$g(o.url, "/auth/logout");
                await $03a97cfeae635a28$var$b(C.toString(), l, o.globals.fetch), this.stopRefreshing(), await p();
            },
            stopRefreshing () {
                c && clearTimeout(c);
            },
            async getToken () {
                return await f().catch(()=>{}), (await i.get())?.access_token ?? null;
            },
            async setToken (h) {
                return i.set({
                    access_token: h,
                    refresh_token: null,
                    expires: null,
                    expires_at: null
                });
            }
        };
    };
var $03a97cfeae635a28$export$d4ac380365815345 = (e)=>(t)=>{
        let o = e ?? null;
        return {
            async getToken () {
                return o;
            },
            async setToken (a) {
                o = a;
            }
        };
    };
var $03a97cfeae635a28$var$K = {
    fetch: globalThis.fetch,
    WebSocket: globalThis.WebSocket,
    URL: globalThis.URL,
    logger: globalThis.console
}, $03a97cfeae635a28$export$63427ba69af216fe = (e, t = {})=>{
    let o = t.globals ? {
        ...$03a97cfeae635a28$var$K,
        ...t.globals
    } : $03a97cfeae635a28$var$K;
    return {
        globals: o,
        url: new o.URL(e),
        with (a) {
            return {
                ...this,
                ...a(this)
            };
        }
    };
};
var $03a97cfeae635a28$var$V = {}, $03a97cfeae635a28$export$1eb4e7c0ed67b035 = (e = {})=>(t)=>{
        let o = {
            ...$03a97cfeae635a28$var$V,
            ...e
        };
        return {
            async query (a, s, c = "items") {
                let i = {
                    method: "POST",
                    body: JSON.stringify({
                        query: a,
                        variables: s
                    })
                };
                "credentials" in o && (i.credentials = o.credentials);
                let p = {};
                if ("getToken" in this) {
                    let D = await this.getToken();
                    D && (p.Authorization = `Bearer ${D}`);
                }
                "Content-Type" in p || (p["Content-Type"] = "application/json"), i.headers = p;
                let u = c === "items" ? "/graphql" : "/graphql/system", f = $03a97cfeae635a28$var$g(t.url, u);
                return await $03a97cfeae635a28$var$b(f.toString(), i, t.globals.fetch);
            }
        };
    };
function $03a97cfeae635a28$export$73693bad9f5880b0(e) {
    return JSON.stringify({
        ...e,
        type: "auth"
    });
}
var $03a97cfeae635a28$export$dffc9798653bfd52 = ()=>JSON.stringify({
        type: "pong"
    });
function* $03a97cfeae635a28$export$b10747473b5ad61e() {
    let e = 1;
    for(;;)yield String(e), e++;
}
var $03a97cfeae635a28$export$2c0e87021c82e6a0 = (e, t = 1e3)=>new Promise((o, a)=>{
        let s = (u)=>{
            try {
                let f = JSON.parse(u.data);
                typeof f == "object" && !Array.isArray(f) && f !== null ? (i(), o(f)) : (i(), c());
            } catch  {
                i(), o(u);
            }
        }, c = ()=>a(), i = ()=>{
            clearTimeout(p), e.removeEventListener("message", s), e.removeEventListener("error", c), e.removeEventListener("close", c);
        };
        e.addEventListener("message", s), e.addEventListener("error", c), e.addEventListener("close", c);
        let p = setTimeout(()=>{
            i(), o(void 0);
        }, t);
    });
var $03a97cfeae635a28$var$M = {
    authMode: "handshake",
    heartbeat: !0,
    debug: !1,
    reconnect: {
        delay: 1e3,
        retries: 10
    }
};
function $03a97cfeae635a28$export$ea80eb855ab064f8(e = {}) {
    return (t)=>{
        e = {
            ...$03a97cfeae635a28$var$M,
            ...e
        };
        let o = $03a97cfeae635a28$export$b10747473b5ad61e(), a = {
            code: "closed"
        }, s = {
            attempts: 0,
            active: !1
        }, c = !1, i = new Set, p = (m)=>"getToken" in m, u = (m, ...n)=>e.debug && t.globals.logger[m]("[Directus SDK]", ...n), f = async (m, n)=>{
            let y = new t.globals.URL(m);
            if (e.authMode === "strict" && p(n)) {
                let d = await n.getToken();
                d && y.searchParams.set("access_token", d);
            }
            return y.toString();
        }, D = async (m)=>{
            if ("url" in e) return await f(e.url, m);
            if ([
                "ws:",
                "wss:"
            ].includes(t.url.protocol)) return await f(t.url, m);
            let n = new t.globals.URL(t.url.toString());
            return n.protocol = t.url.protocol === "https:" ? "wss:" : "ws:", n.pathname = "/websocket", await f(n, m);
        }, I = (m)=>{
            let n = new Promise((y, d)=>{
                if (!e.reconnect || c) return d();
                if (u("info", `reconnect #${s.attempts} ` + (s.attempts >= e.reconnect.retries ? "maximum retries reached" : `trying again in ${Math.max(100, e.reconnect.delay)}ms`)), s.active) return s.active;
                if (s.attempts >= e.reconnect.retries) return s.attempts = -1, d();
                setTimeout(()=>m.connect().then((O)=>(i.forEach((S)=>{
                            m.sendMessage(S);
                        }), O)).then(y).catch(d), Math.max(100, e.reconnect.delay));
            });
            s.attempts += 1, s.active = n.catch(()=>{}).finally(()=>{
                s.active = !1;
            });
        }, h = {
            open: new Set([]),
            error: new Set([]),
            close: new Set([]),
            message: new Set([])
        };
        function l(m) {
            return "type" in m && "status" in m && "error" in m && "code" in m.error && "message" in m.error && m.type === "auth" && m.status === "error";
        }
        async function Q(m, n) {
            if (a.code === "open") {
                if (m.error.code === "TOKEN_EXPIRED" && (u("warn", "Authentication token expired!"), p(n))) {
                    let y = await n.getToken();
                    if (!y) throw Error("No token for re-authenticating the websocket");
                    a.connection.send($03a97cfeae635a28$export$73693bad9f5880b0({
                        access_token: y
                    }));
                }
                if (m.error.code === "AUTH_TIMEOUT") return a.firstMessage && e.authMode === "public" ? (u("warn", 'Authentication failed! Currently the "authMode" is "public" try using "handshake" instead'), e.reconnect = !1) : u("warn", "Authentication timed out!"), a.connection.close();
                if (m.error.code === "AUTH_FAILED") {
                    if (a.firstMessage && e.authMode === "public") return u("warn", 'Authentication failed! Currently the "authMode" is "public" try using "handshake" instead'), e.reconnect = !1, a.connection.close();
                    u("warn", "Authentication failed!");
                }
            }
        }
        let C = async (m)=>{
            for(; a.code === "open";){
                let n = await $03a97cfeae635a28$export$2c0e87021c82e6a0(a.connection).catch(()=>{});
                if (n) {
                    if (l(n)) {
                        await Q(n, m), a.firstMessage = !1;
                        continue;
                    }
                    if (e.heartbeat && n.type === "ping") {
                        a.connection.send($03a97cfeae635a28$export$dffc9798653bfd52()), a.firstMessage = !1;
                        continue;
                    }
                    h.message.forEach((y)=>{
                        a.code === "open" && y.call(a.connection, n);
                    }), a.firstMessage = !1;
                }
            }
        };
        return {
            async connect () {
                if (c = !1, a.code === "connecting") return await a.connection;
                if (a.code !== "closed") throw new Error(`Cannot connect when state is "${a.code}"`);
                let m = this, n = await D(m);
                u("info", `Connecting to ${n}...`);
                let y = new Promise((d, O)=>{
                    let S = !1, T = new t.globals.WebSocket(n);
                    T.addEventListener("open", async (P)=>{
                        if (u("info", "Connection open."), a = {
                            code: "open",
                            connection: T,
                            firstMessage: !0
                        }, s.attempts = 0, s.active = !1, C(m), e.authMode === "handshake" && p(m)) {
                            let R = await m.getToken();
                            if (!R) throw Error("No token for authenticating the websocket. Make sure to provide one or call the login() function beforehand.");
                            T.send($03a97cfeae635a28$export$73693bad9f5880b0({
                                access_token: R
                            }));
                            let E = await $03a97cfeae635a28$export$2c0e87021c82e6a0(T);
                            if (E && "type" in E && "status" in E && E.type === "auth" && E.status === "ok") u("info", "Authentication successful!");
                            else return O("Authentication failed while opening websocket connection");
                        }
                        h.open.forEach((R)=>R.call(T, P)), S = !0, d(T);
                    }), T.addEventListener("error", (P)=>{
                        u("warn", "Connection errored."), h.error.forEach((R)=>R.call(T, P)), T.close(), a = {
                            code: "error"
                        }, S || O(P);
                    }), T.addEventListener("close", (P)=>{
                        u("info", "Connection closed."), h.close.forEach((R)=>R.call(T, P)), o = $03a97cfeae635a28$export$b10747473b5ad61e(), a = {
                            code: "closed"
                        }, I(this), S || O(P);
                    });
                });
                return a = {
                    code: "connecting",
                    connection: y
                }, y;
            },
            disconnect () {
                c = !0, a.code === "open" && a.connection.close();
            },
            onWebSocket (m, n) {
                if (m === "message") {
                    let y = function(d) {
                        if (typeof d.data != "string") return n.call(this, d);
                        try {
                            return n.call(this, JSON.parse(d.data));
                        } catch  {
                            return n.call(this, d);
                        }
                    };
                    return h[m].add(y), ()=>h[m].delete(y);
                }
                return h[m].add(n), ()=>h[m].delete(n);
            },
            sendMessage (m) {
                if (a.code !== "open") throw new Error('Cannot send messages without an open connection. Make sure you are calling "await client.connect()".');
                if (typeof m == "string") return a.connection.send(m);
                "uid" in m || (m.uid = o.next().value), a.connection.send(JSON.stringify(m));
            },
            async subscribe (m, n = {}) {
                "uid" in n || (n.uid = o.next().value), i.add({
                    ...n,
                    collection: m,
                    type: "subscribe"
                }), a.code !== "open" && (u("info", "No connection available for subscribing!"), await this.connect()), this.sendMessage({
                    ...n,
                    collection: m,
                    type: "subscribe"
                });
                let y = !0;
                async function* d() {
                    for(; y && a.code === "open";){
                        let S = await $03a97cfeae635a28$export$2c0e87021c82e6a0(a.connection).catch(()=>{});
                        if (S) {
                            if ("type" in S && "status" in S && S.type === "subscribe" && S.status === "error") throw S;
                            "type" in S && "uid" in S && S.type === "subscription" && S.uid === n.uid && (yield S);
                        }
                    }
                    e.reconnect && s.active && (await s.active, a.code === "open" && (a.connection.send(JSON.stringify({
                        ...n,
                        collection: m,
                        type: "subscribe"
                    })), yield* d()));
                }
                let O = ()=>{
                    i.delete({
                        ...n,
                        collection: m,
                        type: "subscribe"
                    }), this.sendMessage({
                        uid: n.uid,
                        type: "unsubscribe"
                    }), y = !1;
                };
                return {
                    subscription: d(),
                    unsubscribe: O
                };
            }
        };
    };
}
var $03a97cfeae635a28$export$e772c8ff12451969 = (e)=>new Promise((t)=>setTimeout(()=>t(), e));
var $03a97cfeae635a28$export$596d806903d1f59e = (e, t, o = {})=>()=>{
        let a = $03a97cfeae635a28$export$94b8006881d8c10d(o.provider), s = {
            email: e,
            password: t
        };
        return "otp" in o && (s.otp = o.otp), s.mode = o.mode ?? "cookie", {
            path: a,
            method: "POST",
            body: JSON.stringify(s)
        };
    };
var $03a97cfeae635a28$export$a0973bcfe11b05c9 = (e, t = "cookie")=>()=>({
            path: "/auth/logout",
            method: "POST",
            body: JSON.stringify(e ? {
                refresh_token: e,
                mode: t
            } : {
                mode: t
            })
        });
var $03a97cfeae635a28$export$ed100ba7dcdf87f5 = (e, t)=>()=>({
            path: "/auth/password/request",
            method: "POST",
            body: JSON.stringify({
                email: e,
                ...t ? {
                    reset_url: t
                } : {}
            })
        });
var $03a97cfeae635a28$export$ee2fcf8e7aed6a8 = (e, t)=>()=>({
            path: "/auth/password/reset",
            method: "POST",
            body: JSON.stringify({
                token: e,
                password: t
            })
        });
var $03a97cfeae635a28$export$c5742f7ebc1d64e7 = (e = !1)=>()=>({
            path: e ? "/auth?sessionOnly" : "/auth",
            method: "GET"
        });
var $03a97cfeae635a28$export$2d6e9b4c68afb6c8 = (e = "cookie", t)=>()=>({
            path: "/auth/refresh",
            method: "POST",
            body: JSON.stringify(e === "json" ? {
                refresh_token: t,
                mode: e
            } : {
                mode: e
            })
        });
var $03a97cfeae635a28$export$c74125a8e3af6bb2 = (e, t)=>()=>({
            path: "/collections",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$7a30d02be5001f2c = (e, t)=>()=>({
            path: "/comments",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$2a15b079e3f46654 = (e, t)=>()=>({
            path: "/comments",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$7ac7101846d6f893 = (e, t)=>()=>({
            path: "/dashboards",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$eadf0ac433611b3 = (e, t)=>()=>({
            path: "/dashboards",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$17fc0a47da34544a = (e, t, o)=>()=>({
            path: `/fields/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "POST"
        });
var $03a97cfeae635a28$export$69895bd328f2dda9 = (e, t)=>()=>({
            path: "/files",
            method: "POST",
            body: e,
            params: t ?? {},
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }), $03a97cfeae635a28$export$4da7403fdb9cb456 = (e, t = {}, o)=>()=>({
            path: "/files/import",
            method: "POST",
            body: JSON.stringify({
                url: e,
                data: t
            }),
            params: o ?? {}
        });
var $03a97cfeae635a28$export$4400de2e7edcec7c = (e, t)=>()=>({
            path: "/flows",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$7f5b2d57e7eb4cc8 = (e, t)=>()=>({
            path: "/flows",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$d1304b216aaaddfd = (e, t)=>()=>({
            path: "/folders",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$b385cd416acc7fdd = (e, t)=>()=>({
            path: "/folders",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
function $03a97cfeae635a28$var$j(e) {
    return [
        "directus_access",
        "directus_activity",
        "directus_collections",
        "directus_comments",
        "directus_fields",
        "directus_files",
        "directus_folders",
        "directus_migrations",
        "directus_permissions",
        "directus_policies",
        "directus_presets",
        "directus_relations",
        "directus_revisions",
        "directus_roles",
        "directus_sessions",
        "directus_settings",
        "directus_users",
        "directus_webhooks",
        "directus_dashboards",
        "directus_panels",
        "directus_notifications",
        "directus_shares",
        "directus_flows",
        "directus_operations",
        "directus_translations",
        "directus_versions",
        "directus_extensions"
    ].includes(e);
}
var $03a97cfeae635a28$export$af56db357559c888 = (e, t, o)=>()=>{
        let a = String(e);
        if ($03a97cfeae635a28$var$j(a)) throw new Error("Cannot use createItems for core collections");
        return {
            path: `/items/${a}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "POST"
        };
    }, $03a97cfeae635a28$export$1f768fd5b3313118 = (e, t, o)=>()=>{
        let a = String(e);
        if ($03a97cfeae635a28$var$j(a)) throw new Error("Cannot use createItem for core collections");
        return {
            path: `/items/${a}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "POST"
        };
    };
var $03a97cfeae635a28$export$9baa1bac95edf573 = (e, t)=>()=>({
            path: "/notifications",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$9c8f6e8d39c60cf3 = (e, t)=>()=>({
            path: "/notifications",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$798e5748053a0ed9 = (e, t)=>()=>({
            path: "/operations",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$f29bedd62f56fcb2 = (e, t)=>()=>({
            path: "/operations",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$b958d79d7d7b6f61 = (e, t)=>()=>({
            path: "/panels",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$71ce2d4d67b6d9e4 = (e, t)=>()=>({
            path: "/panels",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$b6b064de078f296 = (e, t)=>()=>({
            path: "/permissions",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$18a6ba1ab6e30ce3 = (e, t)=>()=>({
            path: "/permissions",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$24c77b75c2091c0c = (e, t)=>()=>({
            path: "/policies",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$2c8215503a65bf53 = (e, t)=>()=>({
            path: "/policies",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$d94ca23f02b662aa = (e, t)=>()=>({
            path: "/presets",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$b956d067c5bcf6b = (e, t)=>()=>({
            path: "/presets",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$a159e78a5233f6d5 = (e)=>()=>({
            path: "/relations",
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$7e1811c2b24c5dc7 = (e, t)=>()=>({
            path: "/roles",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$9678a115f63a3512 = (e, t)=>()=>({
            path: "/roles",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$db094362415247da = (e, t)=>()=>({
            path: "/shares",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$1df9beb020e7b16b = (e, t)=>()=>({
            path: "/shares",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$f32ebad153facfaa = (e, t)=>()=>({
            path: "/translations",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$883995c7fd4b6dba = (e, t)=>()=>({
            path: "/translations",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$1b62b99291caca7c = (e, t)=>()=>({
            path: "/users",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$3493b8991d49f558 = (e, t)=>()=>({
            path: "/users",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$20912a824a8fdfb3 = (e, t)=>()=>({
            path: "/versions",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$46a32ae567720acd = (e, t)=>()=>({
            path: "/versions",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$b88c523063979268 = (e, t)=>()=>({
            path: "/webhooks",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $03a97cfeae635a28$export$c6ed5a0504098e37 = (e, t)=>()=>({
            path: "/webhooks",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $03a97cfeae635a28$export$3d16e031f6551662 = (e)=>()=>({
            path: `/collections/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$3bdd81914afda1ef = (e)=>{
    let t = (o, a = [])=>{
        if (typeof o == "object") {
            let s = [];
            for(let c in o){
                let i = o[c] ?? [];
                if (Array.isArray(i)) for (let p of i)s.push(t(p, [
                    ...a,
                    c
                ]));
                else if (typeof i == "object") for (let p of Object.keys(i)){
                    let u = i[p];
                    for (let f of u)s.push(t(f, [
                        ...a,
                        `${c}:${p}`
                    ]));
                }
            }
            return s.flatMap((c)=>c);
        }
        return [
            ...a,
            String(o)
        ].join(".");
    };
    return e.flatMap((o)=>t(o));
}, $03a97cfeae635a28$export$9f72cc599b0bf53 = (e)=>{
    let t = {};
    Array.isArray(e.fields) && e.fields.length > 0 && (t.fields = $03a97cfeae635a28$export$3bdd81914afda1ef(e.fields).join(",")), e.filter && Object.keys(e.filter).length > 0 && (t.filter = JSON.stringify(e.filter)), e.search && (t.search = e.search), "sort" in e && e.sort && (t.sort = typeof e.sort == "string" ? e.sort : e.sort.join(",")), typeof e.limit == "number" && e.limit >= -1 && (t.limit = String(e.limit)), typeof e.offset == "number" && e.offset >= 0 && (t.offset = String(e.offset)), typeof e.page == "number" && e.page >= 1 && (t.page = String(e.page)), e.deep && Object.keys(e.deep).length > 0 && (t.deep = JSON.stringify(e.deep)), e.alias && Object.keys(e.alias).length > 0 && (t.alias = JSON.stringify(e.alias)), e.aggregate && Object.keys(e.aggregate).length > 0 && (t.aggregate = JSON.stringify(e.aggregate)), e.groupBy && e.groupBy.length > 0 && (t.groupBy = e.groupBy.join(","));
    for (let [o, a] of Object.entries(e))o in t || (typeof a == "string" || typeof a == "number" || typeof a == "boolean" ? t[o] = String(a) : t[o] = JSON.stringify(a));
    return t;
};
var $03a97cfeae635a28$export$c8ea5e9f84346833 = (e, t)=>{
    if (e.length === 0) throw new Error(t);
};
var $03a97cfeae635a28$export$325fa311b6904a3e = (e, t)=>{
    if ($03a97cfeae635a28$var$j(String(e))) throw new Error(t);
};
var $03a97cfeae635a28$export$16bf88f40abcfa4b = (e)=>()=>{
        let t = {};
        return Array.isArray(e) ? ($03a97cfeae635a28$export$c8ea5e9f84346833(e, "keysOrQuery cannot be empty"), t = {
            keys: e
        }) : ($03a97cfeae635a28$export$c8ea5e9f84346833(Object.keys(e), "keysOrQuery cannot be empty"), t = {
            query: e
        }), {
            path: "/comments",
            body: JSON.stringify(t),
            method: "DELETE"
        };
    }, $03a97cfeae635a28$export$2e6e3ad634e3776 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/comments/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$445e4e54f220f197 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/dashboards",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$794471fec7cce9b7 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/dashboards/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$2bbad96c62fdba3e = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Collection cannot be empty"), $03a97cfeae635a28$export$c8ea5e9f84346833(t, "Field cannot be empty"), {
            path: `/fields/${e}/${t}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$d5d18797070b684f = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/files",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$dccb98b97a3cb8be = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/files/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$ce8eb53a3b42d13f = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/flows",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$cd28db42dd4d115b = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/flows/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$5d771c96f71348b1 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/folders",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$b2b7d6e359abed26 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/folders/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$eb988beca99de9d6 = (e, t)=>()=>{
        let o = {};
        return $03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $03a97cfeae635a28$export$325fa311b6904a3e(e, "Cannot use deleteItems for core collections"), Array.isArray(t) ? ($03a97cfeae635a28$export$c8ea5e9f84346833(t, "keysOrQuery cannot be empty"), o = {
            keys: t
        }) : ($03a97cfeae635a28$export$c8ea5e9f84346833(Object.keys(t), "keysOrQuery cannot be empty"), o = {
            query: t
        }), {
            path: `/items/${e}`,
            body: JSON.stringify(o),
            method: "DELETE"
        };
    }, $03a97cfeae635a28$export$8d8542dbbc23fe1a = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $03a97cfeae635a28$export$325fa311b6904a3e(e, "Cannot use deleteItem for core collections"), $03a97cfeae635a28$export$c8ea5e9f84346833(String(t), "Key cannot be empty"), {
            path: `/items/${e}/${t}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$15471b882705b3b5 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/notifications",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$921a032020d7fa9d = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/notifications/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$b07054d85c60e66d = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/operations",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$b8c2adade071dc6c = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/operations/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$4210f6e285c76393 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/panels",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$deb6901f3e6044a0 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/panels/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$3ee9c75cf06721e7 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/permissions",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$8676cf9296cb5cfa = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/permissions/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$169b0ca9f2d8737b = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/policies",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$d22640c3c0963305 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/policies/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$137997f4e1216209 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/presets",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$f6f31fb6da61ffc6 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/presets/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$16e56e18d1cf5c3c = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Collection cannot be empty"), $03a97cfeae635a28$export$c8ea5e9f84346833(t, "Field cannot be empty"), {
            path: `/relations/${e}/${t}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$701d2b595a570390 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/roles",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$a7396bae498de6f1 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/roles/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$64e78a733483102d = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/shares",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$a27010536c35429f = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/shares/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$22362e8004ffb5c2 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/translations",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$9f7b6bc89a79a3e8 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/translations/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$c89e44cbc145e361 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/users",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$7d0f10f273c0438a = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/users/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$b81ddf8da23a0767 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/versions",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$6f86304d8439c37c = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/versions/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$b634378700de9adc = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/webhooks",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $03a97cfeae635a28$export$273c5791092616a1 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/webhooks/${e}`,
            method: "DELETE"
        });
var $03a97cfeae635a28$export$6475104154d58eed = (e)=>()=>({
            path: "/activity",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$2920dda248384b69 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/activity/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$258f7bf0e3a9da18 = (e, t)=>()=>{
        let o = String(e);
        return $03a97cfeae635a28$export$c8ea5e9f84346833(o, "Collection cannot be empty"), {
            path: $03a97cfeae635a28$var$j(o) ? `/${o.substring(9)}` : `/items/${o}`,
            method: "GET",
            params: {
                ...t.query ?? {},
                ...t.groupBy ? {
                    groupBy: t.groupBy
                } : {},
                aggregate: t.aggregate
            }
        };
    };
var $03a97cfeae635a28$export$f19984c2c49eb871 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/assets/${e}`,
            params: t ?? {},
            method: "GET",
            onResponse: (o)=>o.body
        }), $03a97cfeae635a28$export$251e0afed2252738 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/assets/${e}`,
            params: t ?? {},
            method: "GET",
            onResponse: (o)=>o.blob()
        }), $03a97cfeae635a28$export$5dd82d346ce3741c = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/assets/${e}`,
            params: t ?? {},
            method: "GET",
            onResponse: (o)=>o.arrayBuffer()
        });
var $03a97cfeae635a28$export$db7a999e1995428 = ()=>()=>({
            path: "/collections",
            method: "GET"
        }), $03a97cfeae635a28$export$e130c7ba0494558f = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Collection cannot be empty"), {
            path: `/collections/${e}`,
            method: "GET"
        });
var $03a97cfeae635a28$export$f95224e1817818db = (e)=>()=>({
            path: "/comments",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$480f99f4deada6f = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/comments/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$2675a27295bd1465 = (e)=>()=>({
            path: "/dashboards",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$cd0238957d0994ef = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/dashboards/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$1d217418e0e17831 = ()=>()=>({
            path: "/extensions/",
            method: "GET"
        });
var $03a97cfeae635a28$export$5f7d4498f5d85591 = ()=>()=>({
            path: "/fields",
            method: "GET"
        }), $03a97cfeae635a28$export$e248065a94378cfc = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Collection cannot be empty"), {
            path: `/fields/${e}`,
            method: "GET"
        }), $03a97cfeae635a28$export$382f22472809782a = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Collection cannot be empty"), $03a97cfeae635a28$export$c8ea5e9f84346833(t, "Field cannot be empty"), {
            path: `/fields/${e}/${t}`,
            method: "GET"
        });
var $03a97cfeae635a28$export$68814c6bac157c56 = (e)=>()=>({
            path: "/files",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$72c04af63de9061a = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/files/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$99f56cec798c3864 = (e)=>()=>({
            path: "/flows",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$ac312892a8dd4618 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/flows/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$1743e20a066bc8f4 = (e)=>()=>({
            path: "/folders",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$a1bf3619deefbb5f = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/folders/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$dc1ffac156057709 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $03a97cfeae635a28$export$325fa311b6904a3e(e, "Cannot use readItems for core collections"), {
            path: `/items/${e}`,
            params: t ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$5ccb2a3b476b2cd3 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $03a97cfeae635a28$export$325fa311b6904a3e(e, "Cannot use readItem for core collections"), $03a97cfeae635a28$export$c8ea5e9f84346833(String(t), "Key cannot be empty"), {
            path: `/items/${e}/${t}`,
            params: o ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$81100ddd061ed17a = (e)=>()=>({
            path: "/notifications",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$bdda8f9364ec9548 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/notifications/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$936f8732910c544a = (e)=>()=>({
            path: "/operations",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$377a225cfe5ebfeb = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/operations/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$813f0d558145d14d = (e)=>()=>({
            path: "/panels",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$2e10da30e4920419 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/panels/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$721293565320f0e = (e)=>()=>({
            path: "/permissions",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$c809f605aa3f36fc = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/permissions/${e}`,
            params: t ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$876e8a52766492f0 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), {
            path: `/permissions/me/${t ? `${e}/${t}` : `${e}`}`,
            method: "GET"
        }), $03a97cfeae635a28$export$13ae9459dbfdef2a = ()=>()=>({
            path: "/permissions/me",
            method: "GET"
        });
var $03a97cfeae635a28$export$7997293f55506dda = (e)=>()=>({
            path: "/policies",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$5343d69b8f53b190 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/policies/${e}`,
            params: t ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$7e66383fe090edc6 = ()=>()=>({
            path: "/policies/me/globals",
            method: "GET"
        });
var $03a97cfeae635a28$export$2d189bdbe254aac6 = (e)=>()=>({
            path: "/presets",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$874f998aa0fa5091 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/presets/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$8d5961895b8dcfc7 = ()=>()=>({
            path: "/relations",
            method: "GET"
        }), $03a97cfeae635a28$export$c4fa342b35c497d0 = (e)=>()=>({
            path: `/relations/${e}`,
            method: "GET"
        }), $03a97cfeae635a28$export$daed7da094b8588e = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Collection cannot be empty"), $03a97cfeae635a28$export$c8ea5e9f84346833(t, "Field cannot be empty"), {
            path: `/relations/${e}/${t}`,
            method: "GET"
        });
var $03a97cfeae635a28$export$88d629fad7ac0485 = (e)=>()=>({
            path: "/revisions",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$ce478fdb2b09ea35 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/revisions/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$577f2e3cc5fb778d = (e)=>()=>({
            path: "/roles",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$dc29cc801582329f = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/roles/${e}`,
            params: t ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$d37f20adccfd68fd = (e)=>()=>({
            path: "/roles/me",
            params: e ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$9e99187ea2f61e6d = (e)=>()=>({
            path: "/settings",
            params: e ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$9f1feac81b77afb6 = (e)=>()=>({
            path: "/shares",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$c64af3887efacee = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/shares/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$2cefaf6e917f5b26 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $03a97cfeae635a28$export$325fa311b6904a3e(e, "Cannot use readSingleton for core collections"), {
            path: `/items/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$db2e52950db3187d = (e)=>()=>({
            path: "/translations",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$c7a36405c49d706a = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/translations/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$6bceb4096e4dd906 = (e)=>()=>({
            path: "/users",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$eaefaacc687c1c9a = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/users/${e}`,
            params: t ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$3486c7160223313e = (e)=>()=>({
            path: "/users/me",
            params: e ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$1e3bddd4e9a89ec9 = (e)=>()=>({
            path: "/versions",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$c554451349586164 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/versions/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$d4a4edd8aaeaa4d8 = (e)=>()=>({
            path: "/webhooks",
            params: e ?? {},
            method: "GET"
        }), $03a97cfeae635a28$export$16c5269970cedd3d = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/webhooks/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $03a97cfeae635a28$export$3aff0b2867912504 = (e)=>()=>({
            method: "POST",
            path: "/schema/apply",
            body: JSON.stringify(e)
        });
var $03a97cfeae635a28$export$91cf0c2974056a76 = (e, t = !1)=>()=>({
            method: "POST",
            path: "/schema/diff",
            params: t ? {
                force: t
            } : {},
            body: JSON.stringify(e)
        });
var $03a97cfeae635a28$export$9b097c2fb1bc498 = ()=>()=>({
            method: "GET",
            path: "/schema/snapshot"
        });
var $03a97cfeae635a28$export$2f9c2c3afcf9e94d = (e = "item")=>()=>({
            method: "GET",
            path: e === "item" ? "/server/specs/graphql" : "/server/specs/graphql/system"
        });
var $03a97cfeae635a28$export$55d0404a1e43e217 = ()=>()=>({
            method: "GET",
            path: "/server/health"
        });
var $03a97cfeae635a28$export$7c757dcc6e8e1fc4 = ()=>()=>({
            method: "GET",
            path: "/server/info"
        });
var $03a97cfeae635a28$export$f6eb17377015b310 = ()=>()=>({
            method: "GET",
            path: "/server/specs/oas"
        });
var $03a97cfeae635a28$export$d8d419c14af76fcc = ()=>()=>({
            method: "GET",
            path: "/server/ping"
        });
var $03a97cfeae635a28$export$c0683150b517c317 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Collection cannot be empty"), {
            path: `/collections/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        }), $03a97cfeae635a28$export$a58d51c29096d667 = (e, t)=>()=>({
            path: "/collections",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$2f7e4fbf4e0dafbf = (e, t, o)=>()=>{
        let a = {};
        return Array.isArray(e) ? ($03a97cfeae635a28$export$c8ea5e9f84346833(e, "keysOrQuery cannot be empty"), a = {
            keys: e
        }) : ($03a97cfeae635a28$export$c8ea5e9f84346833(Object.keys(e), "keysOrQuery cannot be empty"), a = {
            query: e
        }), a.data = t, {
            path: "/comments",
            params: o ?? {},
            body: JSON.stringify(a),
            method: "PATCH"
        };
    }, $03a97cfeae635a28$export$5a1cd239009d83a6 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/comments/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$4c2b085fa39ccde6 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/dashboards",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$13581fc439527494 = (e, t)=>()=>({
            path: "/dashboards",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$8a2c60458ca4e242 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/dashboards/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$7c8eb78c790b86b1 = (e, t, o)=>()=>(e !== null && $03a97cfeae635a28$export$c8ea5e9f84346833(e, "Bundle cannot be an empty string"), $03a97cfeae635a28$export$c8ea5e9f84346833(t, "Name cannot be empty"), {
            path: e ? `/extensions/${e}/${t}` : `/extensions/${t}`,
            params: {},
            body: JSON.stringify(o),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$792a18290d173848 = (e, t, o, a)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), $03a97cfeae635a28$export$c8ea5e9f84346833(t, "Field cannot be empty"), {
            path: `/fields/${e}/${t}`,
            params: a ?? {},
            body: JSON.stringify(o),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$88bd792628f814eb = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/files",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$8b6d03d2a160ddb7 = (e, t)=>()=>({
            path: "/files",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$4730664ce047e3bc = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), t instanceof FormData ? {
            path: `/files/${e}`,
            params: o ?? {},
            body: t,
            method: "PATCH",
            headers: {
                "Content-Type": "multipart/form-data"
            }
        } : {
            path: `/files/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$f3d46153a3c4119e = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/flows",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$58f6df7d125575a7 = (e, t)=>()=>({
            path: "/flows",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$f1fc4ca98fea70bb = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/flows/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$11cb17c3bee81c86 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/folders",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$5d91c0fb17620b0e = (e, t)=>()=>({
            path: "/folders",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$2554d0ab4f8435c7 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/folders/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$c7d78f87941eb2fc = (e, t, o, a)=>()=>{
        let s = {};
        return $03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $03a97cfeae635a28$export$325fa311b6904a3e(e, "Cannot use updateItems for core collections"), Array.isArray(t) ? ($03a97cfeae635a28$export$c8ea5e9f84346833(t, "keysOrQuery cannot be empty"), s = {
            keys: t
        }) : ($03a97cfeae635a28$export$c8ea5e9f84346833(Object.keys(t), "keysOrQuery cannot be empty"), s = {
            query: t
        }), s.data = o, {
            path: `/items/${e}`,
            params: a ?? {},
            body: JSON.stringify(s),
            method: "PATCH"
        };
    }, $03a97cfeae635a28$export$a6a7c2deef0e48f = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $03a97cfeae635a28$export$325fa311b6904a3e(e, "Cannot use updateItems for core collections"), {
            path: `/items/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        }), $03a97cfeae635a28$export$72b8c6d38aa6195b = (e, t, o, a)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(t), "Key cannot be empty"), $03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $03a97cfeae635a28$export$325fa311b6904a3e(e, "Cannot use updateItem for core collections"), {
            path: `/items/${e}/${t}`,
            params: a ?? {},
            body: JSON.stringify(o),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$7ef44197c3760235 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/notifications",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$9846d50bc583a499 = (e, t)=>()=>({
            path: "/notifications",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$31ce28e5754d2c6a = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/notifications/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$6f9af0e14927ba5a = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/operations",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$4aa7e168dfaefb6 = (e, t)=>()=>({
            path: "/operations",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$325ee5fecc354190 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/operations/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$5839273119d35dea = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/panels",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$1bdce16ee060f4ea = (e, t)=>()=>({
            path: "/panels",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$48868c133243b4bb = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/panels/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$9b78c18c532ff910 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/permissions",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$3eb6ade7aff4acd0 = (e, t)=>()=>({
            path: "/permissions",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$fd6f7bcb1f904b27 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/permissions/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$d6522db2915e7476 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/policies",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$9a113fac738748cc = (e, t)=>()=>({
            path: "/policies",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$8880afb5a79db59f = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/policies/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$2356f1473e0729ff = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/presets",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$f42aeae9a26cbeeb = (e, t)=>()=>({
            path: "/presets",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$85844243b13ae530 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/presets/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$dc49f0fb1fc1899 = (e, t, o, a)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Collection cannot be empty"), $03a97cfeae635a28$export$c8ea5e9f84346833(t, "Field cannot be empty"), {
            path: `/relations/${e}/${t}`,
            params: a ?? {},
            body: JSON.stringify(o),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$d87af07da5a07efb = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/roles",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$1344a5099ea32106 = (e, t)=>()=>({
            path: "/roles",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$c37c5570c259cd71 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/roles/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$f558026a994b6051 = (e, t)=>()=>({
            path: "/settings",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$1f8f3b884abf7db0 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/shares",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$e6d4085361ee0e92 = (e, t)=>()=>({
            path: "/shares",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$18127db3286b73a9 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/shares/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$9c933e1ead9ec945 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $03a97cfeae635a28$export$325fa311b6904a3e(e, "Cannot use updateSingleton for core collections"), {
            path: `/items/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$676ff478edc2cd7f = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/translations",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$677b96e2655c71 = (e, t)=>()=>({
            path: "/translations",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$252cf2d742c72de9 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/translations/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$5946676442d8ccf7 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/users",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$6dfadd46b153dc6b = (e, t)=>()=>({
            path: "/users",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$e3ac7a5d19605772 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/users/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        }), $03a97cfeae635a28$export$8ddaddf355aae59c = (e, t)=>()=>({
            path: "/users/me",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$2a47cec55cebf1e4 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/versions",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$f4fdeab4ab3de927 = (e, t)=>()=>({
            path: "/versions",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        }), $03a97cfeae635a28$export$e74be6490148ac63 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/versions/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$880ae857f284902c = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/webhooks",
            params: o ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $03a97cfeae635a28$export$641059283e9ab515 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/webhooks/${e}`,
            params: o ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $03a97cfeae635a28$export$d2adf65b87e47523 = ()=>(e = !1)=>({
            method: "POST",
            path: `/utils/cache/clear${e ? "?system" : ""}`
        });
var $03a97cfeae635a28$export$b1d7f171ae44db2f = (e, t, o, a)=>()=>({
            method: "POST",
            path: `/utils/export/${e}`,
            body: JSON.stringify({
                format: t,
                query: o,
                file: a
            })
        });
var $03a97cfeae635a28$export$1bcee6330b05af2a = (e, t, o)=>()=>e === "GET" ? {
            path: `/flows/trigger/${t}`,
            params: o ?? {},
            method: "GET"
        } : {
            path: `/flows/trigger/${t}`,
            body: JSON.stringify(o ?? {}),
            method: "POST"
        };
var $03a97cfeae635a28$export$daf4c137c5f56404 = (e)=>()=>({
            method: "POST",
            path: "/utils/hash/generate",
            body: JSON.stringify({
                string: e
            })
        }), $03a97cfeae635a28$export$434ee6408013d7f2 = (e, t)=>()=>({
            method: "POST",
            path: "/utils/hash/verify",
            body: JSON.stringify({
                string: e,
                hash: t
            })
        });
var $03a97cfeae635a28$export$f4cb417afd8211e5 = (e, t)=>()=>({
            path: `/utils/import/${e}`,
            method: "POST",
            body: t,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
var $03a97cfeae635a28$export$da7e0b54b743b0a0 = (e, t, o = "cookie")=>()=>({
            path: "/shares/auth",
            method: "POST",
            body: JSON.stringify({
                share: e,
                password: t,
                mode: o
            })
        }), $03a97cfeae635a28$export$ff17cf2336ca5253 = (e, t)=>()=>({
            path: "/shares/invite",
            method: "POST",
            body: JSON.stringify({
                share: e,
                emails: t
            })
        }), $03a97cfeae635a28$export$deef9315be003768 = (e)=>()=>({
            path: `/shares/info/${e}`,
            method: "GET"
        });
var $03a97cfeae635a28$export$28ecda779a9bc995 = (e, t, o)=>()=>({
            method: "POST",
            path: `/utils/sort/${e}`,
            body: JSON.stringify({
                item: t,
                to: o
            })
        });
var $03a97cfeae635a28$export$f5ec01bd6261fcdd = (e, t, o)=>()=>({
            path: "/users/invite",
            method: "POST",
            body: JSON.stringify({
                email: e,
                role: t,
                ...o ? {
                    invite_url: o
                } : {}
            })
        }), $03a97cfeae635a28$export$62f88f7ee3ce3263 = (e, t)=>()=>({
            path: "/users/invite/accept",
            method: "POST",
            body: JSON.stringify({
                token: e,
                password: t
            })
        }), $03a97cfeae635a28$export$16015adca85344a = (e, t, o = {})=>()=>({
            path: "/users/register",
            method: "POST",
            body: JSON.stringify({
                email: e,
                password: t,
                ...o
            })
        }), $03a97cfeae635a28$export$279c5f32650688e0 = (e)=>()=>({
            path: "/users/register/verify-email",
            params: {
                token: e
            },
            method: "GET"
        }), $03a97cfeae635a28$export$775267aca7ccdf99 = (e)=>()=>({
            path: "/users/me/tfa/generate",
            method: "POST",
            body: JSON.stringify({
                password: e
            })
        }), $03a97cfeae635a28$export$9fe5fe9229d48aa3 = (e, t)=>()=>({
            path: "/users/me/tfa/enable",
            method: "POST",
            body: JSON.stringify({
                secret: e,
                otp: t
            })
        }), $03a97cfeae635a28$export$5441625492178b0a = (e)=>()=>({
            path: "/users/me/tfa/disable",
            method: "POST",
            body: JSON.stringify({
                otp: e
            })
        });
var $03a97cfeae635a28$export$96ef93abfeef2ab2 = (e, t)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "ID cannot be empty"), {
            path: `/versions/${e}/save`,
            method: "POST",
            body: JSON.stringify(t)
        }), $03a97cfeae635a28$export$d84892fd77e1c33 = (e)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "ID cannot be empty"), {
            path: `/versions/${e}/compare`,
            method: "GET"
        }), $03a97cfeae635a28$export$587acce1566fb354 = (e, t, o)=>()=>($03a97cfeae635a28$export$c8ea5e9f84346833(e, "ID cannot be empty"), {
            path: `/versions/${e}/promote`,
            method: "POST",
            body: JSON.stringify(o ? {
                mainHash: t,
                fields: o
            } : {
                mainHash: t
            })
        });
var $03a97cfeae635a28$export$7fa8378418b4411e = (e)=>()=>({
            method: "GET",
            path: "/utils/random/string",
            params: e !== void 0 ? {
                length: e
            } : {}
        });
var $03a97cfeae635a28$var$B = {}, $03a97cfeae635a28$export$c58417706a208278 = (e = {})=>(t)=>{
        let o = {
            ...$03a97cfeae635a28$var$B,
            ...e
        };
        return {
            async request (a) {
                let s = a();
                if (s.headers || (s.headers = {}), "Content-Type" in s.headers ? s.headers["Content-Type"] === "multipart/form-data" && delete s.headers["Content-Type"] : s.headers["Content-Type"] = "application/json", "getToken" in this && !("Authorization" in s.headers)) {
                    let u = await this.getToken();
                    u && (s.headers.Authorization = `Bearer ${u}`);
                }
                let c = $03a97cfeae635a28$var$g(t.url, s.path, s.params), i = {
                    method: s.method ?? "GET",
                    headers: s.headers ?? {}
                };
                "credentials" in o && (i.credentials = o.credentials), s.body && (i.body = s.body), s.onRequest && (i = await s.onRequest(i)), o.onRequest && (i = await o.onRequest(i));
                let p = await $03a97cfeae635a28$var$b(c.toString(), i, t.globals.fetch);
                return "onResponse" in s && (p = await s.onResponse(p, i)), "onResponse" in e && (p = await e.onResponse(p, i)), p;
            }
        };
    };
function $03a97cfeae635a28$export$69e91e91eb5321f7(e, t) {
    return ()=>{
        let o = e();
        return typeof t == "function" ? o.onRequest = t : o.onRequest = (a)=>({
                ...a,
                ...t
            }), o;
    };
}
function $03a97cfeae635a28$export$efa806de37a4221d(e) {
    return ()=>{
        let t = e();
        return t.method === "GET" && t.params && (t.method = "SEARCH", t.body = JSON.stringify({
            query: {
                ...t.params,
                fields: $03a97cfeae635a28$export$3bdd81914afda1ef(t.params.fields ?? [])
            }
        }), delete t.params), t;
    };
}
function $03a97cfeae635a28$export$f6f0dceccdb6a70d(e, t) {
    return ()=>{
        let o = t();
        return e && (o.headers || (o.headers = {}), o.headers.Authorization = `Bearer ${e}`), o;
    };
}
function $03a97cfeae635a28$export$490486aaefb17d5b(e) {
    return ()=>e;
}
function $03a97cfeae635a28$export$22bb195087a542d8(e) {
    return typeof e == "object" && e !== null && "errors" in e && Array.isArray(e.errors) && "message" in e.errors[0] && "extensions" in e.errors[0] && "code" in e.errors[0].extensions;
}

});


parcelRegister("aY6HT", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdad25ebaf567a82$export$2e2bcd8739ae039);
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $cdad25ebaf567a82$export$2e2bcd8739ae039 = (0, $4jdI8.css)`
  :host {
    --color-primary: #a3151a;
    --color-highlight: #95C4D9;
    --color-grey: #C1CFD7;
    --color-secondary: #14173F;
    --color-white: white;
    --color-black: black;
    --color-success: #5cb85c;
    --content-padding: 10%;
    --font-size-s: 16px;
    --font-size-m: 20px;
    --font-size-l: 28px;
    --font-size-xl: 60px;
    --header-size: 400px;
    --gutter-s: 16px;
    --gutter-m: 32px;
    --breakpoint-medium: 768px;
    --breakpoint-large: 1024px;
    --max-content: 1200px;
  }
  * {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px;
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    color: var(--color-primary);
    text-transform: uppercase;
    font-weight: normal;
  }
  h3 {
    font-size: var(--font-size-m);
    color: black;
  }
  h2 {
    font-size: var(--font-size-l);
  }
  h1 {
    font-size: var(--font-size-xl);
  }
  input,
  textarea {
    padding: 16px;
    background-color: var(--color-grey);
    border: none;
  }
  input:focus,
  textarea:focus {
    outline-color: var(--color-primary);
  }
  button {
    border: none;
    padding: 16px;
    max-width: max-content;
    background-color: var(--color-primary);
    color: var(--color-white);
    opacity: 1;
    cursor: pointer;
    text-transform: uppercase;
    &:hover {
      font-weight: bold;
    }
  }
  a {
    text-underline-offset: 2px;
    color: var(--color-primary);
    width: max-content;
    &:hover {
      background-color: var(--color-primary);
      color: white;
    }
  }
  @media screen and (max-width: 480px) {
    //variables for mobile

  }
  @media screen and (max-width: 1440px) {
    :host {
      --header-size: auto;
      --gutter-s: 8px;
      --gutter-m: 16px;
      --font-size-l: 1.5rem;
      --font-size-xl: 3rem;
      --content-padding: 16px;
    }
  }
`;

});


parcelRegister("2dqH9", function(module, exports) {
// menu-component.ts

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
var $fmLyg = parcelRequire("fmLyg");
var $9Jyha = parcelRequire("9Jyha");
parcelRequire("etiln");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("lmk8H");
var $1eqYq = parcelRequire("1eqYq");

var $b34iv = parcelRequire("b34iv");

var $AaEa3 = parcelRequire("AaEa3");
parcelRequire("7Mxfe");
class $c248ece120ed3ad9$export$a6edb1992047cc25 extends (0, $27Ysw.DefaultComponent) {
    static get componentStyles() {
        return (0, $4jdI8.css)`
      /* Keyframes for the slide-down and fade-in effect */
      @keyframes slideDownFadeIn {
        from {
          opacity: 0;
          transform: translateY(
            -20px
          ); /* Start 20 pixels above its final position */
        }
        to {
          opacity: 1;
          transform: translateY(0); /* End at its final position */
        }
      }

      .menu {
        list-style: none;
        display: flex;
        gap: 32px;
        padding: 8px;
        background-color: var(--color-primary);
        & .main-link::after {
          content: none;
        }
        & li,
        a {
          font-size: var(--font-size-l);
          text-decoration: none;
          color: white;
          cursor: pointer;
          text-transform: uppercase;
          font-weight: normal;
          padding: 0;
          &.selected {
            text-decoration: underline;
            text-underline-offset: 4px;
          }
        }
        & .submenu {
          position: absolute;
          background-color: var(--color-primary);
          padding: 16px;
          opacity: 0; /* Start from invisible */
          animation: slideDownFadeIn 0.2s ease-out forwards; /* Apply the animation */
        }
      }
      @media screen and (max-width: 1440px) {
        .menu {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: var(--color-primary);
          display: flex;
          flex-direction: column;
          justify-content: center;      /* vertical centering */
          align-items: center;          /* horizontal centering */
          overflow-y: auto;             /* allow vertical scroll if needed */
          max-height: 100vh;            /* ensure does not exceed viewport */
          opacity: 0;
          visibility: hidden;
          z-index: 1000;
          transition: opacity 0.5s, visibility 0s linear 0.5s; /* delay visibility change */
          & .submenu {
            position: unset;
          }
        }
        /* Open state for the menu */
        .menu.open {
          opacity: 1;
          visibility: visible;
          transition: opacity 0.5s;
          margin-top: 0;
          height: 100%;
        }
        .hamburger-menu {
          display: flex;
          flex-direction: column;
          gap: 8px;
          z-index: 2000;
          position: fixed;
          top: 16px;
          right: 16px;
          & div {
            width: 40px;
            height: 4px;
            background-color: white;
          }
        }
        .desktop-lang {
          display: none !important;
        }
        .mobile-lang {
          display: block !important;
          padding: 10px;
          position: fixed;
          top: 0;
          left: 0;
        }
      }
      @media screen and (min-width: 1440px) {
        .menu {
          display: flex;
        }
        .hamburger-menu {
          display: none;
        }
        .mobile-lang {
          display: none !important;
        }
        .desktop-lang {
          display: block !important;
          position: absolute;
          top: 0;
          right: -10vw;
        }
      }
    `;
    }
    async afterComponentInitialized() {
        document.addEventListener("click", (e)=>{
            if (this.menuItems.some((i)=>i.submenuVisible)) this.menuItems = this.menuItems.map((i)=>i.submenuVisible ? {
                    ...i,
                    submenuVisible: false
                } : i);
        });
        await this.fetchCities();
        this.isInitialised = true;
    }
    render() {
        return this.isInitialised ? (0, $jJTNo.html)`
          <menu
            class="menu"
            class="${(0, $1eqYq.classMap)({
            open: this.isMenuOpen,
            menu: true
        })}"
          >
          ${this.menuItems.map((item)=>item.submenu ? this.renderMenuItemWithSubmenu(item) : (0, $jJTNo.html)`<a class="main-link" href="${item.link}"
                  >${this.t(item.translationKey)}</a
                >`)}
            <bnn-language-selector class="mobile-lang" .darkMode=${true}></bnn-language-selector>
          </menu>
          <bnn-language-selector class="desktop-lang"></bnn-language-selector>
          <button
            class="hamburger-menu"
            @click="${()=>this.isMenuOpen = !this.isMenuOpen}"
          >
            <div></div>
            <div></div>
            <div></div>
          </button>
        ` : ``;
    }
    renderMenuItemWithSubmenu(item) {
        return (0, $jJTNo.html)`
      <li
        @click="${(e)=>this.toggleSubMenu(item, e)}"
        class="${(0, $1eqYq.classMap)({
            selected: this.isCityItemSelected(item)
        })}"
      >
        ${this.t(item.translationKey)}
        ${item.submenu && item.submenuVisible ? (0, $jJTNo.html)`
              <div class="submenu">
                ${item.submenuSlotName === "bnn-city-selector" ? (0, $jJTNo.html)`<bnn-city-selector
                      .country="${item.key}"
                      .cities="${this.cities}"
                    ></bnn-city-selector>` : (0, $jJTNo.html)`<slot name="${item.submenuSlotName}"></slot>`}
              </div>
            ` : ""}
      </li>
    `;
    }
    toggleSubMenu(item, e) {
        //Important so menu doesn't get closed immediately
        e.preventDefault();
        e.stopPropagation();
        this.menuItems = this.menuItems.map((i)=>i === item ? {
                ...i,
                submenuVisible: !i.submenuVisible
            } : {
                ...i,
                submenuVisible: false
            });
    }
    async fetchCities() {
        this.cityService = new (0, $b34iv.CityService)(this.config);
        try {
            const cities = await this.cityService.getCities();
            this.cities = cities;
            this.requestUpdate();
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    }
    isCityItemSelected(item) {
        const selected = window.location.href.includes(item.urlParam);
        return selected && this.cities.find((c)=>c.id === (0, $AaEa3.getCurrentCity)())?.country === item.key;
    }
    constructor(...args){
        super(...args), this.menuItems = [
            {
                translationKey: "home",
                submenu: false,
                link: "/"
            },
            {
                translationKey: "swiss_cities",
                submenu: true,
                submenuSlotName: "bnn-city-selector",
                key: "ch",
                submenuVisible: false,
                urlParam: "city"
            },
            {
                translationKey: "german_cities",
                submenu: true,
                submenuSlotName: "bnn-city-selector",
                key: "de",
                submenuVisible: false,
                urlParam: "city"
            }
        ], this.cities = [], this.isMenuOpen = false, this.isInitialised = false;
    }
}
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)({
        type: Array
    })
], $c248ece120ed3ad9$export$a6edb1992047cc25.prototype, "menuItems", void 0);
(0, $7WQrb.__decorate)([
    (0, $9Jyha.state)()
], $c248ece120ed3ad9$export$a6edb1992047cc25.prototype, "cities", void 0);
(0, $7WQrb.__decorate)([
    (0, $9Jyha.state)()
], $c248ece120ed3ad9$export$a6edb1992047cc25.prototype, "isMenuOpen", void 0);
(0, $7WQrb.__decorate)([
    (0, $9Jyha.state)()
], $c248ece120ed3ad9$export$a6edb1992047cc25.prototype, "isInitialised", void 0);
$c248ece120ed3ad9$export$a6edb1992047cc25 = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-nav-menu")
], $c248ece120ed3ad9$export$a6edb1992047cc25);

});
parcelRegister("etiln", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
var $fmLyg = parcelRequire("fmLyg");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("lmk8H");
var $1eqYq = parcelRequire("1eqYq");
class $74044a621ea30391$export$71675c9cb84a42a2 extends (0, $27Ysw.DefaultComponent) {
    static get componentStyles() {
        return (0, $4jdI8.css)`
      @media screen and (max-width: 480px) {
        nav {
          align-items: center;
        }
      }
      nav {
        display: flex;
        flex-direction: column;
        font-size: 1.5em;
        gap: 8px;
        & a {
          text-decoration: none;
          color: white;
          font-size: var(--font-size-m);
          font-weight: normal;
          padding: 0;
          &::after {
            content: none;
          }
          &.selected {
            text-decoration: underline;
            text-underline-offset: 4px;
          }
        }
      }
    `;
    }
    render() {
        return (0, $jJTNo.html)`
      <nav>
        ${this.cities.filter((c)=>c.country === this.country).map((city)=>(0, $jJTNo.html)`<a
                class="${(0, $1eqYq.classMap)({
                selected: this.getCurrentCity() === city.id
            })}"
                href="${`/city/${city.domainname?.toLowerCase()}`}"
                @click="${(e)=>e.stopPropagation()}"
                >${city.name}</a
              >`)}
      </nav>
    `;
    }
    getCurrentCity() {
        const currentUrl = window.location.href;
        const parsedUrl = new URL(currentUrl);
        const pathSegments = parsedUrl.pathname.split("/");
        const lastPart = pathSegments.filter((segment)=>segment !== "").pop();
        return Number(lastPart);
    }
    constructor(...args){
        super(...args), this.cities = [], this.country = "ch";
    }
}
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)()
], $74044a621ea30391$export$71675c9cb84a42a2.prototype, "cities", void 0);
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)()
], $74044a621ea30391$export$71675c9cb84a42a2.prototype, "country", void 0);
$74044a621ea30391$export$71675c9cb84a42a2 = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-city-selector")
], $74044a621ea30391$export$71675c9cb84a42a2);

});
parcelRegister("lmk8H", function(module, exports) {
$parcel$export(module.exports, "classMap", () => (parcelRequire("1eqYq")).classMap);
parcelRequire("1eqYq");

});
parcelRegister("1eqYq", function(module, exports) {

$parcel$export(module.exports, "classMap", () => $0e5c059fc79abe53$export$56cc687933817664);

var $jJTNo = parcelRequire("jJTNo");

var $57ByJ = parcelRequire("57ByJ");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0e5c059fc79abe53$export$56cc687933817664 = (0, $57ByJ.directive)(class extends (0, $57ByJ.Directive) {
    constructor(t){
        if (super(t), t.type !== (0, $57ByJ.PartType).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $jJTNo.noChange;
    }
});

});
parcelRegister("57ByJ", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $3baabda811939da5$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $3baabda811939da5$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $3baabda811939da5$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3baabda811939da5$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3baabda811939da5$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3baabda811939da5$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});




parcelRegister("b34iv", function(module, exports) {

$parcel$export(module.exports, "CityService", () => $45072ce92fd01caf$export$c85db99e1787f50b);

var $juzok = parcelRequire("juzok");
class $45072ce92fd01caf$export$c85db99e1787f50b {
    constructor(config){
        this.modelsToTranslate = [
            "events",
            "supportlinks",
            "customSections",
            "emailForm"
        ] // List of related models
        ;
        this.convertToCity = (city)=>{
            city = this.flattenTranslations(city); // Flatten translations for the top-level city object
            // Dynamically flatten translations for related models and assign to cityObj
            this.modelsToTranslate.forEach((model)=>{
                if (city && city[model]) city[model] = city[model].map((item)=>this.flattenTranslations(item));
            });
            return city;
        };
        this.client = (0, $juzok.createDirectus)(config.apiUrl).with((0, $juzok.rest)());
    }
    async getCity(cityId) {
        const languageCode = this.getValidLanguageCode();
        this.langFilter = {
            translations: {
                _filter: {
                    languages_code: {
                        _eq: languageCode
                    }
                }
            }
        };
        return this.fetchCity({
            id: cityId
        }, true);
    }
    async getCityByName(cityName) {
        const languageCode = this.getValidLanguageCode();
        this.langFilter = {
            translations: {
                _filter: {
                    languages_code: {
                        _eq: languageCode
                    }
                }
            }
        };
        return this.fetchCity({
            name: cityName
        }, true);
    }
    async fetchCity(criteria, langFallback) {
        const fields = this.getFieldsArray();
        const deep = this.getDeepFilters();
        let response;
        if (criteria.id !== undefined) response = await this.client.request((0, $juzok.readItem)("city", criteria.id, {
            fields: fields,
            deep: deep
        }));
        else if ("name" in criteria) {
            const nameFilter = {
                domainname: {
                    _icontains: criteria.name
                }
            };
            response = await this.client.request((0, $juzok.readItems)("city", {
                fields: fields,
                filter: nameFilter,
                deep: deep
            }));
            response = response[0];
        }
        const city = this.convertToCity(response);
        if (langFallback) // Check if page_title and description are empty, and refetch if necessary
        {
            if (!city?.page_title && !city?.description) {
                const alternateLanguage = sessionStorage.getItem("selectedLanguage") === "de" ? "fr" : "de";
                this.langFilter = {
                    translations: {
                        _filter: {
                            languages_code: {
                                _eq: alternateLanguage
                            }
                        }
                    }
                };
                return this.fetchCity({
                    name: city?.domainname
                });
            }
        }
        return city;
    }
    getFieldsArray() {
        return [
            "*",
            "translations.*",
            "gallery.*",
            "emailForm.fields.FormFields_id.type",
            "emailForm.fields.translations.*",
            ...this.modelsToTranslate.map((model)=>`${model}.*`),
            ...this.modelsToTranslate.map((model)=>`${model}.translations.*`)
        ];
    }
    getDeepFilters() {
        return this.modelsToTranslate.reduce((acc, model)=>({
                ...acc,
                [model]: this.langFilter
            }), {
            ...this.langFilter
        });
    }
    async getCities() {
        const response = await this.client.request((0, $juzok.readItems)("city", {
            fields: [
                "id",
                "translations.city_id",
                "domainname",
                "translations.name",
                "country"
            ],
            deep: {
                ...this.langFilter,
                events: this.langFilter,
                supportlinks: this.langFilter
            }
        }));
        return response.map(this.convertToCity);
    }
    flattenTranslations(item) {
        if (!item) return;
        if (item?.translations) {
            // Flatten translations into the parent object
            item = {
                ...item,
                ...item.translations[0]
            };
            delete item.translations; // Remove translations property
        }
        // Recursively process each property
        for (const key of Object.keys(item)){
            if (Array.isArray(item[key])) item[key] = item[key].map(this.flattenTranslations.bind(this)); // Process array items
            else if (typeof item[key] === "object" && item[key] !== null) item[key] = this.flattenTranslations(item[key]); // Process nested objects
        }
        return item;
    }
    getValidLanguageCode() {
        // Return selectedLanguage if in storage
        const storedLanguage = sessionStorage.getItem('selectedLanguage');
        if (storedLanguage && (storedLanguage === 'de' || storedLanguage === 'fr')) return storedLanguage;
        // Get browser language, if its de or fr use that, else default to de
        const browserLanguage = navigator.language.slice(0, 2);
        const selectedLanguage = browserLanguage === 'de' || browserLanguage === 'fr' ? browserLanguage : 'de';
        // Store the determined language so it's consistent across services
        sessionStorage.setItem('selectedLanguage', selectedLanguage);
        return selectedLanguage;
    }
}

});

parcelRegister("AaEa3", function(module, exports) {

$parcel$export(module.exports, "getCurrentCity", () => $be8e308eebd4d20e$export$51869e65c904b671);
const $be8e308eebd4d20e$export$51869e65c904b671 = ()=>{
    const currentUrl = window.location.href;
    const parsedUrl = new URL(currentUrl);
    const pathSegments = parsedUrl.pathname.split('/');
    const lastPart = pathSegments.filter((segment)=>segment !== "").pop();
    return Number(lastPart);
};

});

parcelRegister("7Mxfe", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
var $fmLyg = parcelRequire("fmLyg");
var $9Jyha = parcelRequire("9Jyha");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("lmk8H");
var $1eqYq = parcelRequire("1eqYq");
class $acbb22efd551a587$export$ddd501dda1f62236 extends (0, $27Ysw.DefaultComponent) {
    constructor(){
        super(), this.darkMode = false;
        this.language = this.getInitialLanguage();
    }
    static get componentStyles() {
        return (0, $4jdI8.css)`
            .language-wrapper {
                display: flex;
                gap: 12px;
                color: var(--color-white);
                text-transform: uppercase;
                list-style-type: none;
                & .selected {
                    background-color: var(--color-primary);
                }
                & li {
                    font-size: var(--font-size-l);
                    padding: 8px 12px;
                    cursor: pointer;
                }
            }
            .dark-mode {
                & .selected {
                    background-color: var(--color-secondary);
                }
            }
        `;
    }
    render() {
        return (0, $jJTNo.html)`
            <ul class="${(0, $1eqYq.classMap)({
            'language-wrapper': true,
            'dark-mode': this.darkMode
        })}">
                <li class="${(0, $1eqYq.classMap)({
            selected: this.language === 'de'
        })}" @click="${()=>this.setLanguage('de')}">DE</li>
                <li class="${(0, $1eqYq.classMap)({
            selected: this.language === 'fr'
        })}" @click="${()=>this.setLanguage('fr')}">FR</li>
            </ul>
        `;
    }
    setLanguage(value) {
        this.language = value;
        sessionStorage.setItem('selectedLanguage', value);
        dispatchEvent(new CustomEvent('refetch-data', {
            detail: {
                language: value
            },
            bubbles: true,
            composed: true
        }));
    }
    getInitialLanguage() {
        // Return selectedLanguage if in storage
        const storedLanguage = sessionStorage.getItem('selectedLanguage');
        if (storedLanguage) return storedLanguage;
        // Get browser language, if its de or fr store that as selectedLanguage, else default to de
        const browserLanguage = navigator.language.slice(0, 2);
        const selectedLanguage = browserLanguage === 'de' || browserLanguage === 'fr' ? browserLanguage : 'de';
        sessionStorage.setItem('selectedLanguage', selectedLanguage);
        return selectedLanguage;
    }
}
(0, $7WQrb.__decorate)([
    (0, $9Jyha.state)()
], $acbb22efd551a587$export$ddd501dda1f62236.prototype, "language", void 0);
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)()
], $acbb22efd551a587$export$ddd501dda1f62236.prototype, "darkMode", void 0);
$acbb22efd551a587$export$ddd501dda1f62236 = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)('bnn-language-selector')
], $acbb22efd551a587$export$ddd501dda1f62236);

});


parcelRegister("6FqPz", function(module, exports) {

$parcel$export(module.exports, "City", () => $32effb52cdd5b9d3$export$537503d43dd668a1);

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $jJTNo = parcelRequire("jJTNo");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
var $9Jyha = parcelRequire("9Jyha");
parcelRequire("hGXTG");
parcelRequire("2dqH9");

var $b34iv = parcelRequire("b34iv");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("d4bXs");
parcelRequire("adt2Q");
parcelRequire("caIGL");
parcelRequire("gGtHV");
parcelRequire("jAUZi");
parcelRequire("9mFH0");
parcelRequire("9Rdv2");
parcelRequire("3HMBS");
parcelRequire("bXpVM");

var $7zLhD = parcelRequire("7zLhD");
class $32effb52cdd5b9d3$export$537503d43dd668a1 extends (0, $27Ysw.DefaultComponent) {
    static{
        this.SCROLL_INTO_VIEW_EVENT = "city_scroll_into_view";
    }
    getSections() {
        const sections = [];
        if (this.city?.events?.length) sections.push({
            name: this.t("events"),
            id: "events-section"
        });
        if (this.city?.gallery?.length) sections.push({
            name: this.t("gallery"),
            id: "gallery-section"
        });
        if (this.city?.customSections?.length) this.city.customSections.forEach((section, index)=>{
            sections.push({
                name: section.title,
                id: `custom-section-${index}`
            }); // Assuming each custom section has a title
        });
        if (this.city?.sponsors?.length) sections.push({
            name: this.t("sponsors"),
            id: "sponsors-section"
        });
        if (this.city?.supportlinks?.length) sections.push({
            name: this.t("volunteer"),
            id: "support-section"
        });
        if (this.city?.flyer) sections.push({
            name: "Flyer",
            fileId: this.city.flyer
        });
        return sections;
    }
    constructor(){
        super(), this.isLoading = true;
        document.addEventListener($32effb52cdd5b9d3$export$537503d43dd668a1.SCROLL_INTO_VIEW_EVENT, (event)=>this.scrollSectionIntoView(event.detail));
        window.addEventListener('refetch-data', ()=>{
            this.fetchCityData();
        });
    }
    initializeSelectedCityFromURL() {
        const pathSegments = window.location.pathname.split("/");
        const cityIndex = pathSegments.findIndex((segment)=>segment === "city");
        if (cityIndex !== -1 && pathSegments.length > cityIndex + 1) {
            const cityName = pathSegments[cityIndex + 1];
            this.selectedCityName = cityName;
        }
    }
    afterComponentInitialized() {
        (0, $7zLhD.initializeSentry)(this.config);
        this.cityService = new (0, $b34iv.CityService)(this.config);
        this.initializeSelectedCityFromURL();
        this.requestUpdate();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("selectedCityName")) this.fetchCityData();
    }
    fetchCityData() {
        if (this.selectedCityName !== null) this.cityService.getCityByName(this.selectedCityName).then((cityData)=>{
            this.city = cityData;
            this.updateTitleTag();
            this.isLoading = false;
        }).catch((error)=>{
            this.isLoading = false;
            console.error("Failed to fetch city data", error);
        });
    }
    updateTitleTag() {
        const storedLanguage = sessionStorage.getItem("selectedLanguage");
        // Create the meta description tag
        var metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        // Append the meta tag to the document head
        if (storedLanguage === "de") {
            document.title = `Beim Namen nennen - ${this.city?.name}`;
            metaDescription.content = this.city?.description ?? 'Beim Namen nennen';
        }
        if (storedLanguage === "fr") {
            document.title = `Les nommer par leur nom - ${this.city?.name}`;
            metaDescription.content = this.city?.description ?? 'Beim Namen nennen';
        }
        document.head.appendChild(metaDescription);
    }
    render() {
        const sections = this.getSections(); // Dynamically generate the sections
        return (0, $jJTNo.html)`
      <bnn-banner
        .title="${this.city?.name}"
        .sections="${sections}"
        .isLoading="${this.isLoading}"
      ></bnn-banner>
      ${this.isLoading ? (0, $jJTNo.html)`<bnn-spinner></bnn-spinner>` // Use the spinner component
         : (0, $jJTNo.html)`
              ${this.renderDescription()} ${this.renderEventList()}
              ${this.renderGallery()} ${this.renderCustomSections()}
              ${this.renderSupportLinks()} ${this.renderForm()}
              ${this.renderSponsors()}
            ` // Render the content if not loading
        }
      <bnn-footer .isLoading="${this.isLoading}"></bnn-footer>
    `;
    }
    renderSpinner() {
        return (0, $jJTNo.html)`<div class="spinner">Loading...</div>`;
    }
    renderForm() {
        return (0, $jJTNo.html)`${this.city?.emailForm.map((form)=>{
            return (0, $jJTNo.html)`<bnn-form .form=${form}></bnn-form>`;
        })}`;
    }
    renderDescription() {
        return this.city?.page_title ? (0, $jJTNo.html)`
          <bnn-content-container>
            <h2>${this.city?.page_title}</h2>
            <p .innerHTML="${this.city?.description}"></p>
          </bnn-content-container>
        ` : ``;
    }
    renderEventList() {
        return this.city?.events?.length ? (0, $jJTNo.html)`<bnn-event-list
          id="events-section"
          .events="${this.city?.events}"
        ></bnn-event-list>` : ``;
    }
    renderGallery() {
        return this.city?.gallery?.length ? (0, $jJTNo.html)`<bnn-gallery
          id="gallery-section"
          .gallery="${this.city?.gallery}"
        ></bnn-gallery>` : ``;
    }
    renderCustomSections() {
        return this.city?.customSections?.length ? (0, $jJTNo.html)`
          ${this.city.customSections.map((section, index)=>(0, $jJTNo.html)`<bnn-custom-section-list
                id="custom-section-${index}"
                .customSections="${[
                section
            ]}"
              ></bnn-custom-section-list>`)}
        ` : ``;
    }
    renderSponsors() {
        return this.city?.sponsors ? (0, $jJTNo.html)`<bnn-text-content
          id="sponsors-section"
          .title="${this.t("sponsors")}"
          .text="${this.city?.sponsors}"
          .backgroundColor="${"blue"}"
        ></bnn-text-content>` : ``;
    }
    renderSupportLinks() {
        return this.city?.supportlinks?.length ? (0, $jJTNo.html)` <bnn-support-link-list
          id="support-section"
          .supportLinks="${this.city?.supportlinks}"
        ></bnn-support-link-list>` : ``;
    }
    scrollSectionIntoView(id) {
        const element = this.shadowRoot?.getElementById(id);
        element?.scrollIntoView();
    }
}
(0, $7WQrb.__decorate)([
    (0, $9Jyha.state)()
], $32effb52cdd5b9d3$export$537503d43dd668a1.prototype, "city", void 0);
(0, $7WQrb.__decorate)([
    (0, $9Jyha.state)()
], $32effb52cdd5b9d3$export$537503d43dd668a1.prototype, "selectedCityName", void 0);
(0, $7WQrb.__decorate)([
    (0, $9Jyha.state)()
], $32effb52cdd5b9d3$export$537503d43dd668a1.prototype, "isLoading", void 0);
$32effb52cdd5b9d3$export$537503d43dd668a1 = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-city")
], $32effb52cdd5b9d3$export$537503d43dd668a1);

});
parcelRegister("d4bXs", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
var $fmLyg = parcelRequire("fmLyg");
class $d9067f07c57d134a$export$9d2b4227a95687cc extends (0, $27Ysw.DefaultComponent) {
    static get componentStyles() {
        return (0, $4jdI8.css)`
            .container {
                padding: 3em var(--content-padding);
                display: flex;
                justify-content: center;
            }
            .max-content {
                max-width: var(--max-content);
                width: 100%;
                margin: 0;
            }
            .wide {
                max-width: none;
            }
        `;
    }
    get colorStyles() {
        if (this.backgroundColor === 'grey') return `background-color: var(--color-grey)`;
        if (this.backgroundColor === 'highlight') return `background-color: var(--color-highlight)`;
        if (this.backgroundColor === 'blue') return `background-color: var(--color-secondary);`;
    }
    render() {
        // Apply the 'wide' class conditionally based on the 'wide' property
        return (0, $jJTNo.html)`
            <div class="container" .style="${this.colorStyles?.length ? this.colorStyles : ''}">
            <div class="${this.wide ? 'max-content wide' : 'max-content'}">
                <slot></slot>
            </div>
            </div>
        `;
    }
    constructor(...args){
        super(...args), this.wide = false // New property to control wide mode
        ;
    }
}
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)({
        type: String
    })
], $d9067f07c57d134a$export$9d2b4227a95687cc.prototype, "backgroundColor", void 0);
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)({
        type: Boolean
    })
], $d9067f07c57d134a$export$9d2b4227a95687cc.prototype, "wide", void 0);
$d9067f07c57d134a$export$9d2b4227a95687cc = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-content-container")
], $d9067f07c57d134a$export$9d2b4227a95687cc);

});

parcelRegister("adt2Q", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
var $fmLyg = parcelRequire("fmLyg");
parcelRequire("d4bXs");
class $db7461eeae9ae97d$export$af4ae38441ca831f extends (0, $27Ysw.DefaultComponent) {
    static get componentStyles() {
        return (0, $4jdI8.css)`
      .dates {
        font-weight: bold;
      }
      .dates,
      .location {
        font-size: var(--font-size-m);
      }
      .events {
        display: flex;
        flex-direction: column;
        gap: var(--gutter-m);
      }
      .event {
        display: flex;
        flex-direction: column;
        gap: var(--gutter-s);
        padding: 16px;
        background-color: white;
        & p,
        h3 {
          margin: 0;
        }
      }
      img {
        max-height: 400px;
        max-width: -webkit-fill-available;
        object-fit: contain;
        align-self: flex-start;
      }
      }
      h2 {
        background-color: var(--color-primary);
        color: white;
        padding: 4px;
        width: max-content;
      }
    `;
    }
    render() {
        return (0, $jJTNo.html)`
      <bnn-content-container .backgroundColor="${"grey"}">
        <h2>${this.t("events")}</h2>
        <div class="events">
          ${this.events?.sort((a, b)=>a.sort > b.sort ? 1 : -1).map((e)=>this.renderEvent(e))}
        </div>
      </bnn-content-container>
    `;
    }
    renderEvent(event) {
        return (0, $jJTNo.html)`
      <div class="event">
        ${event.location ? (0, $jJTNo.html)`<p .innerHTML="${event.location}" class="location"></p>` : (0, $jJTNo.html)``}
        <h3>${event.name}</h3>
        ${event.teaser ? (0, $jJTNo.html)`<img src="${this.config?.apiUrl}/assets/${event.teaser}" alt="${`image ${event.name}`}"/>` : (0, $jJTNo.html)``}
        ${event.customDates ? (0, $jJTNo.html)`<p .innerHTML="${event.customDates}" class="dates"></p>` : (0, $jJTNo.html)``}
        <p .innerHTML="${event.description}"></p>
        ${event.link ? (0, $jJTNo.html)`<a .href="${event.link}" target="_blank">Mehr</a>` : (0, $jJTNo.html)``}
      </div>
    `;
    }
}
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)()
], $db7461eeae9ae97d$export$af4ae38441ca831f.prototype, "events", void 0);
$db7461eeae9ae97d$export$af4ae38441ca831f = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-event-list")
], $db7461eeae9ae97d$export$af4ae38441ca831f);

});

parcelRegister("caIGL", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
var $fmLyg = parcelRequire("fmLyg");
parcelRequire("d4bXs");
class $dde7429783c64711$export$9e74d0f7b94db275 extends (0, $27Ysw.DefaultComponent) {
    static get componentStyles() {
        return (0, $4jdI8.css)`
      .support-links {
        display: grid;
        gap: var(--gutter-m);
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      }
    `;
    }
    render() {
        return (0, $jJTNo.html)`
      <bnn-content-container .backgroundColor="${"grey"}">
        <h2>${this.t("volunteer")}</h2>
        <div class="support-links">
          ${this.supportLinks?.map((e)=>this.renderSupportLink(e))}
        </div>
      </bnn-content-container>
    `;
    }
    renderSupportLink(link) {
        return (0, $jJTNo.html)`
      <div class="support-link">
        <h3>${link.title}</h3>
        <p>${link.description}</p>
        <a target="_blank" href="${link.link}">${link.linkText}</a>
      </div>
    `;
    }
}
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)()
], $dde7429783c64711$export$9e74d0f7b94db275.prototype, "supportLinks", void 0);
$dde7429783c64711$export$9e74d0f7b94db275 = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-support-link-list")
], $dde7429783c64711$export$9e74d0f7b94db275);

});

parcelRegister("gGtHV", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $jJTNo = parcelRequire("jJTNo");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
var $fmLyg = parcelRequire("fmLyg");
parcelRequire("d4bXs");
parcelRequire("9Rdv2");
class $7dd99eb3820afc0c$export$434537bb7174ca2f extends (0, $27Ysw.DefaultComponent) {
    render() {
        return (0, $jJTNo.html)`
      <div class="custom-sections">
        ${this.customSections?.map((e)=>this.renderSection(e))}
      </div>
    `;
    }
    renderSection(section) {
        return (0, $jJTNo.html)`
      <bnn-text-content
        .title="${section.title}"
        .text="${section.description}"
        .link="${section.link}"
        .linkText="${section.linkText}"
      >
      </bnn-text-content>
    `;
    }
}
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)()
], $7dd99eb3820afc0c$export$434537bb7174ca2f.prototype, "customSections", void 0);
$7dd99eb3820afc0c$export$434537bb7174ca2f = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-custom-section-list")
], $7dd99eb3820afc0c$export$434537bb7174ca2f);

});
parcelRegister("9Rdv2", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
var $fmLyg = parcelRequire("fmLyg");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
class $2e04111572f8f885$export$1b51c6466e79404f extends (0, $27Ysw.DefaultComponent) {
    static get componentStyles() {
        return (0, $4jdI8.css)`
            .more-content {
                display: none;
            }
        `;
    }
    get colorStyles() {
        if (this.backgroundColor === 'highlight') return `color: var(--color-black)`;
        if (this.backgroundColor === 'blue') return `color: var(--color-white);`;
    }
    render() {
        return (0, $jJTNo.html)`
            <bnn-content-container .backgroundColor="${this.backgroundColor}">
                <h2 .style="${this.colorStyles?.length ? this.colorStyles : ''}">${this.title}</h2>
                <p .innerHTML="${this.text}" .style="${this.colorStyles?.length ? this.colorStyles : ''}"></p>
                ${this.link?.length ? (0, $jJTNo.html)`<a target="_blank" href="${this.link}">${this.linkText}</a>` : ``}
            </bnn-content-container>
        `;
    }
    constructor(...args){
        super(...args), this.title = '', this.text = '', this.link = '', this.linkText = '';
    }
}
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)({
        type: String
    })
], $2e04111572f8f885$export$1b51c6466e79404f.prototype, "title", void 0);
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)({
        type: String
    })
], $2e04111572f8f885$export$1b51c6466e79404f.prototype, "text", void 0);
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)()
], $2e04111572f8f885$export$1b51c6466e79404f.prototype, "backgroundColor", void 0);
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)()
], $2e04111572f8f885$export$1b51c6466e79404f.prototype, "link", void 0);
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)()
], $2e04111572f8f885$export$1b51c6466e79404f.prototype, "linkText", void 0);
$2e04111572f8f885$export$1b51c6466e79404f = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)('bnn-text-content')
], $2e04111572f8f885$export$1b51c6466e79404f);

});


parcelRegister("jAUZi", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
parcelRequire("ddFDo");
var $43nog = parcelRequire("43nog");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
var $fmLyg = parcelRequire("fmLyg");
var $9Jyha = parcelRequire("9Jyha");
parcelRequire("d4bXs");
class $ae4aa92443912599$export$ace63239d21d36e extends (0, $27Ysw.DefaultComponent) {
    constructor(){
        super(), this.patternCounter = {
            count: 0,
            target: 0
        };
        this.patternCounter.target = this.getRandomSmallImagesCount();
    }
    static get componentStyles() {
        return (0, $4jdI8.css)`
    .gallery {
        display: grid;
        gap: 16px; /* Adjust gap size as needed */
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); /* Creates a more flexible grid */
        grid-auto-flow: dense; /* Ensures that the grid fills in holes */
      }
      .gallery-image {
        cursor: pointer;
        position: relative;
        overflow: hidden;
        transition: transform 0.5s ease;
      }
      .gallery-image img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
      .gallery-image.large { 
        grid-column: span 2; 
        grid-row: span 2;
      }
      .gallery-image.small { 
        grid-column: span 1; 
        grid-row: span 1;
      }

      .lightbox {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1000;
      }
      
      .lightbox-container {
        display: flex; /* This will be the direct container for the image and navigation areas */
        max-width: 80%;
        max-height: 80%;
        width: auto; /* Adjust based on your needs */
        height: auto; /* Adjust based on your needs */
        position: relative; /* To position arrows */
      }
      
      .lightbox img {
        object-fit: contain;
        width: 100%; /* Let it fill the container */
        height: auto; /* Maintain aspect ratio */
      }
      
      .lightbox-left, .lightbox-right {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 50%; /* Or any desired width */
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.2); /* For visibility, adjust as needed */
      }
      
      .lightbox-left {
        left: -50%;
      }
      
      .lightbox-right {
        right: -50%;
      }
      
      .arrow {
        position: fixed;
        cursor: pointer;
        top: 50%;
        transform: translateY(-50%);
        font-size: 24px;
        color: white;
        z-index: 1010;
      }
      .arrow.left {
        left: 4%;
      }
      .arrow.right {
        right: 4%;
      }
    `;
    }
    render() {
        return this.config ? (0, $jJTNo.html)`
      <bnn-content-container .wide=${true}>
      ${(0, $43nog.guard)([
            this.gallery
        ], ()=>(0, $jJTNo.html)`
        <div class="gallery">
          ${this.gallery?.map((e, index)=>this.renderImage(e, index))}
        </div>
      `)}
        ${this.activeImageIndex !== undefined ? this.renderLightbox(this.gallery[this.activeImageIndex]) : ''}
      </bnn-content-container>
    ` : ``;
    }
    renderImage(image, index) {
        // Calculate size class dynamically
        const imageSize = this.getImageSize();
        return (0, $jJTNo.html)`
      <div class="gallery-image ${imageSize.class}" @click="${()=>this.setActiveImage(index)}">
        <img src="${this.config?.apiUrl}/assets/${image.directus_files_id}?fit=cover&width=${imageSize.sizeX}&height=${imageSize.sizeY}&quality=80">
      </div>
    `;
    }
    renderLightbox(image) {
        return (0, $jJTNo.html)`
      <div class="lightbox" @click="${this.clearActiveImage}">
        <div class="lightbox-container">
          <div class="lightbox-left" @click="${this.prevImage}">
            <span class="arrow left">&#10094;</span>
          </div>
          <img src="${this.config?.apiUrl}/assets/${image.directus_files_id}?quality=80">
          <div class="lightbox-right" @click="${this.nextImage}">
            <span class="arrow right">&#10095;</span>
          </div>
        </div>
      </div>
    `;
    }
    getRandomSmallImagesCount() {
        // Always returns the same sequence of "random" numbers for each session
        return Math.floor(Math.random() * 3) + 2;
    }
    getImageSize() {
        // Define the size mapping for large and small images
        const sizeMapping = {
            'large': {
                class: 'large',
                sizeX: '400',
                sizeY: '400'
            },
            'small': {
                class: 'small',
                sizeX: '200',
                sizeY: '200'
            }
        };
        let imageSize;
        // If count is 0, we are placing a large image
        if (this.patternCounter.count === 0) {
            imageSize = sizeMapping['large'];
            // Set the next target for small images
            this.patternCounter.target = Math.floor(Math.random() * 3) + 2;
            this.patternCounter.count = 1; // Reset the count to start counting small images
        } else {
            imageSize = sizeMapping['small'];
            // Increment the count and check if we reached the target number of small images
            if (++this.patternCounter.count > this.patternCounter.target) this.patternCounter.count = 0; // Reset the count for the next large image
        }
        return imageSize;
    }
    setActiveImage(index) {
        this.activeImageIndex = index;
    }
    clearActiveImage() {
        this.activeImageIndex = undefined;
    }
    prevImage(event) {
        event.stopPropagation(); // Prevent lightbox from closing
        if (this.activeImageIndex !== undefined && this.activeImageIndex > 0) this.activeImageIndex--;
    }
    nextImage(event) {
        event.stopPropagation(); // Prevent lightbox from closing
        if (this.activeImageIndex !== undefined && this.activeImageIndex < this.gallery.length - 1) this.activeImageIndex++;
    }
}
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)()
], $ae4aa92443912599$export$ace63239d21d36e.prototype, "gallery", void 0);
(0, $7WQrb.__decorate)([
    (0, $9Jyha.state)()
], $ae4aa92443912599$export$ace63239d21d36e.prototype, "activeImageIndex", void 0);
(0, $7WQrb.__decorate)([
    (0, $9Jyha.state)()
], $ae4aa92443912599$export$ace63239d21d36e.prototype, "patternCounter", void 0);
$ae4aa92443912599$export$ace63239d21d36e = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-gallery")
], $ae4aa92443912599$export$ace63239d21d36e);

});
parcelRegister("ddFDo", function(module, exports) {
$parcel$export(module.exports, "guard", () => (parcelRequire("43nog")).guard);
parcelRequire("43nog");

});
parcelRegister("43nog", function(module, exports) {

$parcel$export(module.exports, "guard", () => $2f39960df68605f1$export$864d727b48066337);

var $jJTNo = parcelRequire("jJTNo");

var $57ByJ = parcelRequire("57ByJ");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2f39960df68605f1$var$e = {}, $2f39960df68605f1$export$864d727b48066337 = (0, $57ByJ.directive)(class extends (0, $57ByJ.Directive) {
    constructor(){
        super(...arguments), this.ot = $2f39960df68605f1$var$e;
    }
    render(r, t) {
        return t();
    }
    update(t, [s, e]) {
        if (Array.isArray(s)) {
            if (Array.isArray(this.ot) && this.ot.length === s.length && s.every((r, t)=>r === this.ot[t])) return 0, $jJTNo.noChange;
        } else if (this.ot === s) return 0, $jJTNo.noChange;
        return this.ot = Array.isArray(s) ? Array.from(s) : s, this.render(s, e);
    }
});

});



parcelRegister("9mFH0", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
var $fmLyg = parcelRequire("fmLyg");
parcelRequire("d4bXs");
class $c7fee731c18925f3$export$a06f1c675e846f6f extends (0, $27Ysw.DefaultComponent) {
    static get componentStyles() {
        return (0, $4jdI8.css)`
      .footer-content {
        display: flex;
        gap: var(--gutter-m);
        justify-content: space-between;
        flex-wrap: wrap;
        & div {
          gap: var(--gutter-s);
          display: flex;
          flex-direction: column;
          & a {
            padding-bottom: 6px;
            cursor: pointer;
          }
        }
      }
      .sticky-footer {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        z-index: 1000; /* Ensures footer is above other content */
      }
      `;
    }
    render() {
        // Conditional class based on isLoading
        const footerClass = this.isLoading ? 'sticky-footer' : '';
        return (0, $jJTNo.html)`
      <footer class=${footerClass}>
        <bnn-content-container .backgroundColor="${"grey"}">
          <div class="footer-content">
            <div>
              <h3>${this.t('about_us')}</h3>
              <a href="https://www.offene-kirche.ch/">offene kirche bern</a>
              <a href="https://unitedagainstrefugeedeaths.eu/"
                >UNITED against Refugee Deaths</a
              >
            </div>
            <div>
              <h3>${this.t('contact')}</h3>
              <!--Social Media Icons-->
              <a href="mailto:info@beimnamennennen.ch">info@beimnamennennen.ch</a>
            </div>
          </div>
        </bnn-content-container>
      </footer>
    `;
    }
    constructor(...args){
        super(...args), this.isLoading = false;
    }
}
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)({
        type: Boolean
    })
], $c7fee731c18925f3$export$a06f1c675e846f6f.prototype, "isLoading", void 0);
$c7fee731c18925f3$export$a06f1c675e846f6f = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-footer")
], $c7fee731c18925f3$export$a06f1c675e846f6f);

});

parcelRegister("3HMBS", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
var $fmLyg = parcelRequire("fmLyg");
var $9Jyha = parcelRequire("9Jyha");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
parcelRequire("d4bXs");
parcelRequire("87wIp");
parcelRequire("lmk8H");
var $1eqYq = parcelRequire("1eqYq");
parcelRequire("9xI4i");
class $18cbd3c7cd8f3f58$export$a7fed597f4b8afd8 extends (0, $27Ysw.DefaultComponent) {
    static get componentStyles() {
        return (0, $4jdI8.css)`
      form {
        display: flex;
        flex-direction: column;
        gap: var(--gutter-s);
      }
      .checkbox-wrapper {
        display: flex;
        gap: 8px;
      }
      button.submitted {
        background-color: var(--color-success);
      }
      .button-content {
        display: flex;
        align-items: center;
        gap: 4px;
      }
    `;
    }
    render() {
        return (0, $jJTNo.html)`
      <bnn-content-container>
        <h2>${this.form?.title}</h2>
        <p>${this.form?.description}</p>
        <form id="form" @submit="${this.submitForm}">
          ${this.form?.fields.map((field)=>this.renderField(field))}
          <button
            type="submit"
            class="${(0, $1eqYq.classMap)({
            submitted: this.wasSuccessful
        })}"
          >
            <div class="button-content">
              ${this.wasSuccessful ? (0, $jJTNo.html)`<bnn-success-tick></bnn-success-tick>` : (0, $jJTNo.html)``}
              ${this.isLoading ? (0, $jJTNo.html)`<bnn-loader></bnn-loader>` : (0, $jJTNo.html)``}
              ${this.wasSuccessful ? this.form?.submittedButtonText : this.form?.submitText}
            </div>
          </button>
        </form>
        <div class="${this.message.includes("Error") ? "error" : "message"}">
          ${this.message}
        </div>
      </bnn-content-container>
    `;
    }
    async submitForm(e) {
        e.preventDefault();
        this.isLoading = true;
        this.message = ""; // Reset message on new submission
        const form = this.getForm();
        if (form) {
            const payload = this.createPayload(form);
            try {
                await this.sendFormData(payload);
                this.handleSuccess(form);
            } catch (error) {
                this.handleError(error);
            } finally{
                this.isLoading = false;
            }
        }
    }
    getForm() {
        return this.shadowRoot?.getElementById("form") || null;
    }
    createPayload(form) {
        const formData = new FormData(form);
        const values = {};
        this.form?.fields.forEach((field)=>{
            const value = formData.get(field.label);
            if (value) values[field.label] = value;
        });
        return {
            values: values,
            ...this.form
        };
    }
    async sendFormData(payload) {
        const response = await fetch(`${this.config.apiUrl}/flows/trigger/fdcaf62f-a842-492d-9e73-c719f558a149`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error("Failed to send email");
    }
    handleSuccess(form) {
        this.wasSuccessful = true;
        // Show success tick for 10s
        setTimeout(()=>{
            this.wasSuccessful = false;
            form.reset(); // Reset Form Data
        }, 2000);
    }
    handleError(error) {
        console.error("Error submitting form:", error);
        this.message = `Error: ${error.message}`;
    }
    renderField(field) {
        switch(field.FormFields_id.type){
            case "text":
                return (0, $jJTNo.html)` ${this.renderLabel(field)}
          <input
            type="text"
            id="${field.label}"
            name="${field.label}"
            ?disabled="${this.wasSuccessful}"
          />`;
            case "number":
                return (0, $jJTNo.html)` ${this.renderLabel(field)}
          <input
            type="number"
            id="${field.label}"
            name="${field.label}"
            ?disabled="${this.wasSuccessful}"
          />`;
            case "textarea":
                return (0, $jJTNo.html)` ${this.renderLabel(field)}
          <textarea
            id="${field.label}"
            name="${field.label}"
            ?disabled="${this.wasSuccessful}"
          ></textarea>`;
            case "checkbox":
                return (0, $jJTNo.html)` <div class="checkbox-wrapper">
          <input
            type="checkbox"
            id="${field.label}"
            name="${field.label}"
            ?disabled="${this.wasSuccessful}"
          />
          ${this.renderLabel(field)}
        </div>`;
        }
    }
    renderLabel(field) {
        return (0, $jJTNo.html)`<label for="${field.label}">${field.label}</label>`;
    }
    constructor(...args){
        super(...args), this.message = "", this.isLoading = false, this.wasSuccessful = false;
    }
}
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)()
], $18cbd3c7cd8f3f58$export$a7fed597f4b8afd8.prototype, "form", void 0);
(0, $7WQrb.__decorate)([
    (0, $fmLyg.property)()
], $18cbd3c7cd8f3f58$export$a7fed597f4b8afd8.prototype, "message", void 0);
(0, $7WQrb.__decorate)([
    (0, $9Jyha.state)()
], $18cbd3c7cd8f3f58$export$a7fed597f4b8afd8.prototype, "isLoading", void 0);
(0, $7WQrb.__decorate)([
    (0, $9Jyha.state)()
], $18cbd3c7cd8f3f58$export$a7fed597f4b8afd8.prototype, "wasSuccessful", void 0);
$18cbd3c7cd8f3f58$export$a7fed597f4b8afd8 = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-form")
], $18cbd3c7cd8f3f58$export$a7fed597f4b8afd8);

});
parcelRegister("87wIp", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
var $lPSdM = parcelRequire("lPSdM");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
class $017e9a1444e6fd23$export$3b0d6d7590275603 extends (0, $lPSdM.LitElement) {
    static get styles() {
        return (0, $4jdI8.css)`
      .loader {
        width: 24px;
        height: 24px;
        border: 3px solid #fff;
        border-bottom-color: transparent;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
      }

      @keyframes rotation {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `;
    }
    render() {
        return (0, $jJTNo.html)` <span class="loader"></span> `;
    }
}
$017e9a1444e6fd23$export$3b0d6d7590275603 = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-loader")
], $017e9a1444e6fd23$export$3b0d6d7590275603);

});

parcelRegister("9xI4i", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
var $lPSdM = parcelRequire("lPSdM");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
class $3926e9e1136f6e75$export$8d3c77c4a5878c79 extends (0, $lPSdM.LitElement) {
    static get styles() {
        return (0, $4jdI8.css)`
      .success-tick {
        width: 24px;
        margin-right: 8px;
      }
      svg {
        width: 24px;
        display: block;
      }

      .path {
        stroke-dasharray: 1000;
        stroke-dashoffset: 0;
        &.circle {
          -webkit-animation: dash 0.9s ease-in-out;
          animation: dash 0.9s ease-in-out;
        }
        &.line {
          stroke-dashoffset: 1000;
          -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
          animation: dash 0.9s 0.35s ease-in-out forwards;
        }
        &.check {
          stroke-dashoffset: -100;
          -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
          animation: dash-check 0.9s 0.35s ease-in-out forwards;
        }
      }
      @-webkit-keyframes dash {
        0% {
          stroke-dashoffset: 1000;
        }
        100% {
          stroke-dashoffset: 0;
        }
      }

      @keyframes dash {
        0% {
          stroke-dashoffset: 1000;
        }
        100% {
          stroke-dashoffset: 0;
        }
      }

      @-webkit-keyframes dash-check {
        0% {
          stroke-dashoffset: -100;
        }
        100% {
          stroke-dashoffset: 900;
        }
      }

      @keyframes dash-check {
        0% {
          stroke-dashoffset: -100;
        }
        100% {
          stroke-dashoffset: 900;
        }
      }
    `;
    }
    render() {
        return (0, $jJTNo.html)`
      <div class="success-tick">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 130.2 130.2"
        >
          <circle
            class="path circle"
            fill="none"
            stroke="#fff"
            stroke-width="8px"
            stroke-miterlimit="10"
            cx="65.1"
            cy="65.1"
            r="62.1"
          />
          <polyline
            class="path check"
            fill="none"
            stroke="#fff"
            stroke-width="8px"
            stroke-linecap="round"
            stroke-miterlimit="10"
            points="100.2,40.2 51.5,88.8 29.8,67.5 "
          />
        </svg>
      </div>
    `;
    }
}
$3926e9e1136f6e75$export$8d3c77c4a5878c79 = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-success-tick")
], $3926e9e1136f6e75$export$8d3c77c4a5878c79);

});


parcelRegister("bXpVM", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");

var $27Ysw = parcelRequire("27Ysw");
parcelRequire("4OBpG");
var $DB6gH = parcelRequire("DB6gH");
class $ebdadb8aaad35c3b$export$7f7cbe89f1eacd2 extends (0, $27Ysw.DefaultComponent) {
    static get componentStyles() {
        return (0, $4jdI8.css)`
      .spinner-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        margin: 10% 0 10%; 
      }
      .spinner {
        display: inline-block;
        width: 50px;
        height: 50px;
        border: 12px solid rgba(0, 0, 0, 0.3);
        border-radius: 50%;
        border-top-color: var(--color-primary);
        animation: spin 1s ease-in-out infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    `;
    }
    render() {
        return (0, $jJTNo.html)`
    <div class="spinner-wrapper">
      <div class="spinner"></div>
    </div>
    `;
    }
}
$ebdadb8aaad35c3b$export$7f7cbe89f1eacd2 = (0, $7WQrb.__decorate)([
    (0, $DB6gH.customElement)("bnn-spinner")
], $ebdadb8aaad35c3b$export$7f7cbe89f1eacd2);

});

parcelRegister("7zLhD", function(module, exports) {

$parcel$export(module.exports, "initializeSentry", () => $bda28117a3b50aca$export$1f7656c617418e15);

var $5uZv9 = parcelRequire("5uZv9");
var $cA8mQ = parcelRequire("cA8mQ");
var $15iXi = parcelRequire("15iXi");
function $bda28117a3b50aca$export$1f7656c617418e15(config) {
    $cA8mQ.init({
        dsn: "https://b2190aac5c941a081b00e8f2ae396e9d@o4506940162834432.ingest.us.sentry.io/4506940182560768",
        environment: config.environment,
        integrations: [
            $5uZv9.browserTracingIntegration(),
            $15iXi.replayIntegration({
                maskAllText: false,
                blockAllMedia: false
            })
        ],
        tracesSampleRate: 0.2,
        tracePropagationTargets: [
            "localhost",
            /^https:\/\/beimnamennennen\.ch\/api/
        ],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0
    });
}

});
parcelRegister("5uZv9", function(module, exports) {

$parcel$export(module.exports, "browserTracingIntegration", () => $400f75f99113439b$export$b4109253475213e9);

var $l1oVX = parcelRequire("l1oVX");
var $6OKHc = parcelRequire("6OKHc");
var $iWfxY = parcelRequire("iWfxY");
var $kGYVh = parcelRequire("kGYVh");
var $jdzJv = parcelRequire("jdzJv");
var $hA6iJ = parcelRequire("hA6iJ");
var $2fKhD = parcelRequire("2fKhD");
var $hi47i = parcelRequire("hi47i");
var $3M05P = parcelRequire("3M05P");
var $AIi6N = parcelRequire("AIi6N");
var $igqi3 = parcelRequire("igqi3");
var $yQUXg = parcelRequire("yQUXg");
var $4H7Y8 = parcelRequire("4H7Y8");
var $lLL40 = parcelRequire("lLL40");

var $5hw2H = parcelRequire("5hw2H");
var $6zU5D = parcelRequire("6zU5D");
var $a3m81 = parcelRequire("a3m81");

var $aBCC8 = parcelRequire("aBCC8");

var $csQk2 = parcelRequire("csQk2");

var $a4KxH = parcelRequire("a4KxH");

var $eXynY = parcelRequire("eXynY");

var $kqsdS = parcelRequire("kqsdS");
const $400f75f99113439b$export$bbd2089f30bd3708 = 'BrowserTracing';
const $400f75f99113439b$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $lLL40.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    linkPreviousTrace: 'in-memory',
    consistentTraceSampling: false,
    _experiments: {},
    ...(0, $kqsdS.defaultRequestInstrumentationOptions)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $400f75f99113439b$export$b4109253475213e9 = (_options = {})=>{
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $csQk2.WINDOW).document;
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, ignoreResourceSpans: ignoreResourceSpans, ignorePerformanceApiSpans: ignorePerformanceApiSpans, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling, onRequestSpanStart: onRequestSpanStart } = {
        ...$400f75f99113439b$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    let _collectWebVitals;
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        const isPageloadTransaction = startSpanOptions.op === 'pageload';
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (startSpanOptions.name !== finalStartSpanOptions.name) {
            attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'custom';
            finalStartSpanOptions.attributes = attributes;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        const idleSpan = (0, $lLL40.startIdleSpan)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                // This will generally always be defined here, because it is set in `setup()` of the integration
                // but technically, it is optional, so we guard here to be extra safe
                _collectWebVitals?.();
                (0, $6zU5D.addPerformanceEntries)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans,
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans
                });
                $400f75f99113439b$var$setActiveIdleSpan(client, undefined);
                // A trace should stay consistent over the entire timespan of one route - even after the pageload/navigation ended.
                // Only when another navigation happens, we want to create a new trace.
                // This way, e.g. errors that occur after the pageload span ended are still associated to the pageload trace.
                const scope = (0, $kGYVh.getCurrentScope)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $4H7Y8.spanIsSampled)(idleSpan),
                    dsc: (0, $jdzJv.getDynamicSamplingContextFromSpan)(span)
                });
            }
        });
        $400f75f99113439b$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                'interactive',
                'complete'
            ].includes(optionalWindowDocument.readyState)) client.emit('idleSpanEnableAutoFinish', idleSpan);
        }
        if (isPageloadTransaction && optionalWindowDocument) {
            optionalWindowDocument.addEventListener('readystatechange', ()=>{
                emitFinish();
            });
            emitFinish();
        }
    }
    return {
        name: $400f75f99113439b$export$bbd2089f30bd3708,
        setup (client) {
            (0, $igqi3.registerSpanErrorInstrumentation)();
            _collectWebVitals = (0, $6zU5D.startTrackingWebVitals)({
                recordClsStandaloneSpans: enableStandaloneClsSpans || false
            });
            if (enableInp) (0, $a3m81.startTrackingINP)();
            if (enableLongAnimationFrame && (0, $2fKhD.GLOBAL_OBJ).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) (0, $6zU5D.startTrackingLongAnimationFrames)();
            else if (enableLongTask) (0, $6zU5D.startTrackingLongTasks)();
            if (enableInteractions) (0, $6zU5D.startTrackingInteractions)();
            function maybeEndActiveSpan() {
                const activeSpan = $400f75f99113439b$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $4H7Y8.spanToJSON)(activeSpan).timestamp) {
                    (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).log(`[Tracing] Finishing current active span with op: ${(0, $4H7Y8.spanToJSON)(activeSpan).op}`);
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.setAttribute((0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), 'cancelled');
                    activeSpan.end();
                }
            }
            client.on('startNavigationSpan', (startSpanOptions)=>{
                if ((0, $kGYVh.getClient)() !== client) return;
                maybeEndActiveSpan();
                (0, $kGYVh.getIsolationScope)().setPropagationContext({
                    traceId: (0, $iWfxY.generateTraceId)(),
                    sampleRand: Math.random()
                });
                const scope = (0, $kGYVh.getCurrentScope)();
                scope.setPropagationContext({
                    traceId: (0, $iWfxY.generateTraceId)(),
                    sampleRand: Math.random()
                });
                // We reset this to ensure we do not have lingering incorrect data here
                // places that call this hook may set this where appropriate - else, the URL at span sending time is used
                scope.setSDKProcessingMetadata({
                    normalizedRequest: undefined
                });
                _createRouteSpan(client, {
                    op: 'navigation',
                    ...startSpanOptions
                });
            });
            client.on('startPageLoadSpan', (startSpanOptions, traceOptions = {})=>{
                if ((0, $kGYVh.getClient)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $400f75f99113439b$export$f147b32b03c9cf11('sentry-trace');
                const baggage = traceOptions.baggage || $400f75f99113439b$export$f147b32b03c9cf11('baggage');
                const propagationContext = (0, $AIi6N.propagationContextFromHeaders)(sentryTrace, baggage);
                const scope = (0, $kGYVh.getCurrentScope)();
                scope.setPropagationContext(propagationContext);
                // We store the normalized request data on the scope, so we get the request data at time of span creation
                // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $csQk2.getHttpRequestData)()
                });
                _createRouteSpan(client, {
                    op: 'pageload',
                    ...startSpanOptions
                });
            });
        },
        afterAllSetup (client) {
            let startingUrl = (0, $hA6iJ.getLocationHref)();
            if (linkPreviousTrace !== 'off') (0, $eXynY.linkTraces)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $csQk2.WINDOW).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $6OKHc.browserPerformanceTimeOrigin)();
                    $400f75f99113439b$export$aa44a07f82af519f(client, {
                        name: (0, $csQk2.WINDOW).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1000 : undefined,
                        attributes: {
                            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url',
                            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.pageload.browser'
                        }
                    });
                }
                if (instrumentNavigation) (0, $5hw2H.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl?.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    startingUrl = undefined;
                    const parsed = (0, $3M05P.parseStringToURLObject)(to);
                    $400f75f99113439b$export$7d159749bd9969ad(client, {
                        name: parsed?.pathname || (0, $csQk2.WINDOW).location.pathname,
                        attributes: {
                            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url',
                            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.navigation.browser'
                        }
                    });
                    // We store the normalized request data on the scope, so we get the request data at time of span creation
                    // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
                    (0, $kGYVh.getCurrentScope)().setSDKProcessingMetadata({
                        normalizedRequest: {
                            ...(0, $csQk2.getHttpRequestData)(),
                            // Ensure to set this, so this matches the target route even if the URL has not yet been updated
                            url: to
                        }
                    });
                });
            }
            if (markBackgroundSpan) (0, $a4KxH.registerBackgroundTabDetection)();
            if (enableInteractions) $400f75f99113439b$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $a3m81.registerInpInteractionListener)();
            (0, $kqsdS.instrumentOutgoingRequests)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $400f75f99113439b$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit('startPageLoadSpan', spanOptions, traceOptions);
    (0, $kGYVh.getCurrentScope)().setTransactionName(spanOptions.name);
    return $400f75f99113439b$var$getActiveIdleSpan(client);
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $400f75f99113439b$export$7d159749bd9969ad(client, spanOptions) {
    client.emit('startNavigationSpan', spanOptions);
    (0, $kGYVh.getCurrentScope)().setTransactionName(spanOptions.name);
    return $400f75f99113439b$var$getActiveIdleSpan(client);
}
/** Returns the value of a meta tag */ function $400f75f99113439b$export$f147b32b03c9cf11(metaName) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $csQk2.WINDOW).document;
    const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
    return metaTag?.getAttribute('content') || undefined;
}
/** Start listener for interaction transactions */ function $400f75f99113439b$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $csQk2.WINDOW).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = 'ui.action.click';
        const activeIdleSpan = $400f75f99113439b$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $4H7Y8.spanToJSON)(activeIdleSpan).op;
            if ([
                'navigation',
                'pageload'
            ].includes(currentRootSpanOp)) {
                (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), 'interactionInterrupted');
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $lLL40.startIdleSpan)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.source || 'url'
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener('click', registerInteractionTransaction, {
        once: false,
        capture: true
    });
}
// We store the active idle span on the client object, so we can access it from exported functions
const $400f75f99113439b$var$ACTIVE_IDLE_SPAN_PROPERTY = '_sentry_idleSpan';
function $400f75f99113439b$var$getActiveIdleSpan(client) {
    return client[$400f75f99113439b$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $400f75f99113439b$var$setActiveIdleSpan(client, span) {
    (0, $l1oVX.addNonEnumerableProperty)(client, $400f75f99113439b$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}

});
parcelRegister("l1oVX", function(module, exports) {

$parcel$export(module.exports, "fill", () => $f4dd084fe83374eb$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $f4dd084fe83374eb$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $f4dd084fe83374eb$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $f4dd084fe83374eb$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "convertToPlainObject", () => $f4dd084fe83374eb$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $f4dd084fe83374eb$export$b0244d5063c0b61b);

var $fKzCQ = parcelRequire("fKzCQ");

var $hA6iJ = parcelRequire("hA6iJ");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $hLnp0 = parcelRequire("hLnp0");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $f4dd084fe83374eb$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $f4dd084fe83374eb$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $f4dd084fe83374eb$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f4dd084fe83374eb$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $f4dd084fe83374eb$export$62ff257738bf57f5(value) {
    if ((0, $dfMsQ.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$f4dd084fe83374eb$var$getOwnProperties(value)
    };
    else if ((0, $dfMsQ.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $f4dd084fe83374eb$var$serializeEventTarget(value.target),
            currentTarget: $f4dd084fe83374eb$var$serializeEventTarget(value.currentTarget),
            ...$f4dd084fe83374eb$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $dfMsQ.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $f4dd084fe83374eb$var$serializeEventTarget(target) {
    try {
        return (0, $dfMsQ.isElement)(target) ? (0, $hA6iJ.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $f4dd084fe83374eb$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $f4dd084fe83374eb$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($f4dd084fe83374eb$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $hLnp0.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $hLnp0.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $f4dd084fe83374eb$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($f4dd084fe83374eb$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($f4dd084fe83374eb$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $f4dd084fe83374eb$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $f4dd084fe83374eb$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $f4dd084fe83374eb$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $dfMsQ.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("fKzCQ", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $b776c95debaa4af0$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b776c95debaa4af0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("hA6iJ", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $cccaafc2216668b2$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $cccaafc2216668b2$export$1cfafeee2987818b);
$parcel$export(module.exports, "getComponentName", () => $cccaafc2216668b2$export$26727cfcc4d7e0fc);

var $dfMsQ = parcelRequire("dfMsQ");

var $2fKhD = parcelRequire("2fKhD");
const $cccaafc2216668b2$var$WINDOW = (0, $2fKhD.GLOBAL_OBJ);
const $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $cccaafc2216668b2$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($cccaafc2216668b2$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $dfMsQ.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $cccaafc2216668b2$export$1cfafeee2987818b() {
    try {
        return $cccaafc2216668b2$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $cccaafc2216668b2$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$cccaafc2216668b2$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("dfMsQ", function(module, exports) {

$parcel$export(module.exports, "isError", () => $9a62450b4f3c2c3b$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $9a62450b4f3c2c3b$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $9a62450b4f3c2c3b$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $9a62450b4f3c2c3b$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $9a62450b4f3c2c3b$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $9a62450b4f3c2c3b$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $9a62450b4f3c2c3b$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $9a62450b4f3c2c3b$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $9a62450b4f3c2c3b$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $9a62450b4f3c2c3b$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $9a62450b4f3c2c3b$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $9a62450b4f3c2c3b$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $9a62450b4f3c2c3b$export$bc2894c7158efbac);
$parcel$export(module.exports, "isVueViewModel", () => $9a62450b4f3c2c3b$export$7916fad0ebc23f48);
$parcel$export(module.exports, "isRequest", () => $9a62450b4f3c2c3b$export$6d3d1f317d7cda57);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $9a62450b4f3c2c3b$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$e6127cc7fe7395c3(wat) {
    switch($9a62450b4f3c2c3b$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$var$isBuiltin(wat, className) {
    return $9a62450b4f3c2c3b$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9f9636d330b71954(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$ef9e2056653f0c8e(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$12e869b2a583f783(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$844ec244b1367d54(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$c3825b437cbdea5c(wat) {
    return wat === null || $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49841c62b9eff15(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9a62450b4f3c2c3b$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$bc2894c7158efbac(wat) {
    return $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $9a62450b4f3c2c3b$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(request, Request);
}

});

parcelRegister("2fKhD", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $1a40e26460b4422e$export$f1a6cdb1459e81d1);
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $1a40e26460b4422e$export$f1a6cdb1459e81d1 = globalThis;

});


parcelRegister("hi47i", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $c9674f9e04798056$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $c9674f9e04798056$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $c9674f9e04798056$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $c9674f9e04798056$export$af88d00dbe7f521);

var $iNK7c = parcelRequire("iNK7c");

var $fKzCQ = parcelRequire("fKzCQ");

var $2fKhD = parcelRequire("2fKhD");
/** Prefix for logging strings */ const $c9674f9e04798056$var$PREFIX = 'Sentry Logger ';
const $c9674f9e04798056$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $c9674f9e04798056$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $c9674f9e04798056$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $2fKhD.GLOBAL_OBJ))) return callback();
    const console = (0, $2fKhD.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($c9674f9e04798056$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $c9674f9e04798056$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $c9674f9e04798056$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $fKzCQ.DEBUG_BUILD) $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $c9674f9e04798056$export$cda52e2a8927a2ca(()=>{
                (0, $2fKhD.GLOBAL_OBJ).console[name](`${$c9674f9e04798056$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $c9674f9e04798056$export$af88d00dbe7f521 = (0, $iNK7c.getGlobalSingleton)('logger', $c9674f9e04798056$var$makeLogger);

});
parcelRegister("iNK7c", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", () => $db00931c27c5ec41$export$19eade501500c6c1);
$parcel$export(module.exports, "getSentryCarrier", () => $db00931c27c5ec41$export$c8bfa33e4e8ae492);
$parcel$export(module.exports, "getGlobalSingleton", () => $db00931c27c5ec41$export$7e223ec222791509);

var $faPnA = parcelRequire("faPnA");

var $2fKhD = parcelRequire("2fKhD");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $db00931c27c5ec41$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $db00931c27c5ec41$export$c8bfa33e4e8ae492((0, $2fKhD.GLOBAL_OBJ));
    return 0, $2fKhD.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $db00931c27c5ec41$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $faPnA.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $faPnA.SDK_VERSION] = __SENTRY__[0, $faPnA.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $db00931c27c5ec41$export$7e223ec222791509(name, creator, obj = (0, $2fKhD.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $faPnA.SDK_VERSION] = __SENTRY__[0, $faPnA.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

});
parcelRegister("faPnA", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $b0bfa51115099518$export$31499a9cd224b78c);
// This is a magic string replaced by rollup
const $b0bfa51115099518$export$31499a9cd224b78c = "9.25.0";

});



parcelRegister("hLnp0", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $cee8faa76567523a$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $cee8faa76567523a$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $cee8faa76567523a$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $cee8faa76567523a$export$a7a5ec66062ea5d);

var $dfMsQ = parcelRequire("dfMsQ");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $cee8faa76567523a$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $cee8faa76567523a$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $cee8faa76567523a$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $dfMsQ.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $cee8faa76567523a$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $dfMsQ.isString)(value)) return false;
    if ((0, $dfMsQ.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $dfMsQ.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $cee8faa76567523a$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$cee8faa76567523a$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});


parcelRegister("6OKHc", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => $4f6ba265374890ec$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $4f6ba265374890ec$export$ee52dced521e3e18);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => $4f6ba265374890ec$export$baf075a948ffc0bf);

var $2fKhD = parcelRequire("2fKhD");
const $4f6ba265374890ec$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $4f6ba265374890ec$export$7740643b9eeaf0c4() {
    return Date.now() / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $2fKhD.GLOBAL_OBJ);
    if (!performance?.now) return $4f6ba265374890ec$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $4f6ba265374890ec$export$ee52dced521e3e18 = $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $4f6ba265374890ec$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $4f6ba265374890ec$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $2fKhD.GLOBAL_OBJ);
    if (!performance?.now) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $4f6ba265374890ec$export$baf075a948ffc0bf() {
    if (!$4f6ba265374890ec$var$cachedTimeOrigin) $4f6ba265374890ec$var$cachedTimeOrigin = $4f6ba265374890ec$var$getBrowserTimeOrigin();
    return $4f6ba265374890ec$var$cachedTimeOrigin[0];
}

});

parcelRegister("iWfxY", function(module, exports) {

$parcel$export(module.exports, "generateTraceId", () => $dc99b4184ec29e47$export$dc6d7ea554bcce10);
$parcel$export(module.exports, "generateSpanId", () => $dc99b4184ec29e47$export$295213bc4d0c54ad);

var $6OhB9 = parcelRequire("6OhB9");
/**
 * Generate a random, valid trace ID.
 */ function $dc99b4184ec29e47$export$dc6d7ea554bcce10() {
    return (0, $6OhB9.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $dc99b4184ec29e47$export$295213bc4d0c54ad() {
    return (0, $6OhB9.uuid4)().substring(16);
}

});
parcelRegister("6OhB9", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $4f55103f4332a5b0$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $4f55103f4332a5b0$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $4f55103f4332a5b0$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $4f55103f4332a5b0$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $4f55103f4332a5b0$export$6de4ffac6a2f1098);

var $l1oVX = parcelRequire("l1oVX");

var $hLnp0 = parcelRequire("hLnp0");

var $2fKhD = parcelRequire("2fKhD");
function $4f55103f4332a5b0$var$getCrypto() {
    const gbl = (0, $2fKhD.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $4f55103f4332a5b0$export$19f53698e68b2496(crypto = $4f55103f4332a5b0$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $4f55103f4332a5b0$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $4f55103f4332a5b0$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $4f55103f4332a5b0$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $4f55103f4332a5b0$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $4f55103f4332a5b0$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $4f55103f4332a5b0$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $4f55103f4332a5b0$export$d364f2020ab30578(input) {
    const match = input.match($4f55103f4332a5b0$var$SEMVER_REGEXP) || [];
    const major = $4f55103f4332a5b0$var$_parseInt(match[1]);
    const minor = $4f55103f4332a5b0$var$_parseInt(match[2]);
    const patch = $4f55103f4332a5b0$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $4f55103f4332a5b0$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $hLnp0.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $hLnp0.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $hLnp0.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $4f55103f4332a5b0$export$6de4ffac6a2f1098(exception) {
    if ($4f55103f4332a5b0$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $l1oVX.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $4f55103f4332a5b0$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}

});


parcelRegister("kGYVh", function(module, exports) {

$parcel$export(module.exports, "getCurrentScope", () => $f106fce27ec076f7$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getIsolationScope", () => $f106fce27ec076f7$export$68f3af03034c9e90);
$parcel$export(module.exports, "getGlobalScope", () => $f106fce27ec076f7$export$aa55d5ab8e05984f);
$parcel$export(module.exports, "withScope", () => $f106fce27ec076f7$export$ec58d9285c204497);
$parcel$export(module.exports, "withIsolationScope", () => $f106fce27ec076f7$export$9a4fed82c350c2bd);
$parcel$export(module.exports, "getClient", () => $f106fce27ec076f7$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "getTraceContextFromScope", () => $f106fce27ec076f7$export$1e83db7ee4876dc4);

var $7YCyf = parcelRequire("7YCyf");

var $iNK7c = parcelRequire("iNK7c");

var $4rxjU = parcelRequire("4rxjU");

var $iWfxY = parcelRequire("iWfxY");
/**
 * Get the currently active scope.
 */ function $f106fce27ec076f7$export$c7be4b0125a10cba() {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $f106fce27ec076f7$export$68f3af03034c9e90() {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $f106fce27ec076f7$export$aa55d5ab8e05984f() {
    return (0, $iNK7c.getGlobalSingleton)('globalScope', ()=>new (0, $4rxjU.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$ec58d9285c204497(...rest) {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $f106fce27ec076f7$export$6bb76d6eba7e258c() {
    return $f106fce27ec076f7$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $f106fce27ec076f7$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $iWfxY.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

});
parcelRegister("7YCyf", function(module, exports) {

$parcel$export(module.exports, "getAsyncContextStrategy", () => $5cec0a7bd2540b32$export$f639b0c2752203be);

var $iNK7c = parcelRequire("iNK7c");

var $eGYpZ = parcelRequire("eGYpZ");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $5cec0a7bd2540b32$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $iNK7c.getMainCarrier)();
    const sentry = (0, $iNK7c.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $5cec0a7bd2540b32$export$f639b0c2752203be(carrier) {
    const sentry = (0, $iNK7c.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $eGYpZ.getStackAsyncContextStrategy)();
}

});
parcelRegister("eGYpZ", function(module, exports) {

$parcel$export(module.exports, "getStackAsyncContextStrategy", () => $ab23dab597a507b7$export$329d4d4d54e42710);

var $5MoSi = parcelRequire("5MoSi");

var $4rxjU = parcelRequire("4rxjU");

var $dfMsQ = parcelRequire("dfMsQ");

var $iNK7c = parcelRequire("iNK7c");
/**
 * This is an object that holds a stack of scopes.
 */ class $ab23dab597a507b7$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $4rxjU.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $4rxjU.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $dfMsQ.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $ab23dab597a507b7$var$getAsyncContextStack() {
    const registry = (0, $iNK7c.getMainCarrier)();
    const sentry = (0, $iNK7c.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $ab23dab597a507b7$export$d36ec451f120cfba((0, $5MoSi.getDefaultCurrentScope)(), (0, $5MoSi.getDefaultIsolationScope)());
}
function $ab23dab597a507b7$var$withScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(callback);
}
function $ab23dab597a507b7$var$withSetScope(scope, callback) {
    const stack = $ab23dab597a507b7$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $ab23dab597a507b7$var$withIsolationScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(()=>{
        return callback($ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $ab23dab597a507b7$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $ab23dab597a507b7$var$withIsolationScope,
        withScope: $ab23dab597a507b7$var$withScope,
        withSetScope: $ab23dab597a507b7$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $ab23dab597a507b7$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("5MoSi", function(module, exports) {

$parcel$export(module.exports, "getDefaultCurrentScope", () => $4354bb0fac58a6e0$export$6f1b9191db9c4d5);
$parcel$export(module.exports, "getDefaultIsolationScope", () => $4354bb0fac58a6e0$export$de9862929b76bf57);

var $iNK7c = parcelRequire("iNK7c");

var $4rxjU = parcelRequire("4rxjU");
/** Get the default current scope. */ function $4354bb0fac58a6e0$export$6f1b9191db9c4d5() {
    return (0, $iNK7c.getGlobalSingleton)('defaultCurrentScope', ()=>new (0, $4rxjU.Scope)());
}
/** Get the default isolation scope. */ function $4354bb0fac58a6e0$export$de9862929b76bf57() {
    return (0, $iNK7c.getGlobalSingleton)('defaultIsolationScope', ()=>new (0, $4rxjU.Scope)());
}

});
parcelRegister("4rxjU", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $33c387bb26fe522d$export$775b6bb06e53a214);

var $kkdRz = parcelRequire("kkdRz");

var $vNNF0 = parcelRequire("vNNF0");

var $dc48k = parcelRequire("dc48k");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $6OhB9 = parcelRequire("6OhB9");

var $iWfxY = parcelRequire("iWfxY");

var $hLnp0 = parcelRequire("hLnp0");

var $6OKHc = parcelRequire("6OKHc");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $33c387bb26fe522d$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $iWfxY.generateTraceId)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $33c387bb26fe522d$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $dc48k._setSpanForScope)(newScope, (0, $dc48k._getSpanForScope)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $kkdRz.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $33c387bb26fe522d$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $dfMsQ.isPlainObject)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $dc48k._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $iWfxY.generateTraceId)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $6OKHc.dateTimestampInSeconds)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $hLnp0.truncate)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $dc48k._getSpanForScope)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $vNNF0.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $6OhB9.uuid4)();
        if (!this._client) {
            (0, $hi47i.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $6OhB9.uuid4)();
        if (!this._client) {
            (0, $hi47i.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $6OhB9.uuid4)();
        if (!this._client) {
            (0, $hi47i.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}

});
parcelRegister("kkdRz", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $ecc06dd71ed8ff5f$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $ecc06dd71ed8ff5f$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $ecc06dd71ed8ff5f$export$56521d9ba90f62ee);

var $6OhB9 = parcelRequire("6OhB9");

var $6OKHc = parcelRequire("6OKHc");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ecc06dd71ed8ff5f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $6OKHc.timestampInSeconds)();
    const session = {
        sid: (0, $6OhB9.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ecc06dd71ed8ff5f$var$sessionToJSON(session)
    };
    if (context) $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ecc06dd71ed8ff5f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $6OKHc.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $6OhB9.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ecc06dd71ed8ff5f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ecc06dd71ed8ff5f$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

});

parcelRegister("vNNF0", function(module, exports) {

$parcel$export(module.exports, "merge", () => $05f9869a4b646370$export$4950aa0f605343fb);
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $05f9869a4b646370$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $05f9869a4b646370$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("dc48k", function(module, exports) {

$parcel$export(module.exports, "_setSpanForScope", () => $99af9a2b040631ba$export$3f25fa50c18e20ca);
$parcel$export(module.exports, "_getSpanForScope", () => $99af9a2b040631ba$export$91f063ebb8eff307);

var $l1oVX = parcelRequire("l1oVX");
const $99af9a2b040631ba$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $l1oVX.addNonEnumerableProperty)(scope, $99af9a2b040631ba$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$91f063ebb8eff307(scope) {
    return scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}

});






parcelRegister("jdzJv", function(module, exports) {

$parcel$export(module.exports, "freezeDscOnSpan", () => $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd);
$parcel$export(module.exports, "getDynamicSamplingContextFromScope", () => $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $dfdaf30e5fcd5fd9$export$a117f995597e25df);

var $4Baka = parcelRequire("4Baka");

var $kGYVh = parcelRequire("kGYVh");

var $yQUXg = parcelRequire("yQUXg");

var $4XLci = parcelRequire("4XLci");

var $4H7Y8 = parcelRequire("4H7Y8");

var $gdhAa = parcelRequire("gdhAa");

var $cucnP = parcelRequire("cucnP");

var $l1oVX = parcelRequire("l1oVX");

var $5VulJ = parcelRequire("5VulJ");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $l1oVX.addNonEnumerableProperty)(spanWithMaybeDsc, $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $dfdaf30e5fcd5fd9$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key, host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = (0, $cucnP.extractOrgIdFromDsnHost)(host);
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $4Baka.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: org_id
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $dfdaf30e5fcd5fd9$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $dfdaf30e5fcd5fd9$export$a117f995597e25df(span) {
    const client = (0, $kGYVh.getClient)();
    if (!client) return {};
    const rootSpan = (0, $4H7Y8.getRootSpan)(span);
    const rootSpanJson = (0, $4H7Y8.spanToJSON)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $gdhAa.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $dfdaf30e5fcd5fd9$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $4XLci.hasSpansEnabled)()) {
        dsc.sampled = String((0, $4H7Y8.spanIsSampled)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $5VulJ.getCapturedScopesOnSpan)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $dfdaf30e5fcd5fd9$export$95cf936fdacaff7b(span) {
    const dsc = $dfdaf30e5fcd5fd9$export$a117f995597e25df(span);
    return (0, $gdhAa.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("4Baka", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $3592a0510b526070$export$849dbeeeda01ae98);
const $3592a0510b526070$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("yQUXg", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $068c396dceb690a1$export$d7a7d984b0791405);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $068c396dceb690a1$export$ccfe0a40627cc34b);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", () => $068c396dceb690a1$export$889fb736668e1ecc);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $068c396dceb690a1$export$1a413bd9a88fdb09);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $068c396dceb690a1$export$cca8dd30f57f805e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", () => $068c396dceb690a1$export$ba73f34502b7a3b3);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", () => $068c396dceb690a1$export$f5f95cff026507b5);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", () => $068c396dceb690a1$export$69cd5c610c7bb96a);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", () => $068c396dceb690a1$export$165ce9a229f6f050);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", () => $068c396dceb690a1$export$1efec95406bbe327);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", () => $068c396dceb690a1$export$fea48ba9f4550879);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", () => $068c396dceb690a1$export$be7a251980e7e946);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_URL_FULL", () => $068c396dceb690a1$export$25dfd73e0e32c6e1);
$parcel$export(module.exports, "SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE", () => $068c396dceb690a1$export$ff77b5fd5b2d627b);
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $068c396dceb690a1$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $068c396dceb690a1$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $068c396dceb690a1$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $068c396dceb690a1$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $068c396dceb690a1$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $068c396dceb690a1$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $068c396dceb690a1$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $068c396dceb690a1$export$1efec95406bbe327 = 'sentry.profile_id';
const $068c396dceb690a1$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $068c396dceb690a1$export$b016f89ac1066ec = 'cache.hit';
const $068c396dceb690a1$export$3110e4c3f4386399 = 'cache.key';
const $068c396dceb690a1$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $068c396dceb690a1$export$be7a251980e7e946 = 'http.request.method';
const $068c396dceb690a1$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $068c396dceb690a1$export$ff77b5fd5b2d627b = 'sentry.link.type';

});

parcelRegister("4XLci", function(module, exports) {

$parcel$export(module.exports, "hasSpansEnabled", () => $39d14882dc0612d9$export$1f70765132c3c225);

var $kGYVh = parcelRequire("kGYVh");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $39d14882dc0612d9$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $kGYVh.getClient)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $39d14882dc0612d9$export$5008da00b1b6dee6 = $39d14882dc0612d9$export$1f70765132c3c225;

});

parcelRegister("4H7Y8", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", () => $36b15c0d755e29f6$export$208d5b368507fb8b);
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", () => $36b15c0d755e29f6$export$eb571cd9b5d98de8);
$parcel$export(module.exports, "spanToTransactionTraceContext", () => $36b15c0d755e29f6$export$4c3967a8a2f6bbd6);
$parcel$export(module.exports, "spanToJSON", () => $36b15c0d755e29f6$export$92d8c23565496537);
$parcel$export(module.exports, "spanToTraceContext", () => $36b15c0d755e29f6$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanToTraceHeader", () => $36b15c0d755e29f6$export$7e9f8ae9e4a328ab);
$parcel$export(module.exports, "spanIsSampled", () => $36b15c0d755e29f6$export$5caecac1caaf3a71);
$parcel$export(module.exports, "convertSpanLinksForEnvelope", () => $36b15c0d755e29f6$export$cb3e3a12e0eec16c);
$parcel$export(module.exports, "spanTimeInputToSeconds", () => $36b15c0d755e29f6$export$3f7581298f56c6d7);
$parcel$export(module.exports, "getStatusMessage", () => $36b15c0d755e29f6$export$e238a77ea3a8cd66);
$parcel$export(module.exports, "addChildSpanToSpan", () => $36b15c0d755e29f6$export$81397d924722cc65);
$parcel$export(module.exports, "removeChildSpanFromSpan", () => $36b15c0d755e29f6$export$c2a0c9438bb89d91);
$parcel$export(module.exports, "getSpanDescendants", () => $36b15c0d755e29f6$export$340c5c8a13ffc680);
$parcel$export(module.exports, "getRootSpan", () => $36b15c0d755e29f6$export$c4c6a79b1260ca1b);
$parcel$export(module.exports, "getActiveSpan", () => $36b15c0d755e29f6$export$1be426a8e585c83e);
$parcel$export(module.exports, "showSpanDropWarning", () => $36b15c0d755e29f6$export$d11691ff45a3e535);

var $7YCyf = parcelRequire("7YCyf");

var $iNK7c = parcelRequire("iNK7c");

var $kGYVh = parcelRequire("kGYVh");

var $yQUXg = parcelRequire("yQUXg");

var $02dIh = parcelRequire("02dIh");

var $5VulJ = parcelRequire("5VulJ");

var $hi47i = parcelRequire("hi47i");

var $l1oVX = parcelRequire("l1oVX");

var $iWfxY = parcelRequire("iWfxY");

var $6OKHc = parcelRequire("6OKHc");

var $AIi6N = parcelRequire("AIi6N");

var $dc48k = parcelRequire("dc48k");
// These are aligned with OpenTelemetry trace flags
const $36b15c0d755e29f6$export$208d5b368507fb8b = 0x0;
const $36b15c0d755e29f6$export$eb571cd9b5d98de8 = 0x1;
let $36b15c0d755e29f6$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $36b15c0d755e29f6$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $36b15c0d755e29f6$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $36b15c0d755e29f6$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $36b15c0d755e29f6$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $5VulJ.getCapturedScopesOnSpan)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $iWfxY.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $36b15c0d755e29f6$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $36b15c0d755e29f6$export$5caecac1caaf3a71(span);
    return (0, $AIi6N.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $36b15c0d755e29f6$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $36b15c0d755e29f6$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input.getTime());
    return (0, $6OKHc.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $36b15c0d755e29f6$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $36b15c0d755e29f6$export$92d8c23565496537(span) {
    if ($36b15c0d755e29f6$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? span.parentSpanContext?.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(endTime) || undefined,
            status: $36b15c0d755e29f6$export$e238a77ea3a8cd66(status),
            op: attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $36b15c0d755e29f6$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $36b15c0d755e29f6$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $36b15c0d755e29f6$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $36b15c0d755e29f6$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $02dIh.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $02dIh.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'unknown_error';
}
const $36b15c0d755e29f6$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $36b15c0d755e29f6$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $36b15c0d755e29f6$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
    (0, $l1oVX.addNonEnumerableProperty)(childSpan, $36b15c0d755e29f6$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $l1oVX.addNonEnumerableProperty)(span, $36b15c0d755e29f6$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $36b15c0d755e29f6$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $36b15c0d755e29f6$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($36b15c0d755e29f6$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD] ? Array.from(span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $36b15c0d755e29f6$export$c4c6a79b1260ca1b(span) {
    return span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $36b15c0d755e29f6$export$1be426a8e585c83e() {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $dc48k._getSpanForScope)((0, $kGYVh.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $36b15c0d755e29f6$export$d11691ff45a3e535() {
    if (!$36b15c0d755e29f6$var$hasShownSpanDropWarning) {
        (0, $hi47i.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $36b15c0d755e29f6$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $36b15c0d755e29f6$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("02dIh", function(module, exports) {

$parcel$export(module.exports, "SPAN_STATUS_UNSET", () => $006ad32cdaebe09b$export$136e25984ba4a383);
$parcel$export(module.exports, "SPAN_STATUS_OK", () => $006ad32cdaebe09b$export$58f7963109c806fc);
$parcel$export(module.exports, "SPAN_STATUS_ERROR", () => $006ad32cdaebe09b$export$f966a0446ece71e);
$parcel$export(module.exports, "setHttpStatus", () => $006ad32cdaebe09b$export$2ad6630ec8164254);
const $006ad32cdaebe09b$export$136e25984ba4a383 = 0;
const $006ad32cdaebe09b$export$58f7963109c806fc = 1;
const $006ad32cdaebe09b$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $006ad32cdaebe09b$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $006ad32cdaebe09b$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $006ad32cdaebe09b$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}

});

parcelRegister("5VulJ", function(module, exports) {

$parcel$export(module.exports, "setCapturedScopesOnSpan", () => $4509d165411fd11c$export$cddb4027e3b0dd66);
$parcel$export(module.exports, "getCapturedScopesOnSpan", () => $4509d165411fd11c$export$c08fbc656a245d03);

var $l1oVX = parcelRequire("l1oVX");
const $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $4509d165411fd11c$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $l1oVX.addNonEnumerableProperty)(span, $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $l1oVX.addNonEnumerableProperty)(span, $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $4509d165411fd11c$export$c08fbc656a245d03(span) {
    return {
        scope: span[$4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});

parcelRegister("AIi6N", function(module, exports) {

$parcel$export(module.exports, "TRACEPARENT_REGEXP", () => $06e5b8314e290bf2$export$394a210812ba3012);
$parcel$export(module.exports, "propagationContextFromHeaders", () => $06e5b8314e290bf2$export$261f383d16a93e39);
$parcel$export(module.exports, "generateSentryTraceHeader", () => $06e5b8314e290bf2$export$f35d907436da45cf);

var $1oUdV = parcelRequire("1oUdV");

var $gdhAa = parcelRequire("gdhAa");

var $iWfxY = parcelRequire("iWfxY");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $06e5b8314e290bf2$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $06e5b8314e290bf2$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($06e5b8314e290bf2$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $06e5b8314e290bf2$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $06e5b8314e290bf2$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $gdhAa.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $iWfxY.generateTraceId)(),
        sampleRand: Math.random()
    };
    const sampleRand = $06e5b8314e290bf2$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $06e5b8314e290bf2$export$f35d907436da45cf(traceId = (0, $iWfxY.generateTraceId)(), spanId = (0, $iWfxY.generateSpanId)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $06e5b8314e290bf2$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $1oUdV.parseSampleRate)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $1oUdV.parseSampleRate)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}

});
parcelRegister("1oUdV", function(module, exports) {

$parcel$export(module.exports, "parseSampleRate", () => $1053a52e7802e64c$export$a5bd2d81656d9546);
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $1053a52e7802e64c$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

});

parcelRegister("gdhAa", function(module, exports) {

$parcel$export(module.exports, "SENTRY_BAGGAGE_KEY_PREFIX", () => $bcdb7fb6cf7e08bf$export$6e69537d67fa20f);
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $bcdb7fb6cf7e08bf$export$56766feef403f365);

var $fKzCQ = parcelRequire("fKzCQ");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");
const $bcdb7fb6cf7e08bf$export$6e69537d67fa20f = 'sentry-';
const $bcdb7fb6cf7e08bf$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $bcdb7fb6cf7e08bf$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($bcdb7fb6cf7e08bf$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($bcdb7fb6cf7e08bf$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $bcdb7fb6cf7e08bf$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$bcdb7fb6cf7e08bf$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $dfMsQ.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        })).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $bcdb7fb6cf7e08bf$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $bcdb7fb6cf7e08bf$export$bdd844ddb2def819) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});



parcelRegister("cucnP", function(module, exports) {

$parcel$export(module.exports, "dsnToString", () => $9171e4713e443b9b$export$44d472fbb931a776);
$parcel$export(module.exports, "extractOrgIdFromDsnHost", () => $9171e4713e443b9b$export$5914f4e7748c29c9);
$parcel$export(module.exports, "makeDsn", () => $9171e4713e443b9b$export$128827c3562ec0cb);

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");
/** Regular expression used to extract org ID from a DSN host. */ const $9171e4713e443b9b$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $9171e4713e443b9b$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $9171e4713e443b9b$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $9171e4713e443b9b$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $9171e4713e443b9b$export$b892860177f70a30(str) {
    const match = $9171e4713e443b9b$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $hi47i.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $9171e4713e443b9b$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $9171e4713e443b9b$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $9171e4713e443b9b$var$validateDsn(dsn) {
    if (!(0, $fKzCQ.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $hi47i.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $hi47i.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$9171e4713e443b9b$var$isValidProtocol(protocol)) {
        (0, $hi47i.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $hi47i.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $9171e4713e443b9b$export$5914f4e7748c29c9(host) {
    const match = host.match($9171e4713e443b9b$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $9171e4713e443b9b$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $9171e4713e443b9b$export$b892860177f70a30(from) : $9171e4713e443b9b$var$dsnFromComponents(from);
    if (!components || !$9171e4713e443b9b$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("3M05P", function(module, exports) {

$parcel$export(module.exports, "isURLObjectRelative", () => $2bf5ed435a4428b5$export$e258e13805402ba7);
$parcel$export(module.exports, "parseStringToURLObject", () => $2bf5ed435a4428b5$export$2004d912a9ead694);
$parcel$export(module.exports, "getSanitizedUrlStringFromUrlObject", () => $2bf5ed435a4428b5$export$5339fcdc8e2a427c);
$parcel$export(module.exports, "parseUrl", () => $2bf5ed435a4428b5$export$7a5253c0f62e0150);
$parcel$export(module.exports, "stripUrlQueryAndFragment", () => $2bf5ed435a4428b5$export$ce084c78234bd35);

var $yQUXg = parcelRequire("yQUXg");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $2bf5ed435a4428b5$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $2bf5ed435a4428b5$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $2bf5ed435a4428b5$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase ?? (isRelative ? $2bf5ed435a4428b5$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2bf5ed435a4428b5$export$5339fcdc8e2a427c(url) {
    if ($2bf5ed435a4428b5$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $2bf5ed435a4428b5$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $2bf5ed435a4428b5$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $2bf5ed435a4428b5$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
    }
    if (request?.method) attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
        }
        if (!$2bf5ed435a4428b5$export$e258e13805402ba7(urlObject)) {
            attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $2bf5ed435a4428b5$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $2bf5ed435a4428b5$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $2bf5ed435a4428b5$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2bf5ed435a4428b5$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("igqi3", function(module, exports) {

$parcel$export(module.exports, "registerSpanErrorInstrumentation", () => $d4be1d52827a3f28$export$b0914730ee1f6c80);

var $fKzCQ = parcelRequire("fKzCQ");

var $4H7Y8 = parcelRequire("4H7Y8");

var $6El2X = parcelRequire("6El2X");

var $alg0v = parcelRequire("alg0v");

var $hi47i = parcelRequire("hi47i");

var $02dIh = parcelRequire("02dIh");
let $d4be1d52827a3f28$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $d4be1d52827a3f28$export$b0914730ee1f6c80() {
    if ($d4be1d52827a3f28$var$errorsInstrumented) return;
    $d4be1d52827a3f28$var$errorsInstrumented = true;
    (0, $6El2X.addGlobalErrorInstrumentationHandler)($d4be1d52827a3f28$var$errorCallback);
    (0, $alg0v.addGlobalUnhandledRejectionInstrumentationHandler)($d4be1d52827a3f28$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */ function $d4be1d52827a3f28$var$errorCallback() {
    const activeSpan = (0, $4H7Y8.getActiveSpan)();
    const rootSpan = activeSpan && (0, $4H7Y8.getRootSpan)(activeSpan);
    if (rootSpan) {
        const message = 'internal_error';
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`[Tracing] Root span: ${message} -> Global error occurred`);
        rootSpan.setStatus({
            code: (0, $02dIh.SPAN_STATUS_ERROR),
            message: message
        });
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$d4be1d52827a3f28$var$errorCallback.tag = 'sentry_tracingErrorCallback';

});
parcelRegister("6El2X", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $4d76cdf59d4d2156$export$55b5c3ba2194f0c6);

var $2fKhD = parcelRequire("2fKhD");

var $kE1Yf = parcelRequire("kE1Yf");
let $4d76cdf59d4d2156$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4d76cdf59d4d2156$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, $4d76cdf59d4d2156$var$instrumentError);
}
function $4d76cdf59d4d2156$var$instrumentError() {
    $4d76cdf59d4d2156$var$_oldOnErrorHandler = (0, $2fKhD.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $2fKhD.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $kE1Yf.triggerHandlers)('error', handlerData);
        if ($4d76cdf59d4d2156$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $4d76cdf59d4d2156$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $2fKhD.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("kE1Yf", function(module, exports) {

$parcel$export(module.exports, "addHandler", () => $f079126c500c7ea2$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $f079126c500c7ea2$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $f079126c500c7ea2$export$b18c893e424d3127);

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");

var $5v1oS = parcelRequire("5v1oS");
// We keep the handlers globally
const $f079126c500c7ea2$var$handlers = {};
const $f079126c500c7ea2$var$instrumented = {};
/** Add a handler function. */ function $f079126c500c7ea2$export$a4e09611e30da72e(type, handler) {
    $f079126c500c7ea2$var$handlers[type] = $f079126c500c7ea2$var$handlers[type] || [];
    $f079126c500c7ea2$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $f079126c500c7ea2$export$b17eab759a1cb5fe() {
    Object.keys($f079126c500c7ea2$var$handlers).forEach((key)=>{
        $f079126c500c7ea2$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $f079126c500c7ea2$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$f079126c500c7ea2$var$instrumented[type]) {
        $f079126c500c7ea2$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $f079126c500c7ea2$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $f079126c500c7ea2$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $5v1oS.getFunctionName)(handler)}\nError:`, e);
    }
}

});
parcelRegister("5v1oS", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_FUNCTION", () => $4010ef0d9b3761f9$export$27c7e15d453fc0ac);
$parcel$export(module.exports, "createStackParser", () => $4010ef0d9b3761f9$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $4010ef0d9b3761f9$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $4010ef0d9b3761f9$export$aad197c7121a6651);
$parcel$export(module.exports, "getFramesFromEvent", () => $4010ef0d9b3761f9$export$91d8ca51bd9f6a47);
const $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT = 50;
const $4010ef0d9b3761f9$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $4010ef0d9b3761f9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $4010ef0d9b3761f9$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $4010ef0d9b3761f9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $4010ef0d9b3761f9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $4010ef0d9b3761f9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $4010ef0d9b3761f9$var$getLastStackFrame(localStack).filename,
            function: frame.function || $4010ef0d9b3761f9$export$27c7e15d453fc0ac
        }));
}
function $4010ef0d9b3761f9$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $4010ef0d9b3761f9$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $4010ef0d9b3761f9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $4010ef0d9b3761f9$var$defaultFunctionName;
        return fn.name || $4010ef0d9b3761f9$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $4010ef0d9b3761f9$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $4010ef0d9b3761f9$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}

});



parcelRegister("alg0v", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $7878483f8a9932cd$export$8bf4fc6858821a4e);

var $2fKhD = parcelRequire("2fKhD");

var $kE1Yf = parcelRequire("kE1Yf");
let $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7878483f8a9932cd$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, $7878483f8a9932cd$var$instrumentUnhandledRejection);
}
function $7878483f8a9932cd$var$instrumentUnhandledRejection() {
    $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = (0, $2fKhD.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $2fKhD.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $kE1Yf.triggerHandlers)('unhandledrejection', handlerData);
        if ($7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $2fKhD.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("lLL40", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", () => $fd927ea1b5d85956$export$809a2b7987fd5306);
$parcel$export(module.exports, "startIdleSpan", () => $fd927ea1b5d85956$export$901bffd97bd52797);

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $yQUXg = parcelRequire("yQUXg");

var $4XLci = parcelRequire("4XLci");

var $dc48k = parcelRequire("dc48k");

var $4H7Y8 = parcelRequire("4H7Y8");

var $hi47i = parcelRequire("hi47i");

var $6OKHc = parcelRequire("6OKHc");

var $jdzJv = parcelRequire("jdzJv");

var $iAX8i = parcelRequire("iAX8i");

var $02dIh = parcelRequire("02dIh");

var $iMoih = parcelRequire("iMoih");
const $fd927ea1b5d85956$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $fd927ea1b5d85956$var$FINISH_REASON_HEARTBEAT_FAILED = 'heartbeatFailed';
const $fd927ea1b5d85956$var$FINISH_REASON_IDLE_TIMEOUT = 'idleTimeout';
const $fd927ea1b5d85956$var$FINISH_REASON_FINAL_TIMEOUT = 'finalTimeout';
const $fd927ea1b5d85956$var$FINISH_REASON_EXTERNAL_FINISH = 'externalFinish';
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $fd927ea1b5d85956$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $kGYVh.getClient)();
    if (!client || !(0, $4XLci.hasSpansEnabled)()) {
        const span = new (0, $iAX8i.SentryNonRecordingSpan)();
        const dsc = {
            sample_rate: '0',
            sampled: 'false',
            ...(0, $jdzJv.getDynamicSamplingContextFromSpan)(span)
        };
        (0, $jdzJv.freezeDscOnSpan)(span, dsc);
        return span;
    }
    const scope = (0, $kGYVh.getCurrentScope)();
    const previousActiveSpan = (0, $4H7Y8.getActiveSpan)();
    const span = $fd927ea1b5d85956$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // If the span is non-recording, nothing more to do here...
            // This is the case if tracing is enabled but this specific span was not sampled
            if (thisArg instanceof (0, $iAX8i.SentryNonRecordingSpan)) return;
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $6OKHc.timestampInSeconds)();
            const spanEndTimestamp = (0, $4H7Y8.spanTimeInputToSeconds)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $4H7Y8.getSpanDescendants)(span).filter((child)=>child !== span);
            // If we have no spans, we just end, nothing else to do here
            if (!spans.length) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const childEndTimestamps = spans.map((span)=>(0, $4H7Y8.spanToJSON)(span).timestamp).filter((timestamp)=>!!timestamp);
            const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = (0, $4H7Y8.spanToJSON)(span).start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $6OKHc.timestampInSeconds)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $6OKHc.timestampInSeconds)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $dc48k._setSpanForScope)(scope, previousActiveSpan);
        const spanJSON = (0, $4H7Y8.spanToJSON)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute((0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), _finishReason);
        (0, $hi47i.logger).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $4H7Y8.getSpanDescendants)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $02dIh.SPAN_STATUS_ERROR),
                    message: 'cancelled'
                });
                childSpan.end(endTimestamp);
                (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log('[Tracing] Cancelling span since span ended early', JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $4H7Y8.spanToJSON)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $fKzCQ.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $hi47i.logger).log('[Tracing] Discarding span since it happened after idle span was finished', stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $hi47i.logger).log('[Tracing] Discarding span since it finished after idle span final timeout', stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $4H7Y8.removeChildSpanFromSpan)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute('sentry.idle_span_discarded_spans', discardedSpans);
    }
    _cleanupHooks.push(client.on('spanStart', (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $4H7Y8.spanToJSON)(startedSpan).timestamp) return;
        const allSpans = (0, $4H7Y8.getSpanDescendants)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('spanEnd', (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('idleSpanEnableAutoFinish', (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $02dIh.SPAN_STATUS_ERROR),
                message: 'deadline_exceeded'
            });
            _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $fd927ea1b5d85956$var$_startIdleSpan(options) {
    const span = (0, $iMoih.startInactiveSpan)(options);
    (0, $dc48k._setSpanForScope)((0, $kGYVh.getCurrentScope)(), span);
    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log('[Tracing] Started span is an idle span');
    return span;
}

});
parcelRegister("iAX8i", function(module, exports) {

$parcel$export(module.exports, "SentryNonRecordingSpan", () => $d899755a957e1f50$export$d6636b700b76c516);

var $4H7Y8 = parcelRequire("4H7Y8");

var $iWfxY = parcelRequire("iWfxY");
/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $d899755a957e1f50$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $iWfxY.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $iWfxY.generateSpanId)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $4H7Y8.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}

});

parcelRegister("iMoih", function(module, exports) {

$parcel$export(module.exports, "startInactiveSpan", () => $038737f78c636108$export$63dbba021a6b4047);
$parcel$export(module.exports, "withActiveSpan", () => $038737f78c636108$export$e57ac09b143d92a2);

var $7YCyf = parcelRequire("7YCyf");

var $iNK7c = parcelRequire("iNK7c");

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $yQUXg = parcelRequire("yQUXg");

var $e0ut8 = parcelRequire("e0ut8");

var $4XLci = parcelRequire("4XLci");

var $1oUdV = parcelRequire("1oUdV");

var $dc48k = parcelRequire("dc48k");

var $4H7Y8 = parcelRequire("4H7Y8");

var $hi47i = parcelRequire("hi47i");

var $iWfxY = parcelRequire("iWfxY");

var $AIi6N = parcelRequire("AIi6N");

var $jdzJv = parcelRequire("jdzJv");

var $Pw6ba = parcelRequire("Pw6ba");

var $iODTf = parcelRequire("iODTf");

var $iAX8i = parcelRequire("iAX8i");

var $jCe8B = parcelRequire("jCe8B");

var $02dIh = parcelRequire("02dIh");

var $5VulJ = parcelRequire("5VulJ");
/* eslint-disable max-lines */ const $038737f78c636108$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$a1bd95187356f372(options, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $kGYVh.withScope)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $038737f78c636108$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $kGYVh.getCurrentScope)();
            const parentSpan = $038737f78c636108$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $iAX8i.SentryNonRecordingSpan)() : $038737f78c636108$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $dc48k._setSpanForScope)(scope, activeSpan);
            return (0, $e0ut8.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $4H7Y8.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $02dIh.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$c10292ad04b92aea(options, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $kGYVh.withScope)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $038737f78c636108$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $kGYVh.getCurrentScope)();
            const parentSpan = $038737f78c636108$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $iAX8i.SentryNonRecordingSpan)() : $038737f78c636108$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $dc48k._setSpanForScope)(scope, activeSpan);
            return (0, $e0ut8.handleCallbackErrors)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $4H7Y8.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $02dIh.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$63dbba021a6b4047(options) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $kGYVh.withScope)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$038737f78c636108$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $kGYVh.getCurrentScope)();
        const parentSpan = $038737f78c636108$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $iAX8i.SentryNonRecordingSpan)();
        return $038737f78c636108$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $038737f78c636108$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    return (0, $kGYVh.withScope)((scope)=>{
        const propagationContext = (0, $AIi6N.propagationContextFromHeaders)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $038737f78c636108$export$e57ac09b143d92a2(span, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $kGYVh.withScope)((scope)=>{
        (0, $dc48k._setSpanForScope)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $038737f78c636108$export$869298f9835abc68(callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $kGYVh.withScope)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$038737f78c636108$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $038737f78c636108$export$f90b03291402f553(callback) {
    return (0, $kGYVh.withScope)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $iWfxY.generateTraceId)(),
            sampleRand: Math.random()
        });
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $038737f78c636108$export$e57ac09b143d92a2(null, callback);
    });
}
function $038737f78c636108$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $4XLci.hasSpansEnabled)()) {
        const span = new (0, $iAX8i.SentryNonRecordingSpan)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name,
                ...(0, $jdzJv.getDynamicSamplingContextFromSpan)(span)
            };
            (0, $jdzJv.freezeDscOnSpan)(span, dsc);
        }
        return span;
    }
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $038737f78c636108$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $4H7Y8.addChildSpanToSpan)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $jdzJv.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $4H7Y8.spanIsSampled)(parentSpan);
        span = $038737f78c636108$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $jdzJv.freezeDscOnSpan)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $038737f78c636108$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $jdzJv.freezeDscOnSpan)(span, dsc);
    }
    (0, $Pw6ba.logSpanStart)(span);
    (0, $5VulJ.setCapturedScopesOnSpan)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $038737f78c636108$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $4H7Y8.spanTimeInputToSeconds)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $038737f78c636108$var$getAcs() {
    const carrier = (0, $iNK7c.getMainCarrier)();
    return (0, $7YCyf.getAsyncContextStrategy)(carrier);
}
function $038737f78c636108$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $kGYVh.getClient)();
    const options = client?.getOptions() || {};
    const { name: name = '' } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit('beforeSampling', mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const [sampled, sampleRate, localSampleRateWasApplied] = scope.getScopeData().sdkProcessingMetadata[$038737f78c636108$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $iODTf.sampleSpan)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $1oUdV.parseSampleRate)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $jCe8B.SentrySpan)({
        ...spanArguments,
        attributes: {
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $038737f78c636108$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$038737f78c636108$var$SUPPRESS_TRACING_KEY] ? false : (0, $4H7Y8.spanIsSampled)(parentSpan);
    const childSpan = sampled ? new (0, $jCe8B.SentrySpan)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $iAX8i.SentryNonRecordingSpan)({
        traceId: traceId
    });
    (0, $4H7Y8.addChildSpanToSpan)(parentSpan, childSpan);
    const client = (0, $kGYVh.getClient)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function $038737f78c636108$var$getParentSpan(scope) {
    const span = (0, $dc48k._getSpanForScope)(scope);
    if (!span) return undefined;
    const client = (0, $kGYVh.getClient)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $4H7Y8.getRootSpan)(span);
    return span;
}
function $038737f78c636108$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $038737f78c636108$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}

});
parcelRegister("e0ut8", function(module, exports) {

$parcel$export(module.exports, "handleCallbackErrors", () => $a328b345a75725bb$export$18ce21a8b7efd7e9);

var $dfMsQ = parcelRequire("dfMsQ");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $a328b345a75725bb$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $a328b345a75725bb$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $a328b345a75725bb$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $dfMsQ.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("Pw6ba", function(module, exports) {

$parcel$export(module.exports, "logSpanStart", () => $09ada9a941cee5f6$export$2f3d84e767c9592b);
$parcel$export(module.exports, "logSpanEnd", () => $09ada9a941cee5f6$export$b77c830667a4d630);

var $fKzCQ = parcelRequire("fKzCQ");

var $4H7Y8 = parcelRequire("4H7Y8");

var $hi47i = parcelRequire("hi47i");
/**
 * Print a log message for a started span.
 */ function $09ada9a941cee5f6$export$2f3d84e767c9592b(span) {
    if (!(0, $fKzCQ.DEBUG_BUILD)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $4H7Y8.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $4H7Y8.spanIsSampled)(span);
    const rootSpan = (0, $4H7Y8.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $4H7Y8.spanToJSON)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $hi47i.logger).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $09ada9a941cee5f6$export$b77c830667a4d630(span) {
    if (!(0, $fKzCQ.DEBUG_BUILD)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $4H7Y8.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $4H7Y8.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $hi47i.logger).log(msg);
}

});

parcelRegister("iODTf", function(module, exports) {

$parcel$export(module.exports, "sampleSpan", () => $db2bd6d2ef458b60$export$5f833db634b217bb);

var $fKzCQ = parcelRequire("fKzCQ");

var $4XLci = parcelRequire("4XLci");

var $1oUdV = parcelRequire("1oUdV");

var $hi47i = parcelRequire("hi47i");
/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $db2bd6d2ef458b60$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $4XLci.hasSpansEnabled)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $1oUdV.parseSampleRate)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}

});

parcelRegister("jCe8B", function(module, exports) {

$parcel$export(module.exports, "SentrySpan", () => $e47c8865bba9bc73$export$a92149b045260d9f);

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $fQDlp = parcelRequire("fQDlp");

var $yQUXg = parcelRequire("yQUXg");

var $4H7Y8 = parcelRequire("4H7Y8");

var $hi47i = parcelRequire("hi47i");

var $iWfxY = parcelRequire("iWfxY");

var $6OKHc = parcelRequire("6OKHc");

var $jdzJv = parcelRequire("jdzJv");

var $Pw6ba = parcelRequire("Pw6ba");

var $5ovbv = parcelRequire("5ovbv");

var $5VulJ = parcelRequire("5VulJ");
const $e47c8865bba9bc73$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $e47c8865bba9bc73$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $iWfxY.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $iWfxY.generateSpanId)();
        this._startTime = spanContext.startTimestamp || (0, $6OKHc.timestampInSeconds)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'manual',
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $4H7Y8.TRACE_FLAG_SAMPLED) : (0, $4H7Y8.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $4H7Y8.spanTimeInputToSeconds)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $4H7Y8.spanTimeInputToSeconds)(endTimestamp);
        (0, $Pw6ba.logSpanEnd)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $4H7Y8.getStatusMessage)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: (0, $5ovbv.timedEventsToMeasurements)(this._events),
            is_segment: this._isStandaloneSpan && (0, $4H7Y8.getRootSpan)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $4H7Y8.getRootSpan)(this).spanContext().spanId : undefined,
            links: (0, $4H7Y8.convertSpanLinksForEnvelope)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log('[Tracing] Adding an event to span:', name);
        const time = $e47c8865bba9bc73$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $6OKHc.timestampInSeconds)();
        const attributes = $e47c8865bba9bc73$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $4H7Y8.spanTimeInputToSeconds)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $kGYVh.getClient)();
        if (client) client.emit('spanEnd', this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $4H7Y8.getRootSpan)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $e47c8865bba9bc73$var$sendSpanEnvelope((0, $fQDlp.createSpanEnvelope)([
                this
            ], client));
            else {
                (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $5VulJ.getCapturedScopesOnSpan)(this).scope || (0, $kGYVh.getCurrentScope)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$e47c8865bba9bc73$var$isFullFinishedSpan((0, $4H7Y8.spanToJSON)(this))) return undefined;
        if (!this._name) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $5VulJ.getCapturedScopesOnSpan)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $4H7Y8.getSpanDescendants)(this).filter((span)=>span !== this && !$e47c8865bba9bc73$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $4H7Y8.spanToJSON)(span)).filter($e47c8865bba9bc73$var$isFullFinishedSpan);
        const source = this._attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        spans.forEach((span)=>{
            delete span.data[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $4H7Y8.spanToTransactionTraceContext)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $e47c8865bba9bc73$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $e47c8865bba9bc73$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $jdzJv.getDynamicSamplingContextFromSpan)(this)
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $5ovbv.timedEventsToMeasurements)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $e47c8865bba9bc73$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $e47c8865bba9bc73$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $e47c8865bba9bc73$var$isStandaloneSpan(span) {
    return span instanceof $e47c8865bba9bc73$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $e47c8865bba9bc73$var$sendSpanEnvelope(envelope) {
    const client = (0, $kGYVh.getClient)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

});
parcelRegister("fQDlp", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", () => $b89a3b4f1056006b$export$124b03c077baa2f3);
$parcel$export(module.exports, "createEventEnvelope", () => $b89a3b4f1056006b$export$c31057337a18010f);
$parcel$export(module.exports, "createSpanEnvelope", () => $b89a3b4f1056006b$export$19a0081d4b39d77);

var $jdzJv = parcelRequire("jdzJv");

var $4H7Y8 = parcelRequire("4H7Y8");

var $cucnP = parcelRequire("cucnP");

var $l4iiL = parcelRequire("l4iiL");


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $b89a3b4f1056006b$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $l4iiL.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $cucnP.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $l4iiL.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $b89a3b4f1056006b$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $l4iiL.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $l4iiL.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $l4iiL.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $b89a3b4f1056006b$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $jdzJv.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $cucnP.dsnToString)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $4H7Y8.spanToJSON)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $4H7Y8.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $4H7Y8.spanToJSON);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $l4iiL.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $l4iiL.createEnvelope)(headers, items);
}

});
parcelRegister("l4iiL", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", () => $f5682b06913d5b03$export$f93f7f385160c44e);
$parcel$export(module.exports, "addItemToEnvelope", () => $f5682b06913d5b03$export$d650323442802f6f);
$parcel$export(module.exports, "forEachEnvelopeItem", () => $f5682b06913d5b03$export$c56c55acf0136fd3);
$parcel$export(module.exports, "serializeEnvelope", () => $f5682b06913d5b03$export$32f9b428425aac85);
$parcel$export(module.exports, "createSpanEnvelopeItem", () => $f5682b06913d5b03$export$655cf139bc8b8afd);
$parcel$export(module.exports, "createAttachmentEnvelopeItem", () => $f5682b06913d5b03$export$d8fc80952cc31fa4);
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", () => $f5682b06913d5b03$export$b11169581eeaf237);
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", () => $f5682b06913d5b03$export$d369f3b2758f6743);
$parcel$export(module.exports, "createEventEnvelopeHeaders", () => $f5682b06913d5b03$export$92b6093782fe661b);

var $iNK7c = parcelRequire("iNK7c");

var $cucnP = parcelRequire("cucnP");

var $886wr = parcelRequire("886wr");

var $2fKhD = parcelRequire("2fKhD");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $f5682b06913d5b03$export$604a45d95a155e2b(envelope, types) {
    return $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $f5682b06913d5b03$var$encodeUTF8(input) {
    const carrier = (0, $iNK7c.getSentryCarrier)((0, $2fKhD.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $f5682b06913d5b03$var$decodeUTF8(input) {
    const carrier = (0, $iNK7c.getSentryCarrier)((0, $2fKhD.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $f5682b06913d5b03$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $f5682b06913d5b03$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $f5682b06913d5b03$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $886wr.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $f5682b06913d5b03$var$concatBuffers(parts);
}
function $f5682b06913d5b03$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $f5682b06913d5b03$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $f5682b06913d5b03$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($f5682b06913d5b03$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $f5682b06913d5b03$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $f5682b06913d5b03$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $f5682b06913d5b03$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $f5682b06913d5b03$export$b11169581eeaf237(type) {
    return $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $f5682b06913d5b03$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $f5682b06913d5b03$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $cucnP.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}

});
parcelRegister("886wr", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $5eb42146e0d2c9ef$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $5eb42146e0d2c9ef$export$23fbbb20bed71033);

var $dfMsQ = parcelRequire("dfMsQ");

var $l1oVX = parcelRequire("l1oVX");

var $5v1oS = parcelRequire("5v1oS");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $5eb42146e0d2c9ef$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $5eb42146e0d2c9ef$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $5eb42146e0d2c9ef$export$a3295358bff77e(object, depth);
    if ($5eb42146e0d2c9ef$var$jsonSize(normalized) > maxSize) return $5eb42146e0d2c9ef$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $5eb42146e0d2c9ef$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $5eb42146e0d2c9ef$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $5eb42146e0d2c9ef$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $5eb42146e0d2c9ef$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $l1oVX.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $5eb42146e0d2c9ef$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $5eb42146e0d2c9ef$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $dfMsQ.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $dfMsQ.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $5v1oS.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $5eb42146e0d2c9ef$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $5eb42146e0d2c9ef$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $5eb42146e0d2c9ef$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$var$jsonSize(value) {
    return $5eb42146e0d2c9ef$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $5eb42146e0d2c9ef$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $5eb42146e0d2c9ef$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

});



parcelRegister("5ovbv", function(module, exports) {

$parcel$export(module.exports, "setMeasurement", () => $3ed76239c787a980$export$7cc31b475d33a706);
$parcel$export(module.exports, "timedEventsToMeasurements", () => $3ed76239c787a980$export$487db6fcdf36893e);

var $fKzCQ = parcelRequire("fKzCQ");

var $yQUXg = parcelRequire("yQUXg");

var $4H7Y8 = parcelRequire("4H7Y8");

var $hi47i = parcelRequire("hi47i");
/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $3ed76239c787a980$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $4H7Y8.getActiveSpan)()) {
    const rootSpan = activeSpan && (0, $4H7Y8.getRootSpan)(activeSpan);
    if (rootSpan) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: value,
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $3ed76239c787a980$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}

});




parcelRegister("5hw2H", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", () => $3d87653da885c31c$export$3f18c56c58114e75);

var $kE1Yf = parcelRequire("kE1Yf");
var $l1oVX = parcelRequire("l1oVX");
var $aW7Vg = parcelRequire("aW7Vg");

var $cOSHO = parcelRequire("cOSHO");
let $3d87653da885c31c$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3d87653da885c31c$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, $3d87653da885c31c$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $3d87653da885c31c$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $cOSHO.WINDOW).addEventListener('popstate', ()=>{
        const to = (0, $cOSHO.WINDOW).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $3d87653da885c31c$var$lastHref;
        $3d87653da885c31c$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $kE1Yf.triggerHandlers)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $aW7Vg.supportsHistory)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $3d87653da885c31c$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $3d87653da885c31c$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $3d87653da885c31c$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $kE1Yf.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $l1oVX.fill)((0, $cOSHO.WINDOW).history, 'pushState', historyReplacementFunction);
    (0, $l1oVX.fill)((0, $cOSHO.WINDOW).history, 'replaceState', historyReplacementFunction);
}
function $3d87653da885c31c$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $cOSHO.WINDOW).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}

});
parcelRegister("aW7Vg", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", () => $020e060e3b422828$export$67fc34576016d6ec);
$parcel$export(module.exports, "isNativeFunction", () => $020e060e3b422828$export$d5f608b368e73f38);
$parcel$export(module.exports, "supportsNativeFetch", () => $020e060e3b422828$export$c82d238e23c40b21);

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");

var $2fKhD = parcelRequire("2fKhD");
const $020e060e3b422828$var$WINDOW = (0, $2fKhD.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$67fc34576016d6ec() {
    return 'history' in $020e060e3b422828$var$WINDOW && !!$020e060e3b422828$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $020e060e3b422828$export$edf3cb81fd7d2a3e = $020e060e3b422828$var$_isFetchSupported;
function $020e060e3b422828$var$_isFetchSupported() {
    if (!('fetch' in $020e060e3b422828$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $020e060e3b422828$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $020e060e3b422828$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$020e060e3b422828$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($020e060e3b422828$export$d5f608b368e73f38($020e060e3b422828$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $020e060e3b422828$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $020e060e3b422828$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$531055a6c684a70a() {
    return 'ReportingObserver' in $020e060e3b422828$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $020e060e3b422828$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$020e060e3b422828$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("cOSHO", function(module, exports) {

$parcel$export(module.exports, "WINDOW", () => $955496f5d3029976$export$56d8a8a25bd48b81);

var $2fKhD = parcelRequire("2fKhD");
const $955496f5d3029976$export$56d8a8a25bd48b81 = (0, $2fKhD.GLOBAL_OBJ);

});


parcelRegister("6zU5D", function(module, exports) {

$parcel$export(module.exports, "startTrackingWebVitals", () => $4ca18541755f3f2c$export$7c69f0412d101b88);
$parcel$export(module.exports, "startTrackingLongTasks", () => $4ca18541755f3f2c$export$f396d19077034ad2);
$parcel$export(module.exports, "startTrackingLongAnimationFrames", () => $4ca18541755f3f2c$export$5b823ab2ccbc801d);
$parcel$export(module.exports, "startTrackingInteractions", () => $4ca18541755f3f2c$export$e27543e0976315e4);
$parcel$export(module.exports, "addPerformanceEntries", () => $4ca18541755f3f2c$export$5f8fa6b3467a7443);

var $6OKHc = parcelRequire("6OKHc");
var $4H7Y8 = parcelRequire("4H7Y8");
var $hA6iJ = parcelRequire("hA6iJ");
var $3M05P = parcelRequire("3M05P");
var $yQUXg = parcelRequire("yQUXg");
var $5ovbv = parcelRequire("5ovbv");
var $hLnp0 = parcelRequire("hLnp0");

var $cOSHO = parcelRequire("cOSHO");

var $ftz8j = parcelRequire("ftz8j");

var $4hTws = parcelRequire("4hTws");

var $fbcQh = parcelRequire("fbcQh");

var $J8pIz = parcelRequire("J8pIz");

var $5Tr5v = parcelRequire("5Tr5v");

var $gqIP5 = parcelRequire("gqIP5");
const $4ca18541755f3f2c$var$MAX_INT_AS_BYTES = 2147483647;
let $4ca18541755f3f2c$var$_performanceCursor = 0;
let $4ca18541755f3f2c$var$_measurements = {};
let $4ca18541755f3f2c$var$_lcpEntry;
let $4ca18541755f3f2c$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $4ca18541755f3f2c$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans }) {
    const performance = (0, $fbcQh.getBrowserPerformanceAPI)();
    if (performance && (0, $6OKHc.browserPerformanceTimeOrigin)()) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $cOSHO.WINDOW).performance.mark('sentry-tracing-init');
        const fidCleanupCallback = $4ca18541755f3f2c$var$_trackFID();
        const lcpCleanupCallback = $4ca18541755f3f2c$var$_trackLCP();
        const ttfbCleanupCallback = $4ca18541755f3f2c$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $ftz8j.trackClsAsStandaloneSpan)() : $4ca18541755f3f2c$var$_trackCLS();
        return ()=>{
            fidCleanupCallback();
            lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback?.();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $4ca18541755f3f2c$export$f396d19077034ad2() {
    (0, $4hTws.addPerformanceInstrumentationHandler)('longtask', ({ entries: entries })=>{
        const parent = (0, $4H7Y8.getActiveSpan)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $4H7Y8.spanToJSON)(parent);
        for (const entry of entries){
            const startTime = (0, $fbcQh.msToSec)((0, $6OKHc.browserPerformanceTimeOrigin)() + entry.startTime);
            const duration = (0, $fbcQh.msToSec)(entry.duration);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $fbcQh.startAndEndSpan)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-task',
                attributes: {
                    [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $4ca18541755f3f2c$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $4H7Y8.getActiveSpan)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $fbcQh.msToSec)((0, $6OKHc.browserPerformanceTimeOrigin)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $4H7Y8.spanToJSON)(parent);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $fbcQh.msToSec)(entry.duration);
            const attributes = {
                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes['browser.script.invoker'] = invoker;
            attributes['browser.script.invoker_type'] = invokerType;
            if (sourceURL) attributes['code.filepath'] = sourceURL;
            if (sourceFunctionName) attributes['code.function'] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes['browser.script.source_char_position'] = sourceCharPosition;
            (0, $fbcQh.startAndEndSpan)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-animation-frame',
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: 'long-animation-frame',
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $4ca18541755f3f2c$export$e27543e0976315e4() {
    (0, $4hTws.addPerformanceInstrumentationHandler)('event', ({ entries: entries })=>{
        const parent = (0, $4H7Y8.getActiveSpan)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === 'click') {
            const startTime = (0, $fbcQh.msToSec)((0, $6OKHc.browserPerformanceTimeOrigin)() + entry.startTime);
            const duration = (0, $fbcQh.msToSec)(entry.duration);
            const spanOptions = {
                name: (0, $hA6iJ.htmlTreeAsString)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
                }
            };
            const componentName = (0, $hA6iJ.getComponentName)(entry.target);
            if (componentName) spanOptions.attributes['ui.component_name'] = componentName;
            (0, $fbcQh.startAndEndSpan)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $4ca18541755f3f2c$var$_trackCLS() {
    return (0, $4hTws.addClsInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $4ca18541755f3f2c$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $4ca18541755f3f2c$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $4ca18541755f3f2c$var$_trackLCP() {
    return (0, $4hTws.addLcpInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $4ca18541755f3f2c$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $4ca18541755f3f2c$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $4ca18541755f3f2c$var$_trackFID() {
    return (0, $4hTws.addFidInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = (0, $fbcQh.msToSec)((0, $6OKHc.browserPerformanceTimeOrigin)());
        const startTime = (0, $fbcQh.msToSec)(entry.startTime);
        $4ca18541755f3f2c$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $4ca18541755f3f2c$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $4ca18541755f3f2c$var$_trackTtfb() {
    return (0, $4hTws.addTtfbInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $4ca18541755f3f2c$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
/** Add performance related spans to a transaction */ function $4ca18541755f3f2c$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $fbcQh.getBrowserPerformanceAPI)();
    const origin = (0, $6OKHc.browserPerformanceTimeOrigin)();
    if (!performance?.getEntries || !origin) // Gatekeeper if performance API not available
    return;
    const timeOrigin = (0, $fbcQh.msToSec)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $4H7Y8.spanToJSON)(span);
    performanceEntries.slice($4ca18541755f3f2c$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $fbcQh.msToSec)(entry.startTime);
        const duration = (0, $fbcQh.msToSec)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $4ca18541755f3f2c$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $4ca18541755f3f2c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, options.ignorePerformanceApiSpans);
                    // capture web vitals
                    const firstHidden = (0, $gqIP5.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) $4ca18541755f3f2c$var$_measurements['fp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    if (entry.name === 'first-contentful-paint' && shouldRecord) $4ca18541755f3f2c$var$_measurements['fcp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    break;
                }
            case 'resource':
                $4ca18541755f3f2c$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, options.ignoreResourceSpans);
                break;
        }
    });
    $4ca18541755f3f2c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $4ca18541755f3f2c$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $4ca18541755f3f2c$var$_addTtfbRequestTimeToMeasurements($4ca18541755f3f2c$var$_measurements);
        const fidMark = $4ca18541755f3f2c$var$_measurements['mark.fid'];
        if (fidMark && $4ca18541755f3f2c$var$_measurements['fid']) {
            // create span for FID
            (0, $fbcQh.startAndEndSpan)(span, fidMark.value, fidMark.value + (0, $fbcQh.msToSec)($4ca18541755f3f2c$var$_measurements['fid'].value), {
                name: 'first input delay',
                op: 'ui.action',
                attributes: {
                    [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
                }
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $4ca18541755f3f2c$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        // TODO: Check if the first condition is still necessary: `onCLS` already only fires once `onFCP` was called.
        if (!('fcp' in $4ca18541755f3f2c$var$_measurements) || !options.recordClsOnPageloadSpan) delete $4ca18541755f3f2c$var$_measurements.cls;
        Object.entries($4ca18541755f3f2c$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $5ovbv.setMeasurement)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute('performance.timeOrigin', timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute('performance.activationStart', (0, $J8pIz.getActivationStart)());
        $4ca18541755f3f2c$var$_setWebVitalAttributes(span);
    }
    $4ca18541755f3f2c$var$_lcpEntry = undefined;
    $4ca18541755f3f2c$var$_clsEntry = undefined;
    $4ca18541755f3f2c$var$_measurements = {};
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function $4ca18541755f3f2c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ([
        'mark',
        'measure'
    ].includes(entry.entryType) && (0, $hLnp0.stringMatchesSomePattern)(entry.name, ignorePerformanceApiSpans)) return;
    const navEntry = (0, $5Tr5v.getNavigationEntry)(false);
    const requestTime = (0, $fbcQh.msToSec)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.resource.browser.metrics'
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes['sentry.browser.measure_happened_before_request'] = true;
        attributes['sentry.browser.measure_start_time'] = measureStartTimestamp;
    }
    // Measurements from third parties can be off, which would create invalid spans, dropping transactions in the process.
    if (measureStartTimestamp <= measureEndTimestamp) (0, $fbcQh.startAndEndSpan)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
/**
 * Instrument navigation entries
 * exported only for tests
 */ function $4ca18541755f3f2c$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, 'secureConnection', timeOrigin, 'TLS/SSL');
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, 'fetch', timeOrigin, 'cache');
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, 'domainLookup', timeOrigin, 'DNS');
    $4ca18541755f3f2c$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $4ca18541755f3f2c$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $fbcQh.startAndEndSpan)(span, timeOrigin + (0, $fbcQh.msToSec)(start), timeOrigin + (0, $fbcQh.msToSec)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics',
            ...event === 'redirect' && entry.redirectCount != null ? {
                'http.redirect_count': entry.redirectCount
            } : {}
        }
    });
}
function $4ca18541755f3f2c$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === 'secureConnection') return 'connectEnd';
    if (event === 'fetch') return 'domainLookupStart';
    return `${event}End`;
}
/** Create request and response related spans */ function $4ca18541755f3f2c$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $fbcQh.msToSec)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $fbcQh.msToSec)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $fbcQh.msToSec)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $fbcQh.startAndEndSpan)(span, requestStartTimestamp, responseEndTimestamp, {
            op: 'browser.request',
            name: entry.name,
            attributes: {
                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
            }
        });
        (0, $fbcQh.startAndEndSpan)(span, responseStartTimestamp, responseEndTimestamp, {
            op: 'browser.response',
            name: entry.name,
            attributes: {
                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.ui.browser.metrics'
            }
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function $4ca18541755f3f2c$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoreResourceSpans) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const op = entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other';
    if (ignoreResourceSpans?.includes(op)) return;
    const parsedUrl = (0, $3M05P.parseUrl)(resourceUrl);
    const attributes = {
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.resource.browser.metrics'
    };
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, 'transferSize', 'http.response_transfer_size');
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, 'encodedBodySize', 'http.response_content_length');
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    // `deliveryType` is experimental and does not exist everywhere
    const deliveryType = entry.deliveryType;
    if (deliveryType != null) attributes['http.response_delivery_type'] = deliveryType;
    // Types do not reflect this property yet
    const renderBlockingStatus = entry.renderBlockingStatus;
    if (renderBlockingStatus) attributes['resource.render_blocking_status'] = renderBlockingStatus;
    if (parsedUrl.protocol) attributes['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes['server.address'] = parsedUrl.host;
    attributes['url.same_origin'] = resourceUrl.includes((0, $cOSHO.WINDOW).location.origin);
    const { name: name, version: version } = (0, $fbcQh.extractNetworkProtocol)(entry.nextHopProtocol);
    attributes['network.protocol.name'] = name;
    attributes['network.protocol.version'] = version;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $fbcQh.startAndEndSpan)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $cOSHO.WINDOW).location.origin, ''),
        op: op,
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $4ca18541755f3f2c$var$_trackNavigator(span) {
    const navigator = (0, $cOSHO.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute('effectiveConnectionType', connection.effectiveType);
        if (connection.type) span.setAttribute('connectionType', connection.type);
        if ((0, $fbcQh.isMeasurementValue)(connection.rtt)) $4ca18541755f3f2c$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $fbcQh.isMeasurementValue)(navigator.deviceMemory)) span.setAttribute('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $fbcQh.isMeasurementValue)(navigator.hardwareConcurrency)) span.setAttribute('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $4ca18541755f3f2c$var$_setWebVitalAttributes(span) {
    if ($4ca18541755f3f2c$var$_lcpEntry) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($4ca18541755f3f2c$var$_lcpEntry.element) span.setAttribute('lcp.element', (0, $hA6iJ.htmlTreeAsString)($4ca18541755f3f2c$var$_lcpEntry.element));
        if ($4ca18541755f3f2c$var$_lcpEntry.id) span.setAttribute('lcp.id', $4ca18541755f3f2c$var$_lcpEntry.id);
        if ($4ca18541755f3f2c$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute('lcp.url', $4ca18541755f3f2c$var$_lcpEntry.url.trim().slice(0, 200));
        if ($4ca18541755f3f2c$var$_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute('lcp.loadTime', $4ca18541755f3f2c$var$_lcpEntry.loadTime);
        if ($4ca18541755f3f2c$var$_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute('lcp.renderTime', $4ca18541755f3f2c$var$_lcpEntry.renderTime);
        span.setAttribute('lcp.size', $4ca18541755f3f2c$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($4ca18541755f3f2c$var$_clsEntry?.sources) $4ca18541755f3f2c$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $hA6iJ.htmlTreeAsString)(source.node)));
}
function $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $4ca18541755f3f2c$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $4ca18541755f3f2c$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $5Tr5v.getNavigationEntry)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements['ttfb.requestTime'] = {
        value: responseStart - requestStart,
        unit: 'millisecond'
    };
}

});
parcelRegister("ftz8j", function(module, exports) {

$parcel$export(module.exports, "trackClsAsStandaloneSpan", () => $b444d11e9edd543f$export$585bab03c6c18c45);

var $6OKHc = parcelRequire("6OKHc");
var $4H7Y8 = parcelRequire("4H7Y8");
var $kGYVh = parcelRequire("kGYVh");
var $hA6iJ = parcelRequire("hA6iJ");
var $hi47i = parcelRequire("hi47i");
var $yQUXg = parcelRequire("yQUXg");

var $jioJL = parcelRequire("jioJL");

var $4hTws = parcelRequire("4hTws");

var $fbcQh = parcelRequire("fbcQh");

var $e3Xvs = parcelRequire("e3Xvs");
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $b444d11e9edd543f$export$585bab03c6c18c45() {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    let pageloadSpanId;
    if (!$b444d11e9edd543f$var$supportsLayoutShift()) return;
    let sentSpan = false;
    function _collectClsOnce() {
        if (sentSpan) return;
        sentSpan = true;
        if (pageloadSpanId) $b444d11e9edd543f$var$sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId);
        cleanupClsHandler();
    }
    const cleanupClsHandler = (0, $4hTws.addClsInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    // use pagehide event from web-vitals
    (0, $e3Xvs.onHidden)(()=>{
        _collectClsOnce();
    });
    // Since the call chain of this function is synchronous and evaluates before the SDK client is created,
    // we need to wait with subscribing to a client hook until the client is created. Therefore, we defer
    // to the next tick after the SDK setup.
    setTimeout(()=>{
        const client = (0, $kGYVh.getClient)();
        if (!client) return;
        const unsubscribeStartNavigation = client.on('startNavigationSpan', ()=>{
            _collectClsOnce();
            unsubscribeStartNavigation?.();
        });
        const activeSpan = (0, $4H7Y8.getActiveSpan)();
        if (activeSpan) {
            const rootSpan = (0, $4H7Y8.getRootSpan)(activeSpan);
            const spanJSON = (0, $4H7Y8.spanToJSON)(rootSpan);
            if (spanJSON.op === 'pageload') pageloadSpanId = rootSpan.spanContext().spanId;
        }
    }, 0);
}
function $b444d11e9edd543f$var$sendStandaloneClsSpan(clsValue, entry, pageloadSpanId) {
    (0, $jioJL.DEBUG_BUILD) && (0, $hi47i.logger).log(`Sending CLS span (${clsValue})`);
    const startTime = (0, $fbcQh.msToSec)(((0, $6OKHc.browserPerformanceTimeOrigin)() || 0) + (entry?.startTime || 0));
    const routeName = (0, $kGYVh.getCurrentScope)().getScopeData().transactionName;
    const name = entry ? (0, $hA6iJ.htmlTreeAsString)(entry.sources[0]?.node) : 'Layout shift';
    const attributes = {
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser.cls',
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: 'ui.webvital.cls',
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: entry?.duration || 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        'sentry.pageload.span_id': pageloadSpanId
    };
    const span = (0, $fbcQh.startStandaloneWebVitalSpan)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('cls', {
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: '',
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: clsValue
        });
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}
function $b444d11e9edd543f$var$supportsLayoutShift() {
    try {
        return PerformanceObserver.supportedEntryTypes.includes('layout-shift');
    } catch  {
        return false;
    }
}

});
parcelRegister("jioJL", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $e0c2e3106e46caa2$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0c2e3106e46caa2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("4hTws", function(module, exports) {

$parcel$export(module.exports, "addClsInstrumentationHandler", () => $31f3d198369e5cbf$export$861b82818b37ba5b);
$parcel$export(module.exports, "addLcpInstrumentationHandler", () => $31f3d198369e5cbf$export$3fd4b53331200102);
$parcel$export(module.exports, "addFidInstrumentationHandler", () => $31f3d198369e5cbf$export$2707d7471c0b918f);
$parcel$export(module.exports, "addTtfbInstrumentationHandler", () => $31f3d198369e5cbf$export$699d9529c099a797);
$parcel$export(module.exports, "addInpInstrumentationHandler", () => $31f3d198369e5cbf$export$da3b76aa2022cbd7);
$parcel$export(module.exports, "addPerformanceInstrumentationHandler", () => $31f3d198369e5cbf$export$69816c1a049f8db6);
$parcel$export(module.exports, "isPerformanceEventTiming", () => $31f3d198369e5cbf$export$7affb50b622d8714);

var $5v1oS = parcelRequire("5v1oS");
var $hi47i = parcelRequire("hi47i");

var $jioJL = parcelRequire("jioJL");

var $heQ9F = parcelRequire("heQ9F");

var $bK0EO = parcelRequire("bK0EO");

var $gIXvX = parcelRequire("gIXvX");

var $hdReC = parcelRequire("hdReC");

var $5aHAs = parcelRequire("5aHAs");

var $kUXUr = parcelRequire("kUXUr");
const $31f3d198369e5cbf$var$handlers = {};
const $31f3d198369e5cbf$var$instrumented = {};
let $31f3d198369e5cbf$var$_previousCls;
let $31f3d198369e5cbf$var$_previousFid;
let $31f3d198369e5cbf$var$_previousLcp;
let $31f3d198369e5cbf$var$_previousTtfb;
let $31f3d198369e5cbf$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $31f3d198369e5cbf$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $31f3d198369e5cbf$var$addMetricObserver('cls', callback, $31f3d198369e5cbf$var$instrumentCls, $31f3d198369e5cbf$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $31f3d198369e5cbf$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $31f3d198369e5cbf$var$addMetricObserver('lcp', callback, $31f3d198369e5cbf$var$instrumentLcp, $31f3d198369e5cbf$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$2707d7471c0b918f(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver('fid', callback, $31f3d198369e5cbf$var$instrumentFid, $31f3d198369e5cbf$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $31f3d198369e5cbf$export$699d9529c099a797(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver('ttfb', callback, $31f3d198369e5cbf$var$instrumentTtfb, $31f3d198369e5cbf$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$da3b76aa2022cbd7(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver('inp', callback, $31f3d198369e5cbf$var$instrumentInp, $31f3d198369e5cbf$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$69816c1a049f8db6(type, callback) {
    $31f3d198369e5cbf$var$addHandler(type, callback);
    if (!$31f3d198369e5cbf$var$instrumented[type]) {
        $31f3d198369e5cbf$var$instrumentPerformanceObserver(type);
        $31f3d198369e5cbf$var$instrumented[type] = true;
    }
    return $31f3d198369e5cbf$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $31f3d198369e5cbf$var$triggerHandlers(type, data) {
    const typeHandlers = $31f3d198369e5cbf$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $jioJL.DEBUG_BUILD) && (0, $hi47i.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $5v1oS.getFunctionName)(handler)}\nError:`, e);
    }
}
function $31f3d198369e5cbf$var$instrumentCls() {
    return (0, $heQ9F.onCLS)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('cls', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $31f3d198369e5cbf$var$instrumentFid() {
    return (0, $bK0EO.onFID)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('fid', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousFid = metric;
    });
}
function $31f3d198369e5cbf$var$instrumentLcp() {
    return (0, $hdReC.onLCP)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('lcp', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $31f3d198369e5cbf$var$instrumentTtfb() {
    return (0, $kUXUr.onTTFB)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousTtfb = metric;
    });
}
function $31f3d198369e5cbf$var$instrumentInp() {
    return (0, $gIXvX.onINP)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers('inp', {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousInp = metric;
    });
}
function $31f3d198369e5cbf$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $31f3d198369e5cbf$var$addHandler(type, callback);
    let stopListening;
    if (!$31f3d198369e5cbf$var$instrumented[type]) {
        stopListening = instrumentFn();
        $31f3d198369e5cbf$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $31f3d198369e5cbf$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $31f3d198369e5cbf$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $5aHAs.observe)(type, (entries)=>{
        $31f3d198369e5cbf$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $31f3d198369e5cbf$var$addHandler(type, handler) {
    $31f3d198369e5cbf$var$handlers[type] = $31f3d198369e5cbf$var$handlers[type] || [];
    $31f3d198369e5cbf$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $31f3d198369e5cbf$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $31f3d198369e5cbf$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $31f3d198369e5cbf$export$7affb50b622d8714(entry) {
    return 'duration' in entry;
}

});
parcelRegister("heQ9F", function(module, exports) {

$parcel$export(module.exports, "onCLS", () => $c8cc3356aaa35be1$export$a7873055838e5ad8);

var $aUO6s = parcelRequire("aUO6s");

var $2Qq09 = parcelRequire("2Qq09");

var $5aHAs = parcelRequire("5aHAs");

var $e3Xvs = parcelRequire("e3Xvs");

var $iGYWb = parcelRequire("iGYWb");

var $gMmkz = parcelRequire("gMmkz");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $c8cc3356aaa35be1$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c8cc3356aaa35be1$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $gMmkz.onFCP)((0, $iGYWb.runOnce)(()=>{
        const metric = (0, $2Qq09.initMetric)('CLS', 0);
        let report;
        let sessionValue = 0;
        let sessionEntries = [];
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                // Only count layout shifts without recent user input.
                if (!entry.hadRecentInput) {
                    const firstSessionEntry = sessionEntries[0];
                    const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    // If the entry occurred less than 1 second after the previous entry
                    // and less than 5 seconds after the first entry in the session,
                    // include the entry in the current session. Otherwise, start a new
                    // session.
                    if (sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    } else {
                        sessionValue = entry.value;
                        sessionEntries = [
                            entry
                        ];
                    }
                }
            });
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        const po = (0, $5aHAs.observe)('layout-shift', handleEntries);
        if (po) {
            report = (0, $aUO6s.bindReporter)(onReport, metric, $c8cc3356aaa35be1$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $e3Xvs.onHidden)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            setTimeout(report, 0);
        }
    }));
};

});
parcelRegister("aUO6s", function(module, exports) {

$parcel$export(module.exports, "bindReporter", () => $7f25ffc87954188c$export$17679dccdd551979);
const $7f25ffc87954188c$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return 'poor';
    if (value > thresholds[0]) return 'needs-improvement';
    return 'good';
};
const $7f25ffc87954188c$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $7f25ffc87954188c$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("2Qq09", function(module, exports) {

$parcel$export(module.exports, "initMetric", () => $21249b77f35afbbd$export$3c29b44508a0612b);

var $cOSHO = parcelRequire("cOSHO");

var $iYBe1 = parcelRequire("iYBe1");

var $J8pIz = parcelRequire("J8pIz");

var $5Tr5v = parcelRequire("5Tr5v");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $21249b77f35afbbd$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $5Tr5v.getNavigationEntry)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $cOSHO.WINDOW).document?.prerendering || (0, $J8pIz.getActivationStart)() > 0) navigationType = 'prerender';
        else if ((0, $cOSHO.WINDOW).document?.wasDiscarded) navigationType = 'restore';
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, '-');
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: entries,
        id: (0, $iYBe1.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("iYBe1", function(module, exports) {

$parcel$export(module.exports, "generateUniqueID", () => $dd0ab4bb8fd34918$export$407ea409d1f3b539);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $dd0ab4bb8fd34918$export$407ea409d1f3b539 = ()=>{
    return `v4-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

});

parcelRegister("J8pIz", function(module, exports) {

$parcel$export(module.exports, "getActivationStart", () => $087abae3f457004d$export$d3e828b3c7b5b845);

var $5Tr5v = parcelRequire("5Tr5v");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $087abae3f457004d$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $5Tr5v.getNavigationEntry)();
    return navEntry?.activationStart || 0;
};

});
parcelRegister("5Tr5v", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", () => $44a719e67f846077$export$6431553786c94949);

var $cOSHO = parcelRequire("cOSHO");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const $44a719e67f846077$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $cOSHO.WINDOW).performance?.getEntriesByType?.('navigation')[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases no value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // https://github.com/GoogleChrome/web-vitals/issues/137
    // https://github.com/GoogleChrome/web-vitals/issues/162
    // https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};

});



parcelRegister("5aHAs", function(module, exports) {

$parcel$export(module.exports, "observe", () => $3c3fb26ba7f6478b$export$d1203567a167490e);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $3c3fb26ba7f6478b$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("e3Xvs", function(module, exports) {

$parcel$export(module.exports, "onHidden", () => $02a4610d4ee5af80$export$91ec2be6fdd8f1b4);

var $cOSHO = parcelRequire("cOSHO");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Sentry-specific change:
// This function's logic was NOT updated to web-vitals 4.2.4 but we continue
// to use the web-vitals 3.5.2 due to us having stricter browser support.
// PR with context that made the changes: https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
// The PR removed listening to the `pagehide` event, in favour of only listening to `visibilitychange` event.
// This is "more correct" but some browsers we still support (Safari 12.1-14.0) don't fully support `visibilitychange`
// or have known bugs w.r.t the `visibilitychange` event.
// TODO (v9): If we decide to drop support for Safari 12.1-14.0, we can use the logic from web-vitals 4.2.4
// In this case, we also need to update the integration tests that currently trigger the `pagehide` event to
// simulate the page being hidden.
const $02a4610d4ee5af80$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $cOSHO.WINDOW).document?.visibilityState === 'hidden') cb(event);
    };
    if ((0, $cOSHO.WINDOW).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};

});

parcelRegister("iGYWb", function(module, exports) {

$parcel$export(module.exports, "runOnce", () => $d9bb6b2adff68632$export$b841d51e31c12bab);
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d9bb6b2adff68632$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};

});

parcelRegister("gMmkz", function(module, exports) {

$parcel$export(module.exports, "onFCP", () => $c372737293087726$export$fe3c86b74e15d5de);

var $aUO6s = parcelRequire("aUO6s");

var $J8pIz = parcelRequire("J8pIz");

var $gqIP5 = parcelRequire("gqIP5");

var $2Qq09 = parcelRequire("2Qq09");

var $5aHAs = parcelRequire("5aHAs");

var $9A5xV = parcelRequire("9A5xV");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $c372737293087726$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $c372737293087726$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $9A5xV.whenActivated)(()=>{
        const visibilityWatcher = (0, $gqIP5.getVisibilityWatcher)();
        const metric = (0, $2Qq09.initMetric)('FCP');
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.name === 'first-contentful-paint') {
                    po.disconnect();
                    // Only report if the page wasn't hidden prior to the first paint.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The activationStart reference is used because FCP should be
                        // relative to page activation rather than navigation start if the
                        // page was prerendered. But in cases where `activationStart` occurs
                        // after the FCP, this time should be clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, $J8pIz.getActivationStart)(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        const po = (0, $5aHAs.observe)('paint', handleEntries);
        if (po) report = (0, $aUO6s.bindReporter)(onReport, metric, $c372737293087726$export$e610c735b5510cec, opts.reportAllChanges);
    });
};

});
parcelRegister("gqIP5", function(module, exports) {

$parcel$export(module.exports, "getVisibilityWatcher", () => $bf61d7f7ca9bd10a$export$443f86b2c77012c4);

var $cOSHO = parcelRequire("cOSHO");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $bf61d7f7ca9bd10a$var$firstHiddenTime = -1;
const $bf61d7f7ca9bd10a$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return (0, $cOSHO.WINDOW).document.visibilityState === 'hidden' && !(0, $cOSHO.WINDOW).document.prerendering ? 0 : Infinity;
};
const $bf61d7f7ca9bd10a$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $cOSHO.WINDOW).document.visibilityState === 'hidden' && $bf61d7f7ca9bd10a$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $bf61d7f7ca9bd10a$var$firstHiddenTime = event.type === 'visibilitychange' ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        $bf61d7f7ca9bd10a$var$removeChangeListeners();
    }
};
const $bf61d7f7ca9bd10a$var$addChangeListeners = ()=>{
    addEventListener('visibilitychange', $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener('prerenderingchange', $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
};
const $bf61d7f7ca9bd10a$var$removeChangeListeners = ()=>{
    removeEventListener('visibilitychange', $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
    removeEventListener('prerenderingchange', $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
};
const $bf61d7f7ca9bd10a$export$443f86b2c77012c4 = ()=>{
    if ((0, $cOSHO.WINDOW).document && $bf61d7f7ca9bd10a$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $bf61d7f7ca9bd10a$var$firstHiddenTime = $bf61d7f7ca9bd10a$var$initHiddenTime();
        $bf61d7f7ca9bd10a$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $bf61d7f7ca9bd10a$var$firstHiddenTime;
        }
    };
};

});

parcelRegister("9A5xV", function(module, exports) {

$parcel$export(module.exports, "whenActivated", () => $6f9bc735dd2b9313$export$8bdb38a5671b594e);

var $cOSHO = parcelRequire("cOSHO");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6f9bc735dd2b9313$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $cOSHO.WINDOW).document?.prerendering) addEventListener('prerenderingchange', ()=>callback(), true);
    else callback();
};

});



parcelRegister("bK0EO", function(module, exports) {

$parcel$export(module.exports, "onFID", () => $88c48014ef58cf68$export$39705a25c49af873);

var $aUO6s = parcelRequire("aUO6s");

var $gqIP5 = parcelRequire("gqIP5");

var $2Qq09 = parcelRequire("2Qq09");

var $5aHAs = parcelRequire("5aHAs");

var $e3Xvs = parcelRequire("e3Xvs");

var $iGYWb = parcelRequire("iGYWb");

var $9A5xV = parcelRequire("9A5xV");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $88c48014ef58cf68$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $88c48014ef58cf68$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $9A5xV.whenActivated)(()=>{
        const visibilityWatcher = (0, $gqIP5.getVisibilityWatcher)();
        const metric = (0, $2Qq09.initMetric)('FID');
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $5aHAs.observe)('first-input', handleEntries);
        report = (0, $aUO6s.bindReporter)(onReport, metric, $88c48014ef58cf68$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) (0, $e3Xvs.onHidden)((0, $iGYWb.runOnce)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};

});

parcelRegister("gIXvX", function(module, exports) {

$parcel$export(module.exports, "onINP", () => $c2ceebba2f8f4181$export$7df4b36ecaed99e1);

var $cOSHO = parcelRequire("cOSHO");

var $aUO6s = parcelRequire("aUO6s");

var $2Qq09 = parcelRequire("2Qq09");

var $9f0wK = parcelRequire("9f0wK");

var $5aHAs = parcelRequire("5aHAs");

var $e3Xvs = parcelRequire("e3Xvs");

var $hyD1B = parcelRequire("hyD1B");

var $9A5xV = parcelRequire("9A5xV");

var $3bGze = parcelRequire("3bGze");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $c2ceebba2f8f4181$export$7f4cb060ded9173c = [
    200,
    500
];
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c2ceebba2f8f4181$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!('PerformanceEventTiming' in (0, $cOSHO.WINDOW) && 'interactionId' in PerformanceEventTiming.prototype)) return;
    (0, $9A5xV.whenActivated)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $hyD1B.initInteractionCountPolyfill)();
        const metric = (0, $2Qq09.initMetric)('INP');
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntries = (entries)=>{
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, $3bGze.whenIdle)(()=>{
                entries.forEach((0, $9f0wK.processInteractionEntry));
                const inp = (0, $9f0wK.estimateP98LongestInteraction)();
                if (inp && inp.latency !== metric.value) {
                    metric.value = inp.latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $5aHAs.observe)('event', handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : (0, $9f0wK.DEFAULT_DURATION_THRESHOLD)
        });
        report = (0, $aUO6s.bindReporter)(onReport, metric, $c2ceebba2f8f4181$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: 'first-input',
                buffered: true
            });
            (0, $e3Xvs.onHidden)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};

});
parcelRegister("9f0wK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DURATION_THRESHOLD", () => $6ba5ec799590141e$export$9cebd8cf5d8d3416);
$parcel$export(module.exports, "estimateP98LongestInteraction", () => $6ba5ec799590141e$export$70cf089971ed4f82);
$parcel$export(module.exports, "processInteractionEntry", () => $6ba5ec799590141e$export$6a7a48c2c643798f);

var $hyD1B = parcelRequire("hyD1B");
/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER long.
const $6ba5ec799590141e$export$fbb6a65efb09cd7a = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $6ba5ec799590141e$export$7b86959c9ded44e2 = new Map();
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const $6ba5ec799590141e$export$9cebd8cf5d8d3416 = 40;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let $6ba5ec799590141e$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $6ba5ec799590141e$var$getInteractionCountForNavigation = ()=>{
    return (0, $hyD1B.getInteractionCount)() - $6ba5ec799590141e$var$prevInteractionCount;
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $6ba5ec799590141e$export$70cf089971ed4f82 = ()=>{
    const candidateInteractionIndex = Math.min($6ba5ec799590141e$export$fbb6a65efb09cd7a.length - 1, Math.floor($6ba5ec799590141e$var$getInteractionCountForNavigation() / 50));
    return $6ba5ec799590141e$export$fbb6a65efb09cd7a[candidateInteractionIndex];
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
/**
 * A list of callback functions to run before each entry is processed.
 * Exposing this list allows the attribution build to hook into the
 * entry processing pipeline.
 */ const $6ba5ec799590141e$export$1c74e929da1e189d = [];
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $6ba5ec799590141e$export$6a7a48c2c643798f = (entry)=>{
    $6ba5ec799590141e$export$1c74e929da1e189d.forEach((cb)=>cb(entry));
    // Skip further processing for entries that cannot be INP candidates.
    if (!(entry.interactionId || entry.entryType === 'first-input')) return;
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $6ba5ec799590141e$export$fbb6a65efb09cd7a[$6ba5ec799590141e$export$fbb6a65efb09cd7a.length - 1];
    const existingInteraction = $6ba5ec799590141e$export$7b86959c9ded44e2.get(entry.interactionId);
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $6ba5ec799590141e$export$fbb6a65efb09cd7a.length < $6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER || minLongestInteraction && entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            // If the new entry has a longer duration, replace the old entries,
            // otherwise add to the array.
            if (entry.duration > existingInteraction.latency) {
                existingInteraction.entries = [
                    entry
                ];
                existingInteraction.latency = entry.duration;
            } else if (entry.duration === existingInteraction.latency && entry.startTime === existingInteraction.entries[0]?.startTime) existingInteraction.entries.push(entry);
        } else {
            const interaction = {
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $6ba5ec799590141e$export$7b86959c9ded44e2.set(interaction.id, interaction);
            $6ba5ec799590141e$export$fbb6a65efb09cd7a.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $6ba5ec799590141e$export$fbb6a65efb09cd7a.sort((a, b)=>b.latency - a.latency);
        if ($6ba5ec799590141e$export$fbb6a65efb09cd7a.length > $6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER) $6ba5ec799590141e$export$fbb6a65efb09cd7a.splice($6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>$6ba5ec799590141e$export$7b86959c9ded44e2.delete(i.id));
    }
};

});
parcelRegister("hyD1B", function(module, exports) {

$parcel$export(module.exports, "getInteractionCount", () => $cc83e22cb516f528$export$8a962f2683a476d1);
$parcel$export(module.exports, "initInteractionCountPolyfill", () => $cc83e22cb516f528$export$67d90cda6b78a2eb);

var $5aHAs = parcelRequire("5aHAs");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $cc83e22cb516f528$var$interactionCountEstimate = 0;
let $cc83e22cb516f528$var$minKnownInteractionId = Infinity;
let $cc83e22cb516f528$var$maxKnownInteractionId = 0;
const $cc83e22cb516f528$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $cc83e22cb516f528$var$minKnownInteractionId = Math.min($cc83e22cb516f528$var$minKnownInteractionId, e.interactionId);
            $cc83e22cb516f528$var$maxKnownInteractionId = Math.max($cc83e22cb516f528$var$maxKnownInteractionId, e.interactionId);
            $cc83e22cb516f528$var$interactionCountEstimate = $cc83e22cb516f528$var$maxKnownInteractionId ? ($cc83e22cb516f528$var$maxKnownInteractionId - $cc83e22cb516f528$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $cc83e22cb516f528$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $cc83e22cb516f528$export$8a962f2683a476d1 = ()=>{
    return $cc83e22cb516f528$var$po ? $cc83e22cb516f528$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $cc83e22cb516f528$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $cc83e22cb516f528$var$po) return;
    $cc83e22cb516f528$var$po = (0, $5aHAs.observe)('event', $cc83e22cb516f528$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};

});


parcelRegister("3bGze", function(module, exports) {

$parcel$export(module.exports, "whenIdle", () => $25236b21f8c05ee3$export$4d9952dcbf5b2792);

var $cOSHO = parcelRequire("cOSHO");

var $e3Xvs = parcelRequire("e3Xvs");

var $iGYWb = parcelRequire("iGYWb");
/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ const $25236b21f8c05ee3$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = (0, $cOSHO.WINDOW).requestIdleCallback || (0, $cOSHO.WINDOW).setTimeout;
    let handle = -1;
    // eslint-disable-next-line no-param-reassign
    cb = (0, $iGYWb.runOnce)(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if ((0, $cOSHO.WINDOW).document?.visibilityState === 'hidden') cb();
    else {
        handle = rIC(cb);
        (0, $e3Xvs.onHidden)(cb);
    }
    return handle;
};

});


parcelRegister("hdReC", function(module, exports) {

$parcel$export(module.exports, "onLCP", () => $c89cf1e13796625e$export$947b1626ab8d5632);

var $cOSHO = parcelRequire("cOSHO");

var $aUO6s = parcelRequire("aUO6s");

var $J8pIz = parcelRequire("J8pIz");

var $gqIP5 = parcelRequire("gqIP5");

var $2Qq09 = parcelRequire("2Qq09");

var $5aHAs = parcelRequire("5aHAs");

var $e3Xvs = parcelRequire("e3Xvs");

var $iGYWb = parcelRequire("iGYWb");

var $9A5xV = parcelRequire("9A5xV");

var $3bGze = parcelRequire("3bGze");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $c89cf1e13796625e$export$948521ca5b0e1b17 = [
    2500,
    4000
];
const $c89cf1e13796625e$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $c89cf1e13796625e$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $9A5xV.whenActivated)(()=>{
        const visibilityWatcher = (0, $gqIP5.getVisibilityWatcher)();
        const metric = (0, $2Qq09.initMetric)('LCP');
        let report;
        const handleEntries = (entries)=>{
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            entries.forEach((entry)=>{
                // Only report if the page wasn't hidden prior to LCP.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was pre-rendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $J8pIz.getActivationStart)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            });
        };
        const po = (0, $5aHAs.observe)('largest-contentful-paint', handleEntries);
        if (po) {
            report = (0, $aUO6s.bindReporter)(onReport, metric, $c89cf1e13796625e$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $iGYWb.runOnce)(()=>{
                if (!$c89cf1e13796625e$var$reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    $c89cf1e13796625e$var$reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            // Stop listening after input. Note: while scrolling is an input that
            // stops LCP observation, it's unreliable since it can be programmatically
            // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
            [
                'keydown',
                'click'
            ].forEach((type)=>{
                // Wrap in a setTimeout so the callback is run in a separate task
                // to avoid extending the keyboard/click handler to reduce INP impact
                // https://github.com/GoogleChrome/web-vitals/issues/383
                if ((0, $cOSHO.WINDOW).document) addEventListener(type, ()=>(0, $3bGze.whenIdle)(stopListening), {
                    once: true,
                    capture: true
                });
            });
            (0, $e3Xvs.onHidden)(stopListening);
        }
    });
};

});

parcelRegister("kUXUr", function(module, exports) {

$parcel$export(module.exports, "onTTFB", () => $f3a7825c3a5278be$export$33a01e6c5f2c7e33);

var $cOSHO = parcelRequire("cOSHO");

var $aUO6s = parcelRequire("aUO6s");

var $J8pIz = parcelRequire("J8pIz");

var $5Tr5v = parcelRequire("5Tr5v");

var $2Qq09 = parcelRequire("2Qq09");

var $9A5xV = parcelRequire("9A5xV");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $f3a7825c3a5278be$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $f3a7825c3a5278be$var$whenReady = (callback)=>{
    if ((0, $cOSHO.WINDOW).document?.prerendering) (0, $9A5xV.whenActivated)(()=>$f3a7825c3a5278be$var$whenReady(callback));
    else if ((0, $cOSHO.WINDOW).document?.readyState !== 'complete') addEventListener('load', ()=>$f3a7825c3a5278be$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $f3a7825c3a5278be$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $2Qq09.initMetric)('TTFB');
    const report = (0, $aUO6s.bindReporter)(onReport, metric, $f3a7825c3a5278be$export$65c59ea8064668fc, opts.reportAllChanges);
    $f3a7825c3a5278be$var$whenReady(()=>{
        const navigationEntry = (0, $5Tr5v.getNavigationEntry)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, $J8pIz.getActivationStart)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};

});


parcelRegister("fbcQh", function(module, exports) {

$parcel$export(module.exports, "isMeasurementValue", () => $b0d1d845a8fb2673$export$27169ccae1b439e3);
$parcel$export(module.exports, "startAndEndSpan", () => $b0d1d845a8fb2673$export$7567a67bdb69a23d);
$parcel$export(module.exports, "startStandaloneWebVitalSpan", () => $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa);
$parcel$export(module.exports, "getBrowserPerformanceAPI", () => $b0d1d845a8fb2673$export$f72a13c439a30cab);
$parcel$export(module.exports, "msToSec", () => $b0d1d845a8fb2673$export$b4785dbd4a81b33f);
$parcel$export(module.exports, "extractNetworkProtocol", () => $b0d1d845a8fb2673$export$57c6f824442f9fe1);

var $kGYVh = parcelRequire("kGYVh");
var $4H7Y8 = parcelRequire("4H7Y8");
var $iMoih = parcelRequire("iMoih");

var $cOSHO = parcelRequire("cOSHO");
/**
 * Checks if a given value is a valid measurement value.
 */ function $b0d1d845a8fb2673$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $b0d1d845a8fb2673$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $4H7Y8.spanToJSON)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === 'function') parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $iMoih.withActiveSpan)(parentSpan, ()=>{
        const span = (0, $iMoih.startInactiveSpan)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $kGYVh.getClient)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment, sendDefaultPii: sendDefaultPii } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId();
    const scope = (0, $kGYVh.getCurrentScope)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch  {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        'user_agent.original': (0, $cOSHO.WINDOW).navigator?.userAgent,
        // This tells Sentry to infer the IP address from the request
        'client.address': sendDefaultPii ? '{{auto}}' : undefined,
        ...passedAttributes
    };
    return (0, $iMoih.startInactiveSpan)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $b0d1d845a8fb2673$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $cOSHO.WINDOW).addEventListener && (0, $cOSHO.WINDOW).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $b0d1d845a8fb2673$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $b0d1d845a8fb2673$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}

});



parcelRegister("a3m81", function(module, exports) {

$parcel$export(module.exports, "startTrackingINP", () => $751b596e3029fa17$export$f17d06681a4744a3);
$parcel$export(module.exports, "registerInpInteractionListener", () => $751b596e3029fa17$export$e4e04d43e223cce2);

var $6OKHc = parcelRequire("6OKHc");
var $4H7Y8 = parcelRequire("4H7Y8");
var $kGYVh = parcelRequire("kGYVh");
var $hA6iJ = parcelRequire("hA6iJ");
var $yQUXg = parcelRequire("yQUXg");

var $4hTws = parcelRequire("4hTws");

var $fbcQh = parcelRequire("fbcQh");
const $751b596e3029fa17$var$LAST_INTERACTIONS = [];
const $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * Start tracking INP webvital events.
 */ function $751b596e3029fa17$export$f17d06681a4744a3() {
    const performance = (0, $fbcQh.getBrowserPerformanceAPI)();
    if (performance && (0, $6OKHc.browserPerformanceTimeOrigin)()) {
        const inpCallback = $751b596e3029fa17$var$_trackINP();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $751b596e3029fa17$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $751b596e3029fa17$var$_trackINP() {
    return (0, $4hTws.addInpInstrumentationHandler)(({ metric: metric })=>{
        if (metric.value == undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $751b596e3029fa17$var$INP_ENTRY_MAP[entry.name]);
        if (!entry) return;
        const { interactionId: interactionId } = entry;
        const interactionType = $751b596e3029fa17$var$INP_ENTRY_MAP[entry.name];
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $fbcQh.msToSec)((0, $6OKHc.browserPerformanceTimeOrigin)() + entry.startTime);
        const duration = (0, $fbcQh.msToSec)(metric.value);
        const activeSpan = (0, $4H7Y8.getActiveSpan)();
        const rootSpan = activeSpan ? (0, $4H7Y8.getRootSpan)(activeSpan) : undefined;
        // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
        // where we cache the route per interactionId
        const cachedSpan = interactionId != null ? $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
        const spanToUse = cachedSpan || rootSpan;
        // Else, we try to use the active span.
        // Finally, we fall back to look at the transactionName on the scope
        const routeName = spanToUse ? (0, $4H7Y8.spanToJSON)(spanToUse).description : (0, $kGYVh.getCurrentScope)().getScopeData().transactionName;
        const name = (0, $hA6iJ.htmlTreeAsString)(entry.target);
        const attributes = {
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser.inp',
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: `ui.interaction.${interactionType}`,
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: entry.duration
        };
        const span = (0, $fbcQh.startStandaloneWebVitalSpan)({
            name: name,
            transaction: routeName,
            attributes: attributes,
            startTime: startTime
        });
        if (span) {
            span.addEvent('inp', {
                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: 'millisecond',
                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: metric.value
            });
            span.end(startTime + duration);
        }
    });
}
/**
 * Register a listener to cache route information for INP interactions.
 */ function $751b596e3029fa17$export$e4e04d43e223cce2() {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $4H7Y8.getActiveSpan)();
        const activeRootSpan = activeSpan && (0, $4H7Y8.getRootSpan)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $4hTws.isPerformanceEventTiming)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($751b596e3029fa17$var$LAST_INTERACTIONS.length > 10) {
                const last = $751b596e3029fa17$var$LAST_INTERACTIONS.shift();
                $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $751b596e3029fa17$var$LAST_INTERACTIONS.push(interactionId);
            $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $4hTws.addPerformanceInstrumentationHandler)('event', handleEntries);
    (0, $4hTws.addPerformanceInstrumentationHandler)('first-input', handleEntries);
}

});

parcelRegister("aBCC8", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $7b8b500cb80621bc$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7b8b500cb80621bc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("csQk2", function(module, exports) {

$parcel$export(module.exports, "WINDOW", () => $9130afac94f0b7c9$export$56d8a8a25bd48b81);
$parcel$export(module.exports, "shouldIgnoreOnError", () => $9130afac94f0b7c9$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $9130afac94f0b7c9$export$4997ffc0176396a6);
$parcel$export(module.exports, "getHttpRequestData", () => $9130afac94f0b7c9$export$a3c4a8453e8936f0);

var $6OhB9 = parcelRequire("6OhB9");
var $l1oVX = parcelRequire("l1oVX");
var $kQ0sT = parcelRequire("kQ0sT");
var $hA6iJ = parcelRequire("hA6iJ");
var $2fKhD = parcelRequire("2fKhD");
var $kGYVh = parcelRequire("kGYVh");
const $9130afac94f0b7c9$export$56d8a8a25bd48b81 = (0, $2fKhD.GLOBAL_OBJ);
let $9130afac94f0b7c9$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$b79738ab10c590b2() {
    return $9130afac94f0b7c9$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9130afac94f0b7c9$var$ignoreOnError++;
    setTimeout(()=>{
        $9130afac94f0b7c9$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9130afac94f0b7c9$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $l1oVX.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$9130afac94f0b7c9$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9130afac94f0b7c9$export$1265a142ff5ba165();
            (0, $kGYVh.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $6OhB9.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $6OhB9.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $kQ0sT.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $l1oVX.markFunctionWrapped)(sentryWrapped, fn);
    (0, $l1oVX.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $9130afac94f0b7c9$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $hA6iJ.getLocationHref)();
    const { referrer: referrer } = $9130afac94f0b7c9$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $9130afac94f0b7c9$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            'User-Agent': userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}

});
parcelRegister("kQ0sT", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $f2b90654edf2c0a1$export$f5282963edea4a68);
$parcel$export(module.exports, "captureEvent", () => $f2b90654edf2c0a1$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "setContext", () => $f2b90654edf2c0a1$export$2f04de43fe27971a);
$parcel$export(module.exports, "isEnabled", () => $f2b90654edf2c0a1$export$3b029eb57ac4d562);
$parcel$export(module.exports, "addEventProcessor", () => $f2b90654edf2c0a1$export$9aac0b9f77928fbf);
$parcel$export(module.exports, "startSession", () => $f2b90654edf2c0a1$export$c0d84948cecf78d8);
$parcel$export(module.exports, "captureSession", () => $f2b90654edf2c0a1$export$667e7b4d445d566b);

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $kkdRz = parcelRequire("kkdRz");

var $g1WRa = parcelRequire("g1WRa");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $6OhB9 = parcelRequire("6OhB9");

var $6OKHc = parcelRequire("6OKHc");

var $2fKhD = parcelRequire("2fKhD");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $f2b90654edf2c0a1$export$f5282963edea4a68(exception, hint) {
    return (0, $kGYVh.getCurrentScope)().captureException(exception, (0, $g1WRa.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $f2b90654edf2c0a1$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $kGYVh.getCurrentScope)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $f2b90654edf2c0a1$export$1462b974fdcf6ba2(event, hint) {
    return (0, $kGYVh.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$2f04de43fe27971a(name, context) {
    (0, $kGYVh.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $f2b90654edf2c0a1$export$bb4922da0dd51b92(extras) {
    (0, $kGYVh.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$8e8e7789d42ed61d(key, extra) {
    (0, $kGYVh.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $f2b90654edf2c0a1$export$74a8fb34822092e6(tags) {
    (0, $kGYVh.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $f2b90654edf2c0a1$export$a37d07ee78eb4569(key, value) {
    (0, $kGYVh.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $f2b90654edf2c0a1$export$8b6bb3dd62a01be2(user) {
    (0, $kGYVh.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $f2b90654edf2c0a1$export$5d4e9fd7fac8e617() {
    return (0, $kGYVh.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $kGYVh.getCurrentScope)();
    const client = (0, $kGYVh.getClient)();
    if (!client) (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $6OhB9.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $f2b90654edf2c0a1$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $6OKHc.timestampInSeconds)();
    function finishCheckIn(status) {
        $f2b90654edf2c0a1$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $6OKHc.timestampInSeconds)() - now
        });
    }
    return (0, $kGYVh.withIsolationScope)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $dfMsQ.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$4909b86c8034bf73(timeout) {
    const client = (0, $kGYVh.getClient)();
    if (client) return client.flush(timeout);
    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$8360e631d277ea4d(timeout) {
    const client = (0, $kGYVh.getClient)();
    if (client) return client.close(timeout);
    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $f2b90654edf2c0a1$export$3f95c6f800b78024() {
    return !!(0, $kGYVh.getClient)();
}
/** If the SDK is initialized & enabled. */ function $f2b90654edf2c0a1$export$3b029eb57ac4d562() {
    const client = (0, $kGYVh.getClient)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $f2b90654edf2c0a1$export$9aac0b9f77928fbf(callback) {
    (0, $kGYVh.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $f2b90654edf2c0a1$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    const currentScope = (0, $kGYVh.getCurrentScope)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $2fKhD.GLOBAL_OBJ).navigator || {};
    const session = (0, $kkdRz.makeSession)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $kkdRz.updateSession)(currentSession, {
        status: 'exited'
    });
    $f2b90654edf2c0a1$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $f2b90654edf2c0a1$export$17a5be43989a0bc1() {
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    const currentScope = (0, $kGYVh.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $kkdRz.closeSession)(session);
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $f2b90654edf2c0a1$var$_sendSessionUpdate() {
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    const client = (0, $kGYVh.getClient)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $f2b90654edf2c0a1$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $f2b90654edf2c0a1$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
}

});
parcelRegister("g1WRa", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", () => $baba650ac852ba0c$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $baba650ac852ba0c$export$76b5f966996d1653);

var $4Baka = parcelRequire("4Baka");

var $kGYVh = parcelRequire("kGYVh");

var $luMZm = parcelRequire("luMZm");

var $4rxjU = parcelRequire("4rxjU");

var $1pGI9 = parcelRequire("1pGI9");

var $6OhB9 = parcelRequire("6OhB9");

var $886wr = parcelRequire("886wr");

var $hLnp0 = parcelRequire("hLnp0");

var $6OKHc = parcelRequire("6OKHc");

var $3zNRu = parcelRequire("3zNRu");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $baba650ac852ba0c$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $6OhB9.uuid4)(),
        timestamp: event.timestamp || (0, $6OKHc.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $baba650ac852ba0c$export$d7e04067a6fbc882(prepared, options);
    $baba650ac852ba0c$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $baba650ac852ba0c$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $baba650ac852ba0c$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $6OhB9.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $kGYVh.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $3zNRu.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $3zNRu.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $3zNRu.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $luMZm.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $baba650ac852ba0c$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $baba650ac852ba0c$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $baba650ac852ba0c$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $4Baka.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $hLnp0.truncate)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $baba650ac852ba0c$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $1pGI9.getFilenameToDebugIdMap)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $baba650ac852ba0c$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $baba650ac852ba0c$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $baba650ac852ba0c$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $886wr.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $886wr.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $886wr.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $886wr.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $886wr.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $886wr.normalize)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $886wr.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $baba650ac852ba0c$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $4rxjU.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $baba650ac852ba0c$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($baba650ac852ba0c$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($baba650ac852ba0c$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $baba650ac852ba0c$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $4rxjU.Scope) || typeof hint === 'function';
}
const $baba650ac852ba0c$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $baba650ac852ba0c$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$baba650ac852ba0c$var$captureContextKeys.includes(key));
}

});
parcelRegister("luMZm", function(module, exports) {

$parcel$export(module.exports, "notifyEventProcessors", () => $fa62667502ab5c7a$export$bf2a096c3e883e79);

var $fKzCQ = parcelRequire("fKzCQ");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $di9R8 = parcelRequire("di9R8");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $di9R8.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $fKzCQ.DEBUG_BUILD) && processor.id && result === null && (0, $hi47i.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $dfMsQ.isThenable)(result)) result.then((final)=>$fa62667502ab5c7a$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("di9R8", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $9ad49a0639c06d33$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $9ad49a0639c06d33$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $9ad49a0639c06d33$export$78e43115b553f358);

var $dfMsQ = parcelRequire("dfMsQ");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $9ad49a0639c06d33$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($9ad49a0639c06d33$var$States || ($9ad49a0639c06d33$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9ad49a0639c06d33$export$1fda8aa4d135f8aa(value) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9ad49a0639c06d33$export$78e43115b553f358(reason) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9ad49a0639c06d33$export$6f292d4960313241 {
    constructor(executor){
        this._state = $9ad49a0639c06d33$var$States.PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $9ad49a0639c06d33$var$States.PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $9ad49a0639c06d33$var$States.RESOLVED) handler[1](this._value);
            if (this._state === $9ad49a0639c06d33$var$States.REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $9ad49a0639c06d33$var$States.PENDING) return;
            if ((0, $dfMsQ.isThenable)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($9ad49a0639c06d33$var$States.RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($9ad49a0639c06d33$var$States.REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}

});


parcelRegister("1pGI9", function(module, exports) {

$parcel$export(module.exports, "getFilenameToDebugIdMap", () => $107941ce73c7a34f$export$e069fee9c632ed00);

var $2fKhD = parcelRequire("2fKhD");
let $107941ce73c7a34f$var$parsedStackResults;
let $107941ce73c7a34f$var$lastKeysCount;
let $107941ce73c7a34f$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $107941ce73c7a34f$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $2fKhD.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($107941ce73c7a34f$var$cachedFilenameDebugIds && debugIdKeys.length === $107941ce73c7a34f$var$lastKeysCount) return $107941ce73c7a34f$var$cachedFilenameDebugIds;
    $107941ce73c7a34f$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $107941ce73c7a34f$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$107941ce73c7a34f$var$parsedStackResults) $107941ce73c7a34f$var$parsedStackResults = {};
        const result = $107941ce73c7a34f$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $107941ce73c7a34f$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $107941ce73c7a34f$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $107941ce73c7a34f$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $107941ce73c7a34f$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}

});

parcelRegister("3zNRu", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", () => $29ab5181ea4a2c1b$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $29ab5181ea4a2c1b$export$25ac7e259a513db4);

var $jdzJv = parcelRequire("jdzJv");

var $vNNF0 = parcelRequire("vNNF0");

var $4H7Y8 = parcelRequire("4H7Y8");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $29ab5181ea4a2c1b$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $29ab5181ea4a2c1b$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $29ab5181ea4a2c1b$var$applySpanToEvent(event, span);
    $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint);
    $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $29ab5181ea4a2c1b$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'extra', extra);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'tags', tags);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'user', user);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $vNNF0.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $vNNF0.merge)(data[prop], mergeVal, 1);
}
function $29ab5181ea4a2c1b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $29ab5181ea4a2c1b$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $4H7Y8.spanToTraceContext)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $jdzJv.getDynamicSamplingContextFromSpan)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $4H7Y8.getRootSpan)(span);
    const transactionName = (0, $4H7Y8.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}

});




parcelRegister("a4KxH", function(module, exports) {

$parcel$export(module.exports, "registerBackgroundTabDetection", () => $755e6178fce08d17$export$6f18f55521af71a1);

var $4H7Y8 = parcelRequire("4H7Y8");
var $hi47i = parcelRequire("hi47i");
var $02dIh = parcelRequire("02dIh");

var $aBCC8 = parcelRequire("aBCC8");

var $csQk2 = parcelRequire("csQk2");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $755e6178fce08d17$export$6f18f55521af71a1() {
    if ((0, $csQk2.WINDOW).document) (0, $csQk2.WINDOW).document.addEventListener('visibilitychange', ()=>{
        const activeSpan = (0, $4H7Y8.getActiveSpan)();
        if (!activeSpan) return;
        const rootSpan = (0, $4H7Y8.getRootSpan)(activeSpan);
        if ((0, $csQk2.WINDOW).document.hidden && rootSpan) {
            const cancelledStatus = 'cancelled';
            const { op: op, status: status } = (0, $4H7Y8.spanToJSON)(rootSpan);
            if (0, $aBCC8.DEBUG_BUILD) (0, $hi47i.logger).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $02dIh.SPAN_STATUS_ERROR),
                message: cancelledStatus
            });
            rootSpan.setAttribute('sentry.cancellation_reason', 'document.hidden');
            rootSpan.end();
        }
    });
    else (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}

});

parcelRegister("eXynY", function(module, exports) {

$parcel$export(module.exports, "linkTraces", () => $ae413fadab8c23a4$export$830d9ee659c6e4c4);

var $kGYVh = parcelRequire("kGYVh");
var $4H7Y8 = parcelRequire("4H7Y8");
var $hi47i = parcelRequire("hi47i");
var $yQUXg = parcelRequire("yQUXg");

var $aBCC8 = parcelRequire("aBCC8");

var $csQk2 = parcelRequire("csQk2");








// 1h in seconds
const $ae413fadab8c23a4$export$c8d616af96ac729f = 3600;
// session storage key
const $ae413fadab8c23a4$export$16b6aa13b3c0f075 = 'sentry_previous_trace';
const $ae413fadab8c23a4$export$237518aee8726f02 = 'sentry.previous_trace';
/**
 * Takes care of linking traces and applying the (consistent) sampling behavoiour based on the passed options
 * @param options - options for linking traces and consistent trace sampling (@see BrowserTracingOptions)
 * @param client - Sentry client
 */ function $ae413fadab8c23a4$export$830d9ee659c6e4c4(client, { linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling }) {
    const useSessionStorage = linkPreviousTrace === 'session-storage';
    let inMemoryPreviousTraceInfo = useSessionStorage ? $ae413fadab8c23a4$export$ef546bba8a402d99() : undefined;
    client.on('spanStart', (span)=>{
        if ((0, $4H7Y8.getRootSpan)(span) !== span) return;
        const oldPropagationContext = (0, $kGYVh.getCurrentScope)().getPropagationContext();
        inMemoryPreviousTraceInfo = $ae413fadab8c23a4$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $ae413fadab8c23a4$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    let isFirstTraceOnPageload = true;
    if (consistentTraceSampling) /*
    When users opt into `consistentTraceSampling`, we need to ensure that we propagate
    the previous trace's sample rate and rand to the current trace. This is necessary because otherwise, span
    metric extrapolation is inaccurate, as we'd propagate too high of a sample rate for the subsequent traces.

    So therefore, we pretend that the previous trace was the parent trace of the newly started trace. To do that,
    we mutate the propagation context of the current trace and set the sample rate and sample rand of the previous trace.
    Timing-wise, it is fine because it happens before we even sample the root span.

    @see https://github.com/getsentry/sentry-javascript/issues/15754
    */ client.on('beforeSampling', (mutableSamplingContextData)=>{
        if (!inMemoryPreviousTraceInfo) return;
        const scope = (0, $kGYVh.getCurrentScope)();
        const currentPropagationContext = scope.getPropagationContext();
        // We do not want to force-continue the sampling decision if we continue a trace
        // that was started on the backend. Most prominently, this will happen in MPAs where
        // users hard-navigate between pages. In this case, the sampling decision of a potentially
        // started trace on the server takes precedence.
        // Why? We want to prioritize inter-trace consistency over intra-trace consistency.
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext({
            ...currentPropagationContext,
            dsc: {
                ...currentPropagationContext.dsc,
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($ae413fadab8c23a4$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            },
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        });
        mutableSamplingContextData.parentSampled = $ae413fadab8c23a4$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = {
            ...mutableSamplingContextData.spanAttributes,
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE)]: inMemoryPreviousTraceInfo.sampleRate
        };
    });
}
/**
 * Adds a previous_trace span link to the passed span if the passed
 * previousTraceInfo is still valid.
 *
 * @returns the updated previous trace info (based on the current span/trace) to
 * be used on the next call
 */ function $ae413fadab8c23a4$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    const spanJson = (0, $4H7Y8.spanToJSON)(span);
    function getSampleRate() {
        try {
            return Number(oldPropagationContext.dsc?.sample_rate) ?? Number(spanJson.data?.[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]);
        } catch  {
            return 0;
        }
    }
    const updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) // This means, we're still in the same trace so let's not update the previous trace info
    // or add a link to the current span.
    // Once we move away from the long-lived, route-based trace model, we can remove this cases
    return previousTraceInfo;
    // Only add the link if the startTimeStamp of the previous trace's root span is within
    // PREVIOUS_TRACE_MAX_DURATION (1h) of the current root span's startTimestamp
    // This is done to
    // - avoid adding links to "stale" traces
    // - enable more efficient querying for previous/next traces in Sentry
    if (Date.now() / 1000 - previousTraceInfo.startTimestamp <= $ae413fadab8c23a4$export$c8d616af96ac729f) {
        if (0, $aBCC8.DEBUG_BUILD) (0, $hi47i.logger).info(`Adding previous_trace ${previousTraceSpanCtx} link to span ${{
            op: spanJson.op,
            ...span.spanContext()
        }}`);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $yQUXg.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE)]: 'previous_trace'
            }
        });
        // TODO: Remove this once EAP can store span links. We currently only set this attribute so that we
        // can obtain the previous trace information from the EAP store. Long-term, EAP will handle
        // span links and then we should remove this again. Also throwing in a TODO(v10), to remind us
        // to check this at v10 time :)
        span.setAttribute($ae413fadab8c23a4$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${$ae413fadab8c23a4$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0}`);
    }
    return updatedPreviousTraceInfo;
}
/**
 * Stores @param previousTraceInfo in sessionStorage.
 */ function $ae413fadab8c23a4$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $csQk2.WINDOW).sessionStorage.setItem($ae413fadab8c23a4$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        // Ignore potential errors (e.g. if sessionStorage is not available)
        (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).warn('Could not store previous trace in sessionStorage', e);
    }
}
/**
 * Retrieves the previous trace from sessionStorage if available.
 */ function $ae413fadab8c23a4$export$ef546bba8a402d99() {
    try {
        const previousTraceInfo = (0, $csQk2.WINDOW).sessionStorage?.getItem($ae413fadab8c23a4$export$16b6aa13b3c0f075);
        // @ts-expect-error - intentionally risking JSON.parse throwing when previousTraceInfo is null to save bundle size
        return JSON.parse(previousTraceInfo);
    } catch (e) {
        return undefined;
    }
}
/**
 * see {@link import('@sentry/core').spanIsSampled}
 */ function $ae413fadab8c23a4$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 0x1;
}

});

parcelRegister("kqsdS", function(module, exports) {

$parcel$export(module.exports, "defaultRequestInstrumentationOptions", () => $edec20d6c9712df6$export$cc17fb3c0bc95cd7);
$parcel$export(module.exports, "instrumentOutgoingRequests", () => $edec20d6c9712df6$export$864489cb3478db3e);

var $iKmMF = parcelRequire("iKmMF");
var $6OKHc = parcelRequire("6OKHc");
var $4H7Y8 = parcelRequire("4H7Y8");
var $kGYVh = parcelRequire("kGYVh");
var $hA6iJ = parcelRequire("hA6iJ");
var $2stGL = parcelRequire("2stGL");
var $4XLci = parcelRequire("4XLci");
var $XYHbQ = parcelRequire("XYHbQ");
var $3M05P = parcelRequire("3M05P");
var $yQUXg = parcelRequire("yQUXg");
var $iAX8i = parcelRequire("iAX8i");
var $02dIh = parcelRequire("02dIh");
var $iMoih = parcelRequire("iMoih");
var $hLnp0 = parcelRequire("hLnp0");

var $4hTws = parcelRequire("4hTws");
var $8zIFF = parcelRequire("8zIFF");
var $fbcQh = parcelRequire("fbcQh");

var $csQk2 = parcelRequire("csQk2");
/** Options for Request Instrumentation */ const $edec20d6c9712df6$var$responseToSpanId = new WeakMap();
const $edec20d6c9712df6$var$spanIdToEndTimestamp = new Map();
const $edec20d6c9712df6$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $edec20d6c9712df6$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart } = {
        ...$edec20d6c9712df6$export$cc17fb3c0bc95cd7,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$edec20d6c9712df6$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === 'transaction' && event.spans) event.spans.forEach((span)=>{
                if (span.op === 'http.client') {
                    const updatedTimestamp = $edec20d6c9712df6$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $edec20d6c9712df6$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $iKmMF.addFetchEndInstrumentationHandler)((handlerData)=>{
            if (handlerData.response) {
                const span = $edec20d6c9712df6$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $edec20d6c9712df6$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $iKmMF.addFetchInstrumentationHandler)((handlerData)=>{
            const createdSpan = (0, $XYHbQ.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (handlerData.response && handlerData.fetchData.__span) $edec20d6c9712df6$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = $edec20d6c9712df6$var$getFullURL(handlerData.fetchData.url);
                const host = fullUrl ? (0, $3M05P.parseUrl)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    'http.url': fullUrl,
                    'server.address': host
                });
                if (enableHTTPTimings) $edec20d6c9712df6$var$addHTTPTimings(createdSpan);
                onRequestSpanStart?.(createdSpan, {
                    headers: handlerData.headers
                });
            }
        });
    }
    if (traceXHR) (0, $8zIFF.addXhrInstrumentationHandler)((handlerData)=>{
        const createdSpan = $edec20d6c9712df6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (createdSpan) {
            if (enableHTTPTimings) $edec20d6c9712df6$var$addHTTPTimings(createdSpan);
            let headers;
            try {
                headers = new Headers(handlerData.xhr.__sentry_xhr_v3__?.request_headers);
            } catch  {
            // noop
            }
            onRequestSpanStart?.(createdSpan, {
                headers: headers
            });
        }
    });
}
function $edec20d6c9712df6$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $edec20d6c9712df6$var$addHTTPTimings(span) {
    const { url: url } = (0, $4H7Y8.spanToJSON)(span).data;
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $4hTws.addPerformanceInstrumentationHandler)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($edec20d6c9712df6$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $edec20d6c9712df6$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
function $edec20d6c9712df6$var$getAbsoluteTime(time = 0) {
    return (((0, $6OKHc.browserPerformanceTimeOrigin)() || performance.timeOrigin) + time) / 1000;
}
function $edec20d6c9712df6$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = (0, $fbcQh.extractNetworkProtocol)(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $6OKHc.browserPerformanceTimeOrigin)()) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $edec20d6c9712df6$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $hA6iJ.getLocationHref)();
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $hLnp0.stringMatchesSomePattern)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $hLnp0.stringMatchesSomePattern)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $hLnp0.stringMatchesSomePattern)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $edec20d6c9712df6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr?.[0, $8zIFF.SENTRY_XHR_DATA_KEY];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $4XLci.hasSpansEnabled)() && shouldCreateSpan(url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $02dIh.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $edec20d6c9712df6$var$getFullURL(url);
    const parsedUrl = fullUrl ? (0, $3M05P.parseUrl)(fullUrl) : (0, $3M05P.parseUrl)(url);
    const urlForSpanName = (0, $3M05P.stripUrlQueryAndFragment)(url);
    const hasParent = !!(0, $4H7Y8.getActiveSpan)();
    const span = shouldCreateSpanResult && hasParent ? (0, $iMoih.startInactiveSpan)({
        name: `${method} ${urlForSpanName}`,
        attributes: {
            url: url,
            type: 'xhr',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': parsedUrl?.host,
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser',
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: 'http.client',
            ...parsedUrl?.search && {
                'http.query': parsedUrl?.search
            },
            ...parsedUrl?.hash && {
                'http.fragment': parsedUrl?.hash
            }
        }
    }) : new (0, $iAX8i.SentryNonRecordingSpan)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders(url)) $edec20d6c9712df6$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $4XLci.hasSpansEnabled)() && hasParent ? span : undefined);
    const client = (0, $kGYVh.getClient)();
    if (client) client.emit('beforeOutgoingRequestSpan', span, handlerData);
    return span;
}
function $edec20d6c9712df6$var$addTracingHeadersToXhrRequest(xhr, span) {
    const { 'sentry-trace': sentryTrace, baggage: baggage } = (0, $2stGL.getTraceData)({
        span: span
    });
    if (sentryTrace) $edec20d6c9712df6$var$setHeaderOnXhr(xhr, sentryTrace, baggage);
}
function $edec20d6c9712df6$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    const originalHeaders = xhr.__sentry_xhr_v3__?.request_headers;
    if (originalHeaders?.['sentry-trace']) // bail if a sentry-trace header is already set
    return;
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) {
            // only add our headers if
            // - no pre-existing baggage header exists
            // - or it is set and doesn't yet contain sentry values
            const originalBaggageHeader = originalHeaders?.['baggage'];
            if (!originalBaggageHeader || !$edec20d6c9712df6$var$baggageHeaderHasSentryValues(originalBaggageHeader)) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
            // We can therefore simply set a baggage header without checking what was there before
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            xhr.setRequestHeader('baggage', sentryBaggageHeader);
        }
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $edec20d6c9712df6$var$baggageHeaderHasSentryValues(baggageHeader) {
    return baggageHeader.split(',').some((value)=>value.trim().startsWith('sentry-'));
}
function $edec20d6c9712df6$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $csQk2.WINDOW).location.origin);
        return parsed.href;
    } catch  {
        return undefined;
    }
}

});
parcelRegister("iKmMF", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", () => $da5e32477400e3c6$export$f75d3c772c923df0);
$parcel$export(module.exports, "addFetchEndInstrumentationHandler", () => $da5e32477400e3c6$export$1a79663eb318fe6a);

var $dfMsQ = parcelRequire("dfMsQ");

var $l1oVX = parcelRequire("l1oVX");

var $aW7Vg = parcelRequire("aW7Vg");

var $6OKHc = parcelRequire("6OKHc");

var $2fKhD = parcelRequire("2fKhD");

var $kE1Yf = parcelRequire("kE1Yf");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $da5e32477400e3c6$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, ()=>$da5e32477400e3c6$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $da5e32477400e3c6$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, ()=>$da5e32477400e3c6$var$instrumentFetch($da5e32477400e3c6$var$streamHandler));
}
function $da5e32477400e3c6$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $aW7Vg.supportsNativeFetch)()) return;
    (0, $l1oVX.fill)((0, $2fKhD.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $da5e32477400e3c6$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $da5e32477400e3c6$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $kE1Yf.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $2fKhD.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $kE1Yf.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $kE1Yf.triggerHandlers)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                    error: error
                });
                if ((0, $dfMsQ.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $l1oVX.addNonEnumerableProperty)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $da5e32477400e3c6$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $da5e32477400e3c6$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $da5e32477400e3c6$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $kE1Yf.triggerHandlers)('fetch-body-resolved', {
            endTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function $da5e32477400e3c6$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $da5e32477400e3c6$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($da5e32477400e3c6$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $da5e32477400e3c6$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $da5e32477400e3c6$var$getUrlFromResource(url),
            method: $da5e32477400e3c6$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $da5e32477400e3c6$var$getUrlFromResource(arg),
        method: $da5e32477400e3c6$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $da5e32477400e3c6$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $dfMsQ.isRequest)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

});

parcelRegister("2stGL", function(module, exports) {

$parcel$export(module.exports, "getTraceData", () => $1ca539d872b9359e$export$dec8f001b9d982cb);

var $7YCyf = parcelRequire("7YCyf");

var $iNK7c = parcelRequire("iNK7c");

var $kGYVh = parcelRequire("kGYVh");

var $kQ0sT = parcelRequire("kQ0sT");



var $hi47i = parcelRequire("hi47i");

var $4H7Y8 = parcelRequire("4H7Y8");


var $jdzJv = parcelRequire("jdzJv");

var $AIi6N = parcelRequire("AIi6N");

var $gdhAa = parcelRequire("gdhAa");
/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values to strings. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $1ca539d872b9359e$export$dec8f001b9d982cb(options = {}) {
    const client = (0, $kGYVh.getClient)();
    if (!(0, $kQ0sT.isEnabled)() || !client) return {};
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = (0, $kGYVh.getCurrentScope)();
    const span = options.span || (0, $4H7Y8.getActiveSpan)();
    const sentryTrace = span ? (0, $4H7Y8.spanToTraceHeader)(span) : $1ca539d872b9359e$var$scopeToTraceHeader(scope);
    const dsc = span ? (0, $jdzJv.getDynamicSamplingContextFromSpan)(span) : (0, $jdzJv.getDynamicSamplingContextFromScope)(client, scope);
    const baggage = (0, $gdhAa.dynamicSamplingContextToSentryBaggageHeader)(dsc);
    const isValidSentryTraceHeader = (0, $AIi6N.TRACEPARENT_REGEXP).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $hi47i.logger).warn('Invalid sentry-trace data. Cannot generate trace data');
        return {};
    }
    return {
        'sentry-trace': sentryTrace,
        baggage: baggage
    };
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $1ca539d872b9359e$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return (0, $AIi6N.generateSentryTraceHeader)(traceId, propagationSpanId, sampled);
}

});

parcelRegister("XYHbQ", function(module, exports) {

$parcel$export(module.exports, "instrumentFetchRequest", () => $0b4497afe5c251f9$export$6d73c62358c655be);

var $kGYVh = parcelRequire("kGYVh");

var $yQUXg = parcelRequire("yQUXg");



var $dfMsQ = parcelRequire("dfMsQ");


var $4XLci = parcelRequire("4XLci");

var $4H7Y8 = parcelRequire("4H7Y8");


var $gdhAa = parcelRequire("gdhAa");

var $iAX8i = parcelRequire("iAX8i");

var $02dIh = parcelRequire("02dIh");

var $iMoih = parcelRequire("iMoih");

var $2stGL = parcelRequire("2stGL");

var $3M05P = parcelRequire("3M05P");
/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $0b4497afe5c251f9$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!handlerData.fetchData) return undefined;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = (0, $4XLci.hasSpansEnabled)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $0b4497afe5c251f9$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const hasParent = !!(0, $4H7Y8.getActiveSpan)();
    const span = shouldCreateSpanResult && hasParent ? (0, $iMoih.startInactiveSpan)($0b4497afe5c251f9$var$getSpanStartOptions(url, method, spanOrigin)) : new (0, $iAX8i.SentryNonRecordingSpan)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = handlerData.args[1] || {};
        const headers = $0b4497afe5c251f9$export$eab8901e1b084464(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $4XLci.hasSpansEnabled)() && hasParent ? span : undefined);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    const client = (0, $kGYVh.getClient)();
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit('beforeOutgoingRequestSpan', span, fetchHint);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 * exported only for testing purposes
 *
 * When we determine if we should add a baggage header, there are 3 cases:
 * 1. No previous baggage header -> add baggage
 * 2. Previous baggage header has no sentry baggage values -> add our baggage
 * 3. Previous baggage header has sentry baggage values -> do nothing (might have been added manually by users)
 */ // eslint-disable-next-line complexity -- yup it's this complicated :(
function $0b4497afe5c251f9$export$eab8901e1b084464(request, fetchOptionsObj, span) {
    const traceHeaders = (0, $2stGL.getTraceData)({
        span: span
    });
    const sentryTrace = traceHeaders['sentry-trace'];
    const baggage = traceHeaders.baggage;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const originalHeaders = fetchOptionsObj.headers || ((0, $dfMsQ.isRequest)(request) ? request.headers : undefined);
    if (!originalHeaders) return {
        ...traceHeaders
    };
    else if ($0b4497afe5c251f9$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        // We don't want to override manually added sentry headers
        if (!newHeaders.get('sentry-trace')) newHeaders.set('sentry-trace', sentryTrace);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get('baggage');
            if (!prevBaggageHeader) newHeaders.set('baggage', baggage);
            else if (!$0b4497afe5c251f9$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set('baggage', `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if (Array.isArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!originalHeaders.find((header)=>header[0] === 'sentry-trace')) newHeaders.push([
            'sentry-trace',
            sentryTrace
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === 'baggage' && $0b4497afe5c251f9$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            'baggage',
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = 'sentry-trace' in originalHeaders ? originalHeaders['sentry-trace'] : undefined;
        const existingBaggageHeader = 'baggage' in originalHeaders ? originalHeaders.baggage : undefined;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$0b4497afe5c251f9$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $0b4497afe5c251f9$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        return {
            ...originalHeaders,
            'sentry-trace': existingSentryTraceHeader ?? sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
function $0b4497afe5c251f9$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $02dIh.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $02dIh.SPAN_STATUS_ERROR),
        message: 'internal_error'
    });
    span.end();
}
function $0b4497afe5c251f9$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(',').some((baggageEntry)=>baggageEntry.trim().startsWith((0, $gdhAa.SENTRY_BAGGAGE_KEY_PREFIX)));
}
function $0b4497afe5c251f9$var$isHeaders(headers) {
    return typeof Headers !== 'undefined' && (0, $dfMsQ.isInstanceOf)(headers, Headers);
}
function $0b4497afe5c251f9$var$getSpanStartOptions(url, method, spanOrigin) {
    const parsedUrl = (0, $3M05P.parseStringToURLObject)(url);
    return {
        name: parsedUrl ? `${method} ${(0, $3M05P.getSanitizedUrlStringFromUrlObject)(parsedUrl)}` : method,
        attributes: $0b4497afe5c251f9$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin)
    };
}
function $0b4497afe5c251f9$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: url,
        type: 'fetch',
        'http.method': method,
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: 'http.client'
    };
    if (parsedUrl) {
        if (!(0, $3M05P.isURLObjectRelative)(parsedUrl)) {
            attributes['http.url'] = parsedUrl.href;
            attributes['server.address'] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes['http.query'] = parsedUrl.search;
        if (parsedUrl.hash) attributes['http.fragment'] = parsedUrl.hash;
    }
    return attributes;
}

});

parcelRegister("8zIFF", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", () => $63e43e59b4196dc4$export$55b6bb1e45c6cf59);
$parcel$export(module.exports, "addXhrInstrumentationHandler", () => $63e43e59b4196dc4$export$26ace48dd54c9aea);

var $kE1Yf = parcelRequire("kE1Yf");
var $dfMsQ = parcelRequire("dfMsQ");
var $6OKHc = parcelRequire("6OKHc");

var $cOSHO = parcelRequire("cOSHO");
const $63e43e59b4196dc4$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $63e43e59b4196dc4$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, $63e43e59b4196dc4$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $63e43e59b4196dc4$export$c67d533bf77cbf54() {
    if (!(0, $cOSHO.WINDOW).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $6OKHc.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $dfMsQ.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $63e43e59b4196dc4$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $kE1Yf.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $dfMsQ.isString)(header) && (0, $dfMsQ.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, $kE1Yf.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $63e43e59b4196dc4$var$parseXhrUrlArg(url) {
    if ((0, $dfMsQ.isString)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}

});



parcelRegister("cA8mQ", function(module, exports) {

$parcel$export(module.exports, "init", () => $928f566aa50bb77a$export$2cd8252107eb640b);

var $fW1oP = parcelRequire("fW1oP");
var $aNMJx = parcelRequire("aNMJx");
var $lBLPp = parcelRequire("lBLPp");
var $5K5zC = parcelRequire("5K5zC");
var $diSl5 = parcelRequire("diSl5");
var $5v1oS = parcelRequire("5v1oS");

var $9Rc92 = parcelRequire("9Rc92");

var $bXMYE = parcelRequire("bXMYE");

var $6HdUS = parcelRequire("6HdUS");

var $bSsXc = parcelRequire("bSsXc");

var $4U4Fy = parcelRequire("4U4Fy");

var $jXkOO = parcelRequire("jXkOO");

var $a13dx = parcelRequire("a13dx");

var $jjJIz = parcelRequire("jjJIz");

var $3yu4Q = parcelRequire("3yu4Q");

var $lWeSa = parcelRequire("lWeSa");
/** Get the default integrations for the browser SDK. */ function $928f566aa50bb77a$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $5K5zC.inboundFiltersIntegration)(),
        (0, $aNMJx.functionToStringIntegration)(),
        (0, $6HdUS.browserApiErrorsIntegration)(),
        (0, $bXMYE.breadcrumbsIntegration)(),
        (0, $4U4Fy.globalHandlersIntegration)(),
        (0, $a13dx.linkedErrorsIntegration)(),
        (0, $fW1oP.dedupeIntegration)(),
        (0, $jXkOO.httpContextIntegration)(),
        (0, $bSsXc.browserSessionIntegration)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $928f566aa50bb77a$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $lWeSa.checkAndWarnIfIsEmbeddedBrowserExtension)();
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $5v1oS.stackParserFromStackParserOptions)(options.stackParser || (0, $jjJIz.defaultStackParser)),
        integrations: (0, $lBLPp.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: options.defaultIntegrations == null ? $928f566aa50bb77a$export$5783b2920b1d62b9() : options.defaultIntegrations
        }),
        transport: options.transport || (0, $3yu4Q.makeFetchTransport)
    };
    return (0, $diSl5.initAndBind)((0, $9Rc92.BrowserClient), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$4e4d8b287d028b6b(callback) {
    callback();
}

});
parcelRegister("fW1oP", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", () => $b99d5bb3db344fdd$export$6d39aa44cd0c7567);

var $fKzCQ = parcelRequire("fKzCQ");

var $lBLPp = parcelRequire("lBLPp");

var $hi47i = parcelRequire("hi47i");

var $5v1oS = parcelRequire("5v1oS");
const $b99d5bb3db344fdd$var$INTEGRATION_NAME = 'Dedupe';
const $b99d5bb3db344fdd$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $b99d5bb3db344fdd$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $b99d5bb3db344fdd$export$6d39aa44cd0c7567 = (0, $lBLPp.defineIntegration)($b99d5bb3db344fdd$var$_dedupeIntegration);
/** only exported for tests. */ function $b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(previousEvent);
    const currentException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $5v1oS.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $5v1oS.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $b99d5bb3db344fdd$var$_getExceptionFromEvent(event) {
    return event.exception?.values && event.exception.values[0];
}

});
parcelRegister("lBLPp", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", () => $fbb22756c9507e85$export$68bc4c01ab8ae766);
$parcel$export(module.exports, "setupIntegrations", () => $fbb22756c9507e85$export$51abed9797baa598);
$parcel$export(module.exports, "setupIntegration", () => $fbb22756c9507e85$export$e7390a03b70a6f2f);
$parcel$export(module.exports, "afterSetupIntegrations", () => $fbb22756c9507e85$export$35abcfd71227c6ca);
$parcel$export(module.exports, "defineIntegration", () => $fbb22756c9507e85$export$2323046b9414659f);

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");
const $fbb22756c9507e85$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $fbb22756c9507e85$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $fbb22756c9507e85$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $fbb22756c9507e85$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $fbb22756c9507e85$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $fbb22756c9507e85$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($fbb22756c9507e85$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $fbb22756c9507e85$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $fbb22756c9507e85$export$2d8f5188773bcddd(integration) {
    const client = (0, $kGYVh.getClient)();
    if (!client) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $fbb22756c9507e85$export$2323046b9414659f(fn) {
    return fn;
}

});


parcelRegister("aNMJx", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", () => $7dd448759c7f5e18$export$7918117e9202e4fb);

var $kGYVh = parcelRequire("kGYVh");

var $lBLPp = parcelRequire("lBLPp");

var $l1oVX = parcelRequire("l1oVX");
let $7dd448759c7f5e18$var$originalFunctionToString;
const $7dd448759c7f5e18$var$INTEGRATION_NAME = 'FunctionToString';
const $7dd448759c7f5e18$var$SETUP_CLIENTS = new WeakMap();
const $7dd448759c7f5e18$var$_functionToStringIntegration = ()=>{
    return {
        name: $7dd448759c7f5e18$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $7dd448759c7f5e18$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $l1oVX.getOriginalFunction)(this);
                    const context = $7dd448759c7f5e18$var$SETUP_CLIENTS.has((0, $kGYVh.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $7dd448759c7f5e18$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $7dd448759c7f5e18$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $7dd448759c7f5e18$export$7918117e9202e4fb = (0, $lBLPp.defineIntegration)($7dd448759c7f5e18$var$_functionToStringIntegration);

});

parcelRegister("5K5zC", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", () => $42e5926860cf11cf$export$cb3c5c2ceb9818ba);

var $fKzCQ = parcelRequire("fKzCQ");

var $lBLPp = parcelRequire("lBLPp");

var $jHXCX = parcelRequire("jHXCX");

var $hi47i = parcelRequire("hi47i");

var $6OhB9 = parcelRequire("6OhB9");

var $hLnp0 = parcelRequire("hLnp0");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $42e5926860cf11cf$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $42e5926860cf11cf$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $42e5926860cf11cf$export$9a84f518c163c552 = (0, $lBLPp.defineIntegration)((options = {})=>{
    let mergedOptions;
    return {
        name: $42e5926860cf11cf$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $42e5926860cf11cf$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $42e5926860cf11cf$var$_mergeOptions(options, clientOptions);
            }
            return $42e5926860cf11cf$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $42e5926860cf11cf$export$cb3c5c2ceb9818ba = (0, $lBLPp.defineIntegration)((options = {})=>{
    return {
        ...$42e5926860cf11cf$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $42e5926860cf11cf$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $42e5926860cf11cf$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $42e5926860cf11cf$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($42e5926860cf11cf$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}`);
            return true;
        }
        if ($42e5926860cf11cf$var$_isUselessError(event)) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}`);
            return true;
        }
        if ($42e5926860cf11cf$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}.\nUrl: ${$42e5926860cf11cf$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$42e5926860cf11cf$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}.\nUrl: ${$42e5926860cf11cf$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($42e5926860cf11cf$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}`);
            return true;
        }
    }
    return false;
}
function $42e5926860cf11cf$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $jHXCX.getPossibleEventMessages)(event).some((message)=>(0, $hLnp0.stringMatchesSomePattern)(message, ignoreErrors));
}
function $42e5926860cf11cf$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $hLnp0.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $42e5926860cf11cf$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $42e5926860cf11cf$var$_getEventFilterUrl(event);
    return !url ? false : (0, $hLnp0.stringMatchesSomePattern)(url, denyUrls);
}
function $42e5926860cf11cf$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $42e5926860cf11cf$var$_getEventFilterUrl(event);
    return !url ? true : (0, $hLnp0.stringMatchesSomePattern)(url, allowUrls);
}
function $42e5926860cf11cf$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $42e5926860cf11cf$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $42e5926860cf11cf$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error(`Cannot extract url for event ${(0, $6OhB9.getEventDescription)(event)}`);
        return null;
    }
}
function $42e5926860cf11cf$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}

});
parcelRegister("jHXCX", function(module, exports) {

$parcel$export(module.exports, "getPossibleEventMessages", () => $e5904939f3a5a4e3$export$d55a97c329cacfcc);
/**
 * Get a list of possible event messages from a Sentry event.
 */ function $e5904939f3a5a4e3$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}

});


parcelRegister("diSl5", function(module, exports) {

$parcel$export(module.exports, "initAndBind", () => $9af71b6a24a126c8$export$5333c3f1c58d9bc1);

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $9af71b6a24a126c8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $fKzCQ.DEBUG_BUILD) (0, $hi47i.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $hi47i.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $kGYVh.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $9af71b6a24a126c8$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $9af71b6a24a126c8$export$ecb76f41d43c0e43(client) {
    (0, $kGYVh.getCurrentScope)().setClient(client);
}

});

parcelRegister("9Rc92", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", () => $72d27c0252bb80ff$export$1df9218a526d318d);

var $jp1mK = parcelRequire("jp1mK");
var $3Qq0w = parcelRequire("3Qq0w");
var $8gINE = parcelRequire("8gINE");
var $acs5H = parcelRequire("acs5H");
var $2wKOZ = parcelRequire("2wKOZ");

var $34UVT = parcelRequire("34UVT");

var $csQk2 = parcelRequire("csQk2");
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ const $72d27c0252bb80ff$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $72d27c0252bb80ff$export$1df9218a526d318d extends (0, $acs5H.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $72d27c0252bb80ff$export$4e107b20a7f977(options);
        const sdkSource = (0, $csQk2.WINDOW).SENTRY_SDK_SOURCE || (0, $2wKOZ.getSDKSource)();
        (0, $8gINE.applySdkMetadata)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, _experiments: _experiments } = this._options;
        const enableLogs = _experiments?.enableLogs;
        if ((0, $csQk2.WINDOW).document && (sendClientReports || enableLogs)) (0, $csQk2.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $csQk2.WINDOW).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $jp1mK._INTERNAL_flushLogsBuffer)(this);
            }
        });
        if (enableLogs) {
            this.on('flush', ()=>{
                (0, $jp1mK._INTERNAL_flushLogsBuffer)(this);
            });
            this.on('afterCaptureLog', ()=>{
                if (this._logFlushIdleTimeout) clearTimeout(this._logFlushIdleTimeout);
                this._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $jp1mK._INTERNAL_flushLogsBuffer)(this);
                }, $72d27c0252bb80ff$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            this.on('postprocessEvent', (0, $3Qq0w.addAutoIpAddressToUser));
            this.on('beforeSendSession', (0, $3Qq0w.addAutoIpAddressToSession));
        }
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $34UVT.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $34UVT.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $72d27c0252bb80ff$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $csQk2.WINDOW).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}

});
parcelRegister("jp1mK", function(module, exports) {

$parcel$export(module.exports, "_INTERNAL_flushLogsBuffer", () => $e2016958b0149e1a$export$f8ed83d3b6a0b504);

var $acs5H = parcelRequire("acs5H");

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $3zNRu = parcelRequire("3zNRu");

var $dc48k = parcelRequire("dc48k");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $6OKHc = parcelRequire("6OKHc");

var $2fKhD = parcelRequire("2fKhD");

var $oQmNJ = parcelRequire("oQmNJ");

var $idhBv = parcelRequire("idhBv");
const $e2016958b0149e1a$var$MAX_LOG_BUFFER_SIZE = 100;
// The reference to the Client <> LogBuffer map is stored to ensure it's always the same
(0, $2fKhD.GLOBAL_OBJ)._sentryClientToLogBufferMap = new WeakMap();
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $e2016958b0149e1a$export$84cb46f4adfc5d14(value) {
    switch(typeof value){
        case 'number':
            if (Number.isInteger(value)) return {
                value: value,
                type: 'integer'
            };
            return {
                value: value,
                type: 'double'
            };
        case 'boolean':
            return {
                value: value,
                type: 'boolean'
            };
        case 'string':
            return {
                value: value,
                type: 'string'
            };
        default:
            {
                let stringValue = '';
                try {
                    stringValue = JSON.stringify(value) ?? '';
                } catch  {
                // Do nothing
                }
                return {
                    value: stringValue,
                    type: 'string'
                };
            }
    }
}
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $e2016958b0149e1a$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $e2016958b0149e1a$export$743ba6f7ec19225f(client, serializedLog) {
    const logBuffer = $e2016958b0149e1a$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) (0, $2fKhD.GLOBAL_OBJ)._sentryClientToLogBufferMap?.set(client, [
        serializedLog
    ]);
    else {
        (0, $2fKhD.GLOBAL_OBJ)._sentryClientToLogBufferMap?.set(client, [
            ...logBuffer,
            serializedLog
        ]);
        if (logBuffer.length >= $e2016958b0149e1a$var$MAX_LOG_BUFFER_SIZE) $e2016958b0149e1a$export$f8ed83d3b6a0b504(client, logBuffer);
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $e2016958b0149e1a$export$3ab3d16b9eebd986(beforeLog, client = (0, $kGYVh.getClient)(), currentScope = (0, $kGYVh.getCurrentScope)(), captureSerializedLog = $e2016958b0149e1a$export$743ba6f7ec19225f) {
    if (!client) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn('No client available to capture log.');
        return;
    }
    const { _experiments: _experiments, release: release, environment: environment } = client.getOptions();
    const { enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = _experiments ?? {};
    if (!enableLogs) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $acs5H._getTraceInfoFromScope)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: user } = $e2016958b0149e1a$var$getMergedScopeData(currentScope);
    // Only attach user to log attributes if sendDefaultPii is enabled
    if (client.getOptions().sendDefaultPii) {
        const { id: id, email: email, username: username } = user;
        $e2016958b0149e1a$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
        $e2016958b0149e1a$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
        $e2016958b0149e1a$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    }
    $e2016958b0149e1a$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $e2016958b0149e1a$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $e2016958b0149e1a$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $e2016958b0149e1a$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const beforeLogMessage = beforeLog.message;
    if ((0, $dfMsQ.isParameterizedString)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $dc48k._getSpanForScope)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $e2016958b0149e1a$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    const log = beforeSendLog ? beforeSendLog(processedLog) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        timestamp: (0, $6OKHc.timestampInSeconds)(),
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $oQmNJ.SEVERITY_TEXT_TO_SEVERITY_NUMBER)[level],
        attributes: Object.keys(attributes).reduce((acc, key)=>{
            acc[key] = $e2016958b0149e1a$export$84cb46f4adfc5d14(attributes[key]);
            return acc;
        }, {})
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $e2016958b0149e1a$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $e2016958b0149e1a$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $idhBv.createLogEnvelope)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    (0, $2fKhD.GLOBAL_OBJ)._sentryClientToLogBufferMap?.set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $e2016958b0149e1a$export$5365c9902fb9e770(client) {
    return (0, $2fKhD.GLOBAL_OBJ)._sentryClientToLogBufferMap?.get(client);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $e2016958b0149e1a$var$getMergedScopeData(currentScope) {
    const scopeData = (0, $kGYVh.getGlobalScope)().getScopeData();
    (0, $3zNRu.mergeScopeData)(scopeData, (0, $kGYVh.getIsolationScope)().getScopeData());
    (0, $3zNRu.mergeScopeData)(scopeData, currentScope.getScopeData());
    return scopeData;
}

});
parcelRegister("acs5H", function(module, exports) {

$parcel$export(module.exports, "Client", () => $76d0d0aa71b7be3b$export$1f2bb630327ac4b6);
$parcel$export(module.exports, "_getTraceInfoFromScope", () => $76d0d0aa71b7be3b$export$fb7d833b3fdedf5f);

var $1dwxw = parcelRequire("1dwxw");

var $4Baka = parcelRequire("4Baka");

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $fQDlp = parcelRequire("fQDlp");

var $lBLPp = parcelRequire("lBLPp");

var $kkdRz = parcelRequire("kkdRz");

var $jdzJv = parcelRequire("jdzJv");

var $jHXCX = parcelRequire("jHXCX");

var $vNNF0 = parcelRequire("vNNF0");

var $1oUdV = parcelRequire("1oUdV");

var $g1WRa = parcelRequire("g1WRa");

var $4H7Y8 = parcelRequire("4H7Y8");

var $lFsLg = parcelRequire("lFsLg");

var $g8eDs = parcelRequire("g8eDs");

var $cucnP = parcelRequire("cucnP");

var $l4iiL = parcelRequire("l4iiL");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $6OhB9 = parcelRequire("6OhB9");

var $di9R8 = parcelRequire("di9R8");
/* eslint-disable max-lines */ const $76d0d0aa71b7be3b$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $76d0d0aa71b7be3b$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $76d0d0aa71b7be3b$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $76d0d0aa71b7be3b$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function $76d0d0aa71b7be3b$var$_makeInternalError(message) {
    return {
        message: message,
        [$76d0d0aa71b7be3b$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $76d0d0aa71b7be3b$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$76d0d0aa71b7be3b$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $76d0d0aa71b7be3b$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $76d0d0aa71b7be3b$var$INTERNAL_ERROR_SYMBOL in error;
}
function $76d0d0aa71b7be3b$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $76d0d0aa71b7be3b$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $76d0d0aa71b7be3b$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $cucnP.makeDsn)(options.dsn);
        else (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $1dwxw.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $6OhB9.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $6OhB9.checkOrSetAlreadyCaught)(exception)) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log($76d0d0aa71b7be3b$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $6OhB9.uuid4)(),
            ...hint
        };
        const eventMessage = (0, $dfMsQ.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $dfMsQ.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $6OhB9.uuid4)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $6OhB9.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log($76d0d0aa71b7be3b$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $kkdRz.updateSession)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $di9R8.resolvedSyncPromise)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $lBLPp.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $lBLPp.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $fQDlp.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $l4iiL.addItemToEnvelope)(env, (0, $l4iiL.createAttachmentEnvelopeItem)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $4Baka.DEFAULT_ENVIRONMENT) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn($76d0d0aa71b7be3b$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn($76d0d0aa71b7be3b$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $fQDlp.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error('Transport disabled');
        return (0, $di9R8.resolvedSyncPromise)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $lBLPp.setupIntegrations)(this, integrations);
        (0, $lBLPp.afterSetupIntegrations)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $kkdRz.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $di9R8.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $g1WRa.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: (0, $kGYVh.getTraceContextFromScope)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $jdzJv.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $kGYVh.getCurrentScope)(), isolationScope = (0, $kGYVh.getIsolationScope)()) {
        if ((0, $fKzCQ.DEBUG_BUILD) && $76d0d0aa71b7be3b$var$isErrorEvent(event)) (0, $hi47i.logger).log(`Captured error event \`${(0, $jHXCX.getPossibleEventMessages)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $fKzCQ.DEBUG_BUILD) {
                if ($76d0d0aa71b7be3b$var$_isDoNotSendEventError(reason)) (0, $hi47i.logger).log(reason.message);
                else if ($76d0d0aa71b7be3b$var$_isInternalError(reason)) (0, $hi47i.logger).warn(reason.message);
                else (0, $hi47i.logger).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $76d0d0aa71b7be3b$var$isTransactionEvent(event);
        const isError = $76d0d0aa71b7be3b$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $1oUdV.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $di9R8.rejectedSyncPromise)($76d0d0aa71b7be3b$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $76d0d0aa71b7be3b$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $76d0d0aa71b7be3b$var$processBeforeSend(this, options, prepared, hint);
            return $76d0d0aa71b7be3b$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $76d0d0aa71b7be3b$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($76d0d0aa71b7be3b$var$_isDoNotSendEventError(reason) || $76d0d0aa71b7be3b$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $76d0d0aa71b7be3b$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $g8eDs.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $cucnP.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $76d0d0aa71b7be3b$export$4f22f74eddb7716a = $76d0d0aa71b7be3b$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $76d0d0aa71b7be3b$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $dfMsQ.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $dfMsQ.isPlainObject)(event) && event !== null) throw $76d0d0aa71b7be3b$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $76d0d0aa71b7be3b$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $dfMsQ.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw $76d0d0aa71b7be3b$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $76d0d0aa71b7be3b$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($76d0d0aa71b7be3b$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($76d0d0aa71b7be3b$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $lFsLg.convertTransactionEventToSpanJson)(processedEvent));
            if (!processedRootSpanJson) (0, $4H7Y8.showSpanDropWarning)();
            else // update event with processed root span values
            processedEvent = (0, $vNNF0.merge)(event, (0, $lFsLg.convertSpanJsonToTransactionEvent)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $4H7Y8.showSpanDropWarning)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $76d0d0aa71b7be3b$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $76d0d0aa71b7be3b$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** Extract trace information from scope */ function $76d0d0aa71b7be3b$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $kGYVh.withScope)(scope, ()=>{
        const span = (0, $4H7Y8.getActiveSpan)();
        const traceContext = span ? (0, $4H7Y8.spanToTraceContext)(span) : (0, $kGYVh.getTraceContextFromScope)(scope);
        const dynamicSamplingContext = span ? (0, $jdzJv.getDynamicSamplingContextFromSpan)(span) : (0, $jdzJv.getDynamicSamplingContextFromScope)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}

});
parcelRegister("1dwxw", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $0e303f054920e2b1$export$9964600bfe84e6a3);

var $cucnP = parcelRequire("cucnP");
const $0e303f054920e2b1$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $0e303f054920e2b1$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $0e303f054920e2b1$var$_getIngestEndpoint(dsn) {
    return `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $0e303f054920e2b1$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $0e303f054920e2b1$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$0e303f054920e2b1$var$_getIngestEndpoint(dsn)}?${$0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $0e303f054920e2b1$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $cucnP.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $cucnP.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});

parcelRegister("lFsLg", function(module, exports) {

$parcel$export(module.exports, "convertTransactionEventToSpanJson", () => $fc63bcb83eb88e73$export$d9c6b2464b0a687e);
$parcel$export(module.exports, "convertSpanJsonToTransactionEvent", () => $fc63bcb83eb88e73$export$f2d8fce5ae150e92);

var $yQUXg = parcelRequire("yQUXg");
/**
 * Converts a transaction event to a span JSON object.
 */ function $fc63bcb83eb88e73$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $yQUXg.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[0, $yQUXg.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $fc63bcb83eb88e73$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_PROFILE_ID)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}

});

parcelRegister("g8eDs", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", () => $bbe8beff1aee2812$export$f3b9ed77c03eeb00);

var $l4iiL = parcelRequire("l4iiL");

var $6OKHc = parcelRequire("6OKHc");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $bbe8beff1aee2812$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $6OKHc.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $l4iiL.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});


parcelRegister("oQmNJ", function(module, exports) {

$parcel$export(module.exports, "SEVERITY_TEXT_TO_SEVERITY_NUMBER", () => $04aadcf3f679e7b5$export$4fb50c0840d636d1);
/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $04aadcf3f679e7b5$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};

});

parcelRegister("idhBv", function(module, exports) {

$parcel$export(module.exports, "createLogEnvelope", () => $d42718a865457723$export$cdcd668e6516443f);

var $cucnP = parcelRequire("cucnP");

var $l4iiL = parcelRequire("l4iiL");
/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $d42718a865457723$export$efdf3b13edb1118e(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $d42718a865457723$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $cucnP.dsnToString)(dsn);
    return (0, $l4iiL.createEnvelope)(headers, [
        $d42718a865457723$export$efdf3b13edb1118e(logs)
    ]);
}

});


parcelRegister("3Qq0w", function(module, exports) {

$parcel$export(module.exports, "addAutoIpAddressToUser", () => $2cca66f9c5e6f810$export$3e12ad68afa434ac);
$parcel$export(module.exports, "addAutoIpAddressToSession", () => $2cca66f9c5e6f810$export$e8e2d07ba63e2b6c);
// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ function $2cca66f9c5e6f810$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $2cca66f9c5e6f810$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}

});

parcelRegister("8gINE", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", () => $605291aa308d4b89$export$b9f95b027256052c);

var $faPnA = parcelRequire("faPnA");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $605291aa308d4b89$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $faPnA.SDK_VERSION)
            })),
        version: (0, $faPnA.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("2wKOZ", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $1d72e3a9e632bed3$export$2928c40372e623c0);
$parcel$export(module.exports, "getSDKSource", () => $1d72e3a9e632bed3$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $1d72e3a9e632bed3$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $1d72e3a9e632bed3$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

});

parcelRegister("34UVT", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", () => $23dde874fe12fd4c$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $23dde874fe12fd4c$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $23dde874fe12fd4c$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $23dde874fe12fd4c$export$5425b53185d13d6c);

var $6OhB9 = parcelRequire("6OhB9");
var $l1oVX = parcelRequire("l1oVX");
var $kGYVh = parcelRequire("kGYVh");
var $dfMsQ = parcelRequire("dfMsQ");
var $886wr = parcelRequire("886wr");
var $di9R8 = parcelRequire("di9R8");
/**
 * This function creates an exception from a JavaScript Error
 */ function $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $23dde874fe12fd4c$export$2e9ae379995d99e3(ex),
        value: $23dde874fe12fd4c$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $kGYVh.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $23dde874fe12fd4c$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $886wr.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $dfMsQ.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $23dde874fe12fd4c$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $23dde874fe12fd4c$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $23dde874fe12fd4c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex) {
    if (ex && $23dde874fe12fd4c$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $23dde874fe12fd4c$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $23dde874fe12fd4c$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $23dde874fe12fd4c$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $23dde874fe12fd4c$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $23dde874fe12fd4c$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($23dde874fe12fd4c$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $23dde874fe12fd4c$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $6OhB9.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $di9R8.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $23dde874fe12fd4c$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $di9R8.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $dfMsQ.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $23dde874fe12fd4c$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $dfMsQ.isDOMError)(exception) || (0, $dfMsQ.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $dfMsQ.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $6OhB9.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $dfMsQ.isError)(exception)) // we have a real Error object, do nothing
    return $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
    if ((0, $dfMsQ.isPlainObject)(exception) || (0, $dfMsQ.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $6OhB9.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $23dde874fe12fd4c$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $6OhB9.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $6OhB9.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $6OhB9.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $dfMsQ.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $l1oVX.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $dfMsQ.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $dfMsQ.isEvent)(exception)) {
        const className = $23dde874fe12fd4c$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $23dde874fe12fd4c$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $23dde874fe12fd4c$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}

});


parcelRegister("bXMYE", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", () => $8b5b3242e956e79f$export$c079d904b326663a);

var $6El1G = parcelRequire("6El1G");
var $1XAcA = parcelRequire("1XAcA");
var $iKmMF = parcelRequire("iKmMF");
var $lBLPp = parcelRequire("lBLPp");
var $36svk = parcelRequire("36svk");
var $kGYVh = parcelRequire("kGYVh");
var $hA6iJ = parcelRequire("hA6iJ");
var $6OhB9 = parcelRequire("6OhB9");
var $hi47i = parcelRequire("hi47i");
var $3M05P = parcelRequire("3M05P");
var $hLnp0 = parcelRequire("hLnp0");
var $2bC2j = parcelRequire("2bC2j");

var $h8vIJ = parcelRequire("h8vIJ");
var $5hw2H = parcelRequire("5hw2H");
var $8zIFF = parcelRequire("8zIFF");

var $aBCC8 = parcelRequire("aBCC8");

var $csQk2 = parcelRequire("csQk2");
/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $8b5b3242e956e79f$var$INTEGRATION_NAME = 'Breadcrumbs';
const $8b5b3242e956e79f$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $8b5b3242e956e79f$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v10): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $1XAcA.addConsoleInstrumentationHandler)($8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $h8vIJ.addClickKeypressInstrumentationHandler)($8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $8zIFF.addXhrInstrumentationHandler)($8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $iKmMF.addFetchInstrumentationHandler)($8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $5hw2H.addHistoryInstrumentationHandler)($8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $8b5b3242e956e79f$export$c079d904b326663a = (0, $lBLPp.defineIntegration)($8b5b3242e956e79f$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $kGYVh.getClient)() !== client) return;
        (0, $6El1G.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $6OhB9.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $8b5b3242e956e79f$var$_isEvent(event) ? event.target : event;
            target = (0, $hA6iJ.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $hA6iJ.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $6El1G.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $2bC2j.severityLevelFromString)(handlerData.level),
            message: (0, $hLnp0.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $hLnp0.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $6El1G.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $8zIFF.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $36svk.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $6El1G.addBreadcrumb)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $6El1G.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $36svk.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $6El1G.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $3M05P.parseUrl)((0, $csQk2.WINDOW).location.href);
        let parsedFrom = from ? (0, $3M05P.parseUrl)(from) : undefined;
        const parsedTo = (0, $3M05P.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $6El1G.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $8b5b3242e956e79f$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("6El1G", function(module, exports) {

$parcel$export(module.exports, "addBreadcrumb", () => $4d76c9d78abc3a9e$export$efda9a273d7a036d);

var $kGYVh = parcelRequire("kGYVh");

var $hi47i = parcelRequire("hi47i");

var $6OKHc = parcelRequire("6OKHc");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $4d76c9d78abc3a9e$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $kGYVh.getClient)();
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $6OKHc.dateTimestampInSeconds)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $hi47i.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

});

parcelRegister("1XAcA", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $16d762171e064dbd$export$1d6e0d073f9e6723);

var $hi47i = parcelRequire("hi47i");

var $l1oVX = parcelRequire("l1oVX");

var $2fKhD = parcelRequire("2fKhD");

var $kE1Yf = parcelRequire("kE1Yf");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $16d762171e064dbd$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, $16d762171e064dbd$var$instrumentConsole);
}
function $16d762171e064dbd$var$instrumentConsole() {
    if (!('console' in (0, $2fKhD.GLOBAL_OBJ))) return;
    (0, $hi47i.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $2fKhD.GLOBAL_OBJ).console)) return;
        (0, $l1oVX.fill)((0, $2fKhD.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $hi47i.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $kE1Yf.triggerHandlers)('console', handlerData);
                const log = (0, $hi47i.originalConsoleMethods)[level];
                log?.apply((0, $2fKhD.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("36svk", function(module, exports) {

$parcel$export(module.exports, "getBreadcrumbLogLevelFromHttpStatusCode", () => $24280af9d15f06bf$export$b8cfcc4175694bcc);
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $24280af9d15f06bf$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

});

parcelRegister("2bC2j", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", () => $197a1d16f7c0faf5$export$d771ef054122c30a);
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $197a1d16f7c0faf5$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}

});

parcelRegister("h8vIJ", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", () => $c79bca128681c716$export$5aeffd3db2cf9df7);

var $kE1Yf = parcelRequire("kE1Yf");
var $l1oVX = parcelRequire("l1oVX");
var $6OhB9 = parcelRequire("6OhB9");

var $cOSHO = parcelRequire("cOSHO");
const $c79bca128681c716$var$DEBOUNCE_DURATION = 1000;
let $c79bca128681c716$var$debounceTimerID;
let $c79bca128681c716$var$lastCapturedEventType;
let $c79bca128681c716$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c79bca128681c716$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, $c79bca128681c716$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $c79bca128681c716$export$3014bbf0af0e1d4a() {
    if (!(0, $cOSHO.WINDOW).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $kE1Yf.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $cOSHO.WINDOW).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $cOSHO.WINDOW).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $cOSHO.WINDOW);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $l1oVX.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $l1oVX.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $c79bca128681c716$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $c79bca128681c716$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $c79bca128681c716$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c79bca128681c716$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $c79bca128681c716$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $c79bca128681c716$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($c79bca128681c716$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $l1oVX.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $l1oVX.addNonEnumerableProperty)(target, '_sentryId', (0, $6OhB9.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$c79bca128681c716$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $c79bca128681c716$var$lastCapturedEventType = event.type;
            $c79bca128681c716$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c79bca128681c716$var$debounceTimerID);
        $c79bca128681c716$var$debounceTimerID = (0, $cOSHO.WINDOW).setTimeout(()=>{
            $c79bca128681c716$var$lastCapturedEventTargetId = undefined;
            $c79bca128681c716$var$lastCapturedEventType = undefined;
        }, $c79bca128681c716$var$DEBOUNCE_DURATION);
    };
}
function $c79bca128681c716$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});


parcelRegister("6HdUS", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", () => $4e018dbe28beb052$export$59bfe9f1c76150e);

var $lBLPp = parcelRequire("lBLPp");
var $l1oVX = parcelRequire("l1oVX");
var $5v1oS = parcelRequire("5v1oS");

var $csQk2 = parcelRequire("csQk2");
const $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $4e018dbe28beb052$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $4e018dbe28beb052$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $4e018dbe28beb052$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $l1oVX.fill)((0, $csQk2.WINDOW), 'setTimeout', $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $l1oVX.fill)((0, $csQk2.WINDOW), 'setInterval', $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $l1oVX.fill)((0, $csQk2.WINDOW), 'requestAnimationFrame', $4e018dbe28beb052$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $csQk2.WINDOW)) (0, $l1oVX.fill)(XMLHttpRequest.prototype, 'send', $4e018dbe28beb052$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$4e018dbe28beb052$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $4e018dbe28beb052$export$59bfe9f1c76150e = (0, $lBLPp.defineIntegration)($4e018dbe28beb052$var$_browserApiErrorsIntegration);
function $4e018dbe28beb052$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $csQk2.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $5v1oS.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $csQk2.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $5v1oS.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $4e018dbe28beb052$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $l1oVX.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $5v1oS.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $l1oVX.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $5v1oS.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $csQk2.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $csQk2.WINDOW);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $l1oVX.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($4e018dbe28beb052$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $csQk2.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $5v1oS.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $4e018dbe28beb052$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $csQk2.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $5v1oS.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $l1oVX.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $4e018dbe28beb052$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $4e018dbe28beb052$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}

});

parcelRegister("bSsXc", function(module, exports) {

$parcel$export(module.exports, "browserSessionIntegration", () => $8a5b32760c0daa50$export$1baa7880e357371c);

var $kQ0sT = parcelRequire("kQ0sT");
var $lBLPp = parcelRequire("lBLPp");
var $hi47i = parcelRequire("hi47i");

var $5hw2H = parcelRequire("5hw2H");

var $aBCC8 = parcelRequire("aBCC8");

var $csQk2 = parcelRequire("csQk2");
/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $8a5b32760c0daa50$export$1baa7880e357371c = (0, $lBLPp.defineIntegration)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $csQk2.WINDOW).document === 'undefined') {
                (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $kQ0sT.startSession)({
                ignoreDuration: true
            });
            (0, $kQ0sT.captureSession)();
            // We want to create a session for every navigation as well
            (0, $5hw2H.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $kQ0sT.startSession)({
                        ignoreDuration: true
                    });
                    (0, $kQ0sT.captureSession)();
                }
            });
        }
    };
});

});

parcelRegister("4U4Fy", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", () => $3920039f2d643754$export$66acc70e8cf2b71a);

var $6El2X = parcelRequire("6El2X");
var $alg0v = parcelRequire("alg0v");
var $kQ0sT = parcelRequire("kQ0sT");
var $lBLPp = parcelRequire("lBLPp");
var $kGYVh = parcelRequire("kGYVh");
var $hA6iJ = parcelRequire("hA6iJ");
var $dfMsQ = parcelRequire("dfMsQ");
var $hi47i = parcelRequire("hi47i");
var $5v1oS = parcelRequire("5v1oS");

var $aBCC8 = parcelRequire("aBCC8");

var $34UVT = parcelRequire("34UVT");

var $csQk2 = parcelRequire("csQk2");
const $3920039f2d643754$var$INTEGRATION_NAME = 'GlobalHandlers';
const $3920039f2d643754$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $3920039f2d643754$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $3920039f2d643754$var$_installGlobalOnErrorHandler(client);
                $3920039f2d643754$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client);
                $3920039f2d643754$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $3920039f2d643754$export$66acc70e8cf2b71a = (0, $lBLPp.defineIntegration)($3920039f2d643754$var$_globalHandlersIntegration);
function $3920039f2d643754$var$_installGlobalOnErrorHandler(client) {
    (0, $6El2X.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $kGYVh.getClient)() !== client || (0, $csQk2.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $3920039f2d643754$var$_enhanceEventWithInitialFrame((0, $34UVT.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $kQ0sT.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $alg0v.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $kGYVh.getClient)() !== client || (0, $csQk2.shouldIgnoreOnError)()) return;
        const error = $3920039f2d643754$var$_getUnhandledRejectionError(e);
        const event = (0, $dfMsQ.isPrimitive)(error) ? $3920039f2d643754$var$_eventFromRejectionWithPrimitive(error) : (0, $34UVT.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $kQ0sT.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $3920039f2d643754$var$_getUnhandledRejectionError(error) {
    if ((0, $dfMsQ.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $3920039f2d643754$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $3920039f2d643754$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $dfMsQ.isString)(url) && url.length > 0 ? url : (0, $hA6iJ.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $5v1oS.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $3920039f2d643754$var$globalHandlerLog(type) {
    (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).log(`Global Handler attached: ${type}`);
}
function $3920039f2d643754$var$getOptions() {
    const client = (0, $kGYVh.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});

parcelRegister("jXkOO", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", () => $e873ad23f512125c$export$1378794447170364);

var $lBLPp = parcelRequire("lBLPp");

var $csQk2 = parcelRequire("csQk2");
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $e873ad23f512125c$export$1378794447170364 = (0, $lBLPp.defineIntegration)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $csQk2.WINDOW).navigator && !(0, $csQk2.WINDOW).location && !(0, $csQk2.WINDOW).document) return;
            const reqData = (0, $csQk2.getHttpRequestData)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        }
    };
});

});

parcelRegister("a13dx", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", () => $74ac7e452f6a0785$export$ebabb00eb7f3a395);

var $9L0Km = parcelRequire("9L0Km");
var $lBLPp = parcelRequire("lBLPp");

var $34UVT = parcelRequire("34UVT");
const $74ac7e452f6a0785$var$DEFAULT_KEY = 'cause';
const $74ac7e452f6a0785$var$DEFAULT_LIMIT = 5;
const $74ac7e452f6a0785$var$INTEGRATION_NAME = 'LinkedErrors';
const $74ac7e452f6a0785$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $74ac7e452f6a0785$var$DEFAULT_LIMIT;
    const key = options.key || $74ac7e452f6a0785$var$DEFAULT_KEY;
    return {
        name: $74ac7e452f6a0785$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $9L0Km.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $34UVT.exceptionFromError), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $74ac7e452f6a0785$export$ebabb00eb7f3a395 = (0, $lBLPp.defineIntegration)($74ac7e452f6a0785$var$_linkedErrorsIntegration);

});
parcelRegister("9L0Km", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", () => $71a9151fcd5ea774$export$b91c38ed7d8ae9b2);

var $dfMsQ = parcelRequire("dfMsQ");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $71a9151fcd5ea774$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $dfMsQ.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $dfMsQ.isInstanceOf)(error[key], Error)) {
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $dfMsQ.isInstanceOf)(childError, Error)) {
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}

});


parcelRegister("jjJIz", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", () => $e103414b28380d9b$export$2b2b997d81bf3907);

var $5v1oS = parcelRequire("5v1oS");
const $e103414b28380d9b$var$OPERA10_PRIORITY = 10;
const $e103414b28380d9b$var$OPERA11_PRIORITY = 20;
const $e103414b28380d9b$var$CHROME_PRIORITY = 30;
const $e103414b28380d9b$var$WINJS_PRIORITY = 40;
const $e103414b28380d9b$var$GECKO_PRIORITY = 50;
function $e103414b28380d9b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $5v1oS.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $e103414b28380d9b$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $e103414b28380d9b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $e103414b28380d9b$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $e103414b28380d9b$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $e103414b28380d9b$var$createFrame(filename, (0, $5v1oS.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $e103414b28380d9b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(parts[1] || (0, $5v1oS.UNKNOWN_FUNCTION), parts[2]);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$263a749fff749872 = [
    $e103414b28380d9b$var$CHROME_PRIORITY,
    $e103414b28380d9b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e103414b28380d9b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e103414b28380d9b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e103414b28380d9b$var$gecko = (line)=>{
    const parts = $e103414b28380d9b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $5v1oS.UNKNOWN_FUNCTION);
        [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(func, filename);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$cdba47a5dd2804d = [
    $e103414b28380d9b$var$GECKO_PRIORITY,
    $e103414b28380d9b$var$gecko
];
const $e103414b28380d9b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$winjs = (line)=>{
    const parts = $e103414b28380d9b$var$winjsRegex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[1] || (0, $5v1oS.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e103414b28380d9b$export$179460296da408e8 = [
    $e103414b28380d9b$var$WINJS_PRIORITY,
    $e103414b28380d9b$var$winjs
];
const $e103414b28380d9b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e103414b28380d9b$var$opera10 = (line)=>{
    const parts = $e103414b28380d9b$var$opera10Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[3] || (0, $5v1oS.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $e103414b28380d9b$export$f892b52c880ffc7a = [
    $e103414b28380d9b$var$OPERA10_PRIORITY,
    $e103414b28380d9b$var$opera10
];
const $e103414b28380d9b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e103414b28380d9b$var$opera11 = (line)=>{
    const parts = $e103414b28380d9b$var$opera11Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[5], parts[3] || parts[4] || (0, $5v1oS.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $e103414b28380d9b$export$af11af13f09fb0dc = [
    $e103414b28380d9b$var$OPERA11_PRIORITY,
    $e103414b28380d9b$var$opera11
];
const $e103414b28380d9b$export$7197c0fe6554c079 = [
    $e103414b28380d9b$export$263a749fff749872,
    $e103414b28380d9b$export$cdba47a5dd2804d
];
const $e103414b28380d9b$export$2b2b997d81bf3907 = (0, $5v1oS.createStackParser)(...$e103414b28380d9b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e103414b28380d9b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $5v1oS.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("3yu4Q", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", () => $296be0c65ac1edb3$export$b2311068c46d7cc8);

var $kqMGl = parcelRequire("kqMGl");
var $di9R8 = parcelRequire("di9R8");

var $hUuVt = parcelRequire("hUuVt");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $296be0c65ac1edb3$export$b2311068c46d7cc8(options, nativeFetch = (0, $hUuVt.getNativeImplementation)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $hUuVt.clearCachedImplementation)('fetch');
            return (0, $di9R8.rejectedSyncPromise)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $hUuVt.clearCachedImplementation)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $di9R8.rejectedSyncPromise)(e);
        }
    }
    return (0, $kqMGl.createTransport)(options, makeRequest);
}

});
parcelRegister("kqMGl", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $edfbff9038a67171$export$d09f50d9ab7f7b69);

var $fKzCQ = parcelRequire("fKzCQ");

var $l4iiL = parcelRequire("l4iiL");

var $hi47i = parcelRequire("hi47i");

var $kVISx = parcelRequire("kVISx");

var $78AZl = parcelRequire("78AZl");

var $di9R8 = parcelRequire("di9R8");
const $edfbff9038a67171$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $edfbff9038a67171$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $kVISx.makePromiseBuffer)(options.bufferSize || $edfbff9038a67171$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $l4iiL.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $l4iiL.envelopeItemTypeToDataCategory)(type);
            if ((0, $78AZl.isRateLimited)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $di9R8.resolvedSyncPromise)({});
        const filteredEnvelope = (0, $l4iiL.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $l4iiL.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $l4iiL.envelopeItemTypeToDataCategory)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $l4iiL.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $78AZl.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $kVISx.SENTRY_BUFFER_FULL_ERROR)) {
                (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $di9R8.resolvedSyncPromise)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}

});
parcelRegister("kVISx", function(module, exports) {

$parcel$export(module.exports, "SENTRY_BUFFER_FULL_ERROR", () => $f3cbf180d3404fe0$export$c8667f1887a128dc);
$parcel$export(module.exports, "makePromiseBuffer", () => $f3cbf180d3404fe0$export$85a4f67f852183e6);

var $di9R8 = parcelRequire("di9R8");
const $f3cbf180d3404fe0$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $f3cbf180d3404fe0$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $di9R8.rejectedSyncPromise)($f3cbf180d3404fe0$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $di9R8.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $di9R8.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});

parcelRegister("78AZl", function(module, exports) {

$parcel$export(module.exports, "isRateLimited", () => $5325f8e04d3d0467$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $5325f8e04d3d0467$export$699aff705e0d49d4);
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $5325f8e04d3d0467$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $5325f8e04d3d0467$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $5325f8e04d3d0467$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $5325f8e04d3d0467$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $5325f8e04d3d0467$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $5325f8e04d3d0467$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});


parcelRegister("hUuVt", function(module, exports) {

$parcel$export(module.exports, "getNativeImplementation", () => $d09fa7e5070984b9$export$e464f4a514ac28a8);
$parcel$export(module.exports, "clearCachedImplementation", () => $d09fa7e5070984b9$export$8aa36702e8c8978);
$parcel$export(module.exports, "setTimeout", () => $d09fa7e5070984b9$export$831dc9f2ab0a617b);

var $aW7Vg = parcelRequire("aW7Vg");
var $hi47i = parcelRequire("hi47i");

var $jioJL = parcelRequire("jioJL");

var $cOSHO = parcelRequire("cOSHO");
/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $d09fa7e5070984b9$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $d09fa7e5070984b9$export$e464f4a514ac28a8(name) {
    const cached = $d09fa7e5070984b9$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $cOSHO.WINDOW)[name];
    // Fast path to avoid DOM I/O
    if ((0, $aW7Vg.isNativeFunction)(impl)) return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $cOSHO.WINDOW));
    const document = (0, $cOSHO.WINDOW).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $jioJL.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $cOSHO.WINDOW));
}
/** Clear a cached implementation. */ function $d09fa7e5070984b9$export$8aa36702e8c8978(name) {
    $d09fa7e5070984b9$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $d09fa7e5070984b9$export$e7aa7bc5c1b3cfb3(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $d09fa7e5070984b9$export$831dc9f2ab0a617b(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8('setTimeout')(...rest);
}

});


parcelRegister("lWeSa", function(module, exports) {

$parcel$export(module.exports, "checkAndWarnIfIsEmbeddedBrowserExtension", () => $ff8a8d27140f65b2$export$dc236a86065879fc);

var $hi47i = parcelRequire("hi47i");
var $hA6iJ = parcelRequire("hA6iJ");

var $aBCC8 = parcelRequire("aBCC8");

var $csQk2 = parcelRequire("csQk2");
/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $ff8a8d27140f65b2$export$dc236a86065879fc() {
    if ($ff8a8d27140f65b2$var$_isEmbeddedBrowserExtension()) {
        if (0, $aBCC8.DEBUG_BUILD) (0, $hi47i.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $ff8a8d27140f65b2$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $csQk2.WINDOW).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $csQk2.WINDOW);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $hA6iJ.getLocationHref)();
    const extensionProtocols = [
        'chrome-extension',
        'moz-extension',
        'ms-browser-extension',
        'safari-web-extension'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $csQk2.WINDOW) === (0, $csQk2.WINDOW).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}://`));
    return !isDedicatedExtensionPage;
}

});


parcelRegister("15iXi", function(module, exports) {

$parcel$export(module.exports, "replayIntegration", () => $0ca4f63b79e931bd$export$d7706faf7ab354bf);

var $6El1G = parcelRequire("6El1G");
var $kQ0sT = parcelRequire("kQ0sT");
var $6OKHc = parcelRequire("6OKHc");
var $hi47i = parcelRequire("hi47i");
var $l4iiL = parcelRequire("l4iiL");
var $l1oVX = parcelRequire("l1oVX");
var $4H7Y8 = parcelRequire("4H7Y8");
var $kGYVh = parcelRequire("kGYVh");
var $jdzJv = parcelRequire("jdzJv");
var $hA6iJ = parcelRequire("hA6iJ");
var $2fKhD = parcelRequire("2fKhD");
var $bsaEo = parcelRequire("bsaEo");
var $78AZl = parcelRequire("78AZl");
var $jFHzr = parcelRequire("jFHzr");
var $886wr = parcelRequire("886wr");
var $1oUdV = parcelRequire("1oUdV");
var $g1WRa = parcelRequire("g1WRa");
var $di9R8 = parcelRequire("di9R8");
var $yQUXg = parcelRequire("yQUXg");
var $2bC2j = parcelRequire("2bC2j");
var $hLnp0 = parcelRequire("hLnp0");
var $6OhB9 = parcelRequire("6OhB9");

var $h8vIJ = parcelRequire("h8vIJ");
var $4hTws = parcelRequire("4hTws");
var $5hw2H = parcelRequire("5hw2H");
var $bE0lt = parcelRequire("bE0lt");
var $8zIFF = parcelRequire("8zIFF");
var $hUuVt = parcelRequire("hUuVt");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $0ca4f63b79e931bd$var$WINDOW = (0, $2fKhD.GLOBAL_OBJ);
const $0ca4f63b79e931bd$var$REPLAY_SESSION_KEY = 'sentryReplaySession';
const $0ca4f63b79e931bd$var$REPLAY_EVENT_NAME = 'replay_event';
const $0ca4f63b79e931bd$var$UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';
// The idle limit for a session after which recording is paused.
const $0ca4f63b79e931bd$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $0ca4f63b79e931bd$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $0ca4f63b79e931bd$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $0ca4f63b79e931bd$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $0ca4f63b79e931bd$var$BUFFER_CHECKOUT_TIME = 60000;
const $0ca4f63b79e931bd$var$RETRY_BASE_INTERVAL = 5000;
const $0ca4f63b79e931bd$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $0ca4f63b79e931bd$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $0ca4f63b79e931bd$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $0ca4f63b79e931bd$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $0ca4f63b79e931bd$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $0ca4f63b79e931bd$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $0ca4f63b79e931bd$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $0ca4f63b79e931bd$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
var $0ca4f63b79e931bd$var$__defProp$1 = Object.defineProperty;
var $0ca4f63b79e931bd$var$__defNormalProp$1 = (obj, key, value)=>key in obj ? $0ca4f63b79e931bd$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0ca4f63b79e931bd$var$__publicField$1 = (obj, key, value)=>$0ca4f63b79e931bd$var$__defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
var $0ca4f63b79e931bd$var$NodeType$2 = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($0ca4f63b79e931bd$var$NodeType$2 || {});
function $0ca4f63b79e931bd$var$isElement$1(n2) {
    return n2.nodeType === n2.ELEMENT_NODE;
}
function $0ca4f63b79e931bd$var$isShadowRoot(n2) {
    const host = n2?.host;
    return Boolean(host?.shadowRoot === n2);
}
function $0ca4f63b79e931bd$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $0ca4f63b79e931bd$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $0ca4f63b79e931bd$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $0ca4f63b79e931bd$var$stringifyStylesheet(s2) {
    try {
        const rules2 = s2.rules || s2.cssRules;
        return rules2 ? $0ca4f63b79e931bd$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules2, $0ca4f63b79e931bd$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $0ca4f63b79e931bd$var$fixAllCssProperty(rule) {
    let styles = "";
    for(let i2 = 0; i2 < rule.style.length; i2++){
        const styleDeclaration = rule.style;
        const attribute = styleDeclaration[i2];
        const isImportant = styleDeclaration.getPropertyPriority(attribute);
        styles += `${attribute}:${styleDeclaration.getPropertyValue(attribute)}${isImportant ? ` !important` : ""};`;
    }
    return `${rule.selectorText} { ${styles} }`;
}
function $0ca4f63b79e931bd$var$stringifyRule(rule) {
    let importStringified;
    if ($0ca4f63b79e931bd$var$isCSSImportRule(rule)) try {
        importStringified = // we can access the imported stylesheet rules directly
        $0ca4f63b79e931bd$var$stringifyStylesheet(rule.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
        $0ca4f63b79e931bd$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($0ca4f63b79e931bd$var$isCSSStyleRule(rule)) {
        let cssText = rule.cssText;
        const needsSafariColonFix = rule.selectorText.includes(":");
        const needsAllFix = typeof rule.style["all"] === "string" && rule.style["all"];
        if (needsAllFix) cssText = $0ca4f63b79e931bd$var$fixAllCssProperty(rule);
        if (needsSafariColonFix) cssText = $0ca4f63b79e931bd$var$fixSafariColons(cssText);
        if (needsSafariColonFix || needsAllFix) return cssText;
    }
    return importStringified || rule.cssText;
}
function $0ca4f63b79e931bd$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $0ca4f63b79e931bd$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $0ca4f63b79e931bd$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $0ca4f63b79e931bd$var$Mirror {
    constructor(){
        $0ca4f63b79e931bd$var$__publicField$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        $0ca4f63b79e931bd$var$__publicField$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    getId(n2) {
        if (!n2) return -1;
        const id = this.getMeta(n2)?.id;
        return id ?? -1;
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    }
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    removeNodeFromMap(n2) {
        const id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) n2.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n2, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    }
    replace(id, n2) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    }
    reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    }
}
function $0ca4f63b79e931bd$var$createMirror$2() {
    return new $0ca4f63b79e931bd$var$Mirror();
}
function $0ca4f63b79e931bd$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || // Default to "text" option for inputs without a "type" attribute defined
    tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $0ca4f63b79e931bd$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $0ca4f63b79e931bd$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $0ca4f63b79e931bd$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $0ca4f63b79e931bd$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $0ca4f63b79e931bd$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $0ca4f63b79e931bd$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$0ca4f63b79e931bd$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $0ca4f63b79e931bd$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    $0ca4f63b79e931bd$var$toLowerCase(type) : null;
}
function $0ca4f63b79e931bd$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
function $0ca4f63b79e931bd$var$extractFileExtension(path, baseURL) {
    let url;
    try {
        url = new URL(path, baseURL ?? window.location.href);
    } catch (err) {
        return null;
    }
    const regex = /\.([0-9a-z]+)(?:$)/i;
    const match = url.pathname.match(regex);
    return match?.[1] ?? null;
}
const $0ca4f63b79e931bd$var$cachedImplementations$1 = {};
function $0ca4f63b79e931bd$var$getImplementation$1(name) {
    const cached = $0ca4f63b79e931bd$var$cachedImplementations$1[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e2) {}
    return $0ca4f63b79e931bd$var$cachedImplementations$1[name] = impl.bind(window);
}
function $0ca4f63b79e931bd$var$setTimeout$2(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation$1("setTimeout")(...rest);
}
function $0ca4f63b79e931bd$var$clearTimeout$1(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation$1("clearTimeout")(...rest);
}
function $0ca4f63b79e931bd$var$getIframeContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e2) {}
}
let $0ca4f63b79e931bd$var$_id = 1;
const $0ca4f63b79e931bd$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $0ca4f63b79e931bd$var$IGNORED_NODE = -2;
function $0ca4f63b79e931bd$var$genId() {
    return $0ca4f63b79e931bd$var$_id++;
}
function $0ca4f63b79e931bd$var$getValidTagName$1(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $0ca4f63b79e931bd$var$toLowerCase(element.tagName);
    if ($0ca4f63b79e931bd$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $0ca4f63b79e931bd$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $0ca4f63b79e931bd$var$canvasService;
let $0ca4f63b79e931bd$var$canvasCtx;
const $0ca4f63b79e931bd$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $0ca4f63b79e931bd$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $0ca4f63b79e931bd$var$URL_WWW_MATCH = /^www\..*/i;
const $0ca4f63b79e931bd$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $0ca4f63b79e931bd$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($0ca4f63b79e931bd$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($0ca4f63b79e931bd$var$URL_PROTOCOL_MATCH.test(filePath) || $0ca4f63b79e931bd$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($0ca4f63b79e931bd$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$0ca4f63b79e931bd$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $0ca4f63b79e931bd$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $0ca4f63b79e931bd$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $0ca4f63b79e931bd$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars2;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($0ca4f63b79e931bd$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($0ca4f63b79e931bd$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $0ca4f63b79e931bd$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $0ca4f63b79e931bd$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c2 = attributeValue.charAt(pos);
                if (c2 === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c2 === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c2 === "(") inParens = true;
                } else if (c2 === ")") inParens = false;
                descriptorsStr += c2;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
const $0ca4f63b79e931bd$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $0ca4f63b79e931bd$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $0ca4f63b79e931bd$var$getHref(doc, attributeValue);
}
function $0ca4f63b79e931bd$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $0ca4f63b79e931bd$var$getHref(doc, customHref) {
    let a2 = $0ca4f63b79e931bd$var$cachedDocument.get(doc);
    if (!a2) {
        a2 = doc.createElement("a");
        $0ca4f63b79e931bd$var$cachedDocument.set(doc, a2);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a2.setAttribute("href", customHref);
    return a2.href;
}
function $0ca4f63b79e931bd$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $0ca4f63b79e931bd$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $0ca4f63b79e931bd$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $0ca4f63b79e931bd$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $0ca4f63b79e931bd$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $0ca4f63b79e931bd$var$absoluteToStylesheet(value, $0ca4f63b79e931bd$var$getHref(doc));
    else if (tagName === "object" && name === "data") return $0ca4f63b79e931bd$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $0ca4f63b79e931bd$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $0ca4f63b79e931bd$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e2) {}
    return false;
}
function $0ca4f63b79e931bd$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $0ca4f63b79e931bd$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $0ca4f63b79e931bd$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $0ca4f63b79e931bd$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($0ca4f63b79e931bd$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch  {
            return false;
        }
    };
}
function $0ca4f63b79e931bd$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e2) {}
    return !!maskAllText;
}
function $0ca4f63b79e931bd$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = $0ca4f63b79e931bd$var$setTimeout$2(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            $0ca4f63b79e931bd$var$clearTimeout$1(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        $0ca4f63b79e931bd$var$setTimeout$2(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $0ca4f63b79e931bd$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = $0ca4f63b79e931bd$var$setTimeout$2(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        $0ca4f63b79e931bd$var$clearTimeout$1(timer);
        fired = true;
        listener();
    });
}
function $0ca4f63b79e931bd$var$serializeNode(n2, options) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $0ca4f63b79e931bd$var$getRootId(doc, mirror2);
    switch(n2.nodeType){
        case n2.DOCUMENT_NODE:
            if (n2.compatMode !== "CSS1Compat") return {
                type: $0ca4f63b79e931bd$var$NodeType$2.Document,
                childNodes: [],
                compatMode: n2.compatMode
            };
            else return {
                type: $0ca4f63b79e931bd$var$NodeType$2.Document,
                childNodes: []
            };
        case n2.DOCUMENT_TYPE_NODE:
            return {
                type: $0ca4f63b79e931bd$var$NodeType$2.DocumentType,
                name: n2.name,
                publicId: n2.publicId,
                systemId: n2.systemId,
                rootId: rootId
            };
        case n2.ELEMENT_NODE:
            return $0ca4f63b79e931bd$var$serializeElementNode(n2, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n2.TEXT_NODE:
            return $0ca4f63b79e931bd$var$serializeTextNode(n2, {
                doc: doc,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n2.CDATA_SECTION_NODE:
            return {
                type: $0ca4f63b79e931bd$var$NodeType$2.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n2.COMMENT_NODE:
            return {
                type: $0ca4f63b79e931bd$var$NodeType$2.Comment,
                textContent: n2.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $0ca4f63b79e931bd$var$getRootId(doc, mirror2) {
    if (!mirror2.hasNode(doc)) return void 0;
    const docId = mirror2.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $0ca4f63b79e931bd$var$serializeTextNode(n2, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n2.parentNode && n2.parentNode.tagName;
    let textContent = n2.textContent;
    const isStyle = parentTagName === "STYLE" ? true : void 0;
    const isScript = parentTagName === "SCRIPT" ? true : void 0;
    const isTextarea = parentTagName === "TEXTAREA" ? true : void 0;
    if (isStyle && textContent) {
        try {
            if (n2.nextSibling || n2.previousSibling) ;
            else if (n2.parentNode.sheet?.cssRules) textContent = $0ca4f63b79e931bd$var$stringifyStylesheet(n2.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n2);
        }
        textContent = $0ca4f63b79e931bd$var$absoluteToStylesheet(textContent, $0ca4f63b79e931bd$var$getHref(options.doc));
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $0ca4f63b79e931bd$var$needMaskingText(n2, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n2.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n2.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $0ca4f63b79e931bd$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $0ca4f63b79e931bd$var$maskInputValue({
            isMasked: $0ca4f63b79e931bd$var$needMaskingText(n2, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n2,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $0ca4f63b79e931bd$var$NodeType$2.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $0ca4f63b79e931bd$var$serializeElementNode(n2, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $0ca4f63b79e931bd$var$_isBlockedElement(n2, blockClass, blockSelector, unblockSelector);
    const tagName = $0ca4f63b79e931bd$var$getValidTagName$1(n2);
    let attributes2 = {};
    const len = n2.attributes.length;
    for(let i2 = 0; i2 < len; i2++){
        const attr = n2.attributes[i2];
        if (attr.name && !$0ca4f63b79e931bd$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes2[attr.name] = $0ca4f63b79e931bd$var$transformAttribute(doc, tagName, $0ca4f63b79e931bd$var$toLowerCase(attr.name), attr.value, n2, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s2)=>{
            return s2.href === n2.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $0ca4f63b79e931bd$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            attributes2.rel = null;
            attributes2.href = null;
            attributes2.crossorigin = null;
            attributes2._cssText = $0ca4f63b79e931bd$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n2.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
    !(n2.innerText || n2.textContent || "").trim().length) {
        const cssText = $0ca4f63b79e931bd$var$stringifyStylesheet(n2.sheet);
        if (cssText) attributes2._cssText = $0ca4f63b79e931bd$var$absoluteToStylesheet(cssText, $0ca4f63b79e931bd$var$getHref(doc));
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n2;
        const type = $0ca4f63b79e931bd$var$getInputType(el);
        const value = $0ca4f63b79e931bd$var$getInputValue(el, $0ca4f63b79e931bd$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $0ca4f63b79e931bd$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $0ca4f63b79e931bd$var$shouldMaskInput({
                type: type,
                tagName: $0ca4f63b79e931bd$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes2.value = $0ca4f63b79e931bd$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes2.checked = checked;
    }
    if (tagName === "option") {
        if (n2.selected && !maskInputOptions["select"]) attributes2.selected = true;
        else delete attributes2.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n2.__context === "2d") {
            if (!$0ca4f63b79e931bd$var$is2DCanvasBlank(n2)) attributes2.rr_dataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n2)) {
            const canvasDataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n2.width;
            blankCanvas.height = n2.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes2.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$0ca4f63b79e931bd$var$canvasService) {
            $0ca4f63b79e931bd$var$canvasService = doc.createElement("canvas");
            $0ca4f63b79e931bd$var$canvasCtx = $0ca4f63b79e931bd$var$canvasService.getContext("2d");
        }
        const image = n2;
        const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        const priorCrossOrigin = image.crossOrigin;
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $0ca4f63b79e931bd$var$canvasService.width = image.naturalWidth;
                $0ca4f63b79e931bd$var$canvasService.height = image.naturalHeight;
                $0ca4f63b79e931bd$var$canvasCtx.drawImage(image, 0, 0);
                attributes2.rr_dataURL = $0ca4f63b79e931bd$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn(`Cannot inline img src=${imageSrc}! Error: ${err}`);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes2.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes2.rr_mediaState = n2.paused ? "paused" : "played";
        attributes2.rr_mediaCurrentTime = n2.currentTime;
    }
    if (!newlyAddedElement) {
        if (n2.scrollLeft) attributes2.rr_scrollLeft = n2.scrollLeft;
        if (n2.scrollTop) attributes2.rr_scrollTop = n2.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n2.getBoundingClientRect();
        attributes2 = {
            class: attributes2.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes2.src)) {
        if (!needBlock && !$0ca4f63b79e931bd$var$getIframeContentDocument(n2)) attributes2.rr_src = attributes2.src;
        delete attributes2.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e2) {}
    return {
        type: $0ca4f63b79e931bd$var$NodeType$2.Element,
        tagName: tagName,
        attributes: attributes2,
        childNodes: [],
        isSVG: $0ca4f63b79e931bd$var$isSVGElement(n2) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $0ca4f63b79e931bd$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $0ca4f63b79e931bd$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $0ca4f63b79e931bd$var$NodeType$2.Comment) return true;
    else if (sn.type === $0ca4f63b79e931bd$var$NodeType$2.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $0ca4f63b79e931bd$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "application-name" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.rel) === "icon" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "robots" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "googlebot" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "author" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "generator" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "framework" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "publisher" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "progid" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "verification" || $0ca4f63b79e931bd$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $0ca4f63b79e931bd$var$serializeNodeWithId(n2, options) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5e3, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5e3, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $0ca4f63b79e931bd$var$serializeNode(n2, {
        doc: doc,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n2, "not serialized");
        return null;
    }
    let id;
    if (mirror2.hasNode(n2)) id = mirror2.getId(n2);
    else if ($0ca4f63b79e931bd$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $0ca4f63b79e931bd$var$NodeType$2.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $0ca4f63b79e931bd$var$IGNORED_NODE;
    else id = $0ca4f63b79e931bd$var$genId();
    const serializedNode2 = Object.assign(_serializedNode, {
        id: id
    });
    mirror2.add(n2, serializedNode2);
    if (id === $0ca4f63b79e931bd$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n2);
    let recordChild = !skipChild;
    if (serializedNode2.type === $0ca4f63b79e931bd$var$NodeType$2.Element) {
        recordChild = recordChild && !serializedNode2.needBlock;
        delete serializedNode2.needBlock;
        const shadowRoot = n2.shadowRoot;
        if (shadowRoot && $0ca4f63b79e931bd$var$isNativeShadowDom(shadowRoot)) serializedNode2.isShadowHost = true;
    }
    if ((serializedNode2.type === $0ca4f63b79e931bd$var$NodeType$2.Document || serializedNode2.type === $0ca4f63b79e931bd$var$NodeType$2.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode2.type === $0ca4f63b79e931bd$var$NodeType$2.Element && serializedNode2.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror2,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n2.childNodes)){
            const serializedChildNode = $0ca4f63b79e931bd$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode2.childNodes.push(serializedChildNode);
        }
        if ($0ca4f63b79e931bd$var$isElement$1(n2) && n2.shadowRoot) for (const childN of Array.from(n2.shadowRoot.childNodes)){
            const serializedChildNode = $0ca4f63b79e931bd$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $0ca4f63b79e931bd$var$isNativeShadowDom(n2.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode2.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n2.parentNode && $0ca4f63b79e931bd$var$isShadowRoot(n2.parentNode) && $0ca4f63b79e931bd$var$isNativeShadowDom(n2.parentNode)) serializedNode2.isShadow = true;
    if (serializedNode2.type === $0ca4f63b79e931bd$var$NodeType$2.Element && serializedNode2.tagName === "iframe" && !$0ca4f63b79e931bd$var$_isBlockedElement(n2, blockClass, blockSelector, unblockSelector)) $0ca4f63b79e931bd$var$onceIframeLoaded(n2, ()=>{
        const iframeDoc = $0ca4f63b79e931bd$var$getIframeContentDocument(n2);
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $0ca4f63b79e931bd$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n2, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode2.type === $0ca4f63b79e931bd$var$NodeType$2.Element && serializedNode2.tagName === "link" && typeof serializedNode2.attributes.rel === "string" && (serializedNode2.attributes.rel === "stylesheet" || serializedNode2.attributes.rel === "preload" && typeof serializedNode2.attributes.href === "string" && $0ca4f63b79e931bd$var$extractFileExtension(serializedNode2.attributes.href) === "css")) $0ca4f63b79e931bd$var$onceStylesheetLoaded(n2, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $0ca4f63b79e931bd$var$serializeNodeWithId(n2, {
                doc: doc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n2, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode2;
}
function $0ca4f63b79e931bd$var$snapshot(n2, options) {
    const { mirror: mirror2 = new $0ca4f63b79e931bd$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
    {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $0ca4f63b79e931bd$var$serializeNodeWithId(n2, {
        doc: n2,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $0ca4f63b79e931bd$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $0ca4f63b79e931bd$var$_mirror = {
    map: {},
    getId () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $0ca4f63b79e931bd$var$_mirror = new Proxy($0ca4f63b79e931bd$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($0ca4f63b79e931bd$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $0ca4f63b79e931bd$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $0ca4f63b79e931bd$var$clearTimeout$2(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $0ca4f63b79e931bd$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $0ca4f63b79e931bd$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $0ca4f63b79e931bd$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$0ca4f63b79e931bd$var$hookSetter(target, key, original || {}, true);
}
function $0ca4f63b79e931bd$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch  {
        return ()=>{};
    }
}
let $0ca4f63b79e931bd$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $0ca4f63b79e931bd$var$nowTimestamp = ()=>/* @__PURE__ */ new Date().getTime();
function $0ca4f63b79e931bd$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc?.documentElement.scrollLeft || doc?.body?.parentElement?.scrollLeft || doc?.body?.scrollLeft || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : doc?.documentElement.scrollTop || doc?.body?.parentElement?.scrollTop || doc?.body?.scrollTop || 0
    };
}
function $0ca4f63b79e931bd$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $0ca4f63b79e931bd$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $0ca4f63b79e931bd$var$closestElementOfNode(node) {
    if (!node) return null;
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        return el;
    } catch (error) {
        return null;
    }
}
function $0ca4f63b79e931bd$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $0ca4f63b79e931bd$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $0ca4f63b79e931bd$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $0ca4f63b79e931bd$var$distanceToMatch(el, $0ca4f63b79e931bd$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $0ca4f63b79e931bd$var$isSerialized(n2, mirror2) {
    return mirror2.getId(n2) !== -1;
}
function $0ca4f63b79e931bd$var$isIgnored(n2, mirror2) {
    return mirror2.getId(n2) === $0ca4f63b79e931bd$var$IGNORED_NODE;
}
function $0ca4f63b79e931bd$var$isAncestorRemoved(target, mirror2) {
    if ($0ca4f63b79e931bd$var$isShadowRoot(target)) return false;
    const id = mirror2.getId(target);
    if (!mirror2.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $0ca4f63b79e931bd$var$isAncestorRemoved(target.parentNode, mirror2);
}
function $0ca4f63b79e931bd$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $0ca4f63b79e931bd$var$polyfill$1(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $0ca4f63b79e931bd$var$isSerializedIframe(n2, mirror2) {
    return Boolean(n2.nodeName === "IFRAME" && mirror2.getMeta(n2));
}
function $0ca4f63b79e931bd$var$isSerializedStylesheet(n2, mirror2) {
    return Boolean(n2.nodeName === "LINK" && n2.nodeType === n2.ELEMENT_NODE && n2.getAttribute && n2.getAttribute("rel") === "stylesheet" && mirror2.getMeta(n2));
}
function $0ca4f63b79e931bd$var$hasShadowRoot(n2) {
    return Boolean(n2?.shadowRoot);
}
class $0ca4f63b79e931bd$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
    }
    getId(stylesheet) {
        return this.styleIDMap.get(stylesheet) ?? -1;
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === void 0) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $0ca4f63b79e931bd$var$getShadowHost(n2) {
    let shadowHost = null;
    if (n2.getRootNode?.()?.nodeType === Node.DOCUMENT_FRAGMENT_NODE && n2.getRootNode().host) shadowHost = n2.getRootNode().host;
    return shadowHost;
}
function $0ca4f63b79e931bd$var$getRootShadowHost(n2) {
    let rootShadowHost = n2;
    let shadowHost;
    while(shadowHost = $0ca4f63b79e931bd$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $0ca4f63b79e931bd$var$shadowHostInDom(n2) {
    const doc = n2.ownerDocument;
    if (!doc) return false;
    const shadowHost = $0ca4f63b79e931bd$var$getRootShadowHost(n2);
    return doc.contains(shadowHost);
}
function $0ca4f63b79e931bd$var$inDom(n2) {
    const doc = n2.ownerDocument;
    if (!doc) return false;
    return doc.contains(n2) || $0ca4f63b79e931bd$var$shadowHostInDom(n2);
}
const $0ca4f63b79e931bd$var$cachedImplementations = {};
function $0ca4f63b79e931bd$var$getImplementation(name) {
    const cached = $0ca4f63b79e931bd$var$cachedImplementations[name];
    if (cached) return cached;
    const document2 = window.document;
    let impl = window[name];
    if (document2 && typeof document2.createElement === "function") try {
        const sandbox = document2.createElement("iframe");
        sandbox.hidden = true;
        document2.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document2.head.removeChild(sandbox);
    } catch (e2) {}
    return $0ca4f63b79e931bd$var$cachedImplementations[name] = impl.bind(window);
}
function $0ca4f63b79e931bd$var$onRequestAnimationFrame(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation("requestAnimationFrame")(...rest);
}
function $0ca4f63b79e931bd$var$setTimeout$1(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation("setTimeout")(...rest);
}
function $0ca4f63b79e931bd$var$clearTimeout$2(...rest) {
    return $0ca4f63b79e931bd$var$getImplementation("clearTimeout")(...rest);
}
var $0ca4f63b79e931bd$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($0ca4f63b79e931bd$var$EventType || {});
var $0ca4f63b79e931bd$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($0ca4f63b79e931bd$var$IncrementalSource || {});
var $0ca4f63b79e931bd$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($0ca4f63b79e931bd$var$MouseInteractions || {});
var $0ca4f63b79e931bd$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($0ca4f63b79e931bd$var$PointerTypes || {});
var $0ca4f63b79e931bd$var$MediaInteractions = /* @__PURE__ */ ((MediaInteractions2)=>{
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
})($0ca4f63b79e931bd$var$MediaInteractions || {});
function $0ca4f63b79e931bd$var$getIFrameContentDocument(iframe) {
    try {
        return iframe.contentDocument;
    } catch (e2) {}
}
function $0ca4f63b79e931bd$var$getIFrameContentWindow(iframe) {
    try {
        return iframe.contentWindow;
    } catch (e2) {}
}
function $0ca4f63b79e931bd$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
class $0ca4f63b79e931bd$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = current?.next || null;
        return current;
    }
    addNode(n2) {
        const node = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node;
        if (n2.previousSibling && $0ca4f63b79e931bd$var$isNodeInLinkedList(n2.previousSibling)) {
            const current = n2.previousSibling.__ln.next;
            node.next = current;
            node.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n2.nextSibling && $0ca4f63b79e931bd$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            const current = n2.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n2) {
        const current = n2.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n2.__ln) delete n2.__ln;
        this.length--;
    }
}
const $0ca4f63b79e931bd$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $0ca4f63b79e931bd$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = /* @__PURE__ */ new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = /* @__PURE__ */ new Set();
        this.movedSet = /* @__PURE__ */ new Set();
        this.droppedSet = /* @__PURE__ */ new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = /* @__PURE__ */ new Set();
            const addList = new $0ca4f63b79e931bd$var$DoubleLinkedList();
            const getNextId = (n2)=>{
                let ns = n2;
                let nextId = $0ca4f63b79e931bd$var$IGNORED_NODE;
                while(nextId === $0ca4f63b79e931bd$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n2)=>{
                if (!n2.parentNode || !$0ca4f63b79e931bd$var$inDom(n2)) return;
                const parentId = $0ca4f63b79e931bd$var$isShadowRoot(n2.parentNode) ? this.mirror.getId($0ca4f63b79e931bd$var$getShadowHost(n2)) : this.mirror.getId(n2.parentNode);
                const nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                const sn = $0ca4f63b79e931bd$var$serializeNodeWithId(n2, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($0ca4f63b79e931bd$var$isSerializedIframe(currentN, this.mirror) && !$0ca4f63b79e931bd$var$isBlocked(currentN, this.blockClass, this.blockSelector, this.unblockSelector, false)) this.iframeManager.addIframe(currentN);
                        if ($0ca4f63b79e931bd$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($0ca4f63b79e931bd$var$hasShadowRoot(n2)) this.shadowDomManager.addShadowRoot(n2.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        if ($0ca4f63b79e931bd$var$isBlocked(iframe, this.blockClass, this.blockSelector, this.unblockSelector, false)) return;
                        this.iframeManager.attachIframe(iframe, childSn);
                        if (iframe.contentWindow) this.canvasManager.addWindow(iframe.contentWindow);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n2 of this.movedSet){
                if ($0ca4f63b79e931bd$var$isParentRemoved(this.removes, n2, this.mirror) && !this.movedSet.has(n2.parentNode)) continue;
                pushAdd(n2);
            }
            for (const n2 of this.addedSet){
                if (!$0ca4f63b79e931bd$var$isAncestorInSet(this.droppedSet, n2) && !$0ca4f63b79e931bd$var$isParentRemoved(this.removes, n2, this.mirror)) pushAdd(n2);
                else if ($0ca4f63b79e931bd$var$isAncestorInSet(this.movedSet, n2)) pushAdd(n2);
                else this.droppedSet.add(n2);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId2 = this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = /* @__PURE__ */ new WeakMap();
            this.removes = [];
            this.addedSet = /* @__PURE__ */ new Set();
            this.movedSet = /* @__PURE__ */ new Set();
            this.droppedSet = /* @__PURE__ */ new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($0ca4f63b79e931bd$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$0ca4f63b79e931bd$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $0ca4f63b79e931bd$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $0ca4f63b79e931bd$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $0ca4f63b79e931bd$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $0ca4f63b79e931bd$var$getInputValue(target, tagName, type);
                            const isInputMasked = $0ca4f63b79e931bd$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $0ca4f63b79e931bd$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $0ca4f63b79e931bd$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($0ca4f63b79e931bd$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            const iframeDoc = $0ca4f63b79e931bd$var$getIFrameContentDocument(target);
                            if (!iframeDoc) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$0ca4f63b79e931bd$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $0ca4f63b79e931bd$var$transformAttribute(this.doc, $0ca4f63b79e931bd$var$toLowerCase(target.tagName), $0ca4f63b79e931bd$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e2) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($0ca4f63b79e931bd$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n2)=>this.genAdds(n2, m.target));
                    m.removedNodes.forEach((n2)=>{
                        const nodeId = this.mirror.getId(n2);
                        const parentId = $0ca4f63b79e931bd$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($0ca4f63b79e931bd$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $0ca4f63b79e931bd$var$isIgnored(n2, this.mirror) || !$0ca4f63b79e931bd$var$isSerialized(n2, this.mirror)) return;
                        if (this.addedSet.has(n2)) {
                            $0ca4f63b79e931bd$var$deepDelete(this.addedSet, n2);
                            this.droppedSet.add(n2);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($0ca4f63b79e931bd$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n2) && this.movedMap[$0ca4f63b79e931bd$var$moveKey(nodeId, parentId)]) $0ca4f63b79e931bd$var$deepDelete(this.movedSet, n2);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $0ca4f63b79e931bd$var$isShadowRoot(m.target) && $0ca4f63b79e931bd$var$isNativeShadowDom(m.target) ? true : void 0
                        });
                        this.mapRemoves.push(n2);
                    });
                    break;
            }
        };
        this.genAdds = (n2, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n2, this)) return;
            if (this.addedSet.has(n2) || this.movedSet.has(n2)) return;
            if (this.mirror.hasNode(n2)) {
                if ($0ca4f63b79e931bd$var$isIgnored(n2, this.mirror)) return;
                this.movedSet.add(n2);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$0ca4f63b79e931bd$var$moveKey(this.mirror.getId(n2), targetId)] = true;
            } else {
                this.addedSet.add(n2);
                this.droppedSet.delete(n2);
            }
            if (!$0ca4f63b79e931bd$var$isBlocked(n2, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n2.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($0ca4f63b79e931bd$var$hasShadowRoot(n2)) n2.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n2);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $0ca4f63b79e931bd$var$deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    n2.childNodes.forEach((childN)=>$0ca4f63b79e931bd$var$deepDelete(addsSet, childN));
}
function $0ca4f63b79e931bd$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.length === 0) return false;
    return $0ca4f63b79e931bd$var$_isParentRemoved(removes, n2, mirror2);
}
function $0ca4f63b79e931bd$var$_isParentRemoved(removes, n2, mirror2) {
    let node = n2.parentNode;
    while(node){
        const parentId = mirror2.getId(node);
        if (removes.some((r2)=>r2.id === parentId)) return true;
        node = node.parentNode;
    }
    return false;
}
function $0ca4f63b79e931bd$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $0ca4f63b79e931bd$var$_isAncestorInSet(set, n2);
}
function $0ca4f63b79e931bd$var$_isAncestorInSet(set, n2) {
    const { parentNode: parentNode } = n2;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $0ca4f63b79e931bd$var$_isAncestorInSet(set, parentNode);
}
let $0ca4f63b79e931bd$var$errorHandler;
function $0ca4f63b79e931bd$var$registerErrorHandler(handler) {
    $0ca4f63b79e931bd$var$errorHandler = handler;
}
function $0ca4f63b79e931bd$var$unregisterErrorHandler() {
    $0ca4f63b79e931bd$var$errorHandler = void 0;
}
const $0ca4f63b79e931bd$var$callbackWrapper = (cb)=>{
    if (!$0ca4f63b79e931bd$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($0ca4f63b79e931bd$var$errorHandler && $0ca4f63b79e931bd$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
const $0ca4f63b79e931bd$var$mutationBuffers = [];
function $0ca4f63b79e931bd$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch  {}
    return event && event.target;
}
function $0ca4f63b79e931bd$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $0ca4f63b79e931bd$var$MutationBuffer();
    $0ca4f63b79e931bd$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || /**
  * Some websites may disable MutationObserver by removing it from the window object.
  * If someone is using rrweb to build a browser extention or things like it, they
  * could not change the website's code but can have an opportunity to inject some
  * code before the website executing its JS logic.
  * Then they can do this to store the native MutationObserver:
  * window.__rrMutationObserver = MutationObserver
  */ window.__rrMutationObserver;
    const angularZoneSymbol = window?.Zone?.__symbol__?.("MutationObserver");
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($0ca4f63b79e931bd$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $0ca4f63b79e931bd$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror2 }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $0ca4f63b79e931bd$var$callbackWrapper($0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper((evt)=>{
        const target = $0ca4f63b79e931bd$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $0ca4f63b79e931bd$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $0ca4f63b79e931bd$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $0ca4f63b79e931bd$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $0ca4f63b79e931bd$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $0ca4f63b79e931bd$var$IncrementalSource.MouseMove : $0ca4f63b79e931bd$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $0ca4f63b79e931bd$var$on("mousemove", updatePosition, doc),
        $0ca4f63b79e931bd$var$on("touchmove", updatePosition, doc),
        $0ca4f63b79e931bd$var$on("drag", updatePosition, doc)
    ];
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $0ca4f63b79e931bd$var$getEventTarget(event);
            if ($0ca4f63b79e931bd$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $0ca4f63b79e931bd$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $0ca4f63b79e931bd$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $0ca4f63b79e931bd$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $0ca4f63b79e931bd$var$PointerTypes.Touch) {
                    if ($0ca4f63b79e931bd$var$MouseInteractions[eventKey] === $0ca4f63b79e931bd$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($0ca4f63b79e931bd$var$MouseInteractions[eventKey] === $0ca4f63b79e931bd$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $0ca4f63b79e931bd$var$PointerTypes.Pen;
            } else if ($0ca4f63b79e931bd$var$legacy_isTouchEvent(event)) pointerType = $0ca4f63b79e931bd$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $0ca4f63b79e931bd$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $0ca4f63b79e931bd$var$PointerTypes.Mouse) pointerType = null;
            } else if ($0ca4f63b79e931bd$var$MouseInteractions[eventKey] === $0ca4f63b79e931bd$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e2 = $0ca4f63b79e931bd$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            const id = mirror2.getId(target);
            const { clientX: clientX, clientY: clientY } = e2;
            $0ca4f63b79e931bd$var$callbackWrapper(mouseInteractionCb)({
                type: $0ca4f63b79e931bd$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($0ca4f63b79e931bd$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $0ca4f63b79e931bd$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($0ca4f63b79e931bd$var$MouseInteractions[eventKey]){
            case $0ca4f63b79e931bd$var$MouseInteractions.MouseDown:
            case $0ca4f63b79e931bd$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $0ca4f63b79e931bd$var$MouseInteractions.TouchStart:
            case $0ca4f63b79e931bd$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($0ca4f63b79e931bd$var$on(eventName, handler, doc));
    });
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $0ca4f63b79e931bd$var$callbackWrapper($0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper((evt)=>{
        const target = $0ca4f63b79e931bd$var$getEventTarget(evt);
        if (!target || $0ca4f63b79e931bd$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $0ca4f63b79e931bd$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $0ca4f63b79e931bd$var$on("scroll", updatePosition, doc);
}
function $0ca4f63b79e931bd$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $0ca4f63b79e931bd$var$callbackWrapper($0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper(()=>{
        const height = $0ca4f63b79e931bd$var$getWindowHeight();
        const width = $0ca4f63b79e931bd$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $0ca4f63b79e931bd$var$on("resize", updateDimension, win);
}
const $0ca4f63b79e931bd$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $0ca4f63b79e931bd$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $0ca4f63b79e931bd$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $0ca4f63b79e931bd$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $0ca4f63b79e931bd$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $0ca4f63b79e931bd$var$INPUT_TAGS.indexOf(tagName) < 0 || $0ca4f63b79e931bd$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $0ca4f63b79e931bd$var$getInputType(target);
        let text = $0ca4f63b79e931bd$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $0ca4f63b79e931bd$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $0ca4f63b79e931bd$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $0ca4f63b79e931bd$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el2)=>{
            if (el2 !== target) {
                const text2 = $0ca4f63b79e931bd$var$maskInputValue({
                    // share mask behavior of `target`
                    isMasked: forceMask,
                    element: el2,
                    value: $0ca4f63b79e931bd$var$getInputValue(el2, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el2, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        const lastInputValue = $0ca4f63b79e931bd$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $0ca4f63b79e931bd$var$lastInputValueMap.set(target, v2);
            const id = mirror2.getId(target);
            $0ca4f63b79e931bd$var$callbackWrapper(inputCb)({
                ...v2,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$0ca4f63b79e931bd$var$on(eventName, $0ca4f63b79e931bd$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$0ca4f63b79e931bd$var$hookSetter(p[0], p[1], {
            set () {
                $0ca4f63b79e931bd$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($0ca4f63b79e931bd$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $0ca4f63b79e931bd$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $0ca4f63b79e931bd$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $0ca4f63b79e931bd$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules2 = Array.from(childRule.parentRule.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules2 = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules2.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $0ca4f63b79e931bd$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $0ca4f63b79e931bd$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror2, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$0ca4f63b79e931bd$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$0ca4f63b79e931bd$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $0ca4f63b79e931bd$var$initAdoptedStyleSheetObserver({ mirror: mirror2, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror2.getId(host);
    else hostId = mirror2.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? host.defaultView?.Document : host.ownerDocument?.defaultView?.ShadowRoot;
    const originalPropertyDescriptor = patchTarget?.prototype ? Object.getOwnPropertyDescriptor(patchTarget?.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return originalPropertyDescriptor.get?.call(this);
        },
        set (sheets) {
            const result = originalPropertyDescriptor.set?.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result;
        }
    });
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $0ca4f63b79e931bd$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror2, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $0ca4f63b79e931bd$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $0ca4f63b79e931bd$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $0ca4f63b79e931bd$var$getIdAndStyleId(thisArg.parentRule?.parentStyleSheet, mirror2, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $0ca4f63b79e931bd$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $0ca4f63b79e931bd$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror2, sampling: sampling, doc: doc }) {
    const handler = $0ca4f63b79e931bd$var$callbackWrapper((type)=>$0ca4f63b79e931bd$var$throttle$1($0ca4f63b79e931bd$var$callbackWrapper((event)=>{
            const target = $0ca4f63b79e931bd$var$getEventTarget(event);
            if (!target || $0ca4f63b79e931bd$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $0ca4f63b79e931bd$var$on("play", handler($0ca4f63b79e931bd$var$MediaInteractions.Play), doc),
        $0ca4f63b79e931bd$var$on("pause", handler($0ca4f63b79e931bd$var$MediaInteractions.Pause), doc),
        $0ca4f63b79e931bd$var$on("seeked", handler($0ca4f63b79e931bd$var$MediaInteractions.Seeked), doc),
        $0ca4f63b79e931bd$var$on("volumechange", handler($0ca4f63b79e931bd$var$MediaInteractions.VolumeChange), doc),
        $0ca4f63b79e931bd$var$on("ratechange", handler($0ca4f63b79e931bd$var$MediaInteractions.RateChange), doc)
    ];
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = /* @__PURE__ */ new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $0ca4f63b79e931bd$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $0ca4f63b79e931bd$var$setTimeout$1($0ca4f63b79e931bd$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror2, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && selection?.isCollapsed) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i2 = 0; i2 < count; i2++){
            const range = selection.getRangeAt(i2);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $0ca4f63b79e931bd$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $0ca4f63b79e931bd$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $0ca4f63b79e931bd$var$on("selectionchange", updateSelection);
}
function $0ca4f63b79e931bd$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $0ca4f63b79e931bd$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $0ca4f63b79e931bd$var$initObservers(o2, _hooks = {}) {
    const currentWindow = o2.doc.defaultView;
    if (!currentWindow) return ()=>{};
    let mutationObserver;
    if (o2.recordDOM) mutationObserver = $0ca4f63b79e931bd$var$initMutationObserver(o2, o2.doc);
    const mousemoveHandler = $0ca4f63b79e931bd$var$initMoveObserver(o2);
    const mouseInteractionHandler = $0ca4f63b79e931bd$var$initMouseInteractionObserver(o2);
    const scrollHandler = $0ca4f63b79e931bd$var$initScrollObserver(o2);
    const viewportResizeHandler = $0ca4f63b79e931bd$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    const inputHandler = $0ca4f63b79e931bd$var$initInputObserver(o2);
    const mediaInteractionHandler = $0ca4f63b79e931bd$var$initMediaInteractionObserver(o2);
    let styleSheetObserver = ()=>{};
    let adoptedStyleSheetObserver = ()=>{};
    let styleDeclarationObserver = ()=>{};
    let fontObserver = ()=>{};
    if (o2.recordDOM) {
        styleSheetObserver = $0ca4f63b79e931bd$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $0ca4f63b79e931bd$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $0ca4f63b79e931bd$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $0ca4f63b79e931bd$var$initFontObserver(o2);
    }
    const selectionObserver = $0ca4f63b79e931bd$var$initSelectionObserver(o2);
    const customElementObserver = $0ca4f63b79e931bd$var$initCustomElementObserver(o2);
    const pluginHandlers = [];
    for (const plugin of o2.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $0ca4f63b79e931bd$var$callbackWrapper(()=>{
        $0ca4f63b79e931bd$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver?.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $0ca4f63b79e931bd$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $0ca4f63b79e931bd$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $0ca4f63b79e931bd$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
        this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
class $0ca4f63b79e931bd$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $0ca4f63b79e931bd$var$CrossOriginIframeMirror($0ca4f63b79e931bd$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $0ca4f63b79e931bd$var$IframeManager {
    constructor(options){
        this.iframes = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap();
        this.crossOriginIframeMirror = new $0ca4f63b79e931bd$var$CrossOriginIframeMirror($0ca4f63b79e931bd$var$genId);
        this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $0ca4f63b79e931bd$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) iframeEl.contentWindow?.addEventListener("message", this.handleMessage.bind(this));
        this.loadListener?.(iframeEl);
        const iframeDoc = $0ca4f63b79e931bd$var$getIFrameContentDocument(iframeEl);
        if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeDoc.adoptedStyleSheets, this.mirror.getId(iframeDoc));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e2) {
        switch(e2.type){
            case $0ca4f63b79e931bd$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e2.data.node, iframeEl);
                    const rootId = e2.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e2.data.node, rootId);
                    return {
                        timestamp: e2.timestamp,
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e2.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $0ca4f63b79e931bd$var$EventType.Meta:
            case $0ca4f63b79e931bd$var$EventType.Load:
            case $0ca4f63b79e931bd$var$EventType.DomContentLoaded:
                return false;
            case $0ca4f63b79e931bd$var$EventType.Plugin:
                return e2;
            case $0ca4f63b79e931bd$var$EventType.Custom:
                this.replaceIds(e2.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e2;
            case $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot:
                switch(e2.data.source){
                    case $0ca4f63b79e931bd$var$IncrementalSource.Mutation:
                        e2.data.adds.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n2.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n2.node, rootId);
                        });
                        e2.data.removes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e2.data.attributes.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        e2.data.texts.forEach((n2)=>{
                            this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $0ca4f63b79e931bd$var$IncrementalSource.Drag:
                    case $0ca4f63b79e931bd$var$IncrementalSource.TouchMove:
                    case $0ca4f63b79e931bd$var$IncrementalSource.MouseMove:
                        e2.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $0ca4f63b79e931bd$var$IncrementalSource.ViewportResize:
                        return false;
                    case $0ca4f63b79e931bd$var$IncrementalSource.MediaInteraction:
                    case $0ca4f63b79e931bd$var$IncrementalSource.MouseInteraction:
                    case $0ca4f63b79e931bd$var$IncrementalSource.Scroll:
                    case $0ca4f63b79e931bd$var$IncrementalSource.CanvasMutation:
                    case $0ca4f63b79e931bd$var$IncrementalSource.Input:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        return e2;
                    case $0ca4f63b79e931bd$var$IncrementalSource.StyleSheetRule:
                    case $0ca4f63b79e931bd$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleId"
                        ]);
                        return e2;
                    case $0ca4f63b79e931bd$var$IncrementalSource.Font:
                        return e2;
                    case $0ca4f63b79e931bd$var$IncrementalSource.Selection:
                        e2.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e2;
                    case $0ca4f63b79e931bd$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleIds"
                        ]);
                        e2.data.styles?.forEach((style)=>{
                            this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e2;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $0ca4f63b79e931bd$var$NodeType$2.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $0ca4f63b79e931bd$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $0ca4f63b79e931bd$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$0ca4f63b79e931bd$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
        const observer = $0ca4f63b79e931bd$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($0ca4f63b79e931bd$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $0ca4f63b79e931bd$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($0ca4f63b79e931bd$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ observeAttachShadow(iframeElement) {
        const iframeDoc = $0ca4f63b79e931bd$var$getIFrameContentDocument(iframeElement);
        const iframeWindow = $0ca4f63b79e931bd$var$getIFrameContentWindow(iframeElement);
        if (!iframeDoc || !iframeWindow) return;
        this.patchAttachShadow(iframeWindow.Element, iframeDoc);
    }
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($0ca4f63b79e931bd$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $0ca4f63b79e931bd$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
        this.bypassOptions.canvasManager.resetShadowRoots();
    }
}
var $0ca4f63b79e931bd$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $0ca4f63b79e931bd$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $0ca4f63b79e931bd$var$i$1 = 0; $0ca4f63b79e931bd$var$i$1 < $0ca4f63b79e931bd$var$chars.length; $0ca4f63b79e931bd$var$i$1++)$0ca4f63b79e931bd$var$lookup[$0ca4f63b79e931bd$var$chars.charCodeAt($0ca4f63b79e931bd$var$i$1)] = $0ca4f63b79e931bd$var$i$1;
class $0ca4f63b79e931bd$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
    addWindow() {}
    addShadowRoot() {}
    resetShadowRoots() {}
}
class $0ca4f63b79e931bd$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
        this.styleMirror = new $0ca4f63b79e931bd$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r2, index)=>({
                            rule: $0ca4f63b79e931bd$var$stringifyRule(r2),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    }
    // TODO: take snapshot on stylesheet reload by applying event listener
    trackStylesheetInLinkElement(_linkEl) {}
}
class $0ca4f63b79e931bd$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = /* @__PURE__ */ new WeakMap();
        this.active = false;
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        if (!this.active) {
            this.active = true;
            $0ca4f63b79e931bd$var$onRequestAnimationFrame(()=>{
                this.nodeMap = /* @__PURE__ */ new WeakMap();
                this.active = false;
            });
        }
        this.nodeMap.set(node, (this.nodeMap.get(node) || /* @__PURE__ */ new Set()).add(buffer));
    }
    destroy() {}
}
let $0ca4f63b79e931bd$var$wrappedEmit;
let $0ca4f63b79e931bd$var$_takeFullSnapshot;
try {
    if (Array.from([
        1
    ], (x)=>x * 2)[0] !== 2) {
        const cleanFrame = document.createElement("iframe");
        document.body.appendChild(cleanFrame);
        Array.from = cleanFrame.contentWindow?.Array.from || Array.from;
        document.body.removeChild(cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
const $0ca4f63b79e931bd$var$mirror = $0ca4f63b79e931bd$var$createMirror$2();
function $0ca4f63b79e931bd$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordDOM: recordDOM = true, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = /* @__PURE__ */ new Set([]), errorHandler: errorHandler2, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $0ca4f63b79e931bd$var$registerErrorHandler(errorHandler2);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return ()=>{};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $0ca4f63b79e931bd$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $0ca4f63b79e931bd$var$polyfill$1();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e2)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e2 = plugin.eventProcessor(e2);
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $0ca4f63b79e931bd$var$wrappedEmit = (r2, isCheckout)=>{
        const e2 = r2;
        e2.timestamp = $0ca4f63b79e931bd$var$nowTimestamp();
        if ($0ca4f63b79e931bd$var$mutationBuffers[0]?.isFrozen() && e2.type !== $0ca4f63b79e931bd$var$EventType.FullSnapshot && !(e2.type === $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot && e2.data.source === $0ca4f63b79e931bd$var$IncrementalSource.Mutation)) $0ca4f63b79e931bd$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) emit?.(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $0ca4f63b79e931bd$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot) {
            if (e2.data.source === $0ca4f63b79e931bd$var$IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot2(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
            data: {
                source: $0ca4f63b79e931bd$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
            data: {
                source: $0ca4f63b79e931bd$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
            data: {
                source: $0ca4f63b79e931bd$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a2)=>$0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
            data: {
                source: $0ca4f63b79e931bd$var$IncrementalSource.AdoptedStyleSheet,
                ...a2
            }
        });
    const stylesheetManager = new $0ca4f63b79e931bd$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $0ca4f63b79e931bd$var$IframeManagerNoop() : new $0ca4f63b79e931bd$var$IframeManager({
        mirror: $0ca4f63b79e931bd$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $0ca4f63b79e931bd$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $0ca4f63b79e931bd$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $0ca4f63b79e931bd$var$ProcessedNodeManager();
    const canvasManager = $0ca4f63b79e931bd$var$_getCanvasManager(getCanvasManager, {
        mirror: $0ca4f63b79e931bd$var$mirror,
        win: window,
        mutationCb: (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
                type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                data: {
                    source: $0ca4f63b79e931bd$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler2
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $0ca4f63b79e931bd$var$ShadowDomManagerNoop() : new $0ca4f63b79e931bd$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $0ca4f63b79e931bd$var$mirror
    });
    const takeFullSnapshot2 = (isCheckout = false)=>{
        if (!recordDOM) return;
        $0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $0ca4f63b79e931bd$var$getWindowWidth(),
                height: $0ca4f63b79e931bd$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $0ca4f63b79e931bd$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $0ca4f63b79e931bd$var$snapshot(document, {
            mirror: $0ca4f63b79e931bd$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n2)=>{
                if ($0ca4f63b79e931bd$var$isSerializedIframe(n2, $0ca4f63b79e931bd$var$mirror)) iframeManager.addIframe(n2);
                if ($0ca4f63b79e931bd$var$isSerializedStylesheet(n2, $0ca4f63b79e931bd$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($0ca4f63b79e931bd$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot(n2.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                if (iframe.contentWindow) canvasManager.addWindow(iframe.contentWindow);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $0ca4f63b79e931bd$var$wrappedEmit({
            type: $0ca4f63b79e931bd$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $0ca4f63b79e931bd$var$getWindowScroll(window)
            }
        });
        $0ca4f63b79e931bd$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $0ca4f63b79e931bd$var$mirror.getId(document));
    };
    $0ca4f63b79e931bd$var$_takeFullSnapshot = takeFullSnapshot2;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $0ca4f63b79e931bd$var$callbackWrapper($0ca4f63b79e931bd$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v2)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.Input,
                            ...v2
                        }
                    }),
                mediaInteractionCb: (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r2)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.StyleSheetRule,
                            ...r2
                        }
                    }),
                styleDeclarationCb: (r2)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.StyleDeclaration,
                            ...r2
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c2)=>{
                    $0ca4f63b79e931bd$var$wrappedEmit({
                        type: $0ca4f63b79e931bd$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $0ca4f63b79e931bd$var$IncrementalSource.CustomElement,
                            ...c2
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $0ca4f63b79e931bd$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: plugins?.filter((p)=>p.observer)?.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$0ca4f63b79e931bd$var$wrappedEmit({
                                type: $0ca4f63b79e931bd$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            })
                    })) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot2();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($0ca4f63b79e931bd$var$on("DOMContentLoaded", ()=>{
                $0ca4f63b79e931bd$var$wrappedEmit({
                    type: $0ca4f63b79e931bd$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($0ca4f63b79e931bd$var$on("load", ()=>{
                $0ca4f63b79e931bd$var$wrappedEmit({
                    type: $0ca4f63b79e931bd$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $0ca4f63b79e931bd$var$_takeFullSnapshot = void 0;
            $0ca4f63b79e931bd$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $0ca4f63b79e931bd$var$takeFullSnapshot(isCheckout) {
    if (!$0ca4f63b79e931bd$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $0ca4f63b79e931bd$var$_takeFullSnapshot(isCheckout);
}
$0ca4f63b79e931bd$var$record.mirror = $0ca4f63b79e931bd$var$mirror;
$0ca4f63b79e931bd$var$record.takeFullSnapshot = $0ca4f63b79e931bd$var$takeFullSnapshot;
function $0ca4f63b79e931bd$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $0ca4f63b79e931bd$var$CanvasManagerNoop();
    } catch  {
        console.warn("Unable to initialize CanvasManager");
        return new $0ca4f63b79e931bd$var$CanvasManagerNoop();
    }
}
var $0ca4f63b79e931bd$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($0ca4f63b79e931bd$var$n || ($0ca4f63b79e931bd$var$n = {}));
const $0ca4f63b79e931bd$var$ReplayEventTypeIncrementalSnapshot = 3;
const $0ca4f63b79e931bd$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $0ca4f63b79e931bd$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $0ca4f63b79e931bd$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === 'sentry.transaction') return;
    if ([
        'ui.click',
        'ui.input'
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $0ca4f63b79e931bd$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: 'breadcrumb',
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $886wr.normalize)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === 'console';
    });
}
const $0ca4f63b79e931bd$var$INTERACTIVE_SELECTOR = 'button,a';
/** Get the closest interactive parent element, or else return the given element. */ function $0ca4f63b79e931bd$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($0ca4f63b79e931bd$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $0ca4f63b79e931bd$var$getClickTargetNode(event) {
    const target = $0ca4f63b79e931bd$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $0ca4f63b79e931bd$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $0ca4f63b79e931bd$var$getTargetNode(event) {
    if ($0ca4f63b79e931bd$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $0ca4f63b79e931bd$var$isEventWithTarget(event) {
    return typeof event === 'object' && !!event && 'target' in event;
}
let $0ca4f63b79e931bd$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $0ca4f63b79e931bd$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$0ca4f63b79e931bd$var$handlers) {
        $0ca4f63b79e931bd$var$handlers = [];
        $0ca4f63b79e931bd$var$monkeyPatchWindowOpen();
    }
    $0ca4f63b79e931bd$var$handlers.push(cb);
    return ()=>{
        const pos = $0ca4f63b79e931bd$var$handlers ? $0ca4f63b79e931bd$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $0ca4f63b79e931bd$var$handlers.splice(pos, 1);
    };
}
function $0ca4f63b79e931bd$var$monkeyPatchWindowOpen() {
    (0, $l1oVX.fill)($0ca4f63b79e931bd$var$WINDOW, 'open', function(originalWindowOpen) {
        return function(...args) {
            if ($0ca4f63b79e931bd$var$handlers) try {
                $0ca4f63b79e931bd$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($0ca4f63b79e931bd$var$WINDOW, args);
        };
    });
}
/** Any IncrementalSource for rrweb that we interpret as a kind of mutation. */ const $0ca4f63b79e931bd$var$IncrementalMutationSources = new Set([
    $0ca4f63b79e931bd$var$IncrementalSource.Mutation,
    $0ca4f63b79e931bd$var$IncrementalSource.StyleSheetRule,
    $0ca4f63b79e931bd$var$IncrementalSource.StyleDeclaration,
    $0ca4f63b79e931bd$var$IncrementalSource.AdoptedStyleSheet,
    $0ca4f63b79e931bd$var$IncrementalSource.CanvasMutation,
    $0ca4f63b79e931bd$var$IncrementalSource.Selection,
    $0ca4f63b79e931bd$var$IncrementalSource.MediaInteraction
]);
/** Handle a click. */ function $0ca4f63b79e931bd$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $0ca4f63b79e931bd$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $0ca4f63b79e931bd$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scrollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $0ca4f63b79e931bd$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $0ca4f63b79e931bd$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($0ca4f63b79e931bd$var$ignoreElement(node, this._ignoreSelector) || !$0ca4f63b79e931bd$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $0ca4f63b79e931bd$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $0ca4f63b79e931bd$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $0ca4f63b79e931bd$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $0ca4f63b79e931bd$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $0ca4f63b79e931bd$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.slowClickDetected',
                data: {
                    ...clickBreadcrumb.data,
                    url: $0ca4f63b79e931bd$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.multiClick',
                data: {
                    ...clickBreadcrumb.data,
                    url: $0ca4f63b79e931bd$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = (0, $hUuVt.setTimeout)(()=>this._checkClicks(), 1000);
    }
}
const $0ca4f63b79e931bd$var$SLOW_CLICK_TAGS = [
    'A',
    'BUTTON',
    'INPUT'
];
/** exported for tests only */ function $0ca4f63b79e931bd$var$ignoreElement(node, ignoreSelector) {
    if (!$0ca4f63b79e931bd$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === 'INPUT' && ![
        'submit',
        'button'
    ].includes(node.getAttribute('type') || '')) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $0ca4f63b79e931bd$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $0ca4f63b79e931bd$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $0ca4f63b79e931bd$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$0ca4f63b79e931bd$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if ($0ca4f63b79e931bd$var$IncrementalMutationSources.has(source)) clickDetector.registerMutation(event.timestamp);
        if (source === $0ca4f63b79e931bd$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($0ca4f63b79e931bd$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $0ca4f63b79e931bd$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $0ca4f63b79e931bd$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch  {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $0ca4f63b79e931bd$var$isIncrementalEvent(event) {
    return event.type === $0ca4f63b79e931bd$var$ReplayEventTypeIncrementalSnapshot;
}
function $0ca4f63b79e931bd$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $0ca4f63b79e931bd$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $0ca4f63b79e931bd$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: 'default',
        ...breadcrumb
    };
}
var $0ca4f63b79e931bd$var$NodeType = /* @__PURE__ */ ((NodeType2)=>{
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
})($0ca4f63b79e931bd$var$NodeType || {});
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $0ca4f63b79e931bd$var$ATTRIBUTES_TO_RECORD = new Set([
    'id',
    'class',
    'aria-label',
    'role',
    'name',
    'alt',
    'title',
    'data-test-id',
    'data-testid',
    'disabled',
    'aria-disabled',
    'data-sentry-component'
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $0ca4f63b79e931bd$var$getAttributesToRecord(attributes) {
    const obj = {};
    if (!attributes['data-sentry-component'] && attributes['data-sentry-element']) attributes['data-sentry-component'] = attributes['data-sentry-element'];
    for(const key in attributes)if ($0ca4f63b79e931bd$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === 'data-testid' || key === 'data-test-id') normalizedKey = 'testId';
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $0ca4f63b79e931bd$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $0ca4f63b79e931bd$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === 'click';
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $0ca4f63b79e931bd$var$handleClick(replay.clickDetector, result, $0ca4f63b79e931bd$var$getClickTargetNode(handlerData.event));
        $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $0ca4f63b79e931bd$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $0ca4f63b79e931bd$var$record.mirror.getId(target);
    const node = nodeId && $0ca4f63b79e931bd$var$record.mirror.getNode(nodeId);
    const meta = node && $0ca4f63b79e931bd$var$record.mirror.getMeta(node);
    const element = meta && $0ca4f63b79e931bd$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $0ca4f63b79e931bd$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(''),
                attributes: $0ca4f63b79e931bd$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $0ca4f63b79e931bd$var$handleDom(handlerData) {
    const { target: target, message: message } = $0ca4f63b79e931bd$var$getDomTarget(handlerData);
    return $0ca4f63b79e931bd$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$0ca4f63b79e931bd$var$getBaseDomBreadcrumb(target, message)
    });
}
function $0ca4f63b79e931bd$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === 'click';
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $0ca4f63b79e931bd$var$getClickTargetNode(handlerData.event) : $0ca4f63b79e931bd$var$getTargetNode(handlerData.event);
        message = (0, $hA6iJ.htmlTreeAsString)(target, {
            maxStringLength: 200
        }) || '<unknown>';
    } catch (e) {
        message = '<unknown>';
    }
    return {
        target: target,
        message: message
    };
}
function $0ca4f63b79e931bd$var$isElement(node) {
    return node.type === $0ca4f63b79e931bd$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $0ca4f63b79e931bd$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $0ca4f63b79e931bd$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $0ca4f63b79e931bd$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $0ca4f63b79e931bd$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $hA6iJ.htmlTreeAsString)(target, {
        maxStringLength: 200
    }) || '<unknown>';
    const baseBreadcrumb = $0ca4f63b79e931bd$var$getBaseDomBreadcrumb(target, message);
    return $0ca4f63b79e931bd$var$createBreadcrumb({
        category: 'ui.keyDown',
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $0ca4f63b79e931bd$var$isInputElement(target) {
    return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $0ca4f63b79e931bd$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $0ca4f63b79e931bd$var$createResourceEntry,
    paint: $0ca4f63b79e931bd$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $0ca4f63b79e931bd$var$createNavigationEntry
};
/**
 * Handler creater for web vitals
 */ function $0ca4f63b79e931bd$var$webVitalHandler(getter, replay) {
    return ({ metric: metric })=>void replay.replayPerformanceEntries.push(getter(metric));
}
/**
 * Create replay performance entries from the browser performance entries.
 */ function $0ca4f63b79e931bd$var$createPerformanceEntries(entries) {
    return entries.map($0ca4f63b79e931bd$var$createPerformanceEntry).filter(Boolean);
}
function $0ca4f63b79e931bd$var$createPerformanceEntry(entry) {
    const entryType = $0ca4f63b79e931bd$var$ENTRY_TYPES[entry.entryType];
    if (!entryType) return null;
    return entryType(entry);
}
function $0ca4f63b79e931bd$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $6OKHc.browserPerformanceTimeOrigin)() || $0ca4f63b79e931bd$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $0ca4f63b79e931bd$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $0ca4f63b79e931bd$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $0ca4f63b79e931bd$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $0ca4f63b79e931bd$var$getAbsoluteTime(startTime),
        end: $0ca4f63b79e931bd$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $0ca4f63b79e931bd$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        'fetch',
        'xmlhttprequest'
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $0ca4f63b79e931bd$var$getAbsoluteTime(startTime),
        end: $0ca4f63b79e931bd$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on a LCP metric.
 */ function $0ca4f63b79e931bd$var$getLargestContentfulPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.element ? [
        lastEntry.element
    ] : undefined;
    return $0ca4f63b79e931bd$var$getWebVital(metric, 'largest-contentful-paint', node);
}
function $0ca4f63b79e931bd$var$isLayoutShift(entry) {
    return entry.sources !== undefined;
}
/**
 * Add a CLS event to the replay based on a CLS metric.
 */ function $0ca4f63b79e931bd$var$getCumulativeLayoutShift(metric) {
    const layoutShifts = [];
    const nodes = [];
    for (const entry of metric.entries)if ($0ca4f63b79e931bd$var$isLayoutShift(entry)) {
        const nodeIds = [];
        for (const source of entry.sources)if (source.node) {
            nodes.push(source.node);
            const nodeId = $0ca4f63b79e931bd$var$record.mirror.getId(source.node);
            if (nodeId) nodeIds.push(nodeId);
        }
        layoutShifts.push({
            value: entry.value,
            nodeIds: nodeIds.length ? nodeIds : undefined
        });
    }
    return $0ca4f63b79e931bd$var$getWebVital(metric, 'cumulative-layout-shift', nodes, layoutShifts);
}
/**
 * Add a FID event to the replay based on a FID metric.
 */ function $0ca4f63b79e931bd$var$getFirstInputDelay(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.target ? [
        lastEntry.target
    ] : undefined;
    return $0ca4f63b79e931bd$var$getWebVital(metric, 'first-input-delay', node);
}
/**
 * Add an INP event to the replay based on an INP metric.
 */ function $0ca4f63b79e931bd$var$getInteractionToNextPaint(metric) {
    const lastEntry = metric.entries[metric.entries.length - 1];
    const node = lastEntry?.target ? [
        lastEntry.target
    ] : undefined;
    return $0ca4f63b79e931bd$var$getWebVital(metric, 'interaction-to-next-paint', node);
}
/**
 * Add an web vital event to the replay based on the web vital metric.
 */ function $0ca4f63b79e931bd$var$getWebVital(metric, name, nodes, attributions) {
    const value = metric.value;
    const rating = metric.rating;
    const end = $0ca4f63b79e931bd$var$getAbsoluteTime(value);
    return {
        type: 'web-vital',
        name: name,
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            rating: rating,
            nodeIds: nodes ? nodes.map((node)=>$0ca4f63b79e931bd$var$record.mirror.getId(node)) : undefined,
            attributions: attributions
        }
    };
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $0ca4f63b79e931bd$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        'navigation',
        'paint',
        'resource'
    ].forEach((type)=>{
        clearCallbacks.push((0, $4hTws.addPerformanceInstrumentationHandler)(type, onEntries));
    });
    clearCallbacks.push((0, $4hTws.addLcpInstrumentationHandler)($0ca4f63b79e931bd$var$webVitalHandler($0ca4f63b79e931bd$var$getLargestContentfulPaint, replay)), (0, $4hTws.addClsInstrumentationHandler)($0ca4f63b79e931bd$var$webVitalHandler($0ca4f63b79e931bd$var$getCumulativeLayoutShift, replay)), (0, $4hTws.addFidInstrumentationHandler)($0ca4f63b79e931bd$var$webVitalHandler($0ca4f63b79e931bd$var$getFirstInputDelay, replay)), (0, $4hTws.addInpInstrumentationHandler)($0ca4f63b79e931bd$var$webVitalHandler($0ca4f63b79e931bd$var$getInteractionToNextPaint, replay)));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0ca4f63b79e931bd$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
const $0ca4f63b79e931bd$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort((function(t,n){return p[n.s]-p[t.s]||t.f-n.f}));s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}},L=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},O=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},j=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},q=function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&j(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}},B=function(t){return 10+(t.filename?t.filename.length+1:0)},G=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(O(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();var H=function(){function t(t,n){this.c=L(),this.v=1,G.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),G.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=O(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=L();i.p(n.dictionary),j(t,2,i.d())}}(r,this.o),this.v=0),n&&j(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){G.prototype.flush.call(this)},t}(),J="undefined"!=typeof TextEncoder&&new TextEncoder,K="undefined"!=typeof TextDecoder&&new TextDecoder;try{K.decode(F,{stream:!0})}catch(t){}var N=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(P(t),this.d=n||!1)},t}();function P(n,r){if(J)return J.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}function Q(t){return function(t,n){n||(n={});var r=S(),e=t.length;r.p(t);var i=O(t,n,B(n),8),s=i.length;return q(i,n),j(i,s-8,r.d()),j(i,s-4,e),i}(P(t))}const R=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new H,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new N(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},V={clear:()=>{R.clear()},addEvent:t=>R.addEvent(t),finish:()=>R.finish(),compress:t=>Q(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in V&&"function"==typeof V[n])try{const t=V[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $0ca4f63b79e931bd$var$e() {
    const e = new Blob([
        $0ca4f63b79e931bd$var$r
    ]);
    return URL.createObjectURL(e);
}
const $0ca4f63b79e931bd$var$CONSOLE_LEVELS = [
    'info',
    'warn',
    'error',
    'log'
];
const $0ca4f63b79e931bd$var$PREFIX = '[Replay] ';
function $0ca4f63b79e931bd$var$_addBreadcrumb(message, level = 'info') {
    (0, $6El1G.addBreadcrumb)({
        category: 'console',
        data: {
            logger: 'replay'
        },
        level: level,
        message: `${$0ca4f63b79e931bd$var$PREFIX}${message}`
    }, {
        level: level
    });
}
function $0ca4f63b79e931bd$var$makeReplayLogger() {
    let _capture = false;
    let _trace = false;
    const _logger = {
        exception: ()=>undefined,
        infoTick: ()=>undefined,
        setConfig: (opts)=>{
            _capture = !!opts.captureExceptions;
            _trace = !!opts.traceInternals;
        }
    };
    if ($0ca4f63b79e931bd$var$DEBUG_BUILD) {
        $0ca4f63b79e931bd$var$CONSOLE_LEVELS.forEach((name)=>{
            _logger[name] = (...args)=>{
                (0, $hi47i.logger)[name]($0ca4f63b79e931bd$var$PREFIX, ...args);
                if (_trace) $0ca4f63b79e931bd$var$_addBreadcrumb(args.join(''), (0, $2bC2j.severityLevelFromString)(name));
            };
        });
        _logger.exception = (error, ...message)=>{
            if (message.length && _logger.error) _logger.error(...message);
            (0, $hi47i.logger).error($0ca4f63b79e931bd$var$PREFIX, error);
            if (_capture) (0, $kQ0sT.captureException)(error);
            else if (_trace) // No need for a breadcrumb if `_capture` is enabled since it should be
            // captured as an exception
            $0ca4f63b79e931bd$var$_addBreadcrumb(error, 'error');
        };
        _logger.infoTick = (...args)=>{
            (0, $hi47i.logger).info($0ca4f63b79e931bd$var$PREFIX, ...args);
            if (_trace) // Wait a tick here to avoid race conditions for some initial logs
            // which may be added before replay is initialized
            setTimeout(()=>$0ca4f63b79e931bd$var$_addBreadcrumb(args[0]), 0);
        };
    } else $0ca4f63b79e931bd$var$CONSOLE_LEVELS.forEach((name)=>{
        _logger[name] = ()=>undefined;
    });
    return _logger;
}
const $0ca4f63b79e931bd$var$logger = $0ca4f63b79e931bd$var$makeReplayLogger();
/** This error indicates that the event buffer size exceeded the limit.. */ class $0ca4f63b79e931bd$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$0ca4f63b79e931bd$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $0ca4f63b79e931bd$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return 'sync';
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $0ca4f63b79e931bd$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $0ca4f63b79e931bd$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $0ca4f63b79e931bd$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $0ca4f63b79e931bd$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener('message', ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener('error', (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Destroying compression worker');
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener('message', listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.error('Error in compression worker: ', response.response);
                    reject(new Error('Error in compression worker'));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener('message', listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $0ca4f63b79e931bd$var$EventBufferCompressionWorker {
    /** @inheritdoc */ /** @inheritdoc */ constructor(worker){
        this._worker = new $0ca4f63b79e931bd$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this.waitForCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return 'worker';
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */ addEvent(event) {
        const timestamp = $0ca4f63b79e931bd$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $0ca4f63b79e931bd$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $0ca4f63b79e931bd$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage('clear').then(null, (e)=>{
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(e, 'Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage('addEvent', data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage('finish');
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $0ca4f63b79e931bd$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $0ca4f63b79e931bd$var$EventBufferArray();
        this._compression = new $0ca4f63b79e931bd$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get waitForCheckout() {
        return this._used.waitForCheckout;
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    set waitForCheckout(value) {
        this._used.waitForCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to load the compression worker, falling back to simple buffer');
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout, waitForCheckout: waitForCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        this._compression.waitForCheckout = waitForCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
            // Can now clear fallback buffer as it's no longer necessary
            this._fallback.clear();
        } catch (error) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to add events when switching buffers.');
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $0ca4f63b79e931bd$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $0ca4f63b79e931bd$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Using simple buffer');
    return new $0ca4f63b79e931bd$var$EventBufferArray();
}
function $0ca4f63b79e931bd$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $0ca4f63b79e931bd$var$_getWorkerUrl();
        if (!workerUrl) return;
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ''}`);
        const worker = new Worker(workerUrl);
        return new $0ca4f63b79e931bd$var$EventBufferProxy(worker);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to create compression worker');
    // Fall back to use simple event buffer array
    }
}
function $0ca4f63b79e931bd$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === 'undefined' || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $0ca4f63b79e931bd$var$e();
    return '';
}
/** If sessionStorage is available. */ function $0ca4f63b79e931bd$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return 'sessionStorage' in $0ca4f63b79e931bd$var$WINDOW && !!$0ca4f63b79e931bd$var$WINDOW.sessionStorage;
    } catch  {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $0ca4f63b79e931bd$var$clearSession(replay) {
    $0ca4f63b79e931bd$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $0ca4f63b79e931bd$var$deleteSession() {
    if (!$0ca4f63b79e931bd$var$hasSessionStorage()) return;
    try {
        $0ca4f63b79e931bd$var$WINDOW.sessionStorage.removeItem($0ca4f63b79e931bd$var$REPLAY_SESSION_KEY);
    } catch  {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $0ca4f63b79e931bd$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Save a session to session storage.
 */ function $0ca4f63b79e931bd$var$saveSession(session) {
    if (!$0ca4f63b79e931bd$var$hasSessionStorage()) return;
    try {
        $0ca4f63b79e931bd$var$WINDOW.sessionStorage.setItem($0ca4f63b79e931bd$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch  {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get a session with defaults & applied sampling.
 */ function $0ca4f63b79e931bd$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $6OhB9.uuid4)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $0ca4f63b79e931bd$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $0ca4f63b79e931bd$var$isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $0ca4f63b79e931bd$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $0ca4f63b79e931bd$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $0ca4f63b79e931bd$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $0ca4f63b79e931bd$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $0ca4f63b79e931bd$var$fetchSession() {
    if (!$0ca4f63b79e931bd$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $0ca4f63b79e931bd$var$WINDOW.sessionStorage.getItem($0ca4f63b79e931bd$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick('Loading existing session');
        return $0ca4f63b79e931bd$var$makeSession(sessionObj);
    } catch  {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $0ca4f63b79e931bd$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $0ca4f63b79e931bd$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $0ca4f63b79e931bd$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $0ca4f63b79e931bd$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $0ca4f63b79e931bd$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$0ca4f63b79e931bd$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === 'buffer' && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $0ca4f63b79e931bd$var$loadOrCreateSession({ sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $0ca4f63b79e931bd$var$fetchSession();
    // No session exists yet, just create a new one
    if (!existingSession) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick('Creating new session');
        return $0ca4f63b79e931bd$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$0ca4f63b79e931bd$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick('Session in sessionStorage is expired, creating new one...');
    return $0ca4f63b79e931bd$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $0ca4f63b79e931bd$var$isCustomEvent(event) {
    return event.type === $0ca4f63b79e931bd$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $0ca4f63b79e931bd$var$addEventSync(replay, event, isCheckout) {
    if (!$0ca4f63b79e931bd$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $0ca4f63b79e931bd$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $0ca4f63b79e931bd$var$addEvent(replay, event, isCheckout) {
    if (!$0ca4f63b79e931bd$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $0ca4f63b79e931bd$var$_addEvent(replay, event, isCheckout);
}
async function $0ca4f63b79e931bd$var$_addEvent(replay, event, isCheckout) {
    const { eventBuffer: eventBuffer } = replay;
    if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) return null;
    const isBufferMode = replay.recordingMode === 'buffer';
    try {
        if (isCheckout && isBufferMode) eventBuffer.clear();
        if (isCheckout) {
            eventBuffer.hasCheckout = true;
            eventBuffer.waitForCheckout = false;
        }
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $0ca4f63b79e931bd$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const isExceeded = error && error instanceof $0ca4f63b79e931bd$var$EventBufferSizeExceededError;
        const reason = isExceeded ? 'addEventSizeExceeded' : 'addEvent';
        if (isExceeded && isBufferMode) {
            // Clear buffer and wait for next checkout
            eventBuffer.clear();
            eventBuffer.waitForCheckout = true;
            return null;
        }
        replay.handleException(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $kGYVh.getClient)();
        if (client) client.recordDroppedEvent('internal_sdk_error', 'replay');
    }
}
/** Exported only for tests. */ function $0ca4f63b79e931bd$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $0ca4f63b79e931bd$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
        return false;
    }
    return true;
}
function $0ca4f63b79e931bd$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === 'function' && $0ca4f63b79e931bd$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...');
        return null;
    }
    return event;
}
/** If the event is an error event */ function $0ca4f63b79e931bd$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $0ca4f63b79e931bd$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** If the event is an replay event */ function $0ca4f63b79e931bd$var$isReplayEvent(event) {
    return event.type === 'replay_event';
}
/** If the event is a feedback event */ function $0ca4f63b79e931bd$var$isFeedbackEvent(event) {
    return event.type === 'feedback';
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $0ca4f63b79e931bd$var$handleAfterSendEvent(replay) {
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$0ca4f63b79e931bd$var$isErrorEvent(event) && !$0ca4f63b79e931bd$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse?.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($0ca4f63b79e931bd$var$isTransactionEvent(event)) {
            $0ca4f63b79e931bd$var$handleTransactionEvent(replay, event);
            return;
        }
        $0ca4f63b79e931bd$var$handleErrorEvent(replay, event);
    };
}
function $0ca4f63b79e931bd$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts?.trace?.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $0ca4f63b79e931bd$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== 'buffer' || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === 'function' && !beforeErrorSampling(event)) return;
    (0, $hUuVt.setTimeout)(async ()=>{
        try {
            // Capture current event buffer as new replay
            await replay.sendBufferedReplayOrFlush();
        } catch (err) {
            replay.handleException(err);
        }
    });
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $0ca4f63b79e931bd$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$0ca4f63b79e931bd$var$isErrorEvent(event)) return;
        $0ca4f63b79e931bd$var$handleHydrationError(replay, event);
    };
}
function $0ca4f63b79e931bd$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception?.values?.[0]?.value;
    if (typeof exceptionValue !== 'string') return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(/(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
            category: 'replay.hydrate-error',
            data: {
                url: (0, $hA6iJ.getLocationHref)()
            }
        });
        $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Handle breadcrumbs that Sentry captures, and make sure to capture relevant breadcrumbs to Replay as well.
 */ function $0ca4f63b79e931bd$var$handleBreadcrumbs(replay) {
    const client = (0, $kGYVh.getClient)();
    if (!client) return;
    client.on('beforeAddBreadcrumb', (breadcrumb)=>$0ca4f63b79e931bd$var$beforeAddBreadcrumb(replay, breadcrumb));
}
function $0ca4f63b79e931bd$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$0ca4f63b79e931bd$var$isBreadcrumbWithCategory(breadcrumb)) return;
    const result = $0ca4f63b79e931bd$var$normalizeBreadcrumb(breadcrumb);
    if (result) $0ca4f63b79e931bd$var$addBreadcrumbEvent(replay, result);
}
/** Exported only for tests. */ function $0ca4f63b79e931bd$var$normalizeBreadcrumb(breadcrumb) {
    if (!$0ca4f63b79e931bd$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        'fetch',
        'xhr',
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        'sentry.event',
        'sentry.transaction'
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith('ui.')) return null;
    if (breadcrumb.category === 'console') return $0ca4f63b79e931bd$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $0ca4f63b79e931bd$var$createBreadcrumb(breadcrumb);
}
/** exported for tests only */ function $0ca4f63b79e931bd$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data?.arguments;
    if (!Array.isArray(args) || args.length === 0) return $0ca4f63b79e931bd$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === 'string') {
            if (arg.length > $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === 'object') try {
            const normalizedArg = (0, $886wr.normalize)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $0ca4f63b79e931bd$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch  {
        // fall back to default
        }
        return arg;
    });
    return $0ca4f63b79e931bd$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        'CONSOLE_ARG_TRUNCATED'
                    ]
                }
            } : {}
        }
    });
}
function $0ca4f63b79e931bd$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $0ca4f63b79e931bd$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException?.__rrweb__) return true;
    return false;
}
/**
 * Reset the `replay_id` field on the DSC.
 */ function $0ca4f63b79e931bd$var$resetReplayIdOnDynamicSamplingContext() {
    // Reset DSC on the current scope, if there is one
    const dsc = (0, $kGYVh.getCurrentScope)().getPropagationContext().dsc;
    if (dsc) delete dsc.replay_id;
    // Clear it from frozen DSC on the active span
    const activeSpan = (0, $4H7Y8.getActiveSpan)();
    if (activeSpan) {
        const dsc = (0, $jdzJv.getDynamicSamplingContextFromSpan)(activeSpan);
        delete dsc.replay_id;
    }
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $0ca4f63b79e931bd$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $0ca4f63b79e931bd$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: 'breadcrumb',
                payload: {
                    timestamp: event.timestamp,
                    type: 'default',
                    category: 'sentry.feedback',
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `handleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $0ca4f63b79e931bd$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== 'buffer') return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $0ca4f63b79e931bd$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $0ca4f63b79e931bd$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $0ca4f63b79e931bd$var$handleGlobalEventListener(replay) {
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled or paused
        if (!replay.isEnabled() || replay.isPaused()) return event;
        if ($0ca4f63b79e931bd$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$0ca4f63b79e931bd$var$isErrorEvent(event) && !$0ca4f63b79e931bd$var$isTransactionEvent(event) && !$0ca4f63b79e931bd$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // prevent exceeding replay durations by removing the expired replayId from the DSC
            $0ca4f63b79e931bd$var$resetReplayIdOnDynamicSamplingContext();
            return event;
        }
        if ($0ca4f63b79e931bd$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $0ca4f63b79e931bd$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($0ca4f63b79e931bd$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.log('Ignoring error from rrweb internals', event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $0ca4f63b79e931bd$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        return event;
    }, {
        id: 'Replay'
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $0ca4f63b79e931bd$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $0ca4f63b79e931bd$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: 'performanceSpan',
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === 'string' ? Promise.resolve(null) : response;
    });
}
function $0ca4f63b79e931bd$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: 'navigation.push',
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $0ca4f63b79e931bd$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $0ca4f63b79e931bd$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $0ca4f63b79e931bd$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $0ca4f63b79e931bd$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($0ca4f63b79e931bd$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $jFHzr.isSentryRequestUrl)(url, (0, $kGYVh.getClient)());
}
/** Add a performance entry breadcrumb */ function $0ca4f63b79e931bd$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($0ca4f63b79e931bd$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $0ca4f63b79e931bd$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** Get the size of a body. */ function $0ca4f63b79e931bd$var$getBodySize(body) {
    if (!body) return undefined;
    const textEncoder = new TextEncoder();
    try {
        if (typeof body === 'string') return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = (0, $bE0lt.serializeFormData)(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch  {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $0ca4f63b79e931bd$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Merge a warning into an existing network request/response. */ function $0ca4f63b79e931bd$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $0ca4f63b79e931bd$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        }
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                'URL_SKIPPED'
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $0ca4f63b79e931bd$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings?.length) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $0ca4f63b79e931bd$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.entries(headers).reduce((filteredHeaders, [key, value])=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = value;
        return filteredHeaders;
    }, {});
}
function $0ca4f63b79e931bd$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== 'string') return {
        body: body
    };
    const exceedsSizeLimit = body.length > $0ca4f63b79e931bd$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $0ca4f63b79e931bd$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $0ca4f63b79e931bd$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                'MAYBE_JSON_TRUNCATED'
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                'TEXT_TRUNCATED'
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch  {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $0ca4f63b79e931bd$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === '[' && last === ']' || first === '{' && last === '}';
}
/** Match an URL against a list of strings/Regex. */ function $0ca4f63b79e931bd$var$urlMatches(url, urls) {
    const fullUrl = $0ca4f63b79e931bd$var$getFullUrl(url);
    return (0, $hLnp0.stringMatchesSomePattern)(fullUrl, urls);
}
/** exported for tests */ function $0ca4f63b79e931bd$var$getFullUrl(url, baseURI = $0ca4f63b79e931bd$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith($0ca4f63b79e931bd$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith('/') && fullUrl.endsWith('/')) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ async function $0ca4f63b79e931bd$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $0ca4f63b79e931bd$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $0ca4f63b79e931bd$var$makeNetworkReplayBreadcrumb('resource.fetch', data);
        $0ca4f63b79e931bd$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to capture fetch breadcrumb');
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $0ca4f63b79e931bd$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    const { input: input, response: response } = hint;
    const body = input ? (0, $bE0lt.getFetchRequestArgBody)(input) : undefined;
    const reqSize = $0ca4f63b79e931bd$var$getBodySize(body);
    const resSize = response ? $0ca4f63b79e931bd$var$parseContentLengthHeader(response.headers.get('content-length')) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $0ca4f63b79e931bd$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $0ca4f63b79e931bd$var$urlMatches(url, options.networkDetailAllowUrls) && !$0ca4f63b79e931bd$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $0ca4f63b79e931bd$var$_getRequestInfo(options, hint.input, requestBodySize) : $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $0ca4f63b79e931bd$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $0ca4f63b79e931bd$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $0ca4f63b79e931bd$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = (0, $bE0lt.getFetchRequestArgBody)(input);
    const [bodyStr, warning] = (0, $bE0lt.getBodyString)(requestBody, $0ca4f63b79e931bd$var$logger);
    const data = $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $0ca4f63b79e931bd$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $0ca4f63b79e931bd$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $0ca4f63b79e931bd$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $0ca4f63b79e931bd$var$_parseFetchResponseBody(response);
    const result = $0ca4f63b79e931bd$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $0ca4f63b79e931bd$var$mergeWarning(result, warning);
    return result;
}
function $0ca4f63b79e931bd$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText?.length && responseBodySize === undefined ? $0ca4f63b79e931bd$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to serialize response body');
        // fallback
        return $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $0ca4f63b79e931bd$var$_parseFetchResponseBody(response) {
    const res = $0ca4f63b79e931bd$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        'BODY_PARSE_ERROR'
    ];
    try {
        const text = await $0ca4f63b79e931bd$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        if (error instanceof Error && error.message.indexOf('Timeout') > -1) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.warn('Parsing text body from response timed out');
            return [
                undefined,
                'BODY_PARSE_TIMEOUT'
            ];
        }
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to get text body from response');
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
}
function $0ca4f63b79e931bd$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $0ca4f63b79e931bd$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') return $0ca4f63b79e931bd$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $0ca4f63b79e931bd$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $0ca4f63b79e931bd$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $0ca4f63b79e931bd$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $0ca4f63b79e931bd$var$getAllowedHeaders(headers, allowedHeaders);
}
function $0ca4f63b79e931bd$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to clone response body');
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $0ca4f63b79e931bd$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = (0, $hUuVt.setTimeout)(()=>reject(new Error('Timeout while trying to read response body')), 500);
        $0ca4f63b79e931bd$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $0ca4f63b79e931bd$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where appropriate).
 */ async function $0ca4f63b79e931bd$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $0ca4f63b79e931bd$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $0ca4f63b79e931bd$var$makeNetworkReplayBreadcrumb('resource.xhr', data);
        $0ca4f63b79e931bd$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to capture xhr breadcrumb');
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $0ca4f63b79e931bd$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $0ca4f63b79e931bd$var$getBodySize(input);
    const resSize = xhr.getResponseHeader('content-length') ? $0ca4f63b79e931bd$var$parseContentLengthHeader(xhr.getResponseHeader('content-length')) : $0ca4f63b79e931bd$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $0ca4f63b79e931bd$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$0ca4f63b79e931bd$var$urlMatches(url, options.networkDetailAllowUrls) || $0ca4f63b79e931bd$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $0ca4f63b79e931bd$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    // ---- This additional network data below is only captured for URLs defined in `networkDetailAllowUrls` ----
    const xhrInfo = xhr[0, $8zIFF.SENTRY_XHR_DATA_KEY];
    const networkRequestHeaders = xhrInfo ? $0ca4f63b79e931bd$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $0ca4f63b79e931bd$var$getAllowedHeaders($0ca4f63b79e931bd$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? (0, $bE0lt.getBodyString)(input, $0ca4f63b79e931bd$var$logger) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $0ca4f63b79e931bd$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $0ca4f63b79e931bd$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $0ca4f63b79e931bd$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $0ca4f63b79e931bd$var$mergeWarning(response, responseWarning) : response
    };
}
function $0ca4f63b79e931bd$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $0ca4f63b79e931bd$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $0ca4f63b79e931bd$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.warn('Failed to get xhr response body', ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $0ca4f63b79e931bd$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === 'json' && body && typeof body === 'object') return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error, 'Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
function $0ca4f63b79e931bd$var$_getBodySize(body, responseType) {
    try {
        const bodyStr = responseType === 'json' && body && typeof body === 'object' ? JSON.stringify(body) : body;
        return $0ca4f63b79e931bd$var$getBodySize(bodyStr);
    } catch  {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $0ca4f63b79e931bd$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $kGYVh.getClient)();
    try {
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on('beforeAddBreadcrumb', (breadcrumb, hint)=>$0ca4f63b79e931bd$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } catch  {
    // Do nothing
    }
}
/** just exported for tests */ function $0ca4f63b79e931bd$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($0ca4f63b79e931bd$var$_isXhrBreadcrumb(breadcrumb) && $0ca4f63b79e931bd$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $0ca4f63b79e931bd$var$enrichXhrBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $0ca4f63b79e931bd$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($0ca4f63b79e931bd$var$_isFetchBreadcrumb(breadcrumb) && $0ca4f63b79e931bd$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $0ca4f63b79e931bd$var$enrichFetchBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $0ca4f63b79e931bd$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(e, 'Error when enriching network breadcrumb');
    }
}
function $0ca4f63b79e931bd$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'xhr';
}
function $0ca4f63b79e931bd$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'fetch';
}
function $0ca4f63b79e931bd$var$_isXhrHint(hint) {
    return hint?.xhr;
}
function $0ca4f63b79e931bd$var$_isFetchHint(hint) {
    return hint?.response;
}
/**
 * Add global listeners that cannot be removed.
 */ function $0ca4f63b79e931bd$var$addGlobalListeners(replay, { autoFlushOnFeedback: autoFlushOnFeedback }) {
    // Listeners from core SDK //
    const client = (0, $kGYVh.getClient)();
    (0, $h8vIJ.addClickKeypressInstrumentationHandler)($0ca4f63b79e931bd$var$handleDomListener(replay));
    (0, $5hw2H.addHistoryInstrumentationHandler)($0ca4f63b79e931bd$var$handleHistorySpanListener(replay));
    $0ca4f63b79e931bd$var$handleBreadcrumbs(replay);
    $0ca4f63b79e931bd$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $0ca4f63b79e931bd$var$handleGlobalEventListener(replay);
    (0, $kQ0sT.addEventProcessor)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if (client) {
        client.on('beforeSendEvent', $0ca4f63b79e931bd$var$handleBeforeSendEvent(replay));
        client.on('afterSendEvent', $0ca4f63b79e931bd$var$handleAfterSendEvent(replay));
        client.on('createDsc', (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on('spanStart', (span)=>{
            replay.lastActiveSpan = span;
        });
        // We may be missing the initial spanStart due to timing issues,
        // so we capture it on finish again.
        client.on('spanEnd', (span)=>{
            replay.lastActiveSpan = span;
        });
        // We want to attach the replay id to the feedback event
        client.on('beforeSendFeedback', async (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options?.includeReplay && replay.isEnabled() && replayId && feedbackEvent.contexts?.feedback) {
                // In case the feedback is sent via API and not through our widget, we want to flush replay
                if (feedbackEvent.contexts.feedback.source === 'api' && autoFlushOnFeedback) await replay.flush();
                feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
        if (autoFlushOnFeedback) client.on('openFeedbackWidget', async ()=>{
            await replay.flush();
        });
    }
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $0ca4f63b79e931bd$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($0ca4f63b79e931bd$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $0ca4f63b79e931bd$var$createMemoryEntry($0ca4f63b79e931bd$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $0ca4f63b79e931bd$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: 'memory',
        name: 'memory',
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $0ca4f63b79e931bd$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = (0, $hUuVt.setTimeout)(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = (0, $hUuVt.setTimeout)(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
const $0ca4f63b79e931bd$var$NAVIGATOR = (0, $2fKhD.GLOBAL_OBJ).navigator;
/**
 *  Disable sampling mousemove events on iOS browsers as this can cause blocking the main thread
 *  https://github.com/getsentry/sentry-javascript/issues/14534
 */ function $0ca4f63b79e931bd$var$getRecordingSamplingOptions() {
    if (/iPhone|iPad|iPod/i.test($0ca4f63b79e931bd$var$NAVIGATOR?.userAgent ?? '') || /Macintosh/i.test($0ca4f63b79e931bd$var$NAVIGATOR?.userAgent ?? '') && $0ca4f63b79e931bd$var$NAVIGATOR?.maxTouchPoints && $0ca4f63b79e931bd$var$NAVIGATOR?.maxTouchPoints > 1) return {
        sampling: {
            mousemove: false
        }
    };
    return {};
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $0ca4f63b79e931bd$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.warn('Received replay event after session expired.');
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $0ca4f63b79e931bd$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === 'buffer' && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$0ca4f63b79e931bd$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            const session = replay.session;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time. We have an experimental mode
            // to perform multiple checkouts a session (the idea is to improve
            // seeking during playback), so also only include if segmentId is 0
            // (handled in `addSettingsEvent`).
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $0ca4f63b79e931bd$var$addSettingsEvent(replay, isCheckout);
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === 'buffer' && session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
                    session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $0ca4f63b79e931bd$var$saveSession(session);
                }
            }
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (session?.previousSessionId) return true;
            if (replay.recordingMode === 'session') // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $0ca4f63b79e931bd$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $0ca4f63b79e931bd$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: 'options',
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $0ca4f63b79e931bd$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $0ca4f63b79e931bd$var$addEventSync(replay, $0ca4f63b79e931bd$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $0ca4f63b79e931bd$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $l4iiL.createEnvelope)((0, $l4iiL.createEventEnvelopeHeaders)(replayEvent, (0, $l4iiL.getSdkMetadataForEnvelopeHeader)(replayEvent), tunnel, dsn), [
        [
            {
                type: 'replay_event'
            },
            replayEvent
        ],
        [
            {
                type: 'replay_recording',
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $0ca4f63b79e931bd$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === 'string') payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $0ca4f63b79e931bd$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client['_integrations'] === 'object' && client['_integrations'] !== null && !Array.isArray(client['_integrations']) ? Object.keys(client['_integrations']) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    client.emit('preprocessEvent', event, eventHint);
    const preparedEvent = await (0, $g1WRa.prepareEvent)(client.getOptions(), event, eventHint, scope, client, (0, $kGYVh.getIsolationScope)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    client.emit('postprocessEvent', preparedEvent, eventHint);
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || 'javascript';
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata();
    const { name: name, version: version } = metadata?.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || 'sentry.javascript.unknown',
        version: version || '0.0.0'
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $0ca4f63b79e931bd$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $0ca4f63b79e931bd$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $kGYVh.getClient)();
    const scope = (0, $kGYVh.getCurrentScope)();
    const transport = client?.getTransport();
    const dsn = client?.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return (0, $di9R8.resolvedSyncPromise)({});
    const baseEvent = {
        type: $0ca4f63b79e931bd$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $0ca4f63b79e931bd$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent('event_processor', 'replay');
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('An event processor returned `null`, will not send event.');
        return (0, $di9R8.resolvedSyncPromise)({});
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $0ca4f63b79e931bd$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($0ca4f63b79e931bd$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch  {
        // nothing to do
        }
        throw error;
    }
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new $0ca4f63b79e931bd$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $78AZl.updateRateLimits)({}, response);
    if ((0, $78AZl.isRateLimited)(rateLimits, 'replay')) throw new $0ca4f63b79e931bd$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $0ca4f63b79e931bd$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $0ca4f63b79e931bd$var$RateLimitError extends Error {
    constructor(rateLimits){
        super('Rate limit hit');
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $0ca4f63b79e931bd$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $0ca4f63b79e931bd$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, onError: onError } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $0ca4f63b79e931bd$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $0ca4f63b79e931bd$var$TransportStatusCodeError || err instanceof $0ca4f63b79e931bd$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $kQ0sT.setContext)('Replays', {
            _retryCount: retryConfig.count
        });
        if (onError) onError(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $0ca4f63b79e931bd$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$0ca4f63b79e931bd$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch  {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            (0, $hUuVt.setTimeout)(async ()=>{
                try {
                    await $0ca4f63b79e931bd$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $0ca4f63b79e931bd$var$THROTTLED = '__THROTTLED';
const $0ca4f63b79e931bd$var$SKIPPED = '__SKIPPED';
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0ca4f63b79e931bd$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $0ca4f63b79e931bd$var$SKIPPED : $0ca4f63b79e931bd$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $0ca4f63b79e931bd$var$ReplayContainer {
    /**
   * Recording can happen in one of two modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /** The replay has to be manually started, because no sample rate (neither session or error) was provided. */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ /**
   * Handle when page is blurred
   */ /**
   * Handle when page is focused
   */ /** Ensure page remains active when a key is pressed. */ constructor({ options: options, recordingOptions: recordingOptions }){
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = 'session';
        this.timeouts = {
            sessionIdlePause: $0ca4f63b79e931bd$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $0ca4f63b79e931bd$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._requiresManualStart = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ''
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $0ca4f63b79e931bd$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $0ca4f63b79e931bd$var$throttle((event, isCheckout)=>$0ca4f63b79e931bd$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($0ca4f63b79e931bd$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $0ca4f63b79e931bd$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : ''
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $0ca4f63b79e931bd$var$ClickDetector(this, slowClickConfig);
        // Configure replay logger w/ experimental options
        if ($0ca4f63b79e931bd$var$DEBUG_BUILD) {
            const experiments = options._experiments;
            $0ca4f63b79e931bd$var$logger.setConfig({
                captureExceptions: !!experiments.captureExceptions,
                traceInternals: !!experiments.traceInternals
            });
        }
        // We set these handler properties as class properties, to make binding/unbinding them easier
        this._handleVisibilityChange = ()=>{
            if ($0ca4f63b79e931bd$var$WINDOW.document.visibilityState === 'visible') this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
        /**
     * Handle when page is blurred
     */ this._handleWindowBlur = ()=>{
            const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
                category: 'ui.blur'
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
        this._handleWindowFocus = ()=>{
            const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
                category: 'ui.focus'
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
        /** Ensure page remains active when a key is pressed. */ this._handleKeyboardEvent = (event)=>{
            $0ca4f63b79e931bd$var$handleKeyboardEvent(this, event);
        };
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /** A wrapper to conditionally capture exceptions. */ handleException(error) {
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(error);
        if (this._options.onError) this._options.onError(error);
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
        this._requiresManualStart = requiresManualStart;
        if (requiresManualStart) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.exception(new Error('Unable to initialize and create session'));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === 'buffer' && this.session.segmentId === 0 ? 'buffer' : 'session';
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick(`Starting replay in ${this.recordingMode} mode`);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === 'session') {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Recording is already in progress');
            return;
        }
        if (this._isEnabled && this.recordingMode === 'buffer') {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Buffering is in progress, call `flush()` to save the replay');
            return;
        }
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick('Starting replay in session mode');
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $0ca4f63b79e931bd$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Buffering is in progress, call `flush()` to save the replay');
            return;
        }
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.infoTick('Starting replay in buffer mode');
        const session = $0ca4f63b79e931bd$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = 'buffer';
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $0ca4f63b79e931bd$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === 'buffer' ? {
                    checkoutEveryNms: $0ca4f63b79e931bd$var$BUFFER_CHECKOUT_TIME
                } : // This is to improve playback seeking as there could potentially be
                // less mutations to process in the worse cases.
                //
                // checkout by "N" events is probably ideal, but means we have less
                // control about the number of checkouts we make (which generally
                // increases replay size)
                this._options._experiments.continuousCheckout && {
                    // Minimum checkout time is 6 minutes
                    checkoutEveryNms: Math.max(360000, this._options._experiments.continuousCheckout)
                },
                emit: $0ca4f63b79e931bd$var$getHandleRecordingEmit(this),
                ...$0ca4f63b79e931bd$var$getRecordingSamplingOptions(),
                onMutation: this._onMutationHandler.bind(this),
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this.handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info(`Stopping Replay${reason ? ` triggered by ${reason}` : ''}`);
            $0ca4f63b79e931bd$var$resetReplayIdOnDynamicSamplingContext();
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer?.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $0ca4f63b79e931bd$var$clearSession(this);
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Pausing replay');
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Resuming replay');
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === 'session') return this.flushImmediate();
        const activityTime = Date.now();
        $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Converting buffer to session');
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === 'session') return;
        // Re-start recording in session-mode
        this.recordingMode = 'session';
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === 'buffer') return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === 'buffer') return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current session (=replay) ID */ getSessionId() {
        return this.session?.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $0ca4f63b79e931bd$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === 'session') {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$0ca4f63b79e931bd$var$WINDOW.location.pathname}${$0ca4f63b79e931bd$var$WINDOW.location.hash}${$0ca4f63b79e931bd$var$WINDOW.location.search}`;
        const url = `${$0ca4f63b79e931bd$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $0ca4f63b79e931bd$var$THROTTLED) {
            const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
                category: 'replay.throttled'
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$0ca4f63b79e931bd$var$addEventSync(this, {
                    type: $0ca4f63b79e931bd$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: 'breadcrumb',
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastActiveSpan = this.lastActiveSpan || (0, $4H7Y8.getActiveSpan)();
        const lastRootSpan = lastActiveSpan && (0, $4H7Y8.getRootSpan)(lastActiveSpan);
        const attributes = lastRootSpan && (0, $4H7Y8.spanToJSON)(lastRootSpan).data || {};
        const source = attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        if (!lastRootSpan || !source || ![
            'route',
            'custom'
        ].includes(source)) return undefined;
        return (0, $4H7Y8.spanToJSON)(lastRootSpan).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $0ca4f63b79e931bd$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $0ca4f63b79e931bd$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($0ca4f63b79e931bd$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: 'refresh session'
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $0ca4f63b79e931bd$var$WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
            $0ca4f63b79e931bd$var$WINDOW.addEventListener('blur', this._handleWindowBlur);
            $0ca4f63b79e931bd$var$WINDOW.addEventListener('focus', this._handleWindowFocus);
            $0ca4f63b79e931bd$var$WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $0ca4f63b79e931bd$var$addGlobalListeners(this, {
                    autoFlushOnFeedback: this._options._experiments.autoFlushOnFeedback
                });
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this.handleException(err);
        }
        this._performanceCleanupCallback = $0ca4f63b79e931bd$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $0ca4f63b79e931bd$var$WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
            $0ca4f63b79e931bd$var$WINDOW.removeEventListener('blur', this._handleWindowBlur);
            $0ca4f63b79e931bd$var$WINDOW.removeEventListener('focus', this._handleWindowFocus);
            $0ca4f63b79e931bd$var$WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this.handleException(err);
        }
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $0ca4f63b79e931bd$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Document has become active, but session has expired');
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $0ca4f63b79e931bd$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: 'breadcrumb',
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        let performanceEntries = $0ca4f63b79e931bd$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // If we are manually starting, we want to ensure we only include performance entries
        // that are after the initial timestamp
        // The reason for this is that we may have performance entries from the page load, but may decide to start
        // the replay later on, in which case we do not want to include these entries.
        // without this, manually started replays can have events long before the actual replay recording starts,
        // which messes with the timeline etc.
        if (this._requiresManualStart) {
            const initialTimestampInSeconds = this._context.initialTimestamp / 1000;
            performanceEntries = performanceEntries.filter((entry)=>entry.start >= initialTimestampInSeconds);
        }
        return Promise.all($0ca4f63b79e931bd$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        // If replay was started manually (=no sample rate was given),
        // We do not want to back-port the initial timestamp
        if (!session || !eventBuffer || this._requiresManualStart) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.error('No session or eventBuffer found to flush.');
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer?.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $0ca4f63b79e931bd$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accommodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error('Session is too long, not sending replay');
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $0ca4f63b79e931bd$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                timestamp: timestamp,
                onError: (err)=>this.handleException(err)
            });
        } catch (err) {
            this.handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: 'sendReplay'
            });
            const client = (0, $kGYVh.getClient)();
            if (client) {
                const dropReason = err instanceof $0ca4f63b79e931bd$var$RateLimitError ? 'ratelimit_backoff' : 'send_error';
                client.recordDroppedEvent(dropReason, 'replay');
            }
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ async _flush({ force: force = false } = {}) {
        if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
        return;
        if (!this.checkAndHandleExpiredSession()) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.error('Attempting to finish replay event after session expired.');
            return;
        }
        if (!this.session) // should never happen, as we would have bailed out before
        return;
        const start = this.session.started;
        const now = Date.now();
        const duration = now - start;
        // A flush is about to happen, cancel any queued flushes
        this._debouncedFlush.cancel();
        // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
        // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
        const tooShort = duration < this._options.minReplayDuration;
        const tooLong = duration > this._options.maxReplayDuration + 5000;
        if (tooShort || tooLong) {
            $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info(`Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? 'short' : 'long'}, not sending replay.`);
            if (tooShort) this._debouncedFlush();
            return;
        }
        const eventBuffer = this.eventBuffer;
        if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $0ca4f63b79e931bd$var$DEBUG_BUILD && $0ca4f63b79e931bd$var$logger.info('Flushing initial segment without checkout.');
        const _flushInProgress = !!this._flushLock;
        // this._flushLock acts as a lock so that future calls to `_flush()` will
        // be blocked until current flush is finished (i.e. this promise resolves)
        if (!this._flushLock) this._flushLock = this._runFlush();
        try {
            await this._flushLock;
        } catch (err) {
            this.handleException(err);
        } finally{
            this._flushLock = undefined;
            if (_flushInProgress) // Wait for previous flush to finish, then call the debounced
            // `_flush()`. It's possible there are other flush requests queued and
            // waiting for it to resolve. We want to reduce all outstanding
            // requests (as well as any new flush requests that occur within a
            // second of the locked flush completing) into a single flush.
            this._debouncedFlush();
        }
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $0ca4f63b79e931bd$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ _onMutationHandler(mutations) {
        const count = mutations.length;
        const mutationLimit = this._options.mutationLimit;
        const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
        const overMutationLimit = mutationLimit && count > mutationLimit;
        // Create a breadcrumb if a lot of mutations happen at the same time
        // We can show this in the UI as an information with potential performance improvements
        if (count > mutationBreadcrumbLimit || overMutationLimit) {
            const breadcrumb = $0ca4f63b79e931bd$var$createBreadcrumb({
                category: 'replay.mutations',
                data: {
                    count: count,
                    limit: overMutationLimit
                }
            });
            this._createCustomBreadcrumb(breadcrumb);
        }
        // Stop replay if over the mutation limit
        if (overMutationLimit) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: 'mutationLimit',
                forceFlush: this.recordingMode === 'session'
            });
            return false;
        }
        // `true` means we use the regular mutation handling by rrweb
        return true;
    }
}
function $0ca4f63b79e931bd$var$getOption(selectors, defaultSelectors) {
    return [
        ...selectors,
        // sentry defaults
        ...defaultSelectors
    ].join(',');
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $0ca4f63b79e931bd$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore }) {
    const defaultBlockedElements = [
        'base',
        'iframe[srcdoc]:not([src])'
    ];
    const maskSelector = $0ca4f63b79e931bd$var$getOption(mask, [
        '.sentry-mask',
        '[data-sentry-mask]'
    ]);
    const unmaskSelector = $0ca4f63b79e931bd$var$getOption(unmask, []);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $0ca4f63b79e931bd$var$getOption(block, [
            '.sentry-block',
            '[data-sentry-block]',
            ...defaultBlockedElements
        ]),
        unblockSelector: $0ca4f63b79e931bd$var$getOption(unblock, []),
        ignoreSelector: $0ca4f63b79e931bd$var$getOption(ignore, [
            '.sentry-ignore',
            '[data-sentry-ignore]',
            'input[type="file"]'
        ])
    };
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $0ca4f63b79e931bd$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precedence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === 'value' && el.tagName === 'INPUT' && [
        'submit',
        'button'
    ].includes(el.getAttribute('type') || '')) return value.replace(/[\S]/g, '*');
    return value;
}
const $0ca4f63b79e931bd$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $0ca4f63b79e931bd$var$DEFAULT_NETWORK_HEADERS = [
    'content-length',
    'content-type',
    'accept'
];
let $0ca4f63b79e931bd$var$_initialized = false;
/**
 * Sentry integration for [Session Replay](https://sentry.io/for/session-replay/).
 *
 * See the [Replay documentation](https://docs.sentry.io/platforms/javascript/guides/session-replay/) for more information.
 *
 * @example
 *
 * ```
 * Sentry.init({
 *   dsn: '__DSN__',
 *   integrations: [Sentry.replayIntegration()],
 * });
 * ```
 */ const $0ca4f63b79e931bd$export$d7706faf7ab354bf = (options)=>{
    return new $0ca4f63b79e931bd$var$Replay(options);
};
/**
 * Replay integration
 */ class $0ca4f63b79e931bd$var$Replay {
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $0ca4f63b79e931bd$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $0ca4f63b79e931bd$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $0ca4f63b79e931bd$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $0ca4f63b79e931bd$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        'title',
        'placeholder',
        'aria-label'
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, onError: onError } = {}){
        this.name = 'Replay';
        const privacyOptions = $0ca4f63b79e931bd$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$0ca4f63b79e931bd$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: 'all',
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            },
            // experimental support for recording iframes from different origins
            recordCrossOriginIframes: Boolean(_experiments.recordCrossOriginIframes)
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $0ca4f63b79e931bd$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $0ca4f63b79e931bd$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $0ca4f63b79e931bd$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $0ca4f63b79e931bd$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            onError: onError,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $0ca4f63b79e931bd$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$0ca4f63b79e931bd$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $bsaEo.isBrowser)()) throw new Error('Multiple Sentry Session Replay instances are not supported');
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $0ca4f63b79e931bd$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $0ca4f63b79e931bd$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ afterAllSetup(client) {
        if (!(0, $bsaEo.isBrowser)() || this._replay) return;
        this._setup(client);
        this._initialize(client);
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === 'session'
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay) return Promise.resolve();
        // assuming a session should be recorded in this case
        if (!this._replay.isEnabled()) {
            this._replay.start();
            return Promise.resolve();
        }
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay?.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */ getRecordingMode() {
        if (!this._replay?.isEnabled()) return;
        return this._replay.recordingMode;
    }
    /**
   * Initializes replay.
   */ _initialize(client) {
        if (!this._replay) return;
        this._maybeLoadFromReplayCanvasIntegration(client);
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup(client) {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $0ca4f63b79e931bd$var$loadReplayOptionsFromClient(this._initialOptions, client);
        this._replay = new $0ca4f63b79e931bd$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration(client) {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const canvasIntegration = client.getIntegrationByName('ReplayCanvas');
            if (!canvasIntegration) return;
            this._replay['_canvas'] = canvasIntegration.getOptions();
        } catch  {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
/** Parse Replay-related options from SDK options */ function $0ca4f63b79e931bd$var$loadReplayOptionsFromClient(initialOptions, client) {
    const opt = client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...initialOptions
    };
    const replaysSessionSampleRate = (0, $1oUdV.parseSampleRate)(opt.replaysSessionSampleRate);
    const replaysOnErrorSampleRate = (0, $1oUdV.parseSampleRate)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $hi47i.consoleSandbox)(()=>{
        // eslint-disable-next-line no-console
        console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $0ca4f63b79e931bd$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$0ca4f63b79e931bd$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ function $0ca4f63b79e931bd$export$b28310b2f161456b() {
    const client = (0, $kGYVh.getClient)();
    return client?.getIntegrationByName('Replay');
}

});
parcelRegister("bsaEo", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $856a9239af1edf90$export$4e09c449d6c407f7);

var $ctISH = parcelRequire("ctISH");

var $2fKhD = parcelRequire("2fKhD");
/**
 * Returns true if we are in the browser.
 */ function $856a9239af1edf90$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, $ctISH.isNodeEnv)() || $856a9239af1edf90$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $856a9239af1edf90$var$isElectronNodeRenderer() {
    const process = (0, $2fKhD.GLOBAL_OBJ).process;
    return process?.type === 'renderer';
}

});
parcelRegister("ctISH", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);

var $2wKOZ = parcelRequire("2wKOZ");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $2wKOZ.isBrowserBundle)() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch (e) {
    // no-empty
    }
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, 'process');
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});


parcelRegister("jFHzr", function(module, exports) {

$parcel$export(module.exports, "isSentryRequestUrl", () => $e523a4dfa96cd99a$export$d92e61f5600202af);
/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $e523a4dfa96cd99a$export$d92e61f5600202af(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $e523a4dfa96cd99a$var$checkDsn(url, dsn) || $e523a4dfa96cd99a$var$checkTunnel(url, tunnel);
}
function $e523a4dfa96cd99a$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $e523a4dfa96cd99a$var$removeTrailingSlash(url) === $e523a4dfa96cd99a$var$removeTrailingSlash(tunnel);
}
function $e523a4dfa96cd99a$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $e523a4dfa96cd99a$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}

});

parcelRegister("bE0lt", function(module, exports) {

$parcel$export(module.exports, "serializeFormData", () => $87a3b2b2b04e8709$export$2f1b0f57f243f270);
$parcel$export(module.exports, "getBodyString", () => $87a3b2b2b04e8709$export$945a2d5364608d5);
$parcel$export(module.exports, "getFetchRequestArgBody", () => $87a3b2b2b04e8709$export$ad44edf8012ec314);

var $hi47i = parcelRequire("hi47i");

var $jioJL = parcelRequire("jioJL");
/**
 * Serializes FormData.
 *
 * This is a bit simplified, but gives us a decent estimate.
 * This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'.
 *
 */ function $87a3b2b2b04e8709$export$2f1b0f57f243f270(formData) {
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
/** Get the string representation of a body. */ function $87a3b2b2b04e8709$export$945a2d5364608d5(body, _logger = (0, $hi47i.logger)) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $87a3b2b2b04e8709$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        (0, $jioJL.DEBUG_BUILD) && _logger.error(error, 'Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    (0, $jioJL.DEBUG_BUILD) && _logger.info('Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
/**
 * Parses the fetch arguments to extract the request payload.
 *
 * We only support getting the body from the fetch options.
 */ function $87a3b2b2b04e8709$export$ad44edf8012ec314(fetchArgs = []) {
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') return undefined;
    return fetchArgs[1].body;
}

});






parcelRequire("6FqPz");

//# sourceMappingURL=city.eab2e3fd.js.map
